var pf = Object.defineProperty;
var gf = (e, n, t) => n in e ? pf(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var ke = (e, n, t) => gf(e, typeof n != "symbol" ? n + "" : n, t);
import { defineComponent as xe, computed as M, openBlock as b, createElementBlock as $, normalizeStyle as Fe, normalizeClass as X, createCommentVNode as F, toDisplayString as ie, ref as ee, shallowRef as It, onMounted as et, watch as Be, onUnmounted as Jt, h as wt, nextTick as Ge, createBlock as ue, unref as m, useSlots as Ut, inject as On, resolveDynamicComponent as ht, mergeProps as lt, withCtx as ce, renderSlot as Y, provide as ga, createTextVNode as Ye, createElementVNode as E, withModifiers as Ve, createVNode as le, useId as As, watchEffect as Gt, withDirectives as an, vModelCheckbox as yf, toValue as Qe, reactive as wa, getCurrentScope as $u, onScopeDispose as Ol, shallowReadonly as Da, useTemplateRef as Xe, createSlots as dt, renderList as Ie, normalizeProps as Ct, guardReactiveProps as Bt, mergeDefaults as Mu, readonly as ai, toRef as pl, Teleport as Pn, Transition as St, Fragment as Te, onBeforeUpdate as bf, vShow as Wn, withKeys as Pt, useModel as En, mergeModels as Ht, TransitionGroup as Dr, getCurrentInstance as si, hasInjectionContext as Cu, toRaw as Du, vModelText as _u, onUpdated as wf, onBeforeUnmount as Ps, useAttrs as li, onDeactivated as Ou, onActivated as Eu, isVNode as cs, triggerRef as _r, isRef as Iu, markRaw as zi, resolveComponent as Au, isMemoSame as kf, defineAsyncComponent as xf } from "vue";
import { RouterLink as Sf, useRouter as Pu, onBeforeRouteLeave as Tf, useRoute as ri } from "vue-router";
import { defineStore as $f } from "pinia";
const Mf = ["alt", "src"], Cf = {
  key: 1,
  class: "select-none"
}, Df = /* @__PURE__ */ xe({
  __name: "VAvatar",
  props: {
    name: { default: "" },
    avatar: { default: void 0 },
    size: { default: "md" },
    customSize: { default: void 0 },
    shape: { default: "circle" },
    online: { type: Boolean, default: !1 },
    alt: { default: "User avatar" }
  },
  setup(e) {
    const n = e, t = M(() => ({
      xs: "w-6 h-6 text-xs",
      sm: "w-8 h-8 text-sm",
      md: "w-10 h-10 text-base",
      lg: "w-12 h-12 text-lg",
      xl: "w-16 h-16 text-xl"
    })[n.size]), a = M(
      () => n.shape === "square" ? "rounded-md" : "rounded-full"
    ), s = M(() => n.customSize ? {
      width: `${n.customSize}px`,
      height: `${n.customSize}px`,
      fontSize: `${n.customSize * 0.4}px`
    } : {}), l = M(() => {
      if (!n.name) return "?";
      const o = n.name.trim().split(/\s+/);
      return o.length >= 2 ? `${o[0][0]}${o[1][0]}`.toUpperCase() : n.name.substring(0, 2).toUpperCase();
    }), r = M(() => {
      if (!n.name) return "bg-base-200 text-secondaryText";
      let o = 0;
      for (let c = 0; c < n.name.length; c++)
        o = n.name.charCodeAt(c) + ((o << 5) - o);
      const u = [
        "bg-blue-500 text-white",
        "bg-purple-500 text-white",
        "bg-pink-500 text-white",
        "bg-green-500 text-white",
        "bg-orange-500 text-white",
        "bg-primary text-white",
        "bg-indigo-500 text-white",
        "bg-cyan-500 text-white"
      ];
      return u[Math.abs(o) % u.length];
    }), i = M(() => !!n.avatar);
    return (o, u) => (b(), $("div", {
      class: X([[t.value, a.value, !i.value && r.value], "user-avatar relative inline-flex items-center justify-center overflow-hidden flex-shrink-0 font-medium transition-all duration-200"]),
      style: Fe(s.value)
    }, [
      i.value ? (b(), $("img", {
        key: 0,
        alt: e.alt,
        src: e.avatar,
        class: "w-full h-full object-cover",
        onError: u[0] || (u[0] = (c) => c.target.style.display = "none")
      }, null, 40, Mf)) : F("", !0),
      i.value ? F("", !0) : (b(), $("span", Cf, ie(l.value), 1)),
      e.online ? (b(), $("span", {
        key: 2,
        class: X([{
          "w-1.5 h-1.5": e.size === "xs",
          "w-2 h-2": e.size === "sm",
          "w-2.5 h-2.5": e.size === "md",
          "w-3 h-3": e.size === "lg",
          "w-4 h-4": e.size === "xl"
        }, "absolute bottom-0 right-0 block rounded-full bg-success ring-2 ring-base-100 transition-all"]),
        "aria-label": "Online"
      }, null, 2)) : F("", !0)
    ], 6));
  }
}), Ue = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n)
    t[a] = s;
  return t;
}, ID = /* @__PURE__ */ Ue(Df, [["__scopeId", "data-v-985a3a1e"]]), Ru = Symbol("buttonGroup"), Fu = /^[a-z0-9]+(-[a-z0-9]+)*$/, El = (e, n, t, a = "") => {
  const s = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (s.length < 2 || s.length > 3)
      return null;
    a = s.shift().slice(1);
  }
  if (s.length > 3 || !s.length)
    return null;
  if (s.length > 1) {
    const i = s.pop(), o = s.pop(), u = {
      // Allow provider without '@': "provider:prefix:name"
      provider: s.length > 0 ? s[0] : a,
      prefix: o,
      name: i
    };
    return n && !cl(u) ? null : u;
  }
  const l = s[0], r = l.split("-");
  if (r.length > 1) {
    const i = {
      provider: a,
      prefix: r.shift(),
      name: r.join("-")
    };
    return n && !cl(i) ? null : i;
  }
  if (t && a === "") {
    const i = {
      provider: a,
      prefix: "",
      name: l
    };
    return n && !cl(i, t) ? null : i;
  }
  return null;
}, cl = (e, n) => e ? !!// Check prefix: cannot be empty, unless allowSimpleName is enabled
// Check name: cannot be empty
((n && e.prefix === "" || e.prefix) && e.name) : !1, Vu = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), gl = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Il = Object.freeze({
  ...Vu,
  ...gl
}), Or = Object.freeze({
  ...Il,
  body: "",
  hidden: !1
});
function _f(e, n) {
  const t = {};
  !e.hFlip != !n.hFlip && (t.hFlip = !0), !e.vFlip != !n.vFlip && (t.vFlip = !0);
  const a = ((e.rotate || 0) + (n.rotate || 0)) % 4;
  return a && (t.rotate = a), t;
}
function Wi(e, n) {
  const t = _f(e, n);
  for (const a in Or)
    a in gl ? a in e && !(a in t) && (t[a] = gl[a]) : a in n ? t[a] = n[a] : a in e && (t[a] = e[a]);
  return t;
}
function Of(e, n) {
  const t = e.icons, a = e.aliases || /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  function l(r) {
    if (t[r])
      return s[r] = [];
    if (!(r in s)) {
      s[r] = null;
      const i = a[r] && a[r].parent, o = i && l(i);
      o && (s[r] = [i].concat(o));
    }
    return s[r];
  }
  return Object.keys(t).concat(Object.keys(a)).forEach(l), s;
}
function Ef(e, n, t) {
  const a = e.icons, s = e.aliases || /* @__PURE__ */ Object.create(null);
  let l = {};
  function r(i) {
    l = Wi(
      a[i] || s[i],
      l
    );
  }
  return r(n), t.forEach(r), Wi(e, l);
}
function Lu(e, n) {
  const t = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return t;
  e.not_found instanceof Array && e.not_found.forEach((s) => {
    n(s, null), t.push(s);
  });
  const a = Of(e);
  for (const s in a) {
    const l = a[s];
    l && (n(s, Ef(e, s, l)), t.push(s));
  }
  return t;
}
const If = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Vu
};
function nr(e, n) {
  for (const t in n)
    if (t in e && typeof e[t] != typeof n[t])
      return !1;
  return !0;
}
function Nu(e) {
  if (typeof e != "object" || e === null)
    return null;
  const n = e;
  if (typeof n.prefix != "string" || !e.icons || typeof e.icons != "object" || !nr(e, If))
    return null;
  const t = n.icons;
  for (const s in t) {
    const l = t[s];
    if (
      // Name cannot be empty
      !s || // Must have body
      typeof l.body != "string" || // Check other props
      !nr(
        l,
        Or
      )
    )
      return null;
  }
  const a = n.aliases || /* @__PURE__ */ Object.create(null);
  for (const s in a) {
    const l = a[s], r = l.parent;
    if (
      // Name cannot be empty
      !s || // Parent must be set and point to existing icon
      typeof r != "string" || !t[r] && !a[r] || // Check other props
      !nr(
        l,
        Or
      )
    )
      return null;
  }
  return n;
}
const Yi = /* @__PURE__ */ Object.create(null);
function Af(e, n) {
  return {
    provider: e,
    prefix: n,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function ja(e, n) {
  const t = Yi[e] || (Yi[e] = /* @__PURE__ */ Object.create(null));
  return t[n] || (t[n] = Af(e, n));
}
function Bu(e, n) {
  return Nu(n) ? Lu(n, (t, a) => {
    a ? e.icons[t] = a : e.missing.add(t);
  }) : [];
}
function Pf(e, n, t) {
  try {
    if (typeof t.body == "string")
      return e.icons[n] = { ...t }, !0;
  } catch {
  }
  return !1;
}
let _s = !1;
function zu(e) {
  return typeof e == "boolean" && (_s = e), _s;
}
function Rf(e) {
  const n = typeof e == "string" ? El(e, !0, _s) : e;
  if (n) {
    const t = ja(n.provider, n.prefix), a = n.name;
    return t.icons[a] || (t.missing.has(a) ? null : void 0);
  }
}
function Ff(e, n) {
  const t = El(e, !0, _s);
  if (!t)
    return !1;
  const a = ja(t.provider, t.prefix);
  return n ? Pf(a, t.name, n) : (a.missing.add(t.name), !0);
}
function Vf(e, n) {
  if (typeof e != "object")
    return !1;
  if (typeof n != "string" && (n = e.provider || ""), _s && !n && !e.prefix) {
    let s = !1;
    return Nu(e) && (e.prefix = "", Lu(e, (l, r) => {
      Ff(l, r) && (s = !0);
    })), s;
  }
  const t = e.prefix;
  if (!cl({
    prefix: t,
    name: "a"
  }))
    return !1;
  const a = ja(n, t);
  return !!Bu(a, e);
}
const Wu = Object.freeze({
  width: null,
  height: null
}), Yu = Object.freeze({
  // Dimensions
  ...Wu,
  // Transformations
  ...gl
}), Lf = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Nf = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Hi(e, n, t) {
  if (n === 1)
    return e;
  if (t = t || 100, typeof e == "number")
    return Math.ceil(e * n * t) / t;
  if (typeof e != "string")
    return e;
  const a = e.split(Lf);
  if (a === null || !a.length)
    return e;
  const s = [];
  let l = a.shift(), r = Nf.test(l);
  for (; ; ) {
    if (r) {
      const i = parseFloat(l);
      isNaN(i) ? s.push(l) : s.push(Math.ceil(i * n * t) / t);
    } else
      s.push(l);
    if (l = a.shift(), l === void 0)
      return s.join("");
    r = !r;
  }
}
function Bf(e, n = "defs") {
  let t = "";
  const a = e.indexOf("<" + n);
  for (; a >= 0; ) {
    const s = e.indexOf(">", a), l = e.indexOf("</" + n);
    if (s === -1 || l === -1)
      break;
    const r = e.indexOf(">", l);
    if (r === -1)
      break;
    t += e.slice(s + 1, l).trim(), e = e.slice(0, a).trim() + e.slice(r + 1);
  }
  return {
    defs: t,
    content: e
  };
}
function zf(e, n) {
  return e ? "<defs>" + e + "</defs>" + n : n;
}
function Wf(e, n, t) {
  const a = Bf(e);
  return zf(a.defs, n + a.content + t);
}
const Yf = (e) => e === "unset" || e === "undefined" || e === "none";
function Hf(e, n) {
  const t = {
    ...Il,
    ...e
  }, a = {
    ...Yu,
    ...n
  }, s = {
    left: t.left,
    top: t.top,
    width: t.width,
    height: t.height
  };
  let l = t.body;
  [t, a].forEach((v) => {
    const k = [], y = v.hFlip, h = v.vFlip;
    let w = v.rotate;
    y ? h ? w += 2 : (k.push(
      "translate(" + (s.width + s.left).toString() + " " + (0 - s.top).toString() + ")"
    ), k.push("scale(-1 1)"), s.top = s.left = 0) : h && (k.push(
      "translate(" + (0 - s.left).toString() + " " + (s.height + s.top).toString() + ")"
    ), k.push("scale(1 -1)"), s.top = s.left = 0);
    let S;
    switch (w < 0 && (w -= Math.floor(w / 4) * 4), w = w % 4, w) {
      case 1:
        S = s.height / 2 + s.top, k.unshift(
          "rotate(90 " + S.toString() + " " + S.toString() + ")"
        );
        break;
      case 2:
        k.unshift(
          "rotate(180 " + (s.width / 2 + s.left).toString() + " " + (s.height / 2 + s.top).toString() + ")"
        );
        break;
      case 3:
        S = s.width / 2 + s.left, k.unshift(
          "rotate(-90 " + S.toString() + " " + S.toString() + ")"
        );
        break;
    }
    w % 2 === 1 && (s.left !== s.top && (S = s.left, s.left = s.top, s.top = S), s.width !== s.height && (S = s.width, s.width = s.height, s.height = S)), k.length && (l = Wf(
      l,
      '<g transform="' + k.join(" ") + '">',
      "</g>"
    ));
  });
  const r = a.width, i = a.height, o = s.width, u = s.height;
  let c, f;
  r === null ? (f = i === null ? "1em" : i === "auto" ? u : i, c = Hi(f, o / u)) : (c = r === "auto" ? o : r, f = i === null ? Hi(c, u / o) : i === "auto" ? u : i);
  const p = {}, d = (v, k) => {
    Yf(k) || (p[v] = k.toString());
  };
  d("width", c), d("height", f);
  const g = [s.left, s.top, o, u];
  return p.viewBox = g.join(" "), {
    attributes: p,
    viewBox: g,
    body: l
  };
}
const Uf = /\sid="(\S+)"/g, qf = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let jf = 0;
function Gf(e, n = qf) {
  const t = [];
  let a;
  for (; a = Uf.exec(e); )
    t.push(a[1]);
  if (!t.length)
    return e;
  const s = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return t.forEach((l) => {
    const r = typeof n == "function" ? n(l) : n + (jf++).toString(), i = l.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + i + ')([")]|\\.[a-z])', "g"),
      "$1" + r + s + "$3"
    );
  }), e = e.replace(new RegExp(s, "g"), ""), e;
}
const Er = /* @__PURE__ */ Object.create(null);
function Kf(e, n) {
  Er[e] = n;
}
function Ir(e) {
  return Er[e] || Er[""];
}
function ii(e) {
  let n;
  if (typeof e.resources == "string")
    n = [e.resources];
  else if (n = e.resources, !(n instanceof Array) || !n.length)
    return null;
  return {
    // API hosts
    resources: n,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const oi = /* @__PURE__ */ Object.create(null), ds = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], dl = [];
for (; ds.length > 0; )
  ds.length === 1 || Math.random() > 0.5 ? dl.push(ds.shift()) : dl.push(ds.pop());
oi[""] = ii({
  resources: ["https://api.iconify.design"].concat(dl)
});
function Zf(e, n) {
  const t = ii(n);
  return t === null ? !1 : (oi[e] = t, !0);
}
function ui(e) {
  return oi[e];
}
const Xf = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Ui = Xf();
function Jf(e, n) {
  const t = ui(e);
  if (!t)
    return 0;
  let a;
  if (!t.maxURL)
    a = 0;
  else {
    let s = 0;
    t.resources.forEach((r) => {
      s = Math.max(s, r.length);
    });
    const l = n + ".json?icons=";
    a = t.maxURL - s - t.path.length - l.length;
  }
  return a;
}
function Qf(e) {
  return e === 404;
}
const eh = (e, n, t) => {
  const a = [], s = Jf(e, n), l = "icons";
  let r = {
    type: l,
    provider: e,
    prefix: n,
    icons: []
  }, i = 0;
  return t.forEach((o, u) => {
    i += o.length + 1, i >= s && u > 0 && (a.push(r), r = {
      type: l,
      provider: e,
      prefix: n,
      icons: []
    }, i = o.length), r.icons.push(o);
  }), a.push(r), a;
};
function th(e) {
  if (typeof e == "string") {
    const n = ui(e);
    if (n)
      return n.path;
  }
  return "/";
}
const nh = (e, n, t) => {
  if (!Ui) {
    t("abort", 424);
    return;
  }
  let a = th(n.provider);
  switch (n.type) {
    case "icons": {
      const l = n.prefix, i = n.icons.join(","), o = new URLSearchParams({
        icons: i
      });
      a += l + ".json?" + o.toString();
      break;
    }
    case "custom": {
      const l = n.uri;
      a += l.slice(0, 1) === "/" ? l.slice(1) : l;
      break;
    }
    default:
      t("abort", 400);
      return;
  }
  let s = 503;
  Ui(e + a).then((l) => {
    const r = l.status;
    if (r !== 200) {
      setTimeout(() => {
        t(Qf(r) ? "abort" : "next", r);
      });
      return;
    }
    return s = 501, l.json();
  }).then((l) => {
    if (typeof l != "object" || l === null) {
      setTimeout(() => {
        l === 404 ? t("abort", l) : t("next", s);
      });
      return;
    }
    setTimeout(() => {
      t("success", l);
    });
  }).catch(() => {
    t("next", s);
  });
}, ah = {
  prepare: eh,
  send: nh
};
function sh(e) {
  const n = {
    loaded: [],
    missing: [],
    pending: []
  }, t = /* @__PURE__ */ Object.create(null);
  e.sort((s, l) => s.provider !== l.provider ? s.provider.localeCompare(l.provider) : s.prefix !== l.prefix ? s.prefix.localeCompare(l.prefix) : s.name.localeCompare(l.name));
  let a = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((s) => {
    if (a.name === s.name && a.prefix === s.prefix && a.provider === s.provider)
      return;
    a = s;
    const l = s.provider, r = s.prefix, i = s.name, o = t[l] || (t[l] = /* @__PURE__ */ Object.create(null)), u = o[r] || (o[r] = ja(l, r));
    let c;
    i in u.icons ? c = n.loaded : r === "" || u.missing.has(i) ? c = n.missing : c = n.pending;
    const f = {
      provider: l,
      prefix: r,
      name: i
    };
    c.push(f);
  }), n;
}
function Hu(e, n) {
  e.forEach((t) => {
    const a = t.loaderCallbacks;
    a && (t.loaderCallbacks = a.filter((s) => s.id !== n));
  });
}
function lh(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const n = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!n.length)
      return;
    let t = !1;
    const a = e.provider, s = e.prefix;
    n.forEach((l) => {
      const r = l.icons, i = r.pending.length;
      r.pending = r.pending.filter((o) => {
        if (o.prefix !== s)
          return !0;
        const u = o.name;
        if (e.icons[u])
          r.loaded.push({
            provider: a,
            prefix: s,
            name: u
          });
        else if (e.missing.has(u))
          r.missing.push({
            provider: a,
            prefix: s,
            name: u
          });
        else
          return t = !0, !0;
        return !1;
      }), r.pending.length !== i && (t || Hu([e], l.id), l.callback(
        r.loaded.slice(0),
        r.missing.slice(0),
        r.pending.slice(0),
        l.abort
      ));
    });
  }));
}
let rh = 0;
function ih(e, n, t) {
  const a = rh++, s = Hu.bind(null, t, a);
  if (!n.pending.length)
    return s;
  const l = {
    id: a,
    icons: n,
    callback: e,
    abort: s
  };
  return t.forEach((r) => {
    (r.loaderCallbacks || (r.loaderCallbacks = [])).push(l);
  }), s;
}
function oh(e, n = !0, t = !1) {
  const a = [];
  return e.forEach((s) => {
    const l = typeof s == "string" ? El(s, n, t) : s;
    l && a.push(l);
  }), a;
}
var uh = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function ch(e, n, t, a) {
  const s = e.resources.length, l = e.random ? Math.floor(Math.random() * s) : e.index;
  let r;
  if (e.random) {
    let C = e.resources.slice(0);
    for (r = []; C.length > 1; ) {
      const _ = Math.floor(Math.random() * C.length);
      r.push(C[_]), C = C.slice(0, _).concat(C.slice(_ + 1));
    }
    r = r.concat(C);
  } else
    r = e.resources.slice(l).concat(e.resources.slice(0, l));
  const i = Date.now();
  let o = "pending", u = 0, c, f = null, p = [], d = [];
  typeof a == "function" && d.push(a);
  function g() {
    f && (clearTimeout(f), f = null);
  }
  function v() {
    o === "pending" && (o = "aborted"), g(), p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function k(C, _) {
    _ && (d = []), typeof C == "function" && d.push(C);
  }
  function y() {
    return {
      startTime: i,
      payload: n,
      status: o,
      queriesSent: u,
      queriesPending: p.length,
      subscribe: k,
      abort: v
    };
  }
  function h() {
    o = "failed", d.forEach((C) => {
      C(void 0, c);
    });
  }
  function w() {
    p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function S(C, _, O) {
    const P = _ !== "success";
    switch (p = p.filter((D) => D !== C), o) {
      case "pending":
        break;
      case "failed":
        if (P || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (_ === "abort") {
      c = O, h();
      return;
    }
    if (P) {
      c = O, p.length || (r.length ? x() : h());
      return;
    }
    if (g(), w(), !e.random) {
      const D = e.resources.indexOf(C.resource);
      D !== -1 && D !== e.index && (e.index = D);
    }
    o = "completed", d.forEach((D) => {
      D(O);
    });
  }
  function x() {
    if (o !== "pending")
      return;
    g();
    const C = r.shift();
    if (C === void 0) {
      if (p.length) {
        f = setTimeout(() => {
          g(), o === "pending" && (w(), h());
        }, e.timeout);
        return;
      }
      h();
      return;
    }
    const _ = {
      status: "pending",
      resource: C,
      callback: (O, P) => {
        S(_, O, P);
      }
    };
    p.push(_), u++, f = setTimeout(x, e.rotate), t(C, n, _.callback);
  }
  return setTimeout(x), y;
}
function Uu(e) {
  const n = {
    ...uh,
    ...e
  };
  let t = [];
  function a() {
    t = t.filter((i) => i().status === "pending");
  }
  function s(i, o, u) {
    const c = ch(
      n,
      i,
      o,
      (f, p) => {
        a(), u && u(f, p);
      }
    );
    return t.push(c), c;
  }
  function l(i) {
    return t.find((o) => i(o)) || null;
  }
  return {
    query: s,
    find: l,
    setIndex: (i) => {
      n.index = i;
    },
    getIndex: () => n.index,
    cleanup: a
  };
}
function qi() {
}
const ar = /* @__PURE__ */ Object.create(null);
function dh(e) {
  if (!ar[e]) {
    const n = ui(e);
    if (!n)
      return;
    const t = Uu(n), a = {
      config: n,
      redundancy: t
    };
    ar[e] = a;
  }
  return ar[e];
}
function fh(e, n, t) {
  let a, s;
  if (typeof e == "string") {
    const l = Ir(e);
    if (!l)
      return t(void 0, 424), qi;
    s = l.send;
    const r = dh(e);
    r && (a = r.redundancy);
  } else {
    const l = ii(e);
    if (l) {
      a = Uu(l);
      const r = e.resources ? e.resources[0] : "", i = Ir(r);
      i && (s = i.send);
    }
  }
  return !a || !s ? (t(void 0, 424), qi) : a.query(n, s, t)().abort;
}
function ji() {
}
function hh(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, lh(e);
  }));
}
function mh(e) {
  const n = [], t = [];
  return e.forEach((a) => {
    (a.match(Fu) ? n : t).push(a);
  }), {
    valid: n,
    invalid: t
  };
}
function fs(e, n, t) {
  function a() {
    const s = e.pendingIcons;
    n.forEach((l) => {
      s && s.delete(l), e.icons[l] || e.missing.add(l);
    });
  }
  if (t && typeof t == "object")
    try {
      if (!Bu(e, t).length) {
        a();
        return;
      }
    } catch (s) {
      console.error(s);
    }
  a(), hh(e);
}
function Gi(e, n) {
  e instanceof Promise ? e.then((t) => {
    n(t);
  }).catch(() => {
    n(null);
  }) : n(e);
}
function vh(e, n) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(n).sort() : e.iconsToLoad = n, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: t, prefix: a } = e, s = e.iconsToLoad;
    if (delete e.iconsToLoad, !s || !s.length)
      return;
    const l = e.loadIcon;
    if (e.loadIcons && (s.length > 1 || !l)) {
      Gi(
        e.loadIcons(s, a, t),
        (c) => {
          fs(e, s, c);
        }
      );
      return;
    }
    if (l) {
      s.forEach((c) => {
        const f = l(c, a, t);
        Gi(f, (p) => {
          const d = p ? {
            prefix: a,
            icons: {
              [c]: p
            }
          } : null;
          fs(e, [c], d);
        });
      });
      return;
    }
    const { valid: r, invalid: i } = mh(s);
    if (i.length && fs(e, i, null), !r.length)
      return;
    const o = a.match(Fu) ? Ir(t) : null;
    if (!o) {
      fs(e, r, null);
      return;
    }
    o.prepare(t, a, r).forEach((c) => {
      fh(t, c, (f) => {
        fs(e, c.icons, f);
      });
    });
  }));
}
const ph = (e, n) => {
  const t = oh(e, !0, zu()), a = sh(t);
  if (!a.pending.length) {
    let o = !0;
    return n && setTimeout(() => {
      o && n(
        a.loaded,
        a.missing,
        a.pending,
        ji
      );
    }), () => {
      o = !1;
    };
  }
  const s = /* @__PURE__ */ Object.create(null), l = [];
  let r, i;
  return a.pending.forEach((o) => {
    const { provider: u, prefix: c } = o;
    if (c === i && u === r)
      return;
    r = u, i = c, l.push(ja(u, c));
    const f = s[u] || (s[u] = /* @__PURE__ */ Object.create(null));
    f[c] || (f[c] = []);
  }), a.pending.forEach((o) => {
    const { provider: u, prefix: c, name: f } = o, p = ja(u, c), d = p.pendingIcons || (p.pendingIcons = /* @__PURE__ */ new Set());
    d.has(f) || (d.add(f), s[u][c].push(f));
  }), l.forEach((o) => {
    const u = s[o.provider][o.prefix];
    u.length && vh(o, u);
  }), n ? ih(n, a, l) : ji;
};
function gh(e, n) {
  const t = {
    ...e
  };
  for (const a in n) {
    const s = n[a], l = typeof s;
    a in Wu ? (s === null || s && (l === "string" || l === "number")) && (t[a] = s) : l === typeof t[a] && (t[a] = a === "rotate" ? s % 4 : s);
  }
  return t;
}
const yh = /[\s,]+/;
function bh(e, n) {
  n.split(yh).forEach((t) => {
    switch (t.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function wh(e, n = 0) {
  const t = e.replace(/^-?[0-9.]*/, "");
  function a(s) {
    for (; s < 0; )
      s += 4;
    return s % 4;
  }
  if (t === "") {
    const s = parseInt(e);
    return isNaN(s) ? 0 : a(s);
  } else if (t !== e) {
    let s = 0;
    switch (t) {
      case "%":
        s = 25;
        break;
      case "deg":
        s = 90;
    }
    if (s) {
      let l = parseFloat(e.slice(0, e.length - t.length));
      return isNaN(l) ? 0 : (l = l / s, l % 1 === 0 ? a(l) : 0);
    }
  }
  return n;
}
function kh(e, n) {
  let t = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const a in n)
    t += " " + a + '="' + n[a] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + t + ">" + e + "</svg>";
}
function xh(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Sh(e) {
  return "data:image/svg+xml," + xh(e);
}
function Th(e) {
  return 'url("' + Sh(e) + '")';
}
const Ki = {
  ...Yu,
  inline: !1
}, $h = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, Mh = {
  display: "inline-block"
}, Ar = {
  backgroundColor: "currentColor"
}, qu = {
  backgroundColor: "transparent"
}, Zi = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, Xi = {
  webkitMask: Ar,
  mask: Ar,
  background: qu
};
for (const e in Xi) {
  const n = Xi[e];
  for (const t in Zi)
    n[e + t] = Zi[t];
}
const fl = {};
["horizontal", "vertical"].forEach((e) => {
  const n = e.slice(0, 1) + "Flip";
  fl[e + "-flip"] = n, fl[e.slice(0, 1) + "-flip"] = n, fl[e + "Flip"] = n;
});
function Ji(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const Qi = (e, n) => {
  const t = gh(Ki, n), a = { ...$h }, s = n.mode || "svg", l = {}, r = n.style, i = typeof r == "object" && !(r instanceof Array) ? r : {};
  for (let v in n) {
    const k = n[v];
    if (k !== void 0)
      switch (v) {
        // Properties to ignore
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
        case "ssr":
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          t[v] = k === !0 || k === "true" || k === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof k == "string" && bh(t, k);
          break;
        // Color: override style
        case "color":
          l.color = k;
          break;
        // Rotation as string
        case "rotate":
          typeof k == "string" ? t[v] = wh(k) : typeof k == "number" && (t[v] = k);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          k !== !0 && k !== "true" && delete a["aria-hidden"];
          break;
        default: {
          const y = fl[v];
          y ? (k === !0 || k === "true" || k === 1) && (t[y] = !0) : Ki[v] === void 0 && (a[v] = k);
        }
      }
  }
  const o = Hf(e, t), u = o.attributes;
  if (t.inline && (l.verticalAlign = "-0.125em"), s === "svg") {
    a.style = {
      ...l,
      ...i
    }, Object.assign(a, u);
    let v = 0, k = n.id;
    return typeof k == "string" && (k = k.replace(/-/g, "_")), a.innerHTML = Gf(o.body, k ? () => k + "ID" + v++ : "iconifyVue"), wt("svg", a);
  }
  const { body: c, width: f, height: p } = e, d = s === "mask" || (s === "bg" ? !1 : c.indexOf("currentColor") !== -1), g = kh(c, {
    ...u,
    width: f + "",
    height: p + ""
  });
  return a.style = {
    ...l,
    "--svg": Th(g),
    width: Ji(u.width),
    height: Ji(u.height),
    ...Mh,
    ...d ? Ar : qu,
    ...i
  }, wt("span", a);
};
zu(!0);
Kf("", ah);
if (typeof document < "u" && typeof window < "u") {
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const n = e.IconifyPreload, t = "Invalid IconifyPreload syntax.";
    typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((a) => {
      try {
        // Check if item is an object and not null/array
        (typeof a != "object" || a === null || a instanceof Array || // Check for 'icons' and 'prefix'
        typeof a.icons != "object" || typeof a.prefix != "string" || // Add icon set
        !Vf(a)) && console.error(t);
      } catch {
        console.error(t);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const n = e.IconifyProviders;
    if (typeof n == "object" && n !== null)
      for (let t in n) {
        const a = "IconifyProviders[" + t + "] is invalid.";
        try {
          const s = n[t];
          if (typeof s != "object" || !s || s.resources === void 0)
            continue;
          Zf(t, s) || console.error(a);
        } catch {
          console.error(a);
        }
      }
  }
}
const Ch = {
  ...Il,
  body: ""
}, Dh = xe((e, { emit: n }) => {
  const t = ee(null);
  function a() {
    var u, c;
    t.value && ((c = (u = t.value).abort) == null || c.call(u), t.value = null);
  }
  const s = ee(!!e.ssr), l = ee(""), r = It(null);
  function i() {
    const u = e.icon;
    if (typeof u == "object" && u !== null && typeof u.body == "string")
      return l.value = "", {
        data: u
      };
    let c;
    if (typeof u != "string" || (c = El(u, !1, !0)) === null)
      return null;
    let f = Rf(c);
    if (!f) {
      const g = t.value;
      return (!g || g.name !== u) && (f === null ? t.value = {
        name: u
      } : t.value = {
        name: u,
        abort: ph([c], o)
      }), null;
    }
    a(), l.value !== u && (l.value = u, Ge(() => {
      n("load", u);
    }));
    const p = e.customise;
    if (p) {
      f = Object.assign({}, f);
      const g = p(f.body, c.name, c.prefix, c.provider);
      typeof g == "string" && (f.body = g);
    }
    const d = ["iconify"];
    return c.prefix !== "" && d.push("iconify--" + c.prefix), c.provider !== "" && d.push("iconify--" + c.provider), { data: f, classes: d };
  }
  function o() {
    var c;
    const u = i();
    u ? u.data !== ((c = r.value) == null ? void 0 : c.data) && (r.value = u) : r.value = null;
  }
  return s.value ? o() : et(() => {
    s.value = !0, o();
  }), Be(() => e.icon, o), Jt(a), () => {
    const u = r.value;
    if (!u)
      return Qi(Ch, e);
    let c = e;
    return u.classes && (c = {
      ...e,
      class: u.classes.join(" ")
    }), Qi({
      ...Il,
      ...u.data
    }, c);
  };
}, {
  props: [
    // Icon and render mode
    "icon",
    "mode",
    "ssr",
    // Layout and style
    "width",
    "height",
    "style",
    "color",
    "inline",
    // Transformations
    "rotate",
    "hFlip",
    "horizontalFlip",
    "vFlip",
    "verticalFlip",
    "flip",
    // Misc
    "id",
    "ariaHidden",
    "customise",
    "title"
  ],
  emits: ["load"]
}), _h = /* @__PURE__ */ xe({
  __name: "VIcon",
  props: {
    icon: {},
    size: { default: 24 },
    color: { default: "currentColor" },
    class: { default: "" },
    loading: { type: Boolean }
  },
  setup(e) {
    const n = M(() => e.color.startsWith("text-")), t = M(() => e.loading ? "lucide:loader-2" : e.icon), a = M(() => typeof e.size == "number" ? `${e.size}px` : e.size), s = M(() => n.value ? e.color : ""), l = M(() => n.value ? void 0 : { color: e.color });
    return (r, i) => (b(), ue(m(Dh), {
      class: X([[{ "v-icon--spin": e.loading }, s.value, e.class], "v-icon"]),
      height: a.value,
      icon: t.value,
      style: Fe(l.value),
      width: a.value,
      "aria-hidden": "true",
      focusable: "false"
    }, null, 8, ["class", "height", "icon", "style", "width"]));
  }
}), we = /* @__PURE__ */ Ue(_h, [["__scopeId", "data-v-68f452e3"]]), Oh = {
  key: 0,
  class: "v-button__icon"
}, Eh = {
  key: 1,
  class: "v-button__content"
}, Ih = { key: 0 }, Ah = {
  key: 2,
  class: "v-button__icon"
}, Ph = /* @__PURE__ */ xe({
  __name: "VButton",
  props: {
    text: { default: "" },
    type: { default: "button" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: { default: void 0 },
    variant: { default: "default" },
    to: { default: void 0 },
    replace: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 },
    size: { default: void 0 }
  },
  setup(e) {
    const n = Ut(), t = On(Ru, !1), a = e, s = M(() => !a.text && !!a.icon && !n.default), l = M(() => {
      switch (a.variant) {
        case "primary":
          return "v-button--primary";
        case "positive":
          return "v-button--positive";
        case "negative":
          return "v-button--negative";
        case "warning":
          return "v-button--warning";
        case "link":
          return "v-button--link";
        case "secondary":
          return "v-button--secondary";
        case "neutral":
          return "v-button--neutral";
        case "info":
          return "v-button--info";
        default:
          return "v-button--primary";
      }
    }), r = M(() => a.modern ? 15 : 24), i = M(() => !!a.to);
    return (o, u) => (b(), ue(ht(i.value ? m(Sf) : "button"), lt(
      {
        class: [
          "v-button",
          l.value,
          a.size ? `v-button--${a.size}` : "",
          {
            "v-button--modern": a.modern,
            "v-button--grouped": m(t),
            "v-button--icon-only": s.value,
            "v-button--disabled cursor-not-allowed": a.disabled || a.loading
          }
        ]
      },
      i.value ? {
        to: a.disabled || a.loading ? void 0 : a.to,
        replace: a.replace,
        ...o.$attrs
      } : { type: a.type, disabled: a.disabled || a.loading, ...o.$attrs }
    ), {
      default: ce(() => [
        o.$slots.iconLeft || a.loading || a.icon ? (b(), $("span", Oh, [
          a.loading ? (b(), ue(we, {
            key: 0,
            loading: a.loading,
            size: r.value,
            icon: "lucide:loader-2"
          }, null, 8, ["loading", "size"])) : Y(o.$slots, "iconLeft", { key: 1 }, () => [
            a.icon ? (b(), ue(we, {
              key: 0,
              icon: a.icon,
              size: r.value
            }, null, 8, ["icon", "size"])) : F("", !0)
          ], !0)
        ])) : F("", !0),
        s.value ? F("", !0) : (b(), $("span", Eh, [
          a.text ? (b(), $("span", Ih, ie(a.text), 1)) : F("", !0),
          Y(o.$slots, "default", {}, void 0, !0)
        ])),
        o.$slots.iconRight ? (b(), $("span", Ah, [
          Y(o.$slots, "iconRight", {}, void 0, !0)
        ])) : F("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Et = /* @__PURE__ */ Ue(Ph, [["__scopeId", "data-v-0969eba2"]]), Rh = {
  class: "v-button-group",
  role: "group"
}, Fh = /* @__PURE__ */ xe({
  __name: "VButtonGroup",
  setup(e) {
    return ga(Ru, !0), (n, t) => (b(), $("div", Rh, [
      Y(n.$slots, "default", {}, void 0, !0)
    ]));
  }
}), AD = /* @__PURE__ */ Ue(Fh, [["__scopeId", "data-v-b6af72a2"]]), Vh = { key: 1 }, Lh = /* @__PURE__ */ xe({
  __name: "VTag",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "primary" },
    size: { default: "sm" },
    icon: { default: void 0 },
    iconPosition: { default: "left" },
    rounded: { type: Boolean, default: !1 },
    class: { default: "" },
    customColor: { default: void 0 }
  },
  setup(e) {
    const n = e, t = M(() => ({
      xs: 12,
      sm: 14,
      md: 16,
      lg: 18
    })[n.size]), a = M(() => `vtag--${n.size}`), s = M(
      () => n.customColor ? { "--_tag-color": `var(${n.customColor})` } : void 0
    ), l = M(
      () => n.customColor ? `vtag--custom-${n.variant}` : `vtag--${n.variant}-${n.color}`
    ), r = M(() => n.rounded ? "vtag--rounded" : "vtag--square");
    return (i, o) => (b(), $("span", {
      style: Fe(s.value),
      class: X([[a.value, l.value, r.value, n.class], "vtag"])
    }, [
      e.icon && e.iconPosition === "left" ? (b(), ue(we, {
        key: 0,
        icon: e.icon,
        size: t.value
      }, null, 8, ["icon", "size"])) : F("", !0),
      e.label || i.$slots.default ? (b(), $("span", Vh, [
        Y(i.$slots, "default", {}, () => [
          Ye(ie(e.label), 1)
        ], !0)
      ])) : F("", !0),
      Y(i.$slots, "icon-right", {}, () => [
        e.icon && e.iconPosition === "right" ? (b(), ue(we, {
          key: 0,
          icon: e.icon,
          size: t.value
        }, null, 8, ["icon", "size"])) : F("", !0)
      ], !0)
    ], 6));
  }
}), ju = /* @__PURE__ */ Ue(Lh, [["__scopeId", "data-v-6a630cc7"]]), Nh = { class: "vchip__content" }, Bh = {
  key: 1,
  class: "vchip__label"
}, zh = ["disabled"], Wh = /* @__PURE__ */ xe({
  __name: "VChip",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "default" },
    selectedColor: { default: "primary" },
    size: { default: "md" },
    icon: { default: void 0 },
    closable: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    badge: { default: void 0 },
    badgeColor: { default: "primary" },
    class: { default: "" },
    value: { type: [String, Number, Boolean, Object, null], default: void 0 },
    modelValue: { default: void 0 },
    multiple: { type: Boolean, default: !1 },
    valueComparator: { type: Function, default: void 0 }
  },
  emits: ["click", "close", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (p, d) => {
      if (t.valueComparator)
        return t.valueComparator(p, d);
      if (p === d) return !0;
      if (p == null || d == null) return !1;
      if (typeof p == "object" && typeof d == "object")
        try {
          return JSON.stringify(p) === JSON.stringify(d);
        } catch {
          return !1;
        }
      return p === d;
    }, l = M(() => t.modelValue !== void 0 && t.value !== void 0 ? t.multiple ? Array.isArray(t.modelValue) && t.modelValue.some((p) => s(p, t.value)) : s(t.modelValue, t.value) : t.active), r = M(() => ({
      sm: 14,
      md: 16,
      lg: 18
    })[t.size]), i = M(() => `vchip--${t.size}`), o = M(() => {
      if (t.color === "default" && l.value)
        return `vchip--${t.variant}-${t.selectedColor}-selected`;
      const p = `vchip--${t.variant}-${t.color}`;
      return l.value ? `${p}-selected` : p;
    }), u = M(() => t.disabled ? "vchip--disabled" : "vchip--interactive"), c = (p) => {
      if (!t.disabled) {
        if (t.value !== void 0 && t.modelValue !== void 0)
          if (t.multiple) {
            const d = Array.isArray(t.modelValue) ? t.modelValue : [];
            if (d.findIndex((v) => s(v, t.value)) > -1) {
              const v = d.filter((k) => !s(k, t.value));
              a("update:modelValue", v);
            } else
              a("update:modelValue", [...d, t.value]);
          } else
            s(t.modelValue, t.value) ? a("update:modelValue", null) : a("update:modelValue", t.value);
        a("click", p);
      }
    }, f = (p) => {
      t.disabled || a("close", p);
    };
    return (p, d) => (b(), $("span", {
      class: X([[i.value, o.value, u.value, t.class], "vchip"]),
      onClick: c
    }, [
      E("span", Nh, [
        e.icon ? (b(), ue(we, {
          key: 0,
          icon: e.icon,
          size: r.value,
          class: "vchip__icon"
        }, null, 8, ["icon", "size"])) : F("", !0),
        e.label || p.$slots.default ? (b(), $("span", Bh, [
          Y(p.$slots, "default", {}, () => [
            Ye(ie(e.label), 1)
          ], !0)
        ])) : F("", !0),
        Y(p.$slots, "badge", {}, () => [
          e.badge ? (b(), ue(ju, {
            key: 0,
            color: e.badgeColor,
            label: e.badge,
            size: "sm",
            variant: "outline"
          }, null, 8, ["color", "label"])) : F("", !0)
        ], !0)
      ]),
      e.closable ? (b(), $("button", {
        key: 0,
        disabled: e.disabled,
        class: "vchip__close",
        type: "button",
        onClick: Ve(f, ["stop"])
      }, [
        le(we, {
          size: r.value - 2,
          icon: "lucide:x"
        }, null, 8, ["size"])
      ], 8, zh)) : F("", !0)
    ], 2));
  }
}), PD = /* @__PURE__ */ Ue(Wh, [["__scopeId", "data-v-d99cc188"]]);
class Sa extends Error {
}
class Yh extends Sa {
  constructor(n) {
    super(`Invalid DateTime: ${n.toMessage()}`);
  }
}
class Hh extends Sa {
  constructor(n) {
    super(`Invalid Interval: ${n.toMessage()}`);
  }
}
class Uh extends Sa {
  constructor(n) {
    super(`Invalid Duration: ${n.toMessage()}`);
  }
}
class Va extends Sa {
}
class Gu extends Sa {
  constructor(n) {
    super(`Invalid unit ${n}`);
  }
}
class Ft extends Sa {
}
class Gn extends Sa {
  constructor() {
    super("Zone is an abstract class");
  }
}
const De = "numeric", bn = "short", Zt = "long", yl = {
  year: De,
  month: De,
  day: De
}, Ku = {
  year: De,
  month: bn,
  day: De
}, qh = {
  year: De,
  month: bn,
  day: De,
  weekday: bn
}, Zu = {
  year: De,
  month: Zt,
  day: De
}, Xu = {
  year: De,
  month: Zt,
  day: De,
  weekday: Zt
}, Ju = {
  hour: De,
  minute: De
}, Qu = {
  hour: De,
  minute: De,
  second: De
}, ec = {
  hour: De,
  minute: De,
  second: De,
  timeZoneName: bn
}, tc = {
  hour: De,
  minute: De,
  second: De,
  timeZoneName: Zt
}, nc = {
  hour: De,
  minute: De,
  hourCycle: "h23"
}, ac = {
  hour: De,
  minute: De,
  second: De,
  hourCycle: "h23"
}, sc = {
  hour: De,
  minute: De,
  second: De,
  hourCycle: "h23",
  timeZoneName: bn
}, lc = {
  hour: De,
  minute: De,
  second: De,
  hourCycle: "h23",
  timeZoneName: Zt
}, rc = {
  year: De,
  month: De,
  day: De,
  hour: De,
  minute: De
}, ic = {
  year: De,
  month: De,
  day: De,
  hour: De,
  minute: De,
  second: De
}, oc = {
  year: De,
  month: bn,
  day: De,
  hour: De,
  minute: De
}, uc = {
  year: De,
  month: bn,
  day: De,
  hour: De,
  minute: De,
  second: De
}, jh = {
  year: De,
  month: bn,
  day: De,
  weekday: bn,
  hour: De,
  minute: De
}, cc = {
  year: De,
  month: Zt,
  day: De,
  hour: De,
  minute: De,
  timeZoneName: bn
}, dc = {
  year: De,
  month: Zt,
  day: De,
  hour: De,
  minute: De,
  second: De,
  timeZoneName: bn
}, fc = {
  year: De,
  month: Zt,
  day: De,
  weekday: Zt,
  hour: De,
  minute: De,
  timeZoneName: Zt
}, hc = {
  year: De,
  month: Zt,
  day: De,
  weekday: Zt,
  hour: De,
  minute: De,
  second: De,
  timeZoneName: Zt
};
class Rs {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Gn();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Gn();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Gn();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, t) {
    throw new Gn();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    throw new Gn();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    throw new Gn();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    throw new Gn();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Gn();
  }
}
let sr = null;
class Al extends Rs {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return sr === null && (sr = new Al()), sr;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(n, { format: t, locale: a }) {
    return Tc(n, t, a);
  }
  /** @override **/
  formatOffset(n, t) {
    return Ts(this.offset(n), t);
  }
  /** @override **/
  offset(n) {
    return -new Date(n).getTimezoneOffset();
  }
  /** @override **/
  equals(n) {
    return n.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const Pr = /* @__PURE__ */ new Map();
function Gh(e) {
  let n = Pr.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), Pr.set(e, n)), n;
}
const Kh = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function Zh(e, n) {
  const t = e.format(n).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(t), [, s, l, r, i, o, u, c] = a;
  return [r, s, l, i, o, u, c];
}
function Xh(e, n) {
  const t = e.formatToParts(n), a = [];
  for (let s = 0; s < t.length; s++) {
    const { type: l, value: r } = t[s], i = Kh[l];
    l === "era" ? a[i] = r : Ne(i) || (a[i] = parseInt(r, 10));
  }
  return a;
}
const lr = /* @__PURE__ */ new Map();
class Hn extends Rs {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(n) {
    let t = lr.get(n);
    return t === void 0 && lr.set(n, t = new Hn(n)), t;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    lr.clear(), Pr.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(n) {
    return this.isValidZone(n);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(n) {
    if (!n)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: n }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(n) {
    super(), this.zoneName = n, this.valid = Hn.isValidZone(n);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, { format: t, locale: a }) {
    return Tc(n, t, a, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return Ts(this.offset(n), t);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    if (!this.valid) return NaN;
    const t = new Date(n);
    if (isNaN(t)) return NaN;
    const a = Gh(this.name);
    let [s, l, r, i, o, u, c] = a.formatToParts ? Xh(a, t) : Zh(a, t);
    i === "BC" && (s = -Math.abs(s) + 1);
    const p = Rl({
      year: s,
      month: l,
      day: r,
      hour: o === 24 ? 0 : o,
      minute: u,
      second: c,
      millisecond: 0
    });
    let d = +t;
    const g = d % 1e3;
    return d -= g >= 0 ? g : 1e3 + g, (p - d) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "iana" && n.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let eo = {};
function Jh(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = eo[t];
  return a || (a = new Intl.ListFormat(e, n), eo[t] = a), a;
}
const Rr = /* @__PURE__ */ new Map();
function Fr(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Rr.get(t);
  return a === void 0 && (a = new Intl.DateTimeFormat(e, n), Rr.set(t, a)), a;
}
const Vr = /* @__PURE__ */ new Map();
function Qh(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Vr.get(t);
  return a === void 0 && (a = new Intl.NumberFormat(e, n), Vr.set(t, a)), a;
}
const Lr = /* @__PURE__ */ new Map();
function em(e, n = {}) {
  const { base: t, ...a } = n, s = JSON.stringify([e, a]);
  let l = Lr.get(s);
  return l === void 0 && (l = new Intl.RelativeTimeFormat(e, n), Lr.set(s, l)), l;
}
let ws = null;
function tm() {
  return ws || (ws = new Intl.DateTimeFormat().resolvedOptions().locale, ws);
}
const Nr = /* @__PURE__ */ new Map();
function mc(e) {
  let n = Nr.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat(e).resolvedOptions(), Nr.set(e, n)), n;
}
const Br = /* @__PURE__ */ new Map();
function nm(e) {
  let n = Br.get(e);
  if (!n) {
    const t = new Intl.Locale(e);
    n = "getWeekInfo" in t ? t.getWeekInfo() : t.weekInfo, "minimalDays" in n || (n = { ...vc, ...n }), Br.set(e, n);
  }
  return n;
}
function am(e) {
  const n = e.indexOf("-x-");
  n !== -1 && (e = e.substring(0, n));
  const t = e.indexOf("-u-");
  if (t === -1)
    return [e];
  {
    let a, s;
    try {
      a = Fr(e).resolvedOptions(), s = e;
    } catch {
      const o = e.substring(0, t);
      a = Fr(o).resolvedOptions(), s = o;
    }
    const { numberingSystem: l, calendar: r } = a;
    return [s, l, r];
  }
}
function sm(e, n, t) {
  return (t || n) && (e.includes("-u-") || (e += "-u"), t && (e += `-ca-${t}`), n && (e += `-nu-${n}`)), e;
}
function lm(e) {
  const n = [];
  for (let t = 1; t <= 12; t++) {
    const a = Oe.utc(2009, t, 1);
    n.push(e(a));
  }
  return n;
}
function rm(e) {
  const n = [];
  for (let t = 1; t <= 7; t++) {
    const a = Oe.utc(2016, 11, 13 + t);
    n.push(e(a));
  }
  return n;
}
function Qs(e, n, t, a) {
  const s = e.listingMode();
  return s === "error" ? null : s === "en" ? t(n) : a(n);
}
function im(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || mc(e.locale).numberingSystem === "latn";
}
class om {
  constructor(n, t, a) {
    this.padTo = a.padTo || 0, this.floor = a.floor || !1;
    const { padTo: s, floor: l, ...r } = a;
    if (!t || Object.keys(r).length > 0) {
      const i = { useGrouping: !1, ...a };
      a.padTo > 0 && (i.minimumIntegerDigits = a.padTo), this.inf = Qh(n, i);
    }
  }
  format(n) {
    if (this.inf) {
      const t = this.floor ? Math.floor(n) : n;
      return this.inf.format(t);
    } else {
      const t = this.floor ? Math.floor(n) : mi(n, 3);
      return Mt(t, this.padTo);
    }
  }
}
class um {
  constructor(n, t, a) {
    this.opts = a, this.originalZone = void 0;
    let s;
    if (this.opts.timeZone)
      this.dt = n;
    else if (n.zone.type === "fixed") {
      const r = -1 * (n.offset / 60), i = r >= 0 ? `Etc/GMT+${r}` : `Etc/GMT${r}`;
      n.offset !== 0 && Hn.create(i).valid ? (s = i, this.dt = n) : (s = "UTC", this.dt = n.offset === 0 ? n : n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    } else n.zone.type === "system" ? this.dt = n : n.zone.type === "iana" ? (this.dt = n, s = n.zone.name) : (s = "UTC", this.dt = n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    const l = { ...this.opts };
    l.timeZone = l.timeZone || s, this.dtf = Fr(t, l);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: n }) => n).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const n = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? n.map((t) => {
      if (t.type === "timeZoneName") {
        const a = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...t,
          value: a
        };
      } else
        return t;
    }) : n;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class cm {
  constructor(n, t, a) {
    this.opts = { style: "long", ...a }, !t && xc() && (this.rtf = em(n, a));
  }
  format(n, t) {
    return this.rtf ? this.rtf.format(n, t) : Im(t, n, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(n, t) {
    return this.rtf ? this.rtf.formatToParts(n, t) : [];
  }
}
const vc = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class st {
  static fromOpts(n) {
    return st.create(
      n.locale,
      n.numberingSystem,
      n.outputCalendar,
      n.weekSettings,
      n.defaultToEN
    );
  }
  static create(n, t, a, s, l = !1) {
    const r = n || pt.defaultLocale, i = r || (l ? "en-US" : tm()), o = t || pt.defaultNumberingSystem, u = a || pt.defaultOutputCalendar, c = Wr(s) || pt.defaultWeekSettings;
    return new st(i, o, u, c, r);
  }
  static resetCache() {
    ws = null, Rr.clear(), Vr.clear(), Lr.clear(), Nr.clear(), Br.clear();
  }
  static fromObject({ locale: n, numberingSystem: t, outputCalendar: a, weekSettings: s } = {}) {
    return st.create(n, t, a, s);
  }
  constructor(n, t, a, s, l) {
    const [r, i, o] = am(n);
    this.locale = r, this.numberingSystem = t || i || null, this.outputCalendar = a || o || null, this.weekSettings = s, this.intl = sm(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = l, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = im(this)), this.fastNumbersCached;
  }
  listingMode() {
    const n = this.isEnglish(), t = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return n && t ? "en" : "intl";
  }
  clone(n) {
    return !n || Object.getOwnPropertyNames(n).length === 0 ? this : st.create(
      n.locale || this.specifiedLocale,
      n.numberingSystem || this.numberingSystem,
      n.outputCalendar || this.outputCalendar,
      Wr(n.weekSettings) || this.weekSettings,
      n.defaultToEN || !1
    );
  }
  redefaultToEN(n = {}) {
    return this.clone({ ...n, defaultToEN: !0 });
  }
  redefaultToSystem(n = {}) {
    return this.clone({ ...n, defaultToEN: !1 });
  }
  months(n, t = !1) {
    return Qs(this, n, Cc, () => {
      const a = this.intl === "ja" || this.intl.startsWith("ja-");
      t &= !a;
      const s = t ? { month: n, day: "numeric" } : { month: n }, l = t ? "format" : "standalone";
      if (!this.monthsCache[l][n]) {
        const r = a ? (i) => this.dtFormatter(i, s).format() : (i) => this.extract(i, s, "month");
        this.monthsCache[l][n] = lm(r);
      }
      return this.monthsCache[l][n];
    });
  }
  weekdays(n, t = !1) {
    return Qs(this, n, Oc, () => {
      const a = t ? { weekday: n, year: "numeric", month: "long", day: "numeric" } : { weekday: n }, s = t ? "format" : "standalone";
      return this.weekdaysCache[s][n] || (this.weekdaysCache[s][n] = rm(
        (l) => this.extract(l, a, "weekday")
      )), this.weekdaysCache[s][n];
    });
  }
  meridiems() {
    return Qs(
      this,
      void 0,
      () => Ec,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [Oe.utc(2016, 11, 13, 9), Oe.utc(2016, 11, 13, 19)].map(
            (t) => this.extract(t, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(n) {
    return Qs(this, n, Ic, () => {
      const t = { era: n };
      return this.eraCache[n] || (this.eraCache[n] = [Oe.utc(-40, 1, 1), Oe.utc(2017, 1, 1)].map(
        (a) => this.extract(a, t, "era")
      )), this.eraCache[n];
    });
  }
  extract(n, t, a) {
    const s = this.dtFormatter(n, t), l = s.formatToParts(), r = l.find((i) => i.type.toLowerCase() === a);
    return r ? r.value : null;
  }
  numberFormatter(n = {}) {
    return new om(this.intl, n.forceSimple || this.fastNumbers, n);
  }
  dtFormatter(n, t = {}) {
    return new um(n, this.intl, t);
  }
  relFormatter(n = {}) {
    return new cm(this.intl, this.isEnglish(), n);
  }
  listFormatter(n = {}) {
    return Jh(this.intl, n);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || mc(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : Sc() ? nm(this.locale) : vc;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(n) {
    return this.locale === n.locale && this.numberingSystem === n.numberingSystem && this.outputCalendar === n.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let rr = null;
class zt extends Rs {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return rr === null && (rr = new zt(0)), rr;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(n) {
    return n === 0 ? zt.utcInstance : new zt(n);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(n) {
    if (n) {
      const t = n.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (t)
        return new zt(Fl(t[1], t[2]));
    }
    return null;
  }
  constructor(n) {
    super(), this.fixed = n;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Ts(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Ts(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return Ts(this.fixed, t);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "fixed" && n.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class dm extends Rs {
  constructor(n) {
    super(), this.zoneName = n;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Qn(e, n) {
  if (Ne(e) || e === null)
    return n;
  if (e instanceof Rs)
    return e;
  if (gm(e)) {
    const t = e.toLowerCase();
    return t === "default" ? n : t === "local" || t === "system" ? Al.instance : t === "utc" || t === "gmt" ? zt.utcInstance : zt.parseSpecifier(t) || Hn.create(e);
  } else return ta(e) ? zt.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new dm(e);
}
const ci = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, to = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, fm = ci.hanidec.replace(/[\[|\]]/g, "").split("");
function hm(e) {
  let n = parseInt(e, 10);
  if (isNaN(n)) {
    n = "";
    for (let t = 0; t < e.length; t++) {
      const a = e.charCodeAt(t);
      if (e[t].search(ci.hanidec) !== -1)
        n += fm.indexOf(e[t]);
      else
        for (const s in to) {
          const [l, r] = to[s];
          a >= l && a <= r && (n += a - l);
        }
    }
    return parseInt(n, 10);
  } else
    return n;
}
const zr = /* @__PURE__ */ new Map();
function mm() {
  zr.clear();
}
function dn({ numberingSystem: e }, n = "") {
  const t = e || "latn";
  let a = zr.get(t);
  a === void 0 && (a = /* @__PURE__ */ new Map(), zr.set(t, a));
  let s = a.get(n);
  return s === void 0 && (s = new RegExp(`${ci[t]}${n}`), a.set(n, s)), s;
}
let no = () => Date.now(), ao = "system", so = null, lo = null, ro = null, io = 60, oo, uo = null;
class pt {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return no;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    no = n;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(n) {
    ao = n;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Qn(ao, Al.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return so;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(n) {
    so = n;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return lo;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(n) {
    lo = n;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return ro;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(n) {
    ro = n;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return uo;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(n) {
    uo = Wr(n);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return io;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(n) {
    io = n % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return oo;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(n) {
    oo = n;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    st.resetCache(), Hn.resetCache(), Oe.resetCache(), mm();
  }
}
class pn {
  constructor(n, t) {
    this.reason = n, this.explanation = t;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const pc = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], gc = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function sn(e, n) {
  return new pn(
    "unit out of range",
    `you specified ${n} (of type ${typeof n}) as a ${e}, which is invalid`
  );
}
function di(e, n, t) {
  const a = new Date(Date.UTC(e, n - 1, t));
  e < 100 && e >= 0 && a.setUTCFullYear(a.getUTCFullYear() - 1900);
  const s = a.getUTCDay();
  return s === 0 ? 7 : s;
}
function yc(e, n, t) {
  return t + (Fs(e) ? gc : pc)[n - 1];
}
function bc(e, n) {
  const t = Fs(e) ? gc : pc, a = t.findIndex((l) => l < n), s = n - t[a];
  return { month: a + 1, day: s };
}
function fi(e, n) {
  return (e - n + 7) % 7 + 1;
}
function bl(e, n = 4, t = 1) {
  const { year: a, month: s, day: l } = e, r = yc(a, s, l), i = fi(di(a, s, l), t);
  let o = Math.floor((r - i + 14 - n) / 7), u;
  return o < 1 ? (u = a - 1, o = Os(u, n, t)) : o > Os(a, n, t) ? (u = a + 1, o = 1) : u = a, { weekYear: u, weekNumber: o, weekday: i, ...Vl(e) };
}
function co(e, n = 4, t = 1) {
  const { weekYear: a, weekNumber: s, weekday: l } = e, r = fi(di(a, 1, n), t), i = za(a);
  let o = s * 7 + l - r - 7 + n, u;
  o < 1 ? (u = a - 1, o += za(u)) : o > i ? (u = a + 1, o -= za(a)) : u = a;
  const { month: c, day: f } = bc(u, o);
  return { year: u, month: c, day: f, ...Vl(e) };
}
function ir(e) {
  const { year: n, month: t, day: a } = e, s = yc(n, t, a);
  return { year: n, ordinal: s, ...Vl(e) };
}
function fo(e) {
  const { year: n, ordinal: t } = e, { month: a, day: s } = bc(n, t);
  return { year: n, month: a, day: s, ...Vl(e) };
}
function ho(e, n) {
  if (!Ne(e.localWeekday) || !Ne(e.localWeekNumber) || !Ne(e.localWeekYear)) {
    if (!Ne(e.weekday) || !Ne(e.weekNumber) || !Ne(e.weekYear))
      throw new Va(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Ne(e.localWeekday) || (e.weekday = e.localWeekday), Ne(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), Ne(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: n.getMinDaysInFirstWeek(),
      startOfWeek: n.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function vm(e, n = 4, t = 1) {
  const a = Pl(e.weekYear), s = ln(
    e.weekNumber,
    1,
    Os(e.weekYear, n, t)
  ), l = ln(e.weekday, 1, 7);
  return a ? s ? l ? !1 : sn("weekday", e.weekday) : sn("week", e.weekNumber) : sn("weekYear", e.weekYear);
}
function pm(e) {
  const n = Pl(e.year), t = ln(e.ordinal, 1, za(e.year));
  return n ? t ? !1 : sn("ordinal", e.ordinal) : sn("year", e.year);
}
function wc(e) {
  const n = Pl(e.year), t = ln(e.month, 1, 12), a = ln(e.day, 1, wl(e.year, e.month));
  return n ? t ? a ? !1 : sn("day", e.day) : sn("month", e.month) : sn("year", e.year);
}
function kc(e) {
  const { hour: n, minute: t, second: a, millisecond: s } = e, l = ln(n, 0, 23) || n === 24 && t === 0 && a === 0 && s === 0, r = ln(t, 0, 59), i = ln(a, 0, 59), o = ln(s, 0, 999);
  return l ? r ? i ? o ? !1 : sn("millisecond", s) : sn("second", a) : sn("minute", t) : sn("hour", n);
}
function Ne(e) {
  return typeof e > "u";
}
function ta(e) {
  return typeof e == "number";
}
function Pl(e) {
  return typeof e == "number" && e % 1 === 0;
}
function gm(e) {
  return typeof e == "string";
}
function ym(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function xc() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Sc() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function bm(e) {
  return Array.isArray(e) ? e : [e];
}
function mo(e, n, t) {
  if (e.length !== 0)
    return e.reduce((a, s) => {
      const l = [n(s), s];
      return a && t(a[0], l[0]) === a[0] ? a : l;
    }, null)[1];
}
function wm(e, n) {
  return n.reduce((t, a) => (t[a] = e[a], t), {});
}
function Ga(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function Wr(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Ft("Week settings must be an object");
  if (!ln(e.firstDay, 1, 7) || !ln(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((n) => !ln(n, 1, 7)))
    throw new Ft("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function ln(e, n, t) {
  return Pl(e) && e >= n && e <= t;
}
function km(e, n) {
  return e - n * Math.floor(e / n);
}
function Mt(e, n = 2) {
  const t = e < 0;
  let a;
  return t ? a = "-" + ("" + -e).padStart(n, "0") : a = ("" + e).padStart(n, "0"), a;
}
function Jn(e) {
  if (!(Ne(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function oa(e) {
  if (!(Ne(e) || e === null || e === ""))
    return parseFloat(e);
}
function hi(e) {
  if (!(Ne(e) || e === null || e === "")) {
    const n = parseFloat("0." + e) * 1e3;
    return Math.floor(n);
  }
}
function mi(e, n, t = "round") {
  const a = 10 ** n;
  switch (t) {
    case "expand":
      return e > 0 ? Math.ceil(e * a) / a : Math.floor(e * a) / a;
    case "trunc":
      return Math.trunc(e * a) / a;
    case "round":
      return Math.round(e * a) / a;
    case "floor":
      return Math.floor(e * a) / a;
    case "ceil":
      return Math.ceil(e * a) / a;
    default:
      throw new RangeError(`Value rounding ${t} is out of range`);
  }
}
function Fs(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function za(e) {
  return Fs(e) ? 366 : 365;
}
function wl(e, n) {
  const t = km(n - 1, 12) + 1, a = e + (n - t) / 12;
  return t === 2 ? Fs(a) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][t - 1];
}
function Rl(e) {
  let n = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (n = new Date(n), n.setUTCFullYear(e.year, e.month - 1, e.day)), +n;
}
function vo(e, n, t) {
  return -fi(di(e, 1, n), t) + n - 1;
}
function Os(e, n = 4, t = 1) {
  const a = vo(e, n, t), s = vo(e + 1, n, t);
  return (za(e) - a + s) / 7;
}
function Yr(e) {
  return e > 99 ? e : e > pt.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function Tc(e, n, t, a = null) {
  const s = new Date(e), l = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  a && (l.timeZone = a);
  const r = { timeZoneName: n, ...l }, i = new Intl.DateTimeFormat(t, r).formatToParts(s).find((o) => o.type.toLowerCase() === "timezonename");
  return i ? i.value : null;
}
function Fl(e, n) {
  let t = parseInt(e, 10);
  Number.isNaN(t) && (t = 0);
  const a = parseInt(n, 10) || 0, s = t < 0 || Object.is(t, -0) ? -a : a;
  return t * 60 + s;
}
function $c(e) {
  const n = Number(e);
  if (typeof e == "boolean" || e === "" || !Number.isFinite(n))
    throw new Ft(`Invalid unit value ${e}`);
  return n;
}
function kl(e, n) {
  const t = {};
  for (const a in e)
    if (Ga(e, a)) {
      const s = e[a];
      if (s == null) continue;
      t[n(a)] = $c(s);
    }
  return t;
}
function Ts(e, n) {
  const t = Math.trunc(Math.abs(e / 60)), a = Math.trunc(Math.abs(e % 60)), s = e >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return `${s}${Mt(t, 2)}:${Mt(a, 2)}`;
    case "narrow":
      return `${s}${t}${a > 0 ? `:${a}` : ""}`;
    case "techie":
      return `${s}${Mt(t, 2)}${Mt(a, 2)}`;
    default:
      throw new RangeError(`Value format ${n} is out of range for property format`);
  }
}
function Vl(e) {
  return wm(e, ["hour", "minute", "second", "millisecond"]);
}
const xm = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Mc = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Sm = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Cc(e) {
  switch (e) {
    case "narrow":
      return [...Sm];
    case "short":
      return [...Mc];
    case "long":
      return [...xm];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Dc = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], _c = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], Tm = ["M", "T", "W", "T", "F", "S", "S"];
function Oc(e) {
  switch (e) {
    case "narrow":
      return [...Tm];
    case "short":
      return [..._c];
    case "long":
      return [...Dc];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Ec = ["AM", "PM"], $m = ["Before Christ", "Anno Domini"], Mm = ["BC", "AD"], Cm = ["B", "A"];
function Ic(e) {
  switch (e) {
    case "narrow":
      return [...Cm];
    case "short":
      return [...Mm];
    case "long":
      return [...$m];
    default:
      return null;
  }
}
function Dm(e) {
  return Ec[e.hour < 12 ? 0 : 1];
}
function _m(e, n) {
  return Oc(n)[e.weekday - 1];
}
function Om(e, n) {
  return Cc(n)[e.month - 1];
}
function Em(e, n) {
  return Ic(n)[e.year < 0 ? 0 : 1];
}
function Im(e, n, t = "always", a = !1) {
  const s = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, l = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (t === "auto" && l) {
    const f = e === "days";
    switch (n) {
      case 1:
        return f ? "tomorrow" : `next ${s[e][0]}`;
      case -1:
        return f ? "yesterday" : `last ${s[e][0]}`;
      case 0:
        return f ? "today" : `this ${s[e][0]}`;
    }
  }
  const r = Object.is(n, -0) || n < 0, i = Math.abs(n), o = i === 1, u = s[e], c = a ? o ? u[1] : u[2] || u[1] : o ? s[e][0] : e;
  return r ? `${i} ${c} ago` : `in ${i} ${c}`;
}
function po(e, n) {
  let t = "";
  for (const a of e)
    a.literal ? t += a.val : t += n(a.val);
  return t;
}
const Am = {
  D: yl,
  DD: Ku,
  DDD: Zu,
  DDDD: Xu,
  t: Ju,
  tt: Qu,
  ttt: ec,
  tttt: tc,
  T: nc,
  TT: ac,
  TTT: sc,
  TTTT: lc,
  f: rc,
  ff: oc,
  fff: cc,
  ffff: fc,
  F: ic,
  FF: uc,
  FFF: dc,
  FFFF: hc
};
class Vt {
  static create(n, t = {}) {
    return new Vt(n, t);
  }
  static parseFormat(n) {
    let t = null, a = "", s = !1;
    const l = [];
    for (let r = 0; r < n.length; r++) {
      const i = n.charAt(r);
      i === "'" ? ((a.length > 0 || s) && l.push({
        literal: s || /^\s+$/.test(a),
        val: a === "" ? "'" : a
      }), t = null, a = "", s = !s) : s || i === t ? a += i : (a.length > 0 && l.push({ literal: /^\s+$/.test(a), val: a }), a = i, t = i);
    }
    return a.length > 0 && l.push({ literal: s || /^\s+$/.test(a), val: a }), l;
  }
  static macroTokenToFormatOpts(n) {
    return Am[n];
  }
  constructor(n, t) {
    this.opts = t, this.loc = n, this.systemLoc = null;
  }
  formatWithSystemDefault(n, t) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(n, { ...this.opts, ...t }).format();
  }
  dtFormatter(n, t = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...t });
  }
  formatDateTime(n, t) {
    return this.dtFormatter(n, t).format();
  }
  formatDateTimeParts(n, t) {
    return this.dtFormatter(n, t).formatToParts();
  }
  formatInterval(n, t) {
    return this.dtFormatter(n.start, t).dtf.formatRange(n.start.toJSDate(), n.end.toJSDate());
  }
  resolvedOptions(n, t) {
    return this.dtFormatter(n, t).resolvedOptions();
  }
  num(n, t = 0, a = void 0) {
    if (this.opts.forceSimple)
      return Mt(n, t);
    const s = { ...this.opts };
    return t > 0 && (s.padTo = t), a && (s.signDisplay = a), this.loc.numberFormatter(s).format(n);
  }
  formatDateTimeFromString(n, t) {
    const a = this.loc.listingMode() === "en", s = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", l = (d, g) => this.loc.extract(n, d, g), r = (d) => n.isOffsetFixed && n.offset === 0 && d.allowZ ? "Z" : n.isValid ? n.zone.formatOffset(n.ts, d.format) : "", i = () => a ? Dm(n) : l({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), o = (d, g) => a ? Om(n, d) : l(g ? { month: d } : { month: d, day: "numeric" }, "month"), u = (d, g) => a ? _m(n, d) : l(
      g ? { weekday: d } : { weekday: d, month: "long", day: "numeric" },
      "weekday"
    ), c = (d) => {
      const g = Vt.macroTokenToFormatOpts(d);
      return g ? this.formatWithSystemDefault(n, g) : d;
    }, f = (d) => a ? Em(n, d) : l({ era: d }, "era"), p = (d) => {
      switch (d) {
        // ms
        case "S":
          return this.num(n.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(n.millisecond, 3);
        // seconds
        case "s":
          return this.num(n.second);
        case "ss":
          return this.num(n.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(n.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(n.millisecond / 100));
        // minutes
        case "m":
          return this.num(n.minute);
        case "mm":
          return this.num(n.minute, 2);
        // hours
        case "h":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12);
        case "hh":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12, 2);
        case "H":
          return this.num(n.hour);
        case "HH":
          return this.num(n.hour, 2);
        // offset
        case "Z":
          return r({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return r({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return r({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return n.zone.offsetName(n.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return n.zone.offsetName(n.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return n.zoneName;
        // meridiems
        case "a":
          return i();
        // dates
        case "d":
          return s ? l({ day: "numeric" }, "day") : this.num(n.day);
        case "dd":
          return s ? l({ day: "2-digit" }, "day") : this.num(n.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(n.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(n.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        // months - standalone
        case "L":
          return s ? l({ month: "numeric", day: "numeric" }, "month") : this.num(n.month);
        case "LL":
          return s ? l({ month: "2-digit", day: "numeric" }, "month") : this.num(n.month, 2);
        case "LLL":
          return o("short", !0);
        case "LLLL":
          return o("long", !0);
        case "LLLLL":
          return o("narrow", !0);
        // months - format
        case "M":
          return s ? l({ month: "numeric" }, "month") : this.num(n.month);
        case "MM":
          return s ? l({ month: "2-digit" }, "month") : this.num(n.month, 2);
        case "MMM":
          return o("short", !1);
        case "MMMM":
          return o("long", !1);
        case "MMMMM":
          return o("narrow", !1);
        // years
        case "y":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year);
        case "yy":
          return s ? l({ year: "2-digit" }, "year") : this.num(n.year.toString().slice(-2), 2);
        case "yyyy":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year, 4);
        case "yyyyyy":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year, 6);
        // eras
        case "G":
          return f("short");
        case "GG":
          return f("long");
        case "GGGGG":
          return f("narrow");
        case "kk":
          return this.num(n.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(n.weekYear, 4);
        case "W":
          return this.num(n.weekNumber);
        case "WW":
          return this.num(n.weekNumber, 2);
        case "n":
          return this.num(n.localWeekNumber);
        case "nn":
          return this.num(n.localWeekNumber, 2);
        case "ii":
          return this.num(n.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(n.localWeekYear, 4);
        case "o":
          return this.num(n.ordinal);
        case "ooo":
          return this.num(n.ordinal, 3);
        case "q":
          return this.num(n.quarter);
        case "qq":
          return this.num(n.quarter, 2);
        case "X":
          return this.num(Math.floor(n.ts / 1e3));
        case "x":
          return this.num(n.ts);
        default:
          return c(d);
      }
    };
    return po(Vt.parseFormat(t), p);
  }
  formatDurationFromString(n, t) {
    const a = this.opts.signMode === "negativeLargestOnly" ? -1 : 1, s = (c) => {
      switch (c[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, l = (c, f) => (p) => {
      const d = s(p);
      if (d) {
        const g = f.isNegativeDuration && d !== f.largestUnit ? a : 1;
        let v;
        return this.opts.signMode === "negativeLargestOnly" && d !== f.largestUnit ? v = "never" : this.opts.signMode === "all" ? v = "always" : v = "auto", this.num(c.get(d) * g, p.length, v);
      } else
        return p;
    }, r = Vt.parseFormat(t), i = r.reduce(
      (c, { literal: f, val: p }) => f ? c : c.concat(p),
      []
    ), o = n.shiftTo(...i.map(s).filter((c) => c)), u = {
      isNegativeDuration: o < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(o.values)[0]
    };
    return po(r, l(o, u));
  }
}
const Ac = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function ts(...e) {
  const n = e.reduce((t, a) => t + a.source, "");
  return RegExp(`^${n}$`);
}
function ns(...e) {
  return (n) => e.reduce(
    ([t, a, s], l) => {
      const [r, i, o] = l(n, s);
      return [{ ...t, ...r }, i || a, o];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function as(e, ...n) {
  if (e == null)
    return [null, null];
  for (const [t, a] of n) {
    const s = t.exec(e);
    if (s)
      return a(s);
  }
  return [null, null];
}
function Pc(...e) {
  return (n, t) => {
    const a = {};
    let s;
    for (s = 0; s < e.length; s++)
      a[e[s]] = Jn(n[t + s]);
    return [a, null, t + s];
  };
}
const Rc = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, Pm = `(?:${Rc.source}?(?:\\[(${Ac.source})\\])?)?`, vi = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Fc = RegExp(`${vi.source}${Pm}`), pi = RegExp(`(?:[Tt]${Fc.source})?`), Rm = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, Fm = /(\d{4})-?W(\d\d)(?:-?(\d))?/, Vm = /(\d{4})-?(\d{3})/, Lm = Pc("weekYear", "weekNumber", "weekDay"), Nm = Pc("year", "ordinal"), Bm = /(\d{4})-(\d\d)-(\d\d)/, Vc = RegExp(
  `${vi.source} ?(?:${Rc.source}|(${Ac.source}))?`
), zm = RegExp(`(?: ${Vc.source})?`);
function Wa(e, n, t) {
  const a = e[n];
  return Ne(a) ? t : Jn(a);
}
function Wm(e, n) {
  return [{
    year: Wa(e, n),
    month: Wa(e, n + 1, 1),
    day: Wa(e, n + 2, 1)
  }, null, n + 3];
}
function ss(e, n) {
  return [{
    hours: Wa(e, n, 0),
    minutes: Wa(e, n + 1, 0),
    seconds: Wa(e, n + 2, 0),
    milliseconds: hi(e[n + 3])
  }, null, n + 4];
}
function Vs(e, n) {
  const t = !e[n] && !e[n + 1], a = Fl(e[n + 1], e[n + 2]), s = t ? null : zt.instance(a);
  return [{}, s, n + 3];
}
function Ls(e, n) {
  const t = e[n] ? Hn.create(e[n]) : null;
  return [{}, t, n + 1];
}
const Ym = RegExp(`^T?${vi.source}$`), Hm = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function Um(e) {
  const [n, t, a, s, l, r, i, o, u] = e, c = n[0] === "-", f = o && o[0] === "-", p = (d, g = !1) => d !== void 0 && (g || d && c) ? -d : d;
  return [
    {
      years: p(oa(t)),
      months: p(oa(a)),
      weeks: p(oa(s)),
      days: p(oa(l)),
      hours: p(oa(r)),
      minutes: p(oa(i)),
      seconds: p(oa(o), o === "-0"),
      milliseconds: p(hi(u), f)
    }
  ];
}
const qm = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function gi(e, n, t, a, s, l, r) {
  const i = {
    year: n.length === 2 ? Yr(Jn(n)) : Jn(n),
    month: Mc.indexOf(t) + 1,
    day: Jn(a),
    hour: Jn(s),
    minute: Jn(l)
  };
  return r && (i.second = Jn(r)), e && (i.weekday = e.length > 3 ? Dc.indexOf(e) + 1 : _c.indexOf(e) + 1), i;
}
const jm = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Gm(e) {
  const [
    ,
    n,
    t,
    a,
    s,
    l,
    r,
    i,
    o,
    u,
    c,
    f
  ] = e, p = gi(n, s, a, t, l, r, i);
  let d;
  return o ? d = qm[o] : u ? d = 0 : d = Fl(c, f), [p, new zt(d)];
}
function Km(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const Zm = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, Xm = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Jm = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function go(e) {
  const [, n, t, a, s, l, r, i] = e;
  return [gi(n, s, a, t, l, r, i), zt.utcInstance];
}
function Qm(e) {
  const [, n, t, a, s, l, r, i] = e;
  return [gi(n, i, t, a, s, l, r), zt.utcInstance];
}
const ev = ts(Rm, pi), tv = ts(Fm, pi), nv = ts(Vm, pi), av = ts(Fc), Lc = ns(
  Wm,
  ss,
  Vs,
  Ls
), sv = ns(
  Lm,
  ss,
  Vs,
  Ls
), lv = ns(
  Nm,
  ss,
  Vs,
  Ls
), rv = ns(
  ss,
  Vs,
  Ls
);
function iv(e) {
  return as(
    e,
    [ev, Lc],
    [tv, sv],
    [nv, lv],
    [av, rv]
  );
}
function ov(e) {
  return as(Km(e), [jm, Gm]);
}
function uv(e) {
  return as(
    e,
    [Zm, go],
    [Xm, go],
    [Jm, Qm]
  );
}
function cv(e) {
  return as(e, [Hm, Um]);
}
const dv = ns(ss);
function fv(e) {
  return as(e, [Ym, dv]);
}
const hv = ts(Bm, zm), mv = ts(Vc), vv = ns(
  ss,
  Vs,
  Ls
);
function pv(e) {
  return as(
    e,
    [hv, Lc],
    [mv, vv]
  );
}
const yo = "Invalid Duration", Nc = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, gv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...Nc
}, Qt = 146097 / 400, _a = 146097 / 4800, yv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Qt / 7,
    days: Qt,
    hours: Qt * 24,
    minutes: Qt * 24 * 60,
    seconds: Qt * 24 * 60 * 60,
    milliseconds: Qt * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Qt / 28,
    days: Qt / 4,
    hours: Qt * 24 / 4,
    minutes: Qt * 24 * 60 / 4,
    seconds: Qt * 24 * 60 * 60 / 4,
    milliseconds: Qt * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: _a / 7,
    days: _a,
    hours: _a * 24,
    minutes: _a * 24 * 60,
    seconds: _a * 24 * 60 * 60,
    milliseconds: _a * 24 * 60 * 60 * 1e3
  },
  ...Nc
}, ma = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], bv = ma.slice(0).reverse();
function Bn(e, n, t = !1) {
  const a = {
    values: t ? n.values : { ...e.values, ...n.values || {} },
    loc: e.loc.clone(n.loc),
    conversionAccuracy: n.conversionAccuracy || e.conversionAccuracy,
    matrix: n.matrix || e.matrix
  };
  return new Je(a);
}
function Bc(e, n) {
  let t = n.milliseconds ?? 0;
  for (const a of bv.slice(1))
    n[a] && (t += n[a] * e[a].milliseconds);
  return t;
}
function bo(e, n) {
  const t = Bc(e, n) < 0 ? -1 : 1;
  ma.reduceRight((a, s) => {
    if (Ne(n[s]))
      return a;
    if (a) {
      const l = n[a] * t, r = e[s][a], i = Math.floor(l / r);
      n[s] += i * t, n[a] -= i * r * t;
    }
    return s;
  }, null), ma.reduce((a, s) => {
    if (Ne(n[s]))
      return a;
    if (a) {
      const l = n[a] % 1;
      n[a] -= l, n[s] += l * e[a][s];
    }
    return s;
  }, null);
}
function wo(e) {
  const n = {};
  for (const [t, a] of Object.entries(e))
    a !== 0 && (n[t] = a);
  return n;
}
class Je {
  /**
   * @private
   */
  constructor(n) {
    const t = n.conversionAccuracy === "longterm" || !1;
    let a = t ? yv : gv;
    n.matrix && (a = n.matrix), this.values = n.values, this.loc = n.loc || st.create(), this.conversionAccuracy = t ? "longterm" : "casual", this.invalid = n.invalid || null, this.matrix = a, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(n, t) {
    return Je.fromObject({ milliseconds: n }, t);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(n, t = {}) {
    if (n == null || typeof n != "object")
      throw new Ft(
        `Duration.fromObject: argument expected to be an object, got ${n === null ? "null" : typeof n}`
      );
    return new Je({
      values: kl(n, Je.normalizeUnit),
      loc: st.fromObject(t),
      conversionAccuracy: t.conversionAccuracy,
      matrix: t.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(n) {
    if (ta(n))
      return Je.fromMillis(n);
    if (Je.isDuration(n))
      return n;
    if (typeof n == "object")
      return Je.fromObject(n);
    throw new Ft(
      `Unknown duration argument ${n} of type ${typeof n}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(n, t) {
    const [a] = cv(n);
    return a ? Je.fromObject(a, t) : Je.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(n, t) {
    const [a] = fv(n);
    return a ? Je.fromObject(a, t) : Je.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Ft("need to specify a reason the Duration is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (pt.throwOnInvalid)
      throw new Uh(a);
    return new Je({ invalid: a });
  }
  /**
   * @private
   */
  static normalizeUnit(n) {
    const t = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[n && n.toLowerCase()];
    if (!t) throw new Gu(n);
    return t;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(n) {
    return n && n.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(n, t = {}) {
    const a = {
      ...t,
      floor: t.round !== !1 && t.floor !== !1
    };
    return this.isValid ? Vt.create(this.loc, a).formatDurationFromString(this, n) : yo;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(n = {}) {
    if (!this.isValid) return yo;
    const t = n.showZeros !== !1, a = ma.map((s) => {
      const l = this.values[s];
      return Ne(l) || l === 0 && !t ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...n, unit: s.slice(0, -1) }).format(l);
    }).filter((s) => s);
    return this.loc.listFormatter({ type: "conjunction", style: n.listStyle || "narrow", ...n }).format(a);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let n = "P";
    return this.years !== 0 && (n += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (n += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (n += this.weeks + "W"), this.days !== 0 && (n += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (n += "T"), this.hours !== 0 && (n += this.hours + "H"), this.minutes !== 0 && (n += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (n += mi(this.seconds + this.milliseconds / 1e3, 3) + "S"), n === "P" && (n += "T0S"), n;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(n = {}) {
    if (!this.isValid) return null;
    const t = this.toMillis();
    return t < 0 || t >= 864e5 ? null : (n = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...n,
      includeOffset: !1
    }, Oe.fromMillis(t, { zone: "UTC" }).toISOTime(n));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Bc(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n), a = {};
    for (const s of ma)
      (Ga(t.values, s) || Ga(this.values, s)) && (a[s] = t.get(s) + this.get(s));
    return Bn(this, { values: a }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n);
    return this.plus(t.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(n) {
    if (!this.isValid) return this;
    const t = {};
    for (const a of Object.keys(this.values))
      t[a] = $c(n(this.values[a], a));
    return Bn(this, { values: t }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(n) {
    return this[Je.normalizeUnit(n)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = { ...this.values, ...kl(n, Je.normalizeUnit) };
    return Bn(this, { values: t });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: n, numberingSystem: t, conversionAccuracy: a, matrix: s } = {}) {
    const r = { loc: this.loc.clone({ locale: n, numberingSystem: t }), matrix: s, conversionAccuracy: a };
    return Bn(this, r);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(n) {
    return this.isValid ? this.shiftTo(n).get(n) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const n = this.toObject();
    return bo(this.matrix, n), Bn(this, { values: n }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const n = wo(this.normalize().shiftToAll().toObject());
    return Bn(this, { values: n }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...n) {
    if (!this.isValid) return this;
    if (n.length === 0)
      return this;
    n = n.map((r) => Je.normalizeUnit(r));
    const t = {}, a = {}, s = this.toObject();
    let l;
    for (const r of ma)
      if (n.indexOf(r) >= 0) {
        l = r;
        let i = 0;
        for (const u in a)
          i += this.matrix[u][r] * a[u], a[u] = 0;
        ta(s[r]) && (i += s[r]);
        const o = Math.trunc(i);
        t[r] = o, a[r] = (i * 1e3 - o * 1e3) / 1e3;
      } else ta(s[r]) && (a[r] = s[r]);
    for (const r in a)
      a[r] !== 0 && (t[l] += r === l ? a[r] : a[r] / this.matrix[l][r]);
    return bo(this.matrix, t), Bn(this, { values: t }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const n = {};
    for (const t of Object.keys(this.values))
      n[t] = this.values[t] === 0 ? 0 : -this.values[t];
    return Bn(this, { values: n }, !0);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const n = wo(this.values);
    return Bn(this, { values: n }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(n) {
    if (!this.isValid || !n.isValid || !this.loc.equals(n.loc))
      return !1;
    function t(a, s) {
      return a === void 0 || a === 0 ? s === void 0 || s === 0 : a === s;
    }
    for (const a of ma)
      if (!t(this.values[a], n.values[a]))
        return !1;
    return !0;
  }
}
const Oa = "Invalid Interval";
function wv(e, n) {
  return !e || !e.isValid ? vt.invalid("missing or invalid start") : !n || !n.isValid ? vt.invalid("missing or invalid end") : n < e ? vt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${n.toISO()}`
  ) : null;
}
class vt {
  /**
   * @private
   */
  constructor(n) {
    this.s = n.start, this.e = n.end, this.invalid = n.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Ft("need to specify a reason the Interval is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (pt.throwOnInvalid)
      throw new Hh(a);
    return new vt({ invalid: a });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(n, t) {
    const a = hs(n), s = hs(t), l = wv(a, s);
    return l ?? new vt({
      start: a,
      end: s
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(n, t) {
    const a = Je.fromDurationLike(t), s = hs(n);
    return vt.fromDateTimes(s, s.plus(a));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(n, t) {
    const a = Je.fromDurationLike(t), s = hs(n);
    return vt.fromDateTimes(s.minus(a), s);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(n, t) {
    const [a, s] = (n || "").split("/", 2);
    if (a && s) {
      let l, r;
      try {
        l = Oe.fromISO(a, t), r = l.isValid;
      } catch {
        r = !1;
      }
      let i, o;
      try {
        i = Oe.fromISO(s, t), o = i.isValid;
      } catch {
        o = !1;
      }
      if (r && o)
        return vt.fromDateTimes(l, i);
      if (r) {
        const u = Je.fromISO(s, t);
        if (u.isValid)
          return vt.after(l, u);
      } else if (o) {
        const u = Je.fromISO(a, t);
        if (u.isValid)
          return vt.before(i, u);
      }
    }
    return vt.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(n) {
    return n && n.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(n = "milliseconds") {
    return this.isValid ? this.toDuration(n).get(n) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(n = "milliseconds", t) {
    if (!this.isValid) return NaN;
    const a = this.start.startOf(n, t);
    let s;
    return t != null && t.useLocaleWeeks ? s = this.end.reconfigure({ locale: a.locale }) : s = this.end, s = s.startOf(n, t), Math.floor(s.diff(a, n).get(n)) + (s.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(n) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, n) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(n) {
    return this.isValid ? this.s > n : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(n) {
    return this.isValid ? this.e <= n : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(n) {
    return this.isValid ? this.s <= n && this.e > n : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: n, end: t } = {}) {
    return this.isValid ? vt.fromDateTimes(n || this.s, t || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...n) {
    if (!this.isValid) return [];
    const t = n.map(hs).filter((r) => this.contains(r)).sort((r, i) => r.toMillis() - i.toMillis()), a = [];
    let { s } = this, l = 0;
    for (; s < this.e; ) {
      const r = t[l] || this.e, i = +r > +this.e ? this.e : r;
      a.push(vt.fromDateTimes(s, i)), s = i, l += 1;
    }
    return a;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(n) {
    const t = Je.fromDurationLike(n);
    if (!this.isValid || !t.isValid || t.as("milliseconds") === 0)
      return [];
    let { s: a } = this, s = 1, l;
    const r = [];
    for (; a < this.e; ) {
      const i = this.start.plus(t.mapUnits((o) => o * s));
      l = +i > +this.e ? this.e : i, r.push(vt.fromDateTimes(a, l)), a = l, s += 1;
    }
    return r;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(n) {
    return this.isValid ? this.splitBy(this.length() / n).slice(0, n) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(n) {
    return this.e > n.s && this.s < n.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(n) {
    return this.isValid ? +this.e == +n.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(n) {
    return this.isValid ? +n.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(n) {
    return this.isValid ? this.s <= n.s && this.e >= n.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(n) {
    return !this.isValid || !n.isValid ? !1 : this.s.equals(n.s) && this.e.equals(n.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(n) {
    if (!this.isValid) return this;
    const t = this.s > n.s ? this.s : n.s, a = this.e < n.e ? this.e : n.e;
    return t >= a ? null : vt.fromDateTimes(t, a);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(n) {
    if (!this.isValid) return this;
    const t = this.s < n.s ? this.s : n.s, a = this.e > n.e ? this.e : n.e;
    return vt.fromDateTimes(t, a);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(n) {
    const [t, a] = n.sort((s, l) => s.s - l.s).reduce(
      ([s, l], r) => l ? l.overlaps(r) || l.abutsStart(r) ? [s, l.union(r)] : [s.concat([l]), r] : [s, r],
      [[], null]
    );
    return a && t.push(a), t;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(n) {
    let t = null, a = 0;
    const s = [], l = n.map((o) => [
      { time: o.s, type: "s" },
      { time: o.e, type: "e" }
    ]), r = Array.prototype.concat(...l), i = r.sort((o, u) => o.time - u.time);
    for (const o of i)
      a += o.type === "s" ? 1 : -1, a === 1 ? t = o.time : (t && +t != +o.time && s.push(vt.fromDateTimes(t, o.time)), t = null);
    return vt.merge(s);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...n) {
    return vt.xor([this].concat(n)).map((t) => this.intersection(t)).filter((t) => t && !t.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Oa;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(n = yl, t = {}) {
    return this.isValid ? Vt.create(this.s.loc.clone(t), n).formatInterval(this) : Oa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(n) {
    return this.isValid ? `${this.s.toISO(n)}/${this.e.toISO(n)}` : Oa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Oa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(n) {
    return this.isValid ? `${this.s.toISOTime(n)}/${this.e.toISOTime(n)}` : Oa;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(n, { separator: t = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(n)}${t}${this.e.toFormat(n)}` : Oa;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(n, t) {
    return this.isValid ? this.e.diff(this.s, n, t) : Je.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(n) {
    return vt.fromDateTimes(n(this.s), n(this.e));
  }
}
class el {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(n = pt.defaultZone) {
    const t = Oe.now().setZone(n).set({ month: 12 });
    return !n.isUniversal && t.offset !== t.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(n) {
    return Hn.isValidZone(n);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(n) {
    return Qn(n, pt.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: l = "gregory" } = {}) {
    return (s || st.create(t, a, l)).months(n);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: l = "gregory" } = {}) {
    return (s || st.create(t, a, l)).months(n, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || st.create(t, a, null)).weekdays(n);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || st.create(t, a, null)).weekdays(n, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: n = null } = {}) {
    return st.create(n).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(n = "short", { locale: t = null } = {}) {
    return st.create(t, null, "gregory").eras(n);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: xc(), localeWeek: Sc() };
  }
}
function ko(e, n) {
  const t = (s) => s.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), a = t(n) - t(e);
  return Math.floor(Je.fromMillis(a).as("days"));
}
function kv(e, n, t) {
  const a = [
    ["years", (o, u) => u.year - o.year],
    ["quarters", (o, u) => u.quarter - o.quarter + (u.year - o.year) * 4],
    ["months", (o, u) => u.month - o.month + (u.year - o.year) * 12],
    [
      "weeks",
      (o, u) => {
        const c = ko(o, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", ko]
  ], s = {}, l = e;
  let r, i;
  for (const [o, u] of a)
    t.indexOf(o) >= 0 && (r = o, s[o] = u(e, n), i = l.plus(s), i > n ? (s[o]--, e = l.plus(s), e > n && (i = e, s[o]--, e = l.plus(s))) : e = i);
  return [e, s, i, r];
}
function xv(e, n, t, a) {
  let [s, l, r, i] = kv(e, n, t);
  const o = n - s, u = t.filter(
    (f) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(f) >= 0
  );
  u.length === 0 && (r < n && (r = s.plus({ [i]: 1 })), r !== s && (l[i] = (l[i] || 0) + o / (r - s)));
  const c = Je.fromObject(l, a);
  return u.length > 0 ? Je.fromMillis(o, a).shiftTo(...u).plus(c) : c;
}
const Sv = "missing Intl.DateTimeFormat.formatToParts support";
function nt(e, n = (t) => t) {
  return { regex: e, deser: ([t]) => n(hm(t)) };
}
const Tv = " ", zc = `[ ${Tv}]`, Wc = new RegExp(zc, "g");
function $v(e) {
  return e.replace(/\./g, "\\.?").replace(Wc, zc);
}
function xo(e) {
  return e.replace(/\./g, "").replace(Wc, " ").toLowerCase();
}
function fn(e, n) {
  return e === null ? null : {
    regex: RegExp(e.map($v).join("|")),
    deser: ([t]) => e.findIndex((a) => xo(t) === xo(a)) + n
  };
}
function So(e, n) {
  return { regex: e, deser: ([, t, a]) => Fl(t, a), groups: n };
}
function tl(e) {
  return { regex: e, deser: ([n]) => n };
}
function Mv(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Cv(e, n) {
  const t = dn(n), a = dn(n, "{2}"), s = dn(n, "{3}"), l = dn(n, "{4}"), r = dn(n, "{6}"), i = dn(n, "{1,2}"), o = dn(n, "{1,3}"), u = dn(n, "{1,6}"), c = dn(n, "{1,9}"), f = dn(n, "{2,4}"), p = dn(n, "{4,6}"), d = (k) => ({ regex: RegExp(Mv(k.val)), deser: ([y]) => y, literal: !0 }), v = ((k) => {
    if (e.literal)
      return d(k);
    switch (k.val) {
      // era
      case "G":
        return fn(n.eras("short"), 0);
      case "GG":
        return fn(n.eras("long"), 0);
      // years
      case "y":
        return nt(u);
      case "yy":
        return nt(f, Yr);
      case "yyyy":
        return nt(l);
      case "yyyyy":
        return nt(p);
      case "yyyyyy":
        return nt(r);
      // months
      case "M":
        return nt(i);
      case "MM":
        return nt(a);
      case "MMM":
        return fn(n.months("short", !0), 1);
      case "MMMM":
        return fn(n.months("long", !0), 1);
      case "L":
        return nt(i);
      case "LL":
        return nt(a);
      case "LLL":
        return fn(n.months("short", !1), 1);
      case "LLLL":
        return fn(n.months("long", !1), 1);
      // dates
      case "d":
        return nt(i);
      case "dd":
        return nt(a);
      // ordinals
      case "o":
        return nt(o);
      case "ooo":
        return nt(s);
      // time
      case "HH":
        return nt(a);
      case "H":
        return nt(i);
      case "hh":
        return nt(a);
      case "h":
        return nt(i);
      case "mm":
        return nt(a);
      case "m":
        return nt(i);
      case "q":
        return nt(i);
      case "qq":
        return nt(a);
      case "s":
        return nt(i);
      case "ss":
        return nt(a);
      case "S":
        return nt(o);
      case "SSS":
        return nt(s);
      case "u":
        return tl(c);
      case "uu":
        return tl(i);
      case "uuu":
        return nt(t);
      // meridiem
      case "a":
        return fn(n.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return nt(l);
      case "kk":
        return nt(f, Yr);
      // weekNumber (W)
      case "W":
        return nt(i);
      case "WW":
        return nt(a);
      // weekdays
      case "E":
      case "c":
        return nt(t);
      case "EEE":
        return fn(n.weekdays("short", !1), 1);
      case "EEEE":
        return fn(n.weekdays("long", !1), 1);
      case "ccc":
        return fn(n.weekdays("short", !0), 1);
      case "cccc":
        return fn(n.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return So(new RegExp(`([+-]${i.source})(?::(${a.source}))?`), 2);
      case "ZZZ":
        return So(new RegExp(`([+-]${i.source})(${a.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return tl(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return tl(/[^\S\n\r]/);
      default:
        return d(k);
    }
  })(e) || {
    invalidReason: Sv
  };
  return v.token = e, v;
}
const Dv = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function _v(e, n, t) {
  const { type: a, value: s } = e;
  if (a === "literal") {
    const o = /^\s+$/.test(s);
    return {
      literal: !o,
      val: o ? " " : s
    };
  }
  const l = n[a];
  let r = a;
  a === "hour" && (n.hour12 != null ? r = n.hour12 ? "hour12" : "hour24" : n.hourCycle != null ? n.hourCycle === "h11" || n.hourCycle === "h12" ? r = "hour12" : r = "hour24" : r = t.hour12 ? "hour12" : "hour24");
  let i = Dv[r];
  if (typeof i == "object" && (i = i[l]), i)
    return {
      literal: !1,
      val: i
    };
}
function Ov(e) {
  return [`^${e.map((t) => t.regex).reduce((t, a) => `${t}(${a.source})`, "")}$`, e];
}
function Ev(e, n, t) {
  const a = e.match(n);
  if (a) {
    const s = {};
    let l = 1;
    for (const r in t)
      if (Ga(t, r)) {
        const i = t[r], o = i.groups ? i.groups + 1 : 1;
        !i.literal && i.token && (s[i.token.val[0]] = i.deser(a.slice(l, l + o))), l += o;
      }
    return [a, s];
  } else
    return [a, {}];
}
function Iv(e) {
  const n = (l) => {
    switch (l) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let t = null, a;
  return Ne(e.z) || (t = Hn.create(e.z)), Ne(e.Z) || (t || (t = new zt(e.Z)), a = e.Z), Ne(e.q) || (e.M = (e.q - 1) * 3 + 1), Ne(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), Ne(e.u) || (e.S = hi(e.u)), [Object.keys(e).reduce((l, r) => {
    const i = n(r);
    return i && (l[i] = e[r]), l;
  }, {}), t, a];
}
let or = null;
function Av() {
  return or || (or = Oe.fromMillis(1555555555555)), or;
}
function Pv(e, n) {
  if (e.literal)
    return e;
  const t = Vt.macroTokenToFormatOpts(e.val), a = qc(t, n);
  return a == null || a.includes(void 0) ? e : a;
}
function Yc(e, n) {
  return Array.prototype.concat(...e.map((t) => Pv(t, n)));
}
class Hc {
  constructor(n, t) {
    if (this.locale = n, this.format = t, this.tokens = Yc(Vt.parseFormat(t), n), this.units = this.tokens.map((a) => Cv(a, n)), this.disqualifyingUnit = this.units.find((a) => a.invalidReason), !this.disqualifyingUnit) {
      const [a, s] = Ov(this.units);
      this.regex = RegExp(a, "i"), this.handlers = s;
    }
  }
  explainFromTokens(n) {
    if (this.isValid) {
      const [t, a] = Ev(n, this.regex, this.handlers), [s, l, r] = a ? Iv(a) : [null, null, void 0];
      if (Ga(a, "a") && Ga(a, "H"))
        throw new Va(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: n,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: t,
        matches: a,
        result: s,
        zone: l,
        specificOffset: r
      };
    } else
      return { input: n, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function Uc(e, n, t) {
  return new Hc(e, t).explainFromTokens(n);
}
function Rv(e, n, t) {
  const { result: a, zone: s, specificOffset: l, invalidReason: r } = Uc(e, n, t);
  return [a, s, l, r];
}
function qc(e, n) {
  if (!e)
    return null;
  const a = Vt.create(n, e).dtFormatter(Av()), s = a.formatToParts(), l = a.resolvedOptions();
  return s.map((r) => _v(r, e, l));
}
const ur = "Invalid DateTime", To = 864e13;
function ks(e) {
  return new pn("unsupported zone", `the zone "${e.name}" is not supported`);
}
function cr(e) {
  return e.weekData === null && (e.weekData = bl(e.c)), e.weekData;
}
function dr(e) {
  return e.localWeekData === null && (e.localWeekData = bl(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function ua(e, n) {
  const t = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new Oe({ ...t, ...n, old: t });
}
function jc(e, n, t) {
  let a = e - n * 60 * 1e3;
  const s = t.offset(a);
  if (n === s)
    return [a, n];
  a -= (s - n) * 60 * 1e3;
  const l = t.offset(a);
  return s === l ? [a, s] : [e - Math.min(s, l) * 60 * 1e3, Math.max(s, l)];
}
function nl(e, n) {
  e += n * 60 * 1e3;
  const t = new Date(e);
  return {
    year: t.getUTCFullYear(),
    month: t.getUTCMonth() + 1,
    day: t.getUTCDate(),
    hour: t.getUTCHours(),
    minute: t.getUTCMinutes(),
    second: t.getUTCSeconds(),
    millisecond: t.getUTCMilliseconds()
  };
}
function hl(e, n, t) {
  return jc(Rl(e), n, t);
}
function $o(e, n) {
  const t = e.o, a = e.c.year + Math.trunc(n.years), s = e.c.month + Math.trunc(n.months) + Math.trunc(n.quarters) * 3, l = {
    ...e.c,
    year: a,
    month: s,
    day: Math.min(e.c.day, wl(a, s)) + Math.trunc(n.days) + Math.trunc(n.weeks) * 7
  }, r = Je.fromObject({
    years: n.years - Math.trunc(n.years),
    quarters: n.quarters - Math.trunc(n.quarters),
    months: n.months - Math.trunc(n.months),
    weeks: n.weeks - Math.trunc(n.weeks),
    days: n.days - Math.trunc(n.days),
    hours: n.hours,
    minutes: n.minutes,
    seconds: n.seconds,
    milliseconds: n.milliseconds
  }).as("milliseconds"), i = Rl(l);
  let [o, u] = jc(i, t, e.zone);
  return r !== 0 && (o += r, u = e.zone.offset(o)), { ts: o, o: u };
}
function Ea(e, n, t, a, s, l) {
  const { setZone: r, zone: i } = t;
  if (e && Object.keys(e).length !== 0 || n) {
    const o = n || i, u = Oe.fromObject(e, {
      ...t,
      zone: o,
      specificOffset: l
    });
    return r ? u : u.setZone(i);
  } else
    return Oe.invalid(
      new pn("unparsable", `the input "${s}" can't be parsed as ${a}`)
    );
}
function al(e, n, t = !0) {
  return e.isValid ? Vt.create(st.create("en-US"), {
    allowZ: t,
    forceSimple: !0
  }).formatDateTimeFromString(e, n) : null;
}
function fr(e, n, t) {
  const a = e.c.year > 9999 || e.c.year < 0;
  let s = "";
  if (a && e.c.year >= 0 && (s += "+"), s += Mt(e.c.year, a ? 6 : 4), t === "year") return s;
  if (n) {
    if (s += "-", s += Mt(e.c.month), t === "month") return s;
    s += "-";
  } else if (s += Mt(e.c.month), t === "month") return s;
  return s += Mt(e.c.day), s;
}
function Mo(e, n, t, a, s, l, r) {
  let i = !t || e.c.millisecond !== 0 || e.c.second !== 0, o = "";
  switch (r) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      if (o += Mt(e.c.hour), r === "hour") break;
      if (n) {
        if (o += ":", o += Mt(e.c.minute), r === "minute") break;
        i && (o += ":", o += Mt(e.c.second));
      } else {
        if (o += Mt(e.c.minute), r === "minute") break;
        i && (o += Mt(e.c.second));
      }
      if (r === "second") break;
      i && (!a || e.c.millisecond !== 0) && (o += ".", o += Mt(e.c.millisecond, 3));
  }
  return s && (e.isOffsetFixed && e.offset === 0 && !l ? o += "Z" : e.o < 0 ? (o += "-", o += Mt(Math.trunc(-e.o / 60)), o += ":", o += Mt(Math.trunc(-e.o % 60))) : (o += "+", o += Mt(Math.trunc(e.o / 60)), o += ":", o += Mt(Math.trunc(e.o % 60)))), l && (o += "[" + e.zone.ianaName + "]"), o;
}
const Gc = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Fv = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Vv = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ml = ["year", "month", "day", "hour", "minute", "second", "millisecond"], Lv = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], Nv = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function vl(e) {
  const n = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!n) throw new Gu(e);
  return n;
}
function Co(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return vl(e);
  }
}
function Bv(e) {
  if (xs === void 0 && (xs = pt.now()), e.type !== "iana")
    return e.offset(xs);
  const n = e.name;
  let t = Hr.get(n);
  return t === void 0 && (t = e.offset(xs), Hr.set(n, t)), t;
}
function Do(e, n) {
  const t = Qn(n.zone, pt.defaultZone);
  if (!t.isValid)
    return Oe.invalid(ks(t));
  const a = st.fromObject(n);
  let s, l;
  if (Ne(e.year))
    s = pt.now();
  else {
    for (const o of ml)
      Ne(e[o]) && (e[o] = Gc[o]);
    const r = wc(e) || kc(e);
    if (r)
      return Oe.invalid(r);
    const i = Bv(t);
    [s, l] = hl(e, i, t);
  }
  return new Oe({ ts: s, zone: t, loc: a, o: l });
}
function _o(e, n, t) {
  const a = Ne(t.round) ? !0 : t.round, s = Ne(t.rounding) ? "trunc" : t.rounding, l = (i, o) => (i = mi(i, a || t.calendary ? 0 : 2, t.calendary ? "round" : s), n.loc.clone(t).relFormatter(t).format(i, o)), r = (i) => t.calendary ? n.hasSame(e, i) ? 0 : n.startOf(i).diff(e.startOf(i), i).get(i) : n.diff(e, i).get(i);
  if (t.unit)
    return l(r(t.unit), t.unit);
  for (const i of t.units) {
    const o = r(i);
    if (Math.abs(o) >= 1)
      return l(o, i);
  }
  return l(e > n ? -0 : 0, t.units[t.units.length - 1]);
}
function Oo(e) {
  let n = {}, t;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (n = e[e.length - 1], t = Array.from(e).slice(0, e.length - 1)) : t = Array.from(e), [n, t];
}
let xs;
const Hr = /* @__PURE__ */ new Map();
class Oe {
  /**
   * @access private
   */
  constructor(n) {
    const t = n.zone || pt.defaultZone;
    let a = n.invalid || (Number.isNaN(n.ts) ? new pn("invalid input") : null) || (t.isValid ? null : ks(t));
    this.ts = Ne(n.ts) ? pt.now() : n.ts;
    let s = null, l = null;
    if (!a)
      if (n.old && n.old.ts === this.ts && n.old.zone.equals(t))
        [s, l] = [n.old.c, n.old.o];
      else {
        const i = ta(n.o) && !n.old ? n.o : t.offset(this.ts);
        s = nl(this.ts, i), a = Number.isNaN(s.year) ? new pn("invalid input") : null, s = a ? null : s, l = a ? null : i;
      }
    this._zone = t, this.loc = n.loc || st.create(), this.invalid = a, this.weekData = null, this.localWeekData = null, this.c = s, this.o = l, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new Oe({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [n, t] = Oo(arguments), [a, s, l, r, i, o, u] = t;
    return Do({ year: a, month: s, day: l, hour: r, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [n, t] = Oo(arguments), [a, s, l, r, i, o, u] = t;
    return n.zone = zt.utcInstance, Do({ year: a, month: s, day: l, hour: r, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(n, t = {}) {
    const a = ym(n) ? n.valueOf() : NaN;
    if (Number.isNaN(a))
      return Oe.invalid("invalid input");
    const s = Qn(t.zone, pt.defaultZone);
    return s.isValid ? new Oe({
      ts: a,
      zone: s,
      loc: st.fromObject(t)
    }) : Oe.invalid(ks(s));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(n, t = {}) {
    if (ta(n))
      return n < -To || n > To ? Oe.invalid("Timestamp out of range") : new Oe({
        ts: n,
        zone: Qn(t.zone, pt.defaultZone),
        loc: st.fromObject(t)
      });
    throw new Ft(
      `fromMillis requires a numerical input, but received a ${typeof n} with value ${n}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(n, t = {}) {
    if (ta(n))
      return new Oe({
        ts: n * 1e3,
        zone: Qn(t.zone, pt.defaultZone),
        loc: st.fromObject(t)
      });
    throw new Ft("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(n, t = {}) {
    n = n || {};
    const a = Qn(t.zone, pt.defaultZone);
    if (!a.isValid)
      return Oe.invalid(ks(a));
    const s = st.fromObject(t), l = kl(n, Co), { minDaysInFirstWeek: r, startOfWeek: i } = ho(l, s), o = pt.now(), u = Ne(t.specificOffset) ? a.offset(o) : t.specificOffset, c = !Ne(l.ordinal), f = !Ne(l.year), p = !Ne(l.month) || !Ne(l.day), d = f || p, g = l.weekYear || l.weekNumber;
    if ((d || c) && g)
      throw new Va(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (p && c)
      throw new Va("Can't mix ordinal dates with month/day");
    const v = g || l.weekday && !d;
    let k, y, h = nl(o, u);
    v ? (k = Lv, y = Fv, h = bl(h, r, i)) : c ? (k = Nv, y = Vv, h = ir(h)) : (k = ml, y = Gc);
    let w = !1;
    for (const D of k) {
      const B = l[D];
      Ne(B) ? w ? l[D] = y[D] : l[D] = h[D] : w = !0;
    }
    const S = v ? vm(l, r, i) : c ? pm(l) : wc(l), x = S || kc(l);
    if (x)
      return Oe.invalid(x);
    const C = v ? co(l, r, i) : c ? fo(l) : l, [_, O] = hl(C, u, a), P = new Oe({
      ts: _,
      zone: a,
      o: O,
      loc: s
    });
    return l.weekday && d && n.weekday !== P.weekday ? Oe.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${l.weekday} and a date of ${P.toISO()}`
    ) : P.isValid ? P : Oe.invalid(P.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(n, t = {}) {
    const [a, s] = iv(n);
    return Ea(a, s, t, "ISO 8601", n);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(n, t = {}) {
    const [a, s] = ov(n);
    return Ea(a, s, t, "RFC 2822", n);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(n, t = {}) {
    const [a, s] = uv(n);
    return Ea(a, s, t, "HTTP", t);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(n, t, a = {}) {
    if (Ne(n) || Ne(t))
      throw new Ft("fromFormat requires an input string and a format");
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    }), [i, o, u, c] = Rv(r, n, t);
    return c ? Oe.invalid(c) : Ea(i, o, a, `format ${t}`, n, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(n, t, a = {}) {
    return Oe.fromFormat(n, t, a);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(n, t = {}) {
    const [a, s] = pv(n);
    return Ea(a, s, t, "SQL", n);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Ft("need to specify a reason the DateTime is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (pt.throwOnInvalid)
      throw new Yh(a);
    return new Oe({ invalid: a });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(n) {
    return n && n.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(n, t = {}) {
    const a = qc(n, st.fromObject(t));
    return a ? a.map((s) => s ? s.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(n, t = {}) {
    return Yc(Vt.parseFormat(n), st.fromObject(t)).map((s) => s.val).join("");
  }
  static resetCache() {
    xs = void 0, Hr.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(n) {
    return this[n];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? cr(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? cr(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? cr(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? dr(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? dr(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? dr(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? ir(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? el.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? el.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? el.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? el.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const n = 864e5, t = 6e4, a = Rl(this.c), s = this.zone.offset(a - n), l = this.zone.offset(a + n), r = this.zone.offset(a - s * t), i = this.zone.offset(a - l * t);
    if (r === i)
      return [this];
    const o = a - r * t, u = a - i * t, c = nl(o, r), f = nl(u, i);
    return c.hour === f.hour && c.minute === f.minute && c.second === f.second && c.millisecond === f.millisecond ? [ua(this, { ts: o }), ua(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Fs(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return wl(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? za(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? Os(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? Os(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(n = {}) {
    const { locale: t, numberingSystem: a, calendar: s } = Vt.create(
      this.loc.clone(n),
      n
    ).resolvedOptions(this);
    return { locale: t, numberingSystem: a, outputCalendar: s };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(n = 0, t = {}) {
    return this.setZone(zt.instance(n), t);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(pt.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(n, { keepLocalTime: t = !1, keepCalendarTime: a = !1 } = {}) {
    if (n = Qn(n, pt.defaultZone), n.equals(this.zone))
      return this;
    if (n.isValid) {
      let s = this.ts;
      if (t || a) {
        const l = n.offset(this.ts), r = this.toObject();
        [s] = hl(r, l, n);
      }
      return ua(this, { ts: s, zone: n });
    } else
      return Oe.invalid(ks(n));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: n, numberingSystem: t, outputCalendar: a } = {}) {
    const s = this.loc.clone({ locale: n, numberingSystem: t, outputCalendar: a });
    return ua(this, { loc: s });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(n) {
    return this.reconfigure({ locale: n });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = kl(n, Co), { minDaysInFirstWeek: a, startOfWeek: s } = ho(t, this.loc), l = !Ne(t.weekYear) || !Ne(t.weekNumber) || !Ne(t.weekday), r = !Ne(t.ordinal), i = !Ne(t.year), o = !Ne(t.month) || !Ne(t.day), u = i || o, c = t.weekYear || t.weekNumber;
    if ((u || r) && c)
      throw new Va(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (o && r)
      throw new Va("Can't mix ordinal dates with month/day");
    let f;
    l ? f = co(
      { ...bl(this.c, a, s), ...t },
      a,
      s
    ) : Ne(t.ordinal) ? (f = { ...this.toObject(), ...t }, Ne(t.day) && (f.day = Math.min(wl(f.year, f.month), f.day))) : f = fo({ ...ir(this.c), ...t });
    const [p, d] = hl(f, this.o, this.zone);
    return ua(this, { ts: p, o: d });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n);
    return ua(this, $o(this, t));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n).negate();
    return ua(this, $o(this, t));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(n, { useLocaleWeeks: t = !1 } = {}) {
    if (!this.isValid) return this;
    const a = {}, s = Je.normalizeUnit(n);
    switch (s) {
      case "years":
        a.month = 1;
      // falls through
      case "quarters":
      case "months":
        a.day = 1;
      // falls through
      case "weeks":
      case "days":
        a.hour = 0;
      // falls through
      case "hours":
        a.minute = 0;
      // falls through
      case "minutes":
        a.second = 0;
      // falls through
      case "seconds":
        a.millisecond = 0;
        break;
    }
    if (s === "weeks")
      if (t) {
        const l = this.loc.getStartOfWeek(), { weekday: r } = this;
        r < l && (a.weekNumber = this.weekNumber - 1), a.weekday = l;
      } else
        a.weekday = 1;
    if (s === "quarters") {
      const l = Math.ceil(this.month / 3);
      a.month = (l - 1) * 3 + 1;
    }
    return this.set(a);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(n, t) {
    return this.isValid ? this.plus({ [n]: 1 }).startOf(n, t).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(n, t = {}) {
    return this.isValid ? Vt.create(this.loc.redefaultToEN(t)).formatDateTimeFromString(this, n) : ur;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(n = yl, t = {}) {
    return this.isValid ? Vt.create(this.loc.clone(t), n).formatDateTime(this) : ur;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(n = {}) {
    return this.isValid ? Vt.create(this.loc.clone(n), n).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format: n = "extended",
    suppressSeconds: t = !1,
    suppressMilliseconds: a = !1,
    includeOffset: s = !0,
    extendedZone: l = !1,
    precision: r = "milliseconds"
  } = {}) {
    if (!this.isValid)
      return null;
    r = vl(r);
    const i = n === "extended";
    let o = fr(this, i, r);
    return ml.indexOf(r) >= 3 && (o += "T"), o += Mo(
      this,
      i,
      t,
      a,
      s,
      l,
      r
    ), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format: n = "extended", precision: t = "day" } = {}) {
    return this.isValid ? fr(this, n === "extended", vl(t)) : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return al(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: n = !1,
    suppressSeconds: t = !1,
    includeOffset: a = !0,
    includePrefix: s = !1,
    extendedZone: l = !1,
    format: r = "extended",
    precision: i = "milliseconds"
  } = {}) {
    return this.isValid ? (i = vl(i), (s && ml.indexOf(i) >= 3 ? "T" : "") + Mo(
      this,
      r === "extended",
      t,
      n,
      a,
      l,
      i
    )) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return al(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return al(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? fr(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: n = !0, includeZone: t = !1, includeOffsetSpace: a = !0 } = {}) {
    let s = "HH:mm:ss.SSS";
    return (t || n) && (a && (s += " "), t ? s += "z" : n && (s += "ZZ")), al(this, s, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(n = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(n)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : ur;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(n = {}) {
    if (!this.isValid) return {};
    const t = { ...this.c };
    return n.includeConfig && (t.outputCalendar = this.outputCalendar, t.numberingSystem = this.loc.numberingSystem, t.locale = this.loc.locale), t;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(n, t = "milliseconds", a = {}) {
    if (!this.isValid || !n.isValid)
      return Je.invalid("created by diffing an invalid DateTime");
    const s = { locale: this.locale, numberingSystem: this.numberingSystem, ...a }, l = bm(t).map(Je.normalizeUnit), r = n.valueOf() > this.valueOf(), i = r ? this : n, o = r ? n : this, u = xv(i, o, l, s);
    return r ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(n = "milliseconds", t = {}) {
    return this.diff(Oe.now(), n, t);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(n) {
    return this.isValid ? vt.fromDateTimes(this, n) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(n, t, a) {
    if (!this.isValid) return !1;
    const s = n.valueOf(), l = this.setZone(n.zone, { keepLocalTime: !0 });
    return l.startOf(t, a) <= s && s <= l.endOf(t, a);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(n) {
    return this.isValid && n.isValid && this.valueOf() === n.valueOf() && this.zone.equals(n.zone) && this.loc.equals(n.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(n = {}) {
    if (!this.isValid) return null;
    const t = n.base || Oe.fromObject({}, { zone: this.zone }), a = n.padding ? this < t ? -n.padding : n.padding : 0;
    let s = ["years", "months", "days", "hours", "minutes", "seconds"], l = n.unit;
    return Array.isArray(n.unit) && (s = n.unit, l = void 0), _o(t, this.plus(a), {
      ...n,
      numeric: "always",
      units: s,
      unit: l
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(n = {}) {
    return this.isValid ? _o(n.base || Oe.fromObject({}, { zone: this.zone }), this, {
      ...n,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...n) {
    if (!n.every(Oe.isDateTime))
      throw new Ft("min requires all arguments be DateTimes");
    return mo(n, (t) => t.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...n) {
    if (!n.every(Oe.isDateTime))
      throw new Ft("max requires all arguments be DateTimes");
    return mo(n, (t) => t.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(n, t, a = {}) {
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    });
    return Uc(r, n, t);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(n, t, a = {}) {
    return Oe.fromFormatExplain(n, t, a);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(n, t = {}) {
    const { locale: a = null, numberingSystem: s = null } = t, l = st.fromOpts({
      locale: a,
      numberingSystem: s,
      defaultToEN: !0
    });
    return new Hc(l, n);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(n, t, a = {}) {
    if (Ne(n) || Ne(t))
      throw new Ft(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    });
    if (!r.equals(t.locale))
      throw new Ft(
        `fromFormatParser called with a locale of ${r}, but the format parser was created for ${t.locale}`
      );
    const { result: i, zone: o, specificOffset: u, invalidReason: c } = t.explainFromTokens(n);
    return c ? Oe.invalid(c) : Ea(
      i,
      o,
      a,
      `format ${t.format}`,
      n,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return yl;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Ku;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return qh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return Zu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return Xu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Ju;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return Qu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return ec;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return tc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return nc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return ac;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return sc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return lc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return rc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return ic;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return oc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return uc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return jh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return cc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return dc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return fc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return hc;
  }
}
function hs(e) {
  if (Oe.isDateTime(e))
    return e;
  if (e && e.valueOf && ta(e.valueOf()))
    return Oe.fromJSDate(e);
  if (e && typeof e == "object")
    return Oe.fromObject(e);
  throw new Ft(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const zv = ["datetime", "title"], Wv = {
  key: 1,
  class: "text-secondaryText"
}, RD = /* @__PURE__ */ xe({
  __name: "VDate",
  props: {
    value: { default: null },
    format: { default: "MM/dd/yyyy, h:mm a" }
  },
  setup(e) {
    const n = M(() => {
      if (!e.value) return null;
      const s = Oe.fromISO(e.value).toLocal();
      return s.isValid ? s : null;
    }), t = M(() => {
      var s;
      return ((s = n.value) == null ? void 0 : s.toFormat(e.format)) ?? "—";
    }), a = M(() => {
      if (!e.value) return;
      const s = Oe.fromISO(e.value, { zone: "utc" });
      return s.isValid ? `${s.toFormat("yyyy-MM-dd HH:mm:ss")} UTC` : e.value;
    });
    return (s, l) => e.value ? (b(), $("time", {
      key: 0,
      datetime: e.value,
      title: a.value
    }, ie(t.value), 9, zv)) : (b(), $("span", Wv, "—"));
  }
}), Yv = { class: "v-checkbox" }, Hv = ["id", "disabled", "value"], Uv = ["for"], qv = /* @__PURE__ */ xe({
  __name: "VCheckbox",
  props: {
    modelValue: { type: [Boolean, Array] },
    id: {},
    label: {},
    value: { type: [String, Number, Boolean] },
    disabled: { type: Boolean },
    indeterminate: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = As(), l = M(() => t.id || s), r = M({
      get() {
        return t.modelValue;
      },
      set(o) {
        o !== void 0 && a("update:modelValue", o);
      }
    }), i = ee(null);
    return Gt(() => {
      i.value && (i.value.indeterminate = !!t.indeterminate);
    }), (o, u) => (b(), $("div", Yv, [
      an(E("input", lt({
        id: l.value,
        ref_key: "inputRef",
        ref: i,
        "onUpdate:modelValue": u[0] || (u[0] = (c) => r.value = c),
        disabled: t.disabled,
        value: e.value,
        class: "v-checkbox__input",
        type: "checkbox"
      }, o.$attrs), null, 16, Hv), [
        [yf, r.value]
      ]),
      e.label || o.$slots.label ? (b(), $("label", {
        key: 0,
        class: X([
          "v-checkbox__label",
          { "v-checkbox__label--disabled": t.disabled }
        ]),
        for: t.disabled ? void 0 : l.value
      }, [
        Y(o.$slots, "label", {}, () => [
          Ye(ie(e.label), 1)
        ], !0)
      ], 10, Uv)) : F("", !0)
    ]));
  }
}), Kc = /* @__PURE__ */ Ue(qv, [["__scopeId", "data-v-914acca3"]]), jv = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Gv = Object.prototype.toString, Kv = (e) => Gv.call(e) === "[object Object]", sl = () => {
};
function hr(e) {
  return Array.isArray(e) ? e : [e];
}
function Zv(e, n, t) {
  return Be(e, n, {
    ...t,
    immediate: !0
  });
}
const Zc = jv ? window : void 0;
function Kt(e) {
  var n;
  const t = Qe(e);
  return (n = t == null ? void 0 : t.$el) !== null && n !== void 0 ? n : t;
}
function Ya(...e) {
  const n = (a, s, l, r) => (a.addEventListener(s, l, r), () => a.removeEventListener(s, l, r)), t = M(() => {
    const a = hr(Qe(e[0])).filter((s) => s != null);
    return a.every((s) => typeof s != "string") ? a : void 0;
  });
  return Zv(() => {
    var a, s;
    return [
      (a = (s = t.value) === null || s === void 0 ? void 0 : s.map((l) => Kt(l))) !== null && a !== void 0 ? a : [Zc].filter((l) => l != null),
      hr(Qe(t.value ? e[1] : e[0])),
      hr(m(t.value ? e[2] : e[1])),
      Qe(t.value ? e[3] : e[2])
    ];
  }, ([a, s, l, r], i, o) => {
    if (!(a != null && a.length) || !(s != null && s.length) || !(l != null && l.length)) return;
    const u = Kv(r) ? { ...r } : r, c = a.flatMap((f) => s.flatMap((p) => l.map((d) => n(f, p, d, u))));
    o(() => {
      c.forEach((f) => f());
    });
  }, { flush: "post" });
}
function Xv(e, n, t = {}) {
  const { window: a = Zc, ignore: s = [], capture: l = !0, detectIframe: r = !1, controls: i = !1 } = t;
  if (!a) return i ? {
    stop: sl,
    cancel: sl,
    trigger: sl
  } : sl;
  let o = !0;
  const u = (k) => Qe(s).some((y) => {
    if (typeof y == "string") return Array.from(a.document.querySelectorAll(y)).some((h) => h === k.target || k.composedPath().includes(h));
    {
      const h = Kt(y);
      return h && (k.target === h || k.composedPath().includes(h));
    }
  });
  function c(k) {
    const y = Qe(k);
    return y && y.$.subTree.shapeFlag === 16;
  }
  function f(k, y) {
    const h = Qe(k), w = h.$.subTree && h.$.subTree.children;
    return w == null || !Array.isArray(w) ? !1 : w.some((S) => S.el === y.target || y.composedPath().includes(S.el));
  }
  const p = (k) => {
    const y = Kt(e);
    if (k.target != null && !(!(y instanceof Element) && c(e) && f(e, k)) && !(!y || y === k.target || k.composedPath().includes(y))) {
      if ("detail" in k && k.detail === 0 && (o = !u(k)), !o) {
        o = !0;
        return;
      }
      n(k);
    }
  };
  let d = !1;
  const g = [
    Ya(a, "click", (k) => {
      d || (d = !0, setTimeout(() => {
        d = !1;
      }, 0), p(k));
    }, {
      passive: !0,
      capture: l
    }),
    Ya(a, "pointerdown", (k) => {
      const y = Kt(e);
      o = !u(k) && !!(y && !k.composedPath().includes(y));
    }, { passive: !0 }),
    r && Ya(a, "blur", (k) => {
      setTimeout(() => {
        var y;
        const h = Kt(e);
        ((y = a.document.activeElement) === null || y === void 0 ? void 0 : y.tagName) === "IFRAME" && !(h != null && h.contains(a.document.activeElement)) && n(k);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), v = () => g.forEach((k) => k());
  return i ? {
    stop: v,
    cancel: () => {
      o = !1;
    },
    trigger: (k) => {
      o = !0, p(k), o = !1;
    }
  } : v;
}
function Jv(e, n = {}) {
  const { threshold: t = 50, onSwipe: a, onSwipeEnd: s, onSwipeStart: l, passive: r = !0 } = n, i = wa({
    x: 0,
    y: 0
  }), o = wa({
    x: 0,
    y: 0
  }), u = M(() => i.x - o.x), c = M(() => i.y - o.y), { max: f, abs: p } = Math, d = M(() => f(p(u.value), p(c.value)) >= t), g = It(!1), v = M(() => d.value ? p(u.value) > p(c.value) ? u.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), k = (_) => [_.touches[0].clientX, _.touches[0].clientY], y = (_, O) => {
    i.x = _, i.y = O;
  }, h = (_, O) => {
    o.x = _, o.y = O;
  }, w = {
    passive: r,
    capture: !r
  }, S = (_) => {
    g.value && (s == null || s(_, v.value)), g.value = !1;
  }, x = [
    Ya(e, "touchstart", (_) => {
      if (_.touches.length !== 1) return;
      const [O, P] = k(_);
      y(O, P), h(O, P), l == null || l(_);
    }, w),
    Ya(e, "touchmove", (_) => {
      if (_.touches.length !== 1) return;
      const [O, P] = k(_);
      h(O, P), w.capture && !w.passive && Math.abs(u.value) > Math.abs(c.value) && _.preventDefault(), !g.value && d.value && (g.value = !0), g.value && (a == null || a(_));
    }, w),
    Ya(e, ["touchend", "touchcancel"], S, w)
  ];
  return {
    isSwiping: g,
    direction: v,
    coordsStart: i,
    coordsEnd: o,
    lengthX: u,
    lengthY: c,
    stop: () => x.forEach((_) => _())
  };
}
const Ka = Math.min, ya = Math.max, xl = Math.round, ll = Math.floor, Dn = (e) => ({
  x: e,
  y: e
}), Qv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ep = {
  start: "end",
  end: "start"
};
function Ur(e, n, t) {
  return ya(e, Ka(n, t));
}
function Ns(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function ka(e) {
  return e.split("-")[0];
}
function Bs(e) {
  return e.split("-")[1];
}
function Xc(e) {
  return e === "x" ? "y" : "x";
}
function yi(e) {
  return e === "y" ? "height" : "width";
}
const tp = /* @__PURE__ */ new Set(["top", "bottom"]);
function ea(e) {
  return tp.has(ka(e)) ? "y" : "x";
}
function bi(e) {
  return Xc(ea(e));
}
function np(e, n, t) {
  t === void 0 && (t = !1);
  const a = Bs(e), s = bi(e), l = yi(s);
  let r = s === "x" ? a === (t ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return n.reference[l] > n.floating[l] && (r = Sl(r)), [r, Sl(r)];
}
function ap(e) {
  const n = Sl(e);
  return [qr(e), n, qr(n)];
}
function qr(e) {
  return e.replace(/start|end/g, (n) => ep[n]);
}
const Eo = ["left", "right"], Io = ["right", "left"], sp = ["top", "bottom"], lp = ["bottom", "top"];
function rp(e, n, t) {
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? Io : Eo : n ? Eo : Io;
    case "left":
    case "right":
      return n ? sp : lp;
    default:
      return [];
  }
}
function ip(e, n, t, a) {
  const s = Bs(e);
  let l = rp(ka(e), t === "start", a);
  return s && (l = l.map((r) => r + "-" + s), n && (l = l.concat(l.map(qr)))), l;
}
function Sl(e) {
  return e.replace(/left|right|bottom|top/g, (n) => Qv[n]);
}
function op(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Jc(e) {
  return typeof e != "number" ? op(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Tl(e) {
  const {
    x: n,
    y: t,
    width: a,
    height: s
  } = e;
  return {
    width: a,
    height: s,
    top: t,
    left: n,
    right: n + a,
    bottom: t + s,
    x: n,
    y: t
  };
}
function Ao(e, n, t) {
  let {
    reference: a,
    floating: s
  } = e;
  const l = ea(n), r = bi(n), i = yi(r), o = ka(n), u = l === "y", c = a.x + a.width / 2 - s.width / 2, f = a.y + a.height / 2 - s.height / 2, p = a[i] / 2 - s[i] / 2;
  let d;
  switch (o) {
    case "top":
      d = {
        x: c,
        y: a.y - s.height
      };
      break;
    case "bottom":
      d = {
        x: c,
        y: a.y + a.height
      };
      break;
    case "right":
      d = {
        x: a.x + a.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: a.x - s.width,
        y: f
      };
      break;
    default:
      d = {
        x: a.x,
        y: a.y
      };
  }
  switch (Bs(n)) {
    case "start":
      d[r] -= p * (t && u ? -1 : 1);
      break;
    case "end":
      d[r] += p * (t && u ? -1 : 1);
      break;
  }
  return d;
}
async function up(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: a,
    y: s,
    platform: l,
    rects: r,
    elements: i,
    strategy: o
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: d = 0
  } = Ns(n, e), g = Jc(d), k = i[p ? f === "floating" ? "reference" : "floating" : f], y = Tl(await l.getClippingRect({
    element: (t = await (l.isElement == null ? void 0 : l.isElement(k))) == null || t ? k : k.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: o
  })), h = f === "floating" ? {
    x: a,
    y: s,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, w = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(i.floating)), S = await (l.isElement == null ? void 0 : l.isElement(w)) ? await (l.getScale == null ? void 0 : l.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Tl(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: h,
    offsetParent: w,
    strategy: o
  }) : h);
  return {
    top: (y.top - x.top + g.top) / S.y,
    bottom: (x.bottom - y.bottom + g.bottom) / S.y,
    left: (y.left - x.left + g.left) / S.x,
    right: (x.right - y.right + g.right) / S.x
  };
}
const cp = async (e, n, t) => {
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: l = [],
    platform: r
  } = t, i = l.filter(Boolean), o = await (r.isRTL == null ? void 0 : r.isRTL(n));
  let u = await r.getElementRects({
    reference: e,
    floating: n,
    strategy: s
  }), {
    x: c,
    y: f
  } = Ao(u, a, o), p = a, d = {}, g = 0;
  for (let k = 0; k < i.length; k++) {
    var v;
    const {
      name: y,
      fn: h
    } = i[k], {
      x: w,
      y: S,
      data: x,
      reset: C
    } = await h({
      x: c,
      y: f,
      initialPlacement: a,
      placement: p,
      strategy: s,
      middlewareData: d,
      rects: u,
      platform: {
        ...r,
        detectOverflow: (v = r.detectOverflow) != null ? v : up
      },
      elements: {
        reference: e,
        floating: n
      }
    });
    c = w ?? c, f = S ?? f, d = {
      ...d,
      [y]: {
        ...d[y],
        ...x
      }
    }, C && g <= 50 && (g++, typeof C == "object" && (C.placement && (p = C.placement), C.rects && (u = C.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: n,
      strategy: s
    }) : C.rects), {
      x: c,
      y: f
    } = Ao(u, p, o)), k = -1);
  }
  return {
    x: c,
    y: f,
    placement: p,
    strategy: s,
    middlewareData: d
  };
}, dp = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: a,
      placement: s,
      rects: l,
      platform: r,
      elements: i,
      middlewareData: o
    } = n, {
      element: u,
      padding: c = 0
    } = Ns(e, n) || {};
    if (u == null)
      return {};
    const f = Jc(c), p = {
      x: t,
      y: a
    }, d = bi(s), g = yi(d), v = await r.getDimensions(u), k = d === "y", y = k ? "top" : "left", h = k ? "bottom" : "right", w = k ? "clientHeight" : "clientWidth", S = l.reference[g] + l.reference[d] - p[d] - l.floating[g], x = p[d] - l.reference[d], C = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(u));
    let _ = C ? C[w] : 0;
    (!_ || !await (r.isElement == null ? void 0 : r.isElement(C))) && (_ = i.floating[w] || l.floating[g]);
    const O = S / 2 - x / 2, P = _ / 2 - v[g] / 2 - 1, D = Ka(f[y], P), B = Ka(f[h], P), W = D, H = _ - v[g] - B, te = _ / 2 - v[g] / 2 + O, re = Ur(W, te, H), oe = !o.arrow && Bs(s) != null && te !== re && l.reference[g] / 2 - (te < W ? D : B) - v[g] / 2 < 0, K = oe ? te < W ? te - W : te - H : 0;
    return {
      [d]: p[d] + K,
      data: {
        [d]: re,
        centerOffset: te - re - K,
        ...oe && {
          alignmentOffset: K
        }
      },
      reset: oe
    };
  }
}), fp = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, a;
      const {
        placement: s,
        middlewareData: l,
        rects: r,
        initialPlacement: i,
        platform: o,
        elements: u
      } = n, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...k
      } = Ns(e, n);
      if ((t = l.arrow) != null && t.alignmentOffset)
        return {};
      const y = ka(s), h = ea(i), w = ka(i) === i, S = await (o.isRTL == null ? void 0 : o.isRTL(u.floating)), x = p || (w || !v ? [Sl(i)] : ap(i)), C = g !== "none";
      !p && C && x.push(...ip(i, v, g, S));
      const _ = [i, ...x], O = await o.detectOverflow(n, k), P = [];
      let D = ((a = l.flip) == null ? void 0 : a.overflows) || [];
      if (c && P.push(O[y]), f) {
        const te = np(s, r, S);
        P.push(O[te[0]], O[te[1]]);
      }
      if (D = [...D, {
        placement: s,
        overflows: P
      }], !P.every((te) => te <= 0)) {
        var B, W;
        const te = (((B = l.flip) == null ? void 0 : B.index) || 0) + 1, re = _[te];
        if (re && (!(f === "alignment" ? h !== ea(re) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((ae) => ea(ae.placement) === h ? ae.overflows[0] > 0 : !0)))
          return {
            data: {
              index: te,
              overflows: D
            },
            reset: {
              placement: re
            }
          };
        let oe = (W = D.filter((K) => K.overflows[0] <= 0).sort((K, ae) => K.overflows[1] - ae.overflows[1])[0]) == null ? void 0 : W.placement;
        if (!oe)
          switch (d) {
            case "bestFit": {
              var H;
              const K = (H = D.filter((ae) => {
                if (C) {
                  const U = ea(ae.placement);
                  return U === h || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  U === "y";
                }
                return !0;
              }).map((ae) => [ae.placement, ae.overflows.filter((U) => U > 0).reduce((U, z) => U + z, 0)]).sort((ae, U) => ae[1] - U[1])[0]) == null ? void 0 : H[0];
              K && (oe = K);
              break;
            }
            case "initialPlacement":
              oe = i;
              break;
          }
        if (s !== oe)
          return {
            reset: {
              placement: oe
            }
          };
      }
      return {};
    }
  };
}, hp = /* @__PURE__ */ new Set(["left", "top"]);
async function mp(e, n) {
  const {
    placement: t,
    platform: a,
    elements: s
  } = e, l = await (a.isRTL == null ? void 0 : a.isRTL(s.floating)), r = ka(t), i = Bs(t), o = ea(t) === "y", u = hp.has(r) ? -1 : 1, c = l && o ? -1 : 1, f = Ns(n, e);
  let {
    mainAxis: p,
    crossAxis: d,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof g == "number" && (d = i === "end" ? g * -1 : g), o ? {
    x: d * c,
    y: p * u
  } : {
    x: p * u,
    y: d * c
  };
}
const vp = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, a;
      const {
        x: s,
        y: l,
        placement: r,
        middlewareData: i
      } = n, o = await mp(n, e);
      return r === ((t = i.offset) == null ? void 0 : t.placement) && (a = i.arrow) != null && a.alignmentOffset ? {} : {
        x: s + o.x,
        y: l + o.y,
        data: {
          ...o,
          placement: r
        }
      };
    }
  };
}, pp = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: a,
        placement: s,
        platform: l
      } = n, {
        mainAxis: r = !0,
        crossAxis: i = !1,
        limiter: o = {
          fn: (y) => {
            let {
              x: h,
              y: w
            } = y;
            return {
              x: h,
              y: w
            };
          }
        },
        ...u
      } = Ns(e, n), c = {
        x: t,
        y: a
      }, f = await l.detectOverflow(n, u), p = ea(ka(s)), d = Xc(p);
      let g = c[d], v = c[p];
      if (r) {
        const y = d === "y" ? "top" : "left", h = d === "y" ? "bottom" : "right", w = g + f[y], S = g - f[h];
        g = Ur(w, g, S);
      }
      if (i) {
        const y = p === "y" ? "top" : "left", h = p === "y" ? "bottom" : "right", w = v + f[y], S = v - f[h];
        v = Ur(w, v, S);
      }
      const k = o.fn({
        ...n,
        [d]: g,
        [p]: v
      });
      return {
        ...k,
        data: {
          x: k.x - t,
          y: k.y - a,
          enabled: {
            [d]: r,
            [p]: i
          }
        }
      };
    }
  };
};
function Ll() {
  return typeof window < "u";
}
function Ta(e) {
  return wi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Xt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Rn(e) {
  var n;
  return (n = (wi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function wi(e) {
  return Ll() ? e instanceof Node || e instanceof Xt(e).Node : !1;
}
function wn(e) {
  return Ll() ? e instanceof Element || e instanceof Xt(e).Element : !1;
}
function In(e) {
  return Ll() ? e instanceof HTMLElement || e instanceof Xt(e).HTMLElement : !1;
}
function Po(e) {
  return !Ll() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Xt(e).ShadowRoot;
}
const gp = /* @__PURE__ */ new Set(["inline", "contents"]);
function zs(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: a,
    display: s
  } = kn(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + a + t) && !gp.has(s);
}
const yp = /* @__PURE__ */ new Set(["table", "td", "th"]);
function bp(e) {
  return yp.has(Ta(e));
}
const wp = [":popover-open", ":modal"];
function Nl(e) {
  return wp.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
const kp = ["transform", "translate", "scale", "rotate", "perspective"], xp = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Sp = ["paint", "layout", "strict", "content"];
function ki(e) {
  const n = xi(), t = wn(e) ? kn(e) : e;
  return kp.some((a) => t[a] ? t[a] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || xp.some((a) => (t.willChange || "").includes(a)) || Sp.some((a) => (t.contain || "").includes(a));
}
function Tp(e) {
  let n = na(e);
  for (; In(n) && !Za(n); ) {
    if (ki(n))
      return n;
    if (Nl(n))
      return null;
    n = na(n);
  }
  return null;
}
function xi() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const $p = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Za(e) {
  return $p.has(Ta(e));
}
function kn(e) {
  return Xt(e).getComputedStyle(e);
}
function Bl(e) {
  return wn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function na(e) {
  if (Ta(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Po(e) && e.host || // Fallback.
    Rn(e)
  );
  return Po(n) ? n.host : n;
}
function Qc(e) {
  const n = na(e);
  return Za(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : In(n) && zs(n) ? n : Qc(n);
}
function Es(e, n, t) {
  var a;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const s = Qc(e), l = s === ((a = e.ownerDocument) == null ? void 0 : a.body), r = Xt(s);
  if (l) {
    const i = jr(r);
    return n.concat(r, r.visualViewport || [], zs(s) ? s : [], i && t ? Es(i) : []);
  }
  return n.concat(s, Es(s, [], t));
}
function jr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ed(e) {
  const n = kn(e);
  let t = parseFloat(n.width) || 0, a = parseFloat(n.height) || 0;
  const s = In(e), l = s ? e.offsetWidth : t, r = s ? e.offsetHeight : a, i = xl(t) !== l || xl(a) !== r;
  return i && (t = l, a = r), {
    width: t,
    height: a,
    $: i
  };
}
function Si(e) {
  return wn(e) ? e : e.contextElement;
}
function Ha(e) {
  const n = Si(e);
  if (!In(n))
    return Dn(1);
  const t = n.getBoundingClientRect(), {
    width: a,
    height: s,
    $: l
  } = ed(n);
  let r = (l ? xl(t.width) : t.width) / a, i = (l ? xl(t.height) : t.height) / s;
  return (!r || !Number.isFinite(r)) && (r = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: r,
    y: i
  };
}
const Mp = /* @__PURE__ */ Dn(0);
function td(e) {
  const n = Xt(e);
  return !xi() || !n.visualViewport ? Mp : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function Cp(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== Xt(e) ? !1 : n;
}
function xa(e, n, t, a) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const s = e.getBoundingClientRect(), l = Si(e);
  let r = Dn(1);
  n && (a ? wn(a) && (r = Ha(a)) : r = Ha(e));
  const i = Cp(l, t, a) ? td(l) : Dn(0);
  let o = (s.left + i.x) / r.x, u = (s.top + i.y) / r.y, c = s.width / r.x, f = s.height / r.y;
  if (l) {
    const p = Xt(l), d = a && wn(a) ? Xt(a) : a;
    let g = p, v = jr(g);
    for (; v && a && d !== g; ) {
      const k = Ha(v), y = v.getBoundingClientRect(), h = kn(v), w = y.left + (v.clientLeft + parseFloat(h.paddingLeft)) * k.x, S = y.top + (v.clientTop + parseFloat(h.paddingTop)) * k.y;
      o *= k.x, u *= k.y, c *= k.x, f *= k.y, o += w, u += S, g = Xt(v), v = jr(g);
    }
  }
  return Tl({
    width: c,
    height: f,
    x: o,
    y: u
  });
}
function zl(e, n) {
  const t = Bl(e).scrollLeft;
  return n ? n.left + t : xa(Rn(e)).left + t;
}
function nd(e, n) {
  const t = e.getBoundingClientRect(), a = t.left + n.scrollLeft - zl(e, t), s = t.top + n.scrollTop;
  return {
    x: a,
    y: s
  };
}
function Dp(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: a,
    strategy: s
  } = e;
  const l = s === "fixed", r = Rn(a), i = n ? Nl(n.floating) : !1;
  if (a === r || i && l)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Dn(1);
  const c = Dn(0), f = In(a);
  if ((f || !f && !l) && ((Ta(a) !== "body" || zs(r)) && (o = Bl(a)), In(a))) {
    const d = xa(a);
    u = Ha(a), c.x = d.x + a.clientLeft, c.y = d.y + a.clientTop;
  }
  const p = r && !f && !l ? nd(r, o) : Dn(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - o.scrollLeft * u.x + c.x + p.x,
    y: t.y * u.y - o.scrollTop * u.y + c.y + p.y
  };
}
function _p(e) {
  return Array.from(e.getClientRects());
}
function Op(e) {
  const n = Rn(e), t = Bl(e), a = e.ownerDocument.body, s = ya(n.scrollWidth, n.clientWidth, a.scrollWidth, a.clientWidth), l = ya(n.scrollHeight, n.clientHeight, a.scrollHeight, a.clientHeight);
  let r = -t.scrollLeft + zl(e);
  const i = -t.scrollTop;
  return kn(a).direction === "rtl" && (r += ya(n.clientWidth, a.clientWidth) - s), {
    width: s,
    height: l,
    x: r,
    y: i
  };
}
const Ro = 25;
function Ep(e, n) {
  const t = Xt(e), a = Rn(e), s = t.visualViewport;
  let l = a.clientWidth, r = a.clientHeight, i = 0, o = 0;
  if (s) {
    l = s.width, r = s.height;
    const c = xi();
    (!c || c && n === "fixed") && (i = s.offsetLeft, o = s.offsetTop);
  }
  const u = zl(a);
  if (u <= 0) {
    const c = a.ownerDocument, f = c.body, p = getComputedStyle(f), d = c.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, g = Math.abs(a.clientWidth - f.clientWidth - d);
    g <= Ro && (l -= g);
  } else u <= Ro && (l += u);
  return {
    width: l,
    height: r,
    x: i,
    y: o
  };
}
const Ip = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Ap(e, n) {
  const t = xa(e, !0, n === "fixed"), a = t.top + e.clientTop, s = t.left + e.clientLeft, l = In(e) ? Ha(e) : Dn(1), r = e.clientWidth * l.x, i = e.clientHeight * l.y, o = s * l.x, u = a * l.y;
  return {
    width: r,
    height: i,
    x: o,
    y: u
  };
}
function Fo(e, n, t) {
  let a;
  if (n === "viewport")
    a = Ep(e, t);
  else if (n === "document")
    a = Op(Rn(e));
  else if (wn(n))
    a = Ap(n, t);
  else {
    const s = td(e);
    a = {
      x: n.x - s.x,
      y: n.y - s.y,
      width: n.width,
      height: n.height
    };
  }
  return Tl(a);
}
function ad(e, n) {
  const t = na(e);
  return t === n || !wn(t) || Za(t) ? !1 : kn(t).position === "fixed" || ad(t, n);
}
function Pp(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let a = Es(e, [], !1).filter((i) => wn(i) && Ta(i) !== "body"), s = null;
  const l = kn(e).position === "fixed";
  let r = l ? na(e) : e;
  for (; wn(r) && !Za(r); ) {
    const i = kn(r), o = ki(r);
    !o && i.position === "fixed" && (s = null), (l ? !o && !s : !o && i.position === "static" && !!s && Ip.has(s.position) || zs(r) && !o && ad(e, r)) ? a = a.filter((c) => c !== r) : s = i, r = na(r);
  }
  return n.set(e, a), a;
}
function Rp(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: a,
    strategy: s
  } = e;
  const r = [...t === "clippingAncestors" ? Nl(n) ? [] : Pp(n, this._c) : [].concat(t), a], i = r[0], o = r.reduce((u, c) => {
    const f = Fo(n, c, s);
    return u.top = ya(f.top, u.top), u.right = Ka(f.right, u.right), u.bottom = Ka(f.bottom, u.bottom), u.left = ya(f.left, u.left), u;
  }, Fo(n, i, s));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function Fp(e) {
  const {
    width: n,
    height: t
  } = ed(e);
  return {
    width: n,
    height: t
  };
}
function Vp(e, n, t) {
  const a = In(n), s = Rn(n), l = t === "fixed", r = xa(e, !0, l, n);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const o = Dn(0);
  function u() {
    o.x = zl(s);
  }
  if (a || !a && !l)
    if ((Ta(n) !== "body" || zs(s)) && (i = Bl(n)), a) {
      const d = xa(n, !0, l, n);
      o.x = d.x + n.clientLeft, o.y = d.y + n.clientTop;
    } else s && u();
  l && !a && s && u();
  const c = s && !a && !l ? nd(s, i) : Dn(0), f = r.left + i.scrollLeft - o.x - c.x, p = r.top + i.scrollTop - o.y - c.y;
  return {
    x: f,
    y: p,
    width: r.width,
    height: r.height
  };
}
function mr(e) {
  return kn(e).position === "static";
}
function Vo(e, n) {
  if (!In(e) || kn(e).position === "fixed")
    return null;
  if (n)
    return n(e);
  let t = e.offsetParent;
  return Rn(e) === t && (t = t.ownerDocument.body), t;
}
function sd(e, n) {
  const t = Xt(e);
  if (Nl(e))
    return t;
  if (!In(e)) {
    let s = na(e);
    for (; s && !Za(s); ) {
      if (wn(s) && !mr(s))
        return s;
      s = na(s);
    }
    return t;
  }
  let a = Vo(e, n);
  for (; a && bp(a) && mr(a); )
    a = Vo(a, n);
  return a && Za(a) && mr(a) && !ki(a) ? t : a || Tp(e) || t;
}
const Lp = async function(e) {
  const n = this.getOffsetParent || sd, t = this.getDimensions, a = await t(e.floating);
  return {
    reference: Vp(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function Np(e) {
  return kn(e).direction === "rtl";
}
const Bp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Dp,
  getDocumentElement: Rn,
  getClippingRect: Rp,
  getOffsetParent: sd,
  getElementRects: Lp,
  getClientRects: _p,
  getDimensions: Fp,
  getScale: Ha,
  isElement: wn,
  isRTL: Np
};
function ld(e, n) {
  return e.x === n.x && e.y === n.y && e.width === n.width && e.height === n.height;
}
function zp(e, n) {
  let t = null, a;
  const s = Rn(e);
  function l() {
    var i;
    clearTimeout(a), (i = t) == null || i.disconnect(), t = null;
  }
  function r(i, o) {
    i === void 0 && (i = !1), o === void 0 && (o = 1), l();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: p,
      height: d
    } = u;
    if (i || n(), !p || !d)
      return;
    const g = ll(f), v = ll(s.clientWidth - (c + p)), k = ll(s.clientHeight - (f + d)), y = ll(c), w = {
      rootMargin: -g + "px " + -v + "px " + -k + "px " + -y + "px",
      threshold: ya(0, Ka(1, o)) || 1
    };
    let S = !0;
    function x(C) {
      const _ = C[0].intersectionRatio;
      if (_ !== o) {
        if (!S)
          return r();
        _ ? r(!1, _) : a = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      _ === 1 && !ld(u, e.getBoundingClientRect()) && r(), S = !1;
    }
    try {
      t = new IntersectionObserver(x, {
        ...w,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(x, w);
    }
    t.observe(e);
  }
  return r(!0), l;
}
function Wp(e, n, t, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: l = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: o = !1
  } = a, u = Si(e), c = s || l ? [...u ? Es(u) : [], ...Es(n)] : [];
  c.forEach((y) => {
    s && y.addEventListener("scroll", t, {
      passive: !0
    }), l && y.addEventListener("resize", t);
  });
  const f = u && i ? zp(u, t) : null;
  let p = -1, d = null;
  r && (d = new ResizeObserver((y) => {
    let [h] = y;
    h && h.target === u && d && (d.unobserve(n), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var w;
      (w = d) == null || w.observe(n);
    })), t();
  }), u && !o && d.observe(u), d.observe(n));
  let g, v = o ? xa(e) : null;
  o && k();
  function k() {
    const y = xa(e);
    v && !ld(v, y) && t(), v = y, g = requestAnimationFrame(k);
  }
  return t(), () => {
    var y;
    c.forEach((h) => {
      s && h.removeEventListener("scroll", t), l && h.removeEventListener("resize", t);
    }), f == null || f(), (y = d) == null || y.disconnect(), d = null, o && cancelAnimationFrame(g);
  };
}
const Yp = vp, Hp = pp, Up = fp, qp = dp, jp = (e, n, t) => {
  const a = /* @__PURE__ */ new Map(), s = {
    platform: Bp,
    ...t
  }, l = {
    ...s.platform,
    _c: a
  };
  return cp(e, n, {
    ...s,
    platform: l
  });
};
function Gp(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Gr(e) {
  if (Gp(e)) {
    const n = e.$el;
    return wi(n) && Ta(n) === "#comment" ? null : n;
  }
  return e;
}
function Fa(e) {
  return typeof e == "function" ? e() : m(e);
}
function Kp(e) {
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const t = Gr(Fa(e.element));
      return t == null ? {} : qp({
        element: t,
        padding: e.padding
      }).fn(n);
    }
  };
}
function rd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Lo(e, n) {
  const t = rd(e);
  return Math.round(n * t) / t;
}
function Zp(e, n, t) {
  t === void 0 && (t = {});
  const a = t.whileElementsMounted, s = M(() => {
    var _;
    return (_ = Fa(t.open)) != null ? _ : !0;
  }), l = M(() => Fa(t.middleware)), r = M(() => {
    var _;
    return (_ = Fa(t.placement)) != null ? _ : "bottom";
  }), i = M(() => {
    var _;
    return (_ = Fa(t.strategy)) != null ? _ : "absolute";
  }), o = M(() => {
    var _;
    return (_ = Fa(t.transform)) != null ? _ : !0;
  }), u = M(() => Gr(e.value)), c = M(() => Gr(n.value)), f = ee(0), p = ee(0), d = ee(i.value), g = ee(r.value), v = It({}), k = ee(!1), y = M(() => {
    const _ = {
      position: d.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return _;
    const O = Lo(c.value, f.value), P = Lo(c.value, p.value);
    return o.value ? {
      ..._,
      transform: "translate(" + O + "px, " + P + "px)",
      ...rd(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: d.value,
      left: O + "px",
      top: P + "px"
    };
  });
  let h;
  function w() {
    if (u.value == null || c.value == null)
      return;
    const _ = s.value;
    jp(u.value, c.value, {
      middleware: l.value,
      placement: r.value,
      strategy: i.value
    }).then((O) => {
      f.value = O.x, p.value = O.y, d.value = O.strategy, g.value = O.placement, v.value = O.middlewareData, k.value = _ !== !1;
    });
  }
  function S() {
    typeof h == "function" && (h(), h = void 0);
  }
  function x() {
    if (S(), a === void 0) {
      w();
      return;
    }
    if (u.value != null && c.value != null) {
      h = a(u.value, c.value, w);
      return;
    }
  }
  function C() {
    s.value || (k.value = !1);
  }
  return Be([l, r, i, s], w, {
    flush: "sync"
  }), Be([u, c], x, {
    flush: "sync"
  }), Be(s, C, {
    flush: "sync"
  }), $u() && Ol(S), {
    x: Da(f),
    y: Da(p),
    strategy: Da(d),
    placement: Da(g),
    middlewareData: Da(v),
    isPositioned: Da(k),
    floatingStyles: y,
    update: w
  };
}
const id = 6048e5, Xp = 864e5, Jp = 6e4, Qp = 36e5, eg = 1e3, No = Symbol.for("constructDateFrom");
function ot(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && No in e ? e[No](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function Le(e, n) {
  return ot(n || e, e);
}
function nn(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return isNaN(n) ? ot((t == null ? void 0 : t.in) || e, NaN) : (n && a.setDate(a.getDate() + n), a);
}
function gn(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  if (isNaN(n)) return ot(e, NaN);
  if (!n)
    return a;
  const s = a.getDate(), l = ot(e, a.getTime());
  l.setMonth(a.getMonth() + n + 1, 0);
  const r = l.getDate();
  return s >= r ? l : (a.setFullYear(
    l.getFullYear(),
    l.getMonth(),
    s
  ), a);
}
function od(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: l = 0,
    days: r = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = Le(e, t == null ? void 0 : t.in), f = s || a ? gn(c, s + a * 12) : c, p = r || l ? nn(f, r + l * 7) : f, d = o + i * 60, v = (u + d * 60) * 1e3;
  return ot(e, +p + v);
}
let tg = {};
function $a() {
  return tg;
}
function rn(e, n) {
  var i, o, u, c;
  const t = $a(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = Le(e, n == null ? void 0 : n.in), l = s.getDay(), r = (l < a ? 7 : 0) + l - a;
  return s.setDate(s.getDate() - r), s.setHours(0, 0, 0, 0), s;
}
function Xa(e, n) {
  return rn(e, { ...n, weekStartsOn: 1 });
}
function ud(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = ot(t, 0);
  s.setFullYear(a + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const l = Xa(s), r = ot(t, 0);
  r.setFullYear(a, 0, 4), r.setHours(0, 0, 0, 0);
  const i = Xa(r);
  return t.getTime() >= l.getTime() ? a + 1 : t.getTime() >= i.getTime() ? a : a - 1;
}
function $l(e) {
  const n = Le(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Ws(e, ...n) {
  const t = ot.bind(
    null,
    n.find((a) => typeof a == "object")
  );
  return n.map(t);
}
function Bo(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function cd(e, n, t) {
  const [a, s] = Ws(
    t == null ? void 0 : t.in,
    e,
    n
  ), l = Bo(a), r = Bo(s), i = +l - $l(l), o = +r - $l(r);
  return Math.round((i - o) / Xp);
}
function ng(e, n) {
  const t = ud(e, n), a = ot(e, 0);
  return a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0), Xa(a);
}
function ag(e, n, t) {
  return gn(e, n * 3, t);
}
function Ti(e, n, t) {
  return gn(e, n * 12, t);
}
function zo(e, n) {
  const t = +Le(e) - +Le(n);
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function dd(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function $s(e) {
  return !(!dd(e) && typeof e != "number" || isNaN(+Le(e)));
}
function Wo(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function sg(e, n, t) {
  const [a, s] = Ws(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return a.getFullYear() - s.getFullYear();
}
function lg(e) {
  return (n) => {
    const a = (e ? Math[e] : Math.trunc)(n);
    return a === 0 ? 0 : a;
  };
}
function rg(e, n, t) {
  const [a, s] = Ws(
    t == null ? void 0 : t.in,
    e,
    n
  ), l = zo(a, s), r = Math.abs(sg(a, s));
  a.setFullYear(1584), s.setFullYear(1584);
  const i = zo(a, s) === -l, o = l * (r - +i);
  return o === 0 ? 0 : o;
}
function fd(e, n) {
  const [t, a] = Ws(e, n.start, n.end);
  return { start: t, end: a };
}
function $i(e, n) {
  const { start: t, end: a } = fd(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const l = s ? +t : +a, r = s ? a : t;
  r.setHours(0, 0, 0, 0);
  let i = 1;
  const o = [];
  for (; +r <= l; )
    o.push(ot(t, r)), r.setDate(r.getDate() + i), r.setHours(0, 0, 0, 0);
  return s ? o.reverse() : o;
}
function va(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3;
  return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
}
function ig(e, n) {
  const { start: t, end: a } = fd(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const l = s ? +va(t) : +va(a);
  let r = va(s ? a : t), i = 1;
  const o = [];
  for (; +r <= l; )
    o.push(ot(t, r)), r = ag(r, i);
  return s ? o.reverse() : o;
}
function og(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function hd(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear();
  return t.setFullYear(a + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Ua(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Mi(e, n) {
  var i, o, u, c;
  const t = $a(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = Le(e, n == null ? void 0 : n.in), l = s.getDay(), r = (l < a ? -7 : 0) + 6 - (l - a);
  return s.setDate(s.getDate() + r), s.setHours(23, 59, 59, 999), s;
}
function Yo(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3 + 3;
  return t.setMonth(s, 0), t.setHours(23, 59, 59, 999), t;
}
const ug = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, cg = (e, n, t) => {
  let a;
  const s = ug[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
};
function vr(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const dg = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, fg = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hg = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mg = {
  date: vr({
    formats: dg,
    defaultWidth: "full"
  }),
  time: vr({
    formats: fg,
    defaultWidth: "full"
  }),
  dateTime: vr({
    formats: hg,
    defaultWidth: "full"
  })
}, vg = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, pg = (e, n, t, a) => vg[e];
function ms(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : r;
      s = e.formattingValues[i] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[r];
    }
    const l = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[l];
  };
}
const gg = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, yg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, bg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, wg = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, kg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, xg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Sg = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Tg = {
  ordinalNumber: Sg,
  era: ms({
    values: gg,
    defaultWidth: "wide"
  }),
  quarter: ms({
    values: yg,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ms({
    values: bg,
    defaultWidth: "wide"
  }),
  day: ms({
    values: wg,
    defaultWidth: "wide"
  }),
  dayPeriod: ms({
    values: kg,
    defaultWidth: "wide",
    formattingValues: xg,
    defaultFormattingWidth: "wide"
  })
};
function vs(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = n.match(s);
    if (!l)
      return null;
    const r = l[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? Mg(i, (f) => f.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      $g(i, (f) => f.test(r))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(r.length);
    return { value: u, rest: c };
  };
}
function $g(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Mg(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function Cg(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], l = n.match(e.parsePattern);
    if (!l) return null;
    let r = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    r = t.valueCallback ? t.valueCallback(r) : r;
    const i = n.slice(s.length);
    return { value: r, rest: i };
  };
}
const Dg = /^(\d+)(th|st|nd|rd)?/i, _g = /\d+/i, Og = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Eg = {
  any: [/^b/i, /^(a|c)/i]
}, Ig = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ag = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Pg = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Rg = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Fg = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Vg = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Lg = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ng = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Bg = {
  ordinalNumber: Cg({
    matchPattern: Dg,
    parsePattern: _g,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: vs({
    matchPatterns: Og,
    defaultMatchWidth: "wide",
    parsePatterns: Eg,
    defaultParseWidth: "any"
  }),
  quarter: vs({
    matchPatterns: Ig,
    defaultMatchWidth: "wide",
    parsePatterns: Ag,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: vs({
    matchPatterns: Pg,
    defaultMatchWidth: "wide",
    parsePatterns: Rg,
    defaultParseWidth: "any"
  }),
  day: vs({
    matchPatterns: Fg,
    defaultMatchWidth: "wide",
    parsePatterns: Vg,
    defaultParseWidth: "any"
  }),
  dayPeriod: vs({
    matchPatterns: Lg,
    defaultMatchWidth: "any",
    parsePatterns: Ng,
    defaultParseWidth: "any"
  })
}, md = {
  code: "en-US",
  formatDistance: cg,
  formatLong: mg,
  formatRelative: pg,
  localize: Tg,
  match: Bg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function zg(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return cd(t, Ua(t)) + 1;
}
function Ci(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = +Xa(t) - +ng(t);
  return Math.round(a / id) + 1;
}
function Di(e, n) {
  var c, f, p, d;
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = $a(), l = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((d = (p = s.locale) == null ? void 0 : p.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, r = ot((n == null ? void 0 : n.in) || e, 0);
  r.setFullYear(a + 1, 0, l), r.setHours(0, 0, 0, 0);
  const i = rn(r, n), o = ot((n == null ? void 0 : n.in) || e, 0);
  o.setFullYear(a, 0, l), o.setHours(0, 0, 0, 0);
  const u = rn(o, n);
  return +t >= +i ? a + 1 : +t >= +u ? a : a - 1;
}
function Wg(e, n) {
  var i, o, u, c;
  const t = $a(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = Di(e, n), l = ot((n == null ? void 0 : n.in) || e, 0);
  return l.setFullYear(s, 0, a), l.setHours(0, 0, 0, 0), rn(l, n);
}
function _i(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = +rn(t, n) - +Wg(t, n);
  return Math.round(a / id) + 1;
}
function it(e, n) {
  const t = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(n, "0");
  return t + a;
}
const Kn = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), a = t > 0 ? t : 1 - t;
    return it(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : it(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return it(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return it(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return it(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return it(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return it(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, a = e.getMilliseconds(), s = Math.trunc(
      a * Math.pow(10, t - 3)
    );
    return it(s, n.length);
  }
}, Ia = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ho = {
  // Era
  G: function(e, n, t) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(a, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const a = e.getFullYear(), s = a > 0 ? a : 1 - a;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return Kn.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, a) {
    const s = Di(e, a), l = s > 0 ? s : 1 - s;
    if (n === "YY") {
      const r = l % 100;
      return it(r, 2);
    }
    return n === "Yo" ? t.ordinalNumber(l, { unit: "year" }) : it(l, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = ud(e);
    return it(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return it(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return it(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return it(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Kn.M(e, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return it(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, a) {
    const s = _i(e, a);
    return n === "wo" ? t.ordinalNumber(s, { unit: "week" }) : it(s, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const a = Ci(e);
    return n === "Io" ? t.ordinalNumber(a, { unit: "week" }) : it(a, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Kn.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const a = zg(e);
    return n === "Do" ? t.ordinalNumber(a, { unit: "dayOfYear" }) : it(a, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const a = e.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, a) {
    const s = e.getDay(), l = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(l);
      // Padded numerical value
      case "ee":
        return it(l, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(l, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, a) {
    const s = e.getDay(), l = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(l);
      // Padded numerical value
      case "cc":
        return it(l, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const a = e.getDay(), s = a === 0 ? 7 : a;
    switch (n) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return it(s, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a === 12 ? s = Ia.noon : a === 0 ? s = Ia.midnight : s = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a >= 17 ? s = Ia.evening : a >= 12 ? s = Ia.afternoon : a >= 4 ? s = Ia.morning : s = Ia.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), t.ordinalNumber(a, { unit: "hour" });
    }
    return Kn.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Kn.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const a = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(a, { unit: "hour" }) : it(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let a = e.getHours();
    return a === 0 && (a = 24), n === "ko" ? t.ordinalNumber(a, { unit: "hour" }) : it(a, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Kn.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Kn.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Kn.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return qo(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return fa(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return fa(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return qo(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return fa(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return fa(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Uo(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + fa(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Uo(a, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + fa(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const a = Math.trunc(+e / 1e3);
    return it(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return it(+e, n.length);
  }
};
function Uo(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = Math.trunc(a / 60), l = a % 60;
  return l === 0 ? t + String(s) : t + String(s) + n + it(l, 2);
}
function qo(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + it(Math.abs(e) / 60, 2) : fa(e, n);
}
function fa(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = it(Math.trunc(a / 60), 2), l = it(a % 60, 2);
  return t + s + n + l;
}
const jo = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, vd = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, Yg = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], a = t[1], s = t[2];
  if (!s)
    return jo(e, n);
  let l;
  switch (a) {
    case "P":
      l = n.dateTime({ width: "short" });
      break;
    case "PP":
      l = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      l = n.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", jo(a, n)).replace("{{time}}", vd(s, n));
}, Kr = {
  p: vd,
  P: Yg
}, Hg = /^D+$/, Ug = /^Y+$/, qg = ["D", "DD", "YY", "YYYY"];
function pd(e) {
  return Hg.test(e);
}
function gd(e) {
  return Ug.test(e);
}
function Zr(e, n, t) {
  const a = jg(e, n, t);
  if (console.warn(a), qg.includes(e)) throw new RangeError(a);
}
function jg(e, n, t) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${a} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Gg = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Kg = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Zg = /^'([^]*?)'?$/, Xg = /''/g, Jg = /[a-zA-Z]/;
function tn(e, n, t) {
  var c, f, p, d, g, v, k, y;
  const a = $a(), s = (t == null ? void 0 : t.locale) ?? a.locale ?? md, l = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((d = (p = a.locale) == null ? void 0 : p.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, r = (t == null ? void 0 : t.weekStartsOn) ?? ((v = (g = t == null ? void 0 : t.locale) == null ? void 0 : g.options) == null ? void 0 : v.weekStartsOn) ?? a.weekStartsOn ?? ((y = (k = a.locale) == null ? void 0 : k.options) == null ? void 0 : y.weekStartsOn) ?? 0, i = Le(e, t == null ? void 0 : t.in);
  if (!$s(i))
    throw new RangeError("Invalid time value");
  let o = n.match(Kg).map((h) => {
    const w = h[0];
    if (w === "p" || w === "P") {
      const S = Kr[w];
      return S(h, s.formatLong);
    }
    return h;
  }).join("").match(Gg).map((h) => {
    if (h === "''")
      return { isToken: !1, value: "'" };
    const w = h[0];
    if (w === "'")
      return { isToken: !1, value: Qg(h) };
    if (Ho[w])
      return { isToken: !0, value: h };
    if (w.match(Jg))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: h };
  });
  s.localize.preprocessor && (o = s.localize.preprocessor(i, o));
  const u = {
    firstWeekContainsDate: l,
    weekStartsOn: r,
    locale: s
  };
  return o.map((h) => {
    if (!h.isToken) return h.value;
    const w = h.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && gd(w) || !(t != null && t.useAdditionalDayOfYearTokens) && pd(w)) && Zr(w, n, String(e));
    const S = Ho[w[0]];
    return S(i, w, s.localize, u);
  }).join("");
}
function Qg(e) {
  const n = e.match(Zg);
  return n ? n[1].replace(Xg, "'") : e;
}
function ey(e, n) {
  return Le(e, n == null ? void 0 : n.in).getDay();
}
function ty(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = t.getMonth(), l = ot(t, 0);
  return l.setFullYear(a, s + 1, 0), l.setHours(0, 0, 0, 0), l.getDate();
}
function ny() {
  return Object.assign({}, $a());
}
function An(e, n) {
  return Le(e, n == null ? void 0 : n.in).getHours();
}
function ay(e, n) {
  const t = Le(e, n == null ? void 0 : n.in).getDay();
  return t === 0 ? 7 : t;
}
function Un(e, n) {
  return Le(e, n == null ? void 0 : n.in).getMinutes();
}
function Ze(e, n) {
  return Le(e, n == null ? void 0 : n.in).getMonth();
}
function aa(e) {
  return Le(e).getSeconds();
}
function ze(e, n) {
  return Le(e, n == null ? void 0 : n.in).getFullYear();
}
function Mn(e, n) {
  return +Le(e) > +Le(n);
}
function Yn(e, n) {
  return +Le(e) < +Le(n);
}
function La(e, n) {
  return +Le(e) == +Le(n);
}
function sy(e, n) {
  const t = ly(n) ? new n(0) : ot(n, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function ly(e) {
  var n;
  return typeof e == "function" && ((n = e.prototype) == null ? void 0 : n.constructor) === e;
}
const ry = 10;
class yd {
  constructor() {
    ke(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class iy extends yd {
  constructor(n, t, a, s, l) {
    super(), this.value = n, this.validateValue = t, this.setValue = a, this.priority = s, l && (this.subPriority = l);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, a) {
    return this.setValue(n, t, this.value, a);
  }
}
class oy extends yd {
  constructor(t, a) {
    super();
    ke(this, "priority", ry);
    ke(this, "subPriority", -1);
    this.context = t || ((s) => ot(a, s));
  }
  set(t, a) {
    return a.timestampIsSet ? t : ot(t, sy(t, this.context));
  }
}
class at {
  run(n, t, a, s) {
    const l = this.parse(n, t, a, s);
    return l ? {
      setter: new iy(
        l.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: l.rest
    } : null;
  }
  validate(n, t, a) {
    return !0;
  }
}
class uy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 140);
    ke(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(t, { width: "wide" }) || s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
    }
  }
  set(t, a, s) {
    return a.era = s, t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const kt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Tn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function xt(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function mt(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function $n(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const a = t[1] === "+" ? 1 : -1, s = t[2] ? parseInt(t[2], 10) : 0, l = t[3] ? parseInt(t[3], 10) : 0, r = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: a * (s * Qp + l * Jp + r * eg),
    rest: n.slice(t[0].length)
  };
}
function bd(e) {
  return mt(kt.anyDigitsSigned, e);
}
function gt(e, n) {
  switch (e) {
    case 1:
      return mt(kt.singleDigit, n);
    case 2:
      return mt(kt.twoDigits, n);
    case 3:
      return mt(kt.threeDigits, n);
    case 4:
      return mt(kt.fourDigits, n);
    default:
      return mt(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function Ml(e, n) {
  switch (e) {
    case 1:
      return mt(kt.singleDigitSigned, n);
    case 2:
      return mt(kt.twoDigitsSigned, n);
    case 3:
      return mt(kt.threeDigitsSigned, n);
    case 4:
      return mt(kt.fourDigitsSigned, n);
    default:
      return mt(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function Oi(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function wd(e, n) {
  const t = n > 0, a = t ? n : 1 - n;
  let s;
  if (a <= 50)
    s = e || 100;
  else {
    const l = a + 50, r = Math.trunc(l / 100) * 100, i = e >= l % 100;
    s = e + r - (i ? 100 : 0);
  }
  return t ? s : 1 - s;
}
function kd(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class cy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 130);
    ke(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    const l = (r) => ({
      year: r,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return xt(gt(4, t), l);
      case "yo":
        return xt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return xt(gt(a.length, t), l);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s) {
    const l = t.getFullYear();
    if (s.isTwoDigitYear) {
      const i = wd(
        s.year,
        l
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const r = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class dy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 130);
    ke(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => ({
      year: r,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return xt(gt(4, t), l);
      case "Yo":
        return xt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return xt(gt(a.length, t), l);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s, l) {
    const r = Di(t, l);
    if (s.isTwoDigitYear) {
      const o = wd(
        s.year,
        r
      );
      return t.setFullYear(
        o,
        0,
        l.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), rn(t, l);
    }
    const i = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(i, 0, l.firstWeekContainsDate), t.setHours(0, 0, 0, 0), rn(t, l);
  }
}
class fy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 130);
    ke(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a) {
    return Ml(a === "R" ? 4 : a.length, t);
  }
  set(t, a, s) {
    const l = ot(t, 0);
    return l.setFullYear(s, 0, 4), l.setHours(0, 0, 0, 0), Xa(l);
  }
}
class hy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 130);
    ke(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a) {
    return Ml(a === "u" ? 4 : a.length, t);
  }
  set(t, a, s) {
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class my extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 120);
    ke(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return gt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class vy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 120);
    ke(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return gt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class py extends at {
  constructor() {
    super(...arguments);
    ke(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    ke(this, "priority", 110);
  }
  parse(t, a, s) {
    const l = (r) => r - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "M":
        return xt(
          mt(kt.month, t),
          l
        );
      // 01, 02, ..., 12
      case "MM":
        return xt(gt(2, t), l);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return xt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(t, { width: "wide", context: "formatting" }) || s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class gy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 110);
    ke(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => r - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return xt(
          mt(kt.month, t),
          l
        );
      // 01, 02, ..., 12
      case "LL":
        return xt(gt(2, t), l);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return xt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(t, { width: "wide", context: "standalone" }) || s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function yy(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = _i(a, t) - n;
  return a.setDate(a.getDate() - s * 7), Le(a, t == null ? void 0 : t.in);
}
class by extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 100);
    ke(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "w":
        return mt(kt.week, t);
      case "wo":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s, l) {
    return rn(yy(t, s, l), l);
  }
}
function wy(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = Ci(a, t) - n;
  return a.setDate(a.getDate() - s * 7), a;
}
class ky extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 100);
    ke(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "I":
        return mt(kt.week, t);
      case "Io":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s) {
    return Xa(wy(t, s));
  }
}
const xy = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Sy = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Ty extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 90);
    ke(this, "subPriority", 1);
    ke(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "d":
        return mt(kt.date, t);
      case "do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear(), l = kd(s), r = t.getMonth();
    return l ? a >= 1 && a <= Sy[r] : a >= 1 && a <= xy[r];
  }
  set(t, a, s) {
    return t.setDate(s), t.setHours(0, 0, 0, 0), t;
  }
}
class $y extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 90);
    ke(this, "subpriority", 1);
    ke(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "D":
      case "DD":
        return mt(kt.dayOfYear, t);
      case "Do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear();
    return kd(s) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(t, a, s) {
    return t.setMonth(0, s), t.setHours(0, 0, 0, 0), t;
  }
}
function Ei(e, n, t) {
  var f, p, d, g;
  const a = $a(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : p.weekStartsOn) ?? a.weekStartsOn ?? ((g = (d = a.locale) == null ? void 0 : d.options) == null ? void 0 : g.weekStartsOn) ?? 0, l = Le(e, t == null ? void 0 : t.in), r = l.getDay(), o = (n % 7 + 7) % 7, u = 7 - s, c = n < 0 || n > 6 ? n - (r + u) % 7 : (o + u) % 7 - (r + u) % 7;
  return nn(l, c, t);
}
class My extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 90);
    ke(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Ei(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
class Cy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 90);
    ke(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, l) {
    const r = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "e":
      case "ee":
        return xt(gt(a.length, t), r);
      // 3rd
      case "eo":
        return xt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "eee":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Ei(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
class Dy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 90);
    ke(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, l) {
    const r = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "c":
      case "cc":
        return xt(gt(a.length, t), r);
      // 3rd
      case "co":
        return xt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "ccc":
        return s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(t, { width: "wide", context: "standalone" }) || s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Ei(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
function _y(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = ay(a, t), l = n - s;
  return nn(a, l, t);
}
class Oy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 90);
    ke(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => r === 0 ? 7 : r;
    switch (a) {
      // 2
      case "i":
      case "ii":
        return gt(a.length, t);
      // 2nd
      case "io":
        return s.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return xt(
          s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // T
      case "iiiii":
        return xt(
          s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // Tu
      case "iiiiii":
        return xt(
          s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // Tuesday
      case "iiii":
      default:
        return xt(
          s.day(t, {
            width: "wide",
            context: "formatting"
          }) || s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 7;
  }
  set(t, a, s) {
    return t = _y(t, s), t.setHours(0, 0, 0, 0), t;
  }
}
class Ey extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 80);
    ke(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Oi(s), 0, 0, 0), t;
  }
}
class Iy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 80);
    ke(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Oi(s), 0, 0, 0), t;
  }
}
class Ay extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 80);
    ke(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Oi(s), 0, 0, 0), t;
  }
}
class Py extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 70);
    ke(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "h":
        return mt(kt.hour12h, t);
      case "ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 12;
  }
  set(t, a, s) {
    const l = t.getHours() >= 12;
    return l && s < 12 ? t.setHours(s + 12, 0, 0, 0) : !l && s === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Ry extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 70);
    ke(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "H":
        return mt(kt.hour23h, t);
      case "Ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 23;
  }
  set(t, a, s) {
    return t.setHours(s, 0, 0, 0), t;
  }
}
class Fy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 70);
    ke(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "K":
        return mt(kt.hour11h, t);
      case "Ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.getHours() >= 12 && s < 12 ? t.setHours(s + 12, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Vy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 70);
    ke(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "k":
        return mt(kt.hour24h, t);
      case "ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 24;
  }
  set(t, a, s) {
    const l = s <= 24 ? s % 24 : s;
    return t.setHours(l, 0, 0, 0), t;
  }
}
class Ly extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 60);
    ke(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "m":
        return mt(kt.minute, t);
      case "mo":
        return s.ordinalNumber(t, { unit: "minute" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setMinutes(s, 0, 0), t;
  }
}
class Ny extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 50);
    ke(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "s":
        return mt(kt.second, t);
      case "so":
        return s.ordinalNumber(t, { unit: "second" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setSeconds(s, 0), t;
  }
}
class By extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 30);
    ke(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a) {
    const s = (l) => Math.trunc(l * Math.pow(10, -a.length + 3));
    return xt(gt(a.length, t), s);
  }
  set(t, a, s) {
    return t.setMilliseconds(s), t;
  }
}
class zy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 10);
    ke(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, a) {
    switch (a) {
      case "X":
        return $n(
          Tn.basicOptionalMinutes,
          t
        );
      case "XX":
        return $n(Tn.basic, t);
      case "XXXX":
        return $n(
          Tn.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return $n(
          Tn.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return $n(Tn.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ot(
      t,
      t.getTime() - $l(t) - s
    );
  }
}
class Wy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 10);
    ke(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, a) {
    switch (a) {
      case "x":
        return $n(
          Tn.basicOptionalMinutes,
          t
        );
      case "xx":
        return $n(Tn.basic, t);
      case "xxxx":
        return $n(
          Tn.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return $n(
          Tn.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return $n(Tn.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ot(
      t,
      t.getTime() - $l(t) - s
    );
  }
}
class Yy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 40);
    ke(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return bd(t);
  }
  set(t, a, s) {
    return [ot(t, s * 1e3), { timestampIsSet: !0 }];
  }
}
class Hy extends at {
  constructor() {
    super(...arguments);
    ke(this, "priority", 20);
    ke(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return bd(t);
  }
  set(t, a, s) {
    return [ot(t, s), { timestampIsSet: !0 }];
  }
}
const Uy = {
  G: new uy(),
  y: new cy(),
  Y: new dy(),
  R: new fy(),
  u: new hy(),
  Q: new my(),
  q: new vy(),
  M: new py(),
  L: new gy(),
  w: new by(),
  I: new ky(),
  d: new Ty(),
  D: new $y(),
  E: new My(),
  e: new Cy(),
  c: new Dy(),
  i: new Oy(),
  a: new Ey(),
  b: new Iy(),
  B: new Ay(),
  h: new Py(),
  H: new Ry(),
  K: new Fy(),
  k: new Vy(),
  m: new Ly(),
  s: new Ny(),
  S: new By(),
  X: new zy(),
  x: new Wy(),
  t: new Yy(),
  T: new Hy()
}, qy = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, jy = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Gy = /^'([^]*?)'?$/, Ky = /''/g, Zy = /\S/, Xy = /[a-zA-Z]/;
function Xr(e, n, t, a) {
  var k, y, h, w, S, x, C, _;
  const s = () => ot((a == null ? void 0 : a.in) || t, NaN), l = ny(), r = (a == null ? void 0 : a.locale) ?? l.locale ?? md, i = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((y = (k = a == null ? void 0 : a.locale) == null ? void 0 : k.options) == null ? void 0 : y.firstWeekContainsDate) ?? l.firstWeekContainsDate ?? ((w = (h = l.locale) == null ? void 0 : h.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, o = (a == null ? void 0 : a.weekStartsOn) ?? ((x = (S = a == null ? void 0 : a.locale) == null ? void 0 : S.options) == null ? void 0 : x.weekStartsOn) ?? l.weekStartsOn ?? ((_ = (C = l.locale) == null ? void 0 : C.options) == null ? void 0 : _.weekStartsOn) ?? 0;
  if (!n)
    return e ? s() : Le(t, a == null ? void 0 : a.in);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: r
  }, c = [new oy(a == null ? void 0 : a.in, t)], f = n.match(jy).map((O) => {
    const P = O[0];
    if (P in Kr) {
      const D = Kr[P];
      return D(O, r.formatLong);
    }
    return O;
  }).join("").match(qy), p = [];
  for (let O of f) {
    !(a != null && a.useAdditionalWeekYearTokens) && gd(O) && Zr(O, n, e), !(a != null && a.useAdditionalDayOfYearTokens) && pd(O) && Zr(O, n, e);
    const P = O[0], D = Uy[P];
    if (D) {
      const { incompatibleTokens: B } = D;
      if (Array.isArray(B)) {
        const H = p.find(
          (te) => B.includes(te.token) || te.token === P
        );
        if (H)
          throw new RangeError(
            `The format string mustn't contain \`${H.fullToken}\` and \`${O}\` at the same time`
          );
      } else if (D.incompatibleTokens === "*" && p.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${O}\` and any other token at the same time`
        );
      p.push({ token: P, fullToken: O });
      const W = D.run(
        e,
        O,
        r.match,
        u
      );
      if (!W)
        return s();
      c.push(W.setter), e = W.rest;
    } else {
      if (P.match(Xy))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + P + "`"
        );
      if (O === "''" ? O = "'" : P === "'" && (O = Jy(O)), e.indexOf(O) === 0)
        e = e.slice(O.length);
      else
        return s();
    }
  }
  if (e.length > 0 && Zy.test(e))
    return s();
  const d = c.map((O) => O.priority).sort((O, P) => P - O).filter((O, P, D) => D.indexOf(O) === P).map(
    (O) => c.filter((P) => P.priority === O).sort((P, D) => D.subPriority - P.subPriority)
  ).map((O) => O[0]);
  let g = Le(t, a == null ? void 0 : a.in);
  if (isNaN(+g)) return s();
  const v = {};
  for (const O of d) {
    if (!O.validate(g, u))
      return s();
    const P = O.set(g, v, u);
    Array.isArray(P) ? (g = P[0], Object.assign(v, P[1])) : g = P;
  }
  return g;
}
function Jy(e) {
  return e.match(Gy)[1].replace(Ky, "'");
}
function Go(e, n, t) {
  const [a, s] = Ws(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return +va(a) == +va(s);
}
function xd(e, n, t) {
  return nn(e, -n, t);
}
function Qy(e, n) {
  const t = (n == null ? void 0 : n.nearestTo) ?? 1;
  if (t < 1 || t > 30) return ot(e, NaN);
  const a = Le(e, n == null ? void 0 : n.in), s = a.getSeconds() / 60, l = a.getMilliseconds() / 1e3 / 60, r = a.getMinutes() + s + l, i = (n == null ? void 0 : n.roundingMethod) ?? "round", u = lg(i)(r / t) * t;
  return a.setMinutes(u, 0, 0), a;
}
function Sd(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = a.getFullYear(), l = a.getDate(), r = ot(e, 0);
  r.setFullYear(s, n, 15), r.setHours(0, 0, 0, 0);
  const i = ty(r);
  return a.setMonth(n, Math.min(l, i)), a;
}
function je(e, n, t) {
  let a = Le(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ot(e, NaN) : (n.year != null && a.setFullYear(n.year), n.month != null && (a = Sd(a, n.month)), n.date != null && a.setDate(n.date), n.hours != null && a.setHours(n.hours), n.minutes != null && a.setMinutes(n.minutes), n.seconds != null && a.setSeconds(n.seconds), n.milliseconds != null && a.setMilliseconds(n.milliseconds), a);
}
function eb(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return a.setMilliseconds(n), a;
}
function tb(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return a.setSeconds(n), a;
}
function vn(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ot(e, NaN) : (a.setFullYear(n), a);
}
function Ja(e, n, t) {
  return gn(e, -n, t);
}
function nb(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: l = 0,
    days: r = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = Ja(e, s + a * 12, t), f = xd(c, r + l * 7, t), p = o + i * 60, g = (u + p * 60) * 1e3;
  return ot(e, +f - g);
}
function Td(e, n, t) {
  return Ti(e, -n, t);
}
function ab(e, n, t = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: t
  }).format(n).split(/\s/g).slice(2).join(" ");
}
const pr = {}, Ss = {};
function pa(e, n) {
  try {
    const a = (pr[e] || (pr[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(n).split("GMT")[1];
    return a in Ss ? Ss[a] : Ko(a, a.split(":"));
  } catch {
    if (e in Ss) return Ss[e];
    const t = e == null ? void 0 : e.match(sb);
    return t ? Ko(e, t.slice(1)) : NaN;
  }
}
const sb = /([+-]\d\d):?(\d\d)?/;
function Ko(e, n) {
  const t = +(n[0] || 0), a = +(n[1] || 0), s = +(n[2] || 0) / 60;
  return Ss[e] = t * 60 + a > 0 ? t * 60 + a + s : t * 60 - a - s;
}
class Cn extends Date {
  //#region static
  constructor(...n) {
    super(), n.length > 1 && typeof n[n.length - 1] == "string" && (this.timeZone = n.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(pa(this.timeZone, this)) ? this.setTime(NaN) : n.length ? typeof n[0] == "number" && (n.length === 1 || n.length === 2 && typeof n[1] != "number") ? this.setTime(n[0]) : typeof n[0] == "string" ? this.setTime(+new Date(n[0])) : n[0] instanceof Date ? this.setTime(+n[0]) : (this.setTime(+new Date(...n)), $d(this), Jr(this)) : this.setTime(Date.now());
  }
  static tz(n, ...t) {
    return t.length ? new Cn(...t, n) : new Cn(Date.now(), n);
  }
  //#endregion
  //#region time zone
  withTimeZone(n) {
    return new Cn(+this, n);
  }
  getTimezoneOffset() {
    const n = -pa(this.timeZone, this);
    return n > 0 ? Math.floor(n) : Math.ceil(n);
  }
  //#endregion
  //#region time
  setTime(n) {
    return Date.prototype.setTime.apply(this, arguments), Jr(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Cn(+new Date(n), this.timeZone);
  }
  //#endregion
}
const Zo = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Zo.test(e)) return;
  const n = e.replace(Zo, "$1UTC");
  Cn.prototype[n] && (e.startsWith("get") ? Cn.prototype[e] = function() {
    return this.internal[n]();
  } : (Cn.prototype[e] = function() {
    return Date.prototype[n].apply(this.internal, arguments), lb(this), +this;
  }, Cn.prototype[n] = function() {
    return Date.prototype[n].apply(this, arguments), Jr(this), +this;
  }));
});
function Jr(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-pa(e.timeZone, e) * 60));
}
function lb(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), $d(e);
}
function $d(e) {
  const n = pa(e.timeZone, e), t = n > 0 ? Math.floor(n) : Math.ceil(n), a = /* @__PURE__ */ new Date(+e);
  a.setUTCHours(a.getUTCHours() - 1);
  const s = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), l = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), r = s - l, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  r && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + r);
  const o = s - t;
  o && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + o);
  const u = /* @__PURE__ */ new Date(+e);
  u.setUTCSeconds(0);
  const c = s > 0 ? u.getSeconds() : (u.getSeconds() - 60) % 60, f = Math.round(-(pa(e.timeZone, e) * 60)) % 60;
  (f || c) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + f), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + f + c));
  const p = pa(e.timeZone, e), d = p > 0 ? Math.floor(p) : Math.ceil(p), v = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - d, k = d !== t, y = v - o;
  if (k && y) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + y);
    const h = pa(e.timeZone, e), w = h > 0 ? Math.floor(h) : Math.ceil(h), S = d - w;
    S && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + S), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + S));
  }
}
class Na extends Cn {
  //#region static
  static tz(n, ...t) {
    return t.length ? new Na(...t, n) : new Na(Date.now(), n);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [n, t, a] = this.tzComponents(), s = `${n}${t}:${a}`;
    return this.internal.toISOString().slice(0, -1) + s;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [n, t, a, s] = this.internal.toUTCString().split(" ");
    return `${n == null ? void 0 : n.slice(0, -1)} ${a} ${t} ${s}`;
  }
  toTimeString() {
    const n = this.internal.toUTCString().split(" ")[4], [t, a, s] = this.tzComponents();
    return `${n} GMT${t}${a}${s} (${ab(this.timeZone, this)})`;
  }
  toLocaleString(n, t) {
    return Date.prototype.toLocaleString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(n, t) {
    return Date.prototype.toLocaleDateString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(n, t) {
    return Date.prototype.toLocaleTimeString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const n = this.getTimezoneOffset(), t = n > 0 ? "-" : "+", a = String(Math.floor(Math.abs(n) / 60)).padStart(2, "0"), s = String(Math.abs(n) % 60).padStart(2, "0");
    return [t, a, s];
  }
  //#endregion
  withTimeZone(n) {
    return new Na(+this, n);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Na(+new Date(n), this.timeZone);
  }
  //#endregion
}
function Ys() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      wt("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      wt("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      wt("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
function rb() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      wt("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
function Md() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Cd() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
function Dd() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      wt("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
function _d() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Od() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
const Ed = Symbol("ContextKey"), ib = (e, n) => {
  const { setTimeModelValue: t } = _t(), a = e0(e), s = ee(null), l = wa({
    menuFocused: !1,
    shiftKeyInMenu: !1,
    isInputFocused: !1,
    isTextInputDate: !1,
    arrowNavigationLevel: 0
  }), r = a.getDate(/* @__PURE__ */ new Date()), i = ee(""), o = ee([{ month: Ze(r), year: ze(r) }]), u = wa({ hours: 0, minutes: 0, seconds: 0 });
  t(u, null, r, a.range.value.enabled);
  const c = M({
    get: () => s.value,
    set: (v) => {
      s.value = v;
    }
  }), f = M(
    () => (v) => o.value[v] ? o.value[v].month : 0
  ), p = M(
    () => (v) => o.value[v] ? o.value[v].year : 0
  ), d = (v, k) => {
    l[v] = k;
  }, g = () => {
    t(u, c.value, r, a.range.value.enabled);
  };
  ga(Ed, {
    rootProps: e,
    defaults: a,
    modelValue: c,
    state: ai(l),
    rootEmit: n,
    calendars: o,
    month: f,
    year: p,
    time: u,
    today: r,
    inputValue: i,
    setState: d,
    updateTime: g,
    getDate: a.getDate
  });
}, Ke = () => {
  const e = On(Ed);
  if (!e)
    throw new Error("Can't use context");
  return e;
};
var hn = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(hn || {}), ba = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(ba || {}), Nt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Nt || {});
const ob = ["timestamp", "date", "iso"];
var mn = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(mn || {}), ct = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(ct || {}), Ba = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(Ba || {}), Id = /* @__PURE__ */ ((e) => (e[e.Sunday = 0] = "Sunday", e[e.Monday = 1] = "Monday", e[e.Tuesday = 2] = "Tuesday", e[e.Wednesday = 3] = "Wednesday", e[e.Thursday = 4] = "Thursday", e[e.Friday = 5] = "Friday", e[e.Saturday = 6] = "Saturday", e))(Id || {});
const ub = () => {
  const { rootProps: e, state: n } = Ke(), t = M(() => n.arrowNavigationLevel), a = ee(-1), s = ee(-1);
  Be(t, (h, w) => {
    y(h === 0 && w > 0);
  });
  const l = ee([]), r = ee(/* @__PURE__ */ new Map()), i = () => {
    const h = Array.from(
      document.querySelectorAll(`[data-dp-action-element="${t.value}"]`)
    ), w = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map();
    for (const x of h) {
      const C = x.getBoundingClientRect(), _ = C.top, O = C.left;
      w.has(_) || w.set(_, []), w.get(_).push(x), S.set(x, { row: _, col: O });
    }
    l.value = Array.from(w.entries()).sort((x, C) => x[0] - C[0]).map(([x, C]) => o(C, S)), r.value = S;
  }, o = (h, w) => h.sort((S, x) => {
    const C = w.get(S), _ = w.get(x);
    return C.col - _.col;
  }), u = (h, w) => {
    t.value === 0 && (a.value = h, s.value = w);
  }, c = (h) => {
    if (![ct.arrowUp, ct.arrowDown, ct.arrowLeft, ct.arrowRight].includes(h.key))
      return;
    i(), h.preventDefault();
    const w = document.activeElement;
    if (!(w != null && w.hasAttribute("data-dp-action-element")))
      return;
    let S = -1, x = -1;
    for (let C = 0; C < l.value.length; C++) {
      const _ = l.value[C].indexOf(w);
      if (_ !== -1) {
        S = C, x = _;
        break;
      }
    }
    if (S !== -1)
      switch (h.key) {
        case ct.arrowLeft:
          return f(S, x);
        case ct.arrowRight:
          return p(S, x);
        case ct.arrowUp:
          return d(S, x);
        case ct.arrowDown:
          return g(S, x);
        default:
          return;
      }
  }, f = (h, w) => {
    if (w > 0) {
      const S = l.value[h][w - 1];
      u(h, w - 1), S && S.focus();
    }
  }, p = (h, w) => {
    if (w < l.value[h].length - 1) {
      const S = l.value[h][w + 1];
      u(h, w + 1), S && S.focus();
    }
  }, d = (h, w) => {
    if (h > 0) {
      const S = l.value[h - 1], x = Math.min(w, S.length - 1), C = S[x];
      u(h - 1, x), C && C.focus();
    }
  }, g = (h, w) => {
    if (h < l.value.length - 1) {
      const S = l.value[h + 1], x = Math.min(w, S.length - 1), C = S[x];
      u(h + 1, x), C && C.focus();
    }
  }, v = () => {
    Ge().then(() => {
      var w;
      i();
      const h = (w = l.value[a.value]) == null ? void 0 : w[s.value];
      h && k(h);
    });
  }, k = (h) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        h.focus({ preventScroll: !0 });
      });
    });
  }, y = (h) => {
    if (h)
      return v();
    const w = document.querySelector(`[data-dp-element-active="${t.value}"]`);
    if (w && !h)
      k(w);
    else {
      const S = document.querySelector(`[data-dp-action-element="${t.value}"]`);
      S && k(S);
    }
  };
  et(() => {
    e.arrowNavigation && (y(!1), document.addEventListener("keydown", c));
  }), Jt(() => {
    e.arrowNavigation && document.removeEventListener("keydown", c);
  });
}, cb = () => {
  const { checkPartialRangeValue: e, checkRangeEnabled: n, isValidDate: t } = on(), { convertType: a, errorMapper: s } = _t(), {
    getDate: l,
    rootEmit: r,
    state: i,
    rootProps: o,
    inputValue: u,
    defaults: { textInput: c, range: f, multiDates: p, timeConfig: d, formats: g },
    modelValue: v,
    updateTime: k
  } = Ke(), { setTime: y, getWeekFromDate: h } = Lt(), { formatSelectedDate: w, formatForTextInput: S } = sa();
  Be(
    v,
    (V, G) => {
      r("internal-model-change", v.value), JSON.stringify(G ?? {}) !== JSON.stringify(V ?? {}) && k();
    },
    { deep: !0 }
  ), Be(f, (V, G) => {
    V.enabled !== G.enabled && (v.value = null);
  }), Be(
    () => g.value.input,
    () => {
      de();
    }
  );
  const x = (V) => V ? o.modelType ? ge(V) : {
    hours: An(V),
    minutes: Un(V),
    seconds: d.value.enableSeconds ? aa(V) : 0
  } : null, C = (V) => o.modelType ? ge(V) : { month: Ze(V), year: ze(V) }, _ = (V) => Array.isArray(V) ? p.value.enabled ? V.map((G) => O(G, vn(l(), G))) : n(
    () => [
      vn(l(), V[0]),
      V[1] ? vn(l(), V[1]) : e(f.value.partialRange)
    ],
    f.value.enabled
  ) : vn(l(), +V), O = (V, G) => (typeof V == "string" || typeof V == "number") && o.modelType ? pe(V) : G, P = (V) => Array.isArray(V) ? [
    O(V[0], y(V[0])),
    O(V[1], y(V[1]))
  ] : O(V, y(V)), D = (V) => {
    const G = je(l(), { date: 1 });
    return Array.isArray(V) ? p.value.enabled ? V.map(
      (he) => O(he, je(G, { month: +he.month, year: +he.year }))
    ) : n(
      () => [
        O(V[0], je(G, { month: +V[0].month, year: +V[0].year })),
        O(
          V[1],
          V[1] ? je(G, { month: +V[1].month, year: +V[1].year }) : e(f.value.partialRange)
        )
      ],
      f.value.enabled
    ) : O(V, je(G, { month: +V.month, year: +V.year }));
  }, B = (V) => {
    if (Array.isArray(V))
      return V.map((G) => pe(G));
    throw new Error(s.dateArr("multi-dates"));
  }, W = (V) => {
    if (Array.isArray(V) && f.value.enabled) {
      const G = V[0], he = V[1];
      return [
        l(Array.isArray(G) ? G[0] : null),
        Array.isArray(he) && he.length ? l(he[0]) : null
      ];
    }
    return l(V[0]);
  }, H = (V) => o.modelAuto ? Array.isArray(V) ? [pe(V[0]), pe(V[1])] : o.autoApply ? [pe(V)] : [pe(V), null] : Array.isArray(V) ? n(
    () => V[1] ? [
      pe(V[0]),
      V[1] ? pe(V[1]) : e(f.value.partialRange)
    ] : [pe(V[0])],
    f.value.enabled
  ) : pe(V), te = () => {
    Array.isArray(v.value) && f.value.enabled && v.value.length === 1 && v.value.push(e(f.value.partialRange));
  }, re = () => {
    const V = v.value;
    return [
      ge(V[0]),
      V[1] ? ge(V[1]) : e(f.value.partialRange)
    ];
  }, oe = () => Array.isArray(v.value) ? v.value[1] ? re() : ge(a(v.value[0])) : [], K = () => (v.value || []).map((V) => ge(V)), ae = (V = !1) => (V || te(), o.modelAuto ? oe() : p.value.enabled ? K() : Array.isArray(v.value) ? n(() => re(), f.value.enabled) : ge(a(v.value))), U = (V) => !V || Array.isArray(V) && !V.length ? null : o.timePicker ? P(a(V)) : o.monthPicker ? D(a(V)) : o.yearPicker ? _(a(V)) : p.value.enabled ? B(a(V)) : o.weekPicker ? W(a(V)) : H(a(V)), z = (V) => {
    if (i.isTextInputDate) return;
    const G = U(V);
    t(a(G)) ? (v.value = a(G), de()) : (v.value = null, u.value = "");
  }, J = () => v.value ? p.value.enabled ? v.value.map((V) => w(V)).join("; ") : c.value.enabled ? S() : w(v.value) : "", de = () => {
    u.value = J();
  }, pe = (V) => o.modelType ? ob.includes(o.modelType) ? l(V) : o.modelType === "format" && typeof g.value.input == "string" ? Xr(V, g.value.input, l(), { locale: o.locale }) : Xr(V, o.modelType, l(), { locale: o.locale }) : l(V), ge = (V) => V ? o.modelType ? o.modelType === "timestamp" ? +V : o.modelType === "iso" ? V.toISOString() : o.modelType === "format" && typeof g.value.input == "string" ? w(V) : w(V, o.modelType) : V : null, Me = (V) => {
    r("update:model-value", V);
  }, be = (V) => Array.isArray(v.value) ? p.value.enabled ? v.value.map((G) => V(G)) : [V(v.value[0]), v.value[1] ? V(v.value[1]) : null] : V(a(v.value)), q = () => {
    if (Array.isArray(v.value)) {
      const V = h(v.value[0], o.weekStart), G = v.value[1] ? h(v.value[1], o.weekStart) : [];
      return [V.map((he) => l(he)), G.map((he) => l(he))];
    }
    return h(v.value, o.weekStart).map((V) => l(V));
  }, ye = (V) => Me(a(be(V))), Ce = () => r("update:model-value", q());
  return {
    checkBeforeEmit: () => v.value ? f.value.enabled ? f.value.partialRange ? v.value.length >= 1 : v.value.length === 2 : !!v.value : !1,
    parseExternalModelValue: z,
    formatInputValue: de,
    emitModelValue: () => (de(), o.monthPicker ? ye(C) : o.timePicker ? ye(x) : o.yearPicker ? ye(ze) : o.weekPicker ? Ce() : Me(ae()))
  };
}, Hs = () => {
  const {
    defaults: { transitions: e }
  } = Ke(), n = M(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), t = M(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: n, showTransition: !!e.value, menuTransition: t };
}, Us = (e) => {
  const {
    today: n,
    time: t,
    modelValue: a,
    defaults: { range: s }
  } = Ke(), { setTimeModelValue: l } = _t();
  Be(
    s,
    (r, i) => {
      r.enabled !== i.enabled && l(t, a.value, n, s.value.enabled);
    },
    { deep: !0 }
  ), Be(
    a,
    (r, i) => {
      e && JSON.stringify(r ?? {}) !== JSON.stringify(i ?? {}) && e();
    },
    { deep: !0 }
  );
}, on = () => {
  const {
    defaults: { safeDates: e, range: n, multiDates: t, filters: a, timeConfig: s },
    rootProps: l,
    getDate: r
  } = Ke(), { getMapKeyType: i, getMapDate: o, errorMapper: u, convertType: c } = _t(), { isDateBefore: f, isDateAfter: p, isDateEqual: d, resetDate: g, getDaysInBetween: v, setTimeValue: k, getTimeObj: y, setTime: h } = Lt(), w = (j) => e.value.disabledDates ? typeof e.value.disabledDates == "function" ? e.value.disabledDates(r(j)) : !!o(j, e.value.disabledDates) : !1, S = (j) => e.value.maxDate ? l.yearPicker ? ze(j) > ze(e.value.maxDate) : p(j, e.value.maxDate) : !1, x = (j) => e.value.minDate ? l.yearPicker ? ze(j) < ze(e.value.minDate) : f(j, e.value.minDate) : !1, C = (j) => {
    var L;
    if (!j) return !1;
    const se = S(j), me = x(j), I = w(j), N = a.value.months.map((fe) => +fe).includes(Ze(j)), T = (L = a.value.weekDays) != null && L.length ? a.value.weekDays.some((fe) => +fe === ey(j)) : !1, R = B(j), A = ze(j), Z = A < +l.yearRange[0] || A > +l.yearRange[1];
    return !(se || me || I || N || Z || T || R);
  }, _ = (j, se) => f(...Ce(e.value.minDate, j, se)) || d(...Ce(e.value.minDate, j, se)), O = (j, se) => p(...Ce(e.value.maxDate, j, se)) || d(...Ce(e.value.maxDate, j, se)), P = (j, se, me) => {
    let I = !1;
    return e.value.maxDate && me && O(j, se) && (I = !0), e.value.minDate && !me && _(j, se) && (I = !0), I;
  }, D = (j, se, me, I) => {
    let N = !1;
    return I && (e.value.minDate || e.value.maxDate) ? e.value.minDate && e.value.maxDate ? N = P(j, se, me) : (e.value.minDate && _(j, se) || e.value.maxDate && O(j, se)) && (N = !0) : N = !0, N;
  }, B = (j) => Array.isArray(e.value.allowedDates) && !e.value.allowedDates.length ? !0 : e.value.allowedDates ? !o(
    j,
    e.value.allowedDates,
    i(l.monthPicker, l.yearPicker)
  ) : !1, W = (j) => !C(j), H = (j) => n.value.noDisabledRange ? !$i({ start: j[0], end: j[1] }).some((se) => W(se)) : !0, te = (j) => {
    if (j) {
      const se = ze(j);
      return se >= +l.yearRange[0] && se <= l.yearRange[1];
    }
    return !0;
  }, re = (j, se) => !!(Array.isArray(j) && j[se] && (n.value.maxRange || n.value.minRange) && te(j[se])), oe = (j, se, me = 0) => {
    if (re(se, me) && te(j)) {
      const I = cd(j, se[me]), N = v(se[me], j), T = N.length === 1 ? 0 : N.filter((A) => W(A)).length, R = Math.abs(I) - (n.value.minMaxRawRange ? 0 : T);
      if (n.value.minRange && n.value.maxRange)
        return R >= +n.value.minRange && R <= +n.value.maxRange;
      if (n.value.minRange) return R >= +n.value.minRange;
      if (n.value.maxRange) return R <= +n.value.maxRange;
    }
    return !0;
  }, K = () => !s.value.enableTimePicker || l.monthPicker || l.yearPicker || s.value.ignoreTimeValidation, ae = (j) => Array.isArray(j) ? [j[0] ? k(j[0]) : null, j[1] ? k(j[1]) : null] : k(j), U = (j, se, me) => se ? j.find(
    (I) => +I.hours === An(se) && I.minutes === "*" ? !0 : +I.minutes === Un(se) && +I.hours === An(se)
  ) && me : !1, z = (j, se, me) => {
    const [I, N] = j, [T, R] = se;
    return !U(I, T, me) && !U(N, R, me) && me;
  }, J = (j, se) => {
    const me = Array.isArray(se) ? se : [se];
    return Array.isArray(l.disabledTimes) ? Array.isArray(l.disabledTimes[0]) ? z(l.disabledTimes, me, j) : !me.some((I) => U(l.disabledTimes, I, j)) : j;
  }, de = (j, se) => {
    const me = Array.isArray(se) ? [y(se[0]), se[1] ? y(se[1]) : void 0] : y(se), I = !l.disabledTimes(me);
    return j && I;
  }, pe = (j, se) => l.disabledTimes ? Array.isArray(l.disabledTimes) ? J(se, j) : de(se, j) : se, ge = (j) => {
    let se = !0;
    if (!j || K()) return !0;
    const me = !e.value.minDate && !e.value.maxDate ? ae(j) : j;
    return (l.maxTime || e.value.maxDate) && (se = G(
      l.maxTime,
      e.value.maxDate,
      "max",
      c(me),
      se
    )), (l.minTime || e.value.minDate) && (se = G(
      l.minTime,
      e.value.minDate,
      "min",
      c(me),
      se
    )), pe(j, se);
  }, Me = (j) => {
    if (!l.monthPicker) return !0;
    let se = !0;
    const me = r(g(j));
    if (e.value.minDate && e.value.maxDate) {
      const I = r(g(e.value.minDate)), N = r(g(e.value.maxDate));
      return p(me, I) && f(me, N) || d(me, I) || d(me, N);
    }
    if (e.value.minDate) {
      const I = r(g(e.value.minDate));
      se = p(me, I) || d(me, I);
    }
    if (e.value.maxDate) {
      const I = r(g(e.value.maxDate));
      se = f(me, I) || d(me, I);
    }
    return se;
  }, be = M(() => (j) => !s.value.enableTimePicker || s.value.ignoreTimeValidation ? !0 : ge(j)), q = M(() => (j) => l.monthPicker ? Array.isArray(j) && (n.value.enabled || t.value.enabled) ? !j.filter((se) => !Me(se)).length : Me(j) : !0), ye = (j, se, me) => {
    if (!se || me && !e.value.maxDate || !me && !e.value.minDate) return !1;
    const I = me ? gn(j, 1) : Ja(j, 1), N = [Ze(I), ze(I)];
    return me ? !O(...N) : !_(...N);
  }, Ce = (j, se, me) => [je(r(j), { date: 1 }), je(r(), { month: se, year: me, date: 1 })], V = (j, se, me, I) => {
    if (!j) return !0;
    if (I) {
      const N = me === "max" ? Yn(j, se) : Mn(j, se), T = { seconds: 0, milliseconds: 0 };
      return N || La(je(j, T), je(se, T));
    }
    return me === "max" ? j.getTime() <= se.getTime() : j.getTime() >= se.getTime();
  }, G = (j, se, me, I, N) => {
    if (Array.isArray(I)) {
      const R = he(j, I[0], se), A = he(j, I[1], se);
      return V(I[0], R, me, !!se) && V(I[1], A, me, !!se) && N;
    }
    const T = he(j, I, se);
    return V(I, T, me, !!se) && N;
  }, he = (j, se, me) => j ? h(j, se) : r(me ?? se);
  return {
    isDisabled: W,
    validateDate: C,
    validateMonthYearInRange: D,
    isDateRangeAllowed: H,
    checkMinMaxRange: oe,
    isValidTime: ge,
    validateMonthYear: ye,
    validateMinDate: _,
    validateMaxDate: O,
    isValidDate: (j) => Array.isArray(j) ? $s(j[0]) && (j[1] ? $s(j[1]) : !0) : j ? $s(j) : !1,
    checkPartialRangeValue: (j) => {
      if (j) return null;
      throw new Error(u.prop("partial-range"));
    },
    checkRangeEnabled: (j, se) => {
      if (se) return j();
      throw new Error(u.prop("range"));
    },
    checkMinMaxValue: (j, se, me) => {
      const I = me != null, N = se != null;
      if (!I && !N) return !1;
      const T = +me, R = +se;
      return I && N ? +j > T || +j < R : I ? +j > T : N ? +j < R : !1;
    },
    isTimeValid: be,
    isMonthValid: q
  };
}, db = (e) => {
  const {
    rootEmit: n,
    rootProps: t,
    defaults: { timeConfig: a, flow: s }
  } = Ke(), l = ee(0), r = wa({
    [ba.timePicker]: !a.value.enableTimePicker || t.timePicker || t.monthPicker,
    [ba.calendar]: !1,
    [ba.header]: !1
  }), i = M(() => t.monthPicker || t.timePicker), o = (d) => {
    var g, v;
    if ((v = (g = s.value) == null ? void 0 : g.steps) != null && v.length) {
      if (!d && i.value) return p();
      r[d] = !0, Object.keys(r).filter((k) => !r[k]).length || p();
    }
  }, u = () => {
    var d, g, v, k;
    (g = (d = s.value) == null ? void 0 : d.steps) != null && g.length && l.value !== -1 && (l.value += 1, n("flow-step", l.value), p()), ((k = (v = s.value) == null ? void 0 : v.steps) == null ? void 0 : k.length) === l.value && Ge().then(() => c());
  }, c = () => {
    l.value = -1;
  }, f = (d, g, ...v) => {
    var k, y, h;
    ((k = s.value) == null ? void 0 : k.steps[l.value]) === d && e.value && ((h = (y = e.value)[g]) == null || h.call(y, ...v));
  }, p = (d = 0) => {
    var v;
    d && (l.value += d), f(Nt.month, "toggleMonthPicker", !0), f(Nt.year, "toggleYearPicker", !0), f(Nt.calendar, "toggleTimePicker", !1, !0), f(Nt.time, "toggleTimePicker", !0, !0);
    const g = (v = s.value) == null ? void 0 : v.steps[l.value];
    (g === Nt.hours || g === Nt.minutes || g === Nt.seconds) && f(g, "toggleTimePicker", !0, !0, g);
  };
  return { childMount: o, updateFlowStep: u, resetFlow: c, handleFlow: p, flowStep: l };
};
function gr(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
function ps(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : r;
      s = e.formattingValues[i] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[r];
    }
    const l = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[l];
  };
}
function gs(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = n.match(s);
    if (!l)
      return null;
    const r = l[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? hb(i, (f) => f.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      fb(i, (f) => f.test(r))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(r.length);
    return { value: u, rest: c };
  };
}
function fb(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function hb(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function mb(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], l = n.match(e.parsePattern);
    if (!l) return null;
    let r = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    r = t.valueCallback ? t.valueCallback(r) : r;
    const i = n.slice(s.length);
    return { value: r, rest: i };
  };
}
const vb = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, pb = (e, n, t) => {
  let a;
  const s = vb[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
}, gb = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, yb = (e, n, t, a) => gb[e], bb = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, wb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, kb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, xb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Sb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Tb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, $b = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Mb = {
  ordinalNumber: $b,
  era: ps({
    values: bb,
    defaultWidth: "wide"
  }),
  quarter: ps({
    values: wb,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ps({
    values: kb,
    defaultWidth: "wide"
  }),
  day: ps({
    values: xb,
    defaultWidth: "wide"
  }),
  dayPeriod: ps({
    values: Sb,
    defaultWidth: "wide",
    formattingValues: Tb,
    defaultFormattingWidth: "wide"
  })
}, Cb = /^(\d+)(th|st|nd|rd)?/i, Db = /\d+/i, _b = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ob = {
  any: [/^b/i, /^(a|c)/i]
}, Eb = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ib = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ab = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Pb = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Rb = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Fb = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Vb = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Lb = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Nb = {
  ordinalNumber: mb({
    matchPattern: Cb,
    parsePattern: Db,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: gs({
    matchPatterns: _b,
    defaultMatchWidth: "wide",
    parsePatterns: Ob,
    defaultParseWidth: "any"
  }),
  quarter: gs({
    matchPatterns: Eb,
    defaultMatchWidth: "wide",
    parsePatterns: Ib,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: gs({
    matchPatterns: Ab,
    defaultMatchWidth: "wide",
    parsePatterns: Pb,
    defaultParseWidth: "any"
  }),
  day: gs({
    matchPatterns: Rb,
    defaultMatchWidth: "wide",
    parsePatterns: Fb,
    defaultParseWidth: "any"
  }),
  dayPeriod: gs({
    matchPatterns: Vb,
    defaultMatchWidth: "any",
    parsePatterns: Lb,
    defaultParseWidth: "any"
  })
}, Bb = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, zb = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Wb = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Yb = {
  date: gr({
    formats: Bb,
    defaultWidth: "full"
  }),
  time: gr({
    formats: zb,
    defaultWidth: "full"
  }),
  dateTime: gr({
    formats: Wb,
    defaultWidth: "full"
  })
}, Hb = {
  code: "en-US",
  formatDistance: pb,
  formatLong: Yb,
  formatRelative: yb,
  localize: Mb,
  match: Nb,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Xo = {
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1,
  autoSwitchStartEnd: !0
}, Ub = {
  allowStopPropagation: !0,
  closeOnScroll: !1,
  modeHeight: 255,
  allowPreventDefault: !1,
  closeOnClearValue: !0,
  closeOnAutoApply: !0,
  noSwipe: !1,
  keepActionRow: !1,
  onClickOutside: void 0,
  tabOutClosesMenu: !0,
  arrowLeft: void 0,
  keepViewOnOffsetClick: !1,
  timeArrowHoldThreshold: 0,
  shadowDom: !1,
  mobileBreakpoint: 600,
  setDateOnMenuClose: !1,
  escClose: !0,
  spaceConfirm: !0,
  monthChangeOnArrows: !0,
  monthChangeOnScroll: !0
}, Jo = {
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: "open",
  selectOnFocus: !1,
  rangeSeparator: " - ",
  escClose: !0,
  format: void 0,
  maskFormat: void 0,
  applyOnBlur: !1,
  separators: void 0
}, qb = {
  dates: [],
  years: [],
  months: [],
  quarters: [],
  weeks: [],
  weekdays: [],
  options: { highlightDisabled: !1 }
}, jb = {
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  selectBtnLabel: "Select",
  cancelBtnLabel: "Cancel",
  nowBtnLabel: "Now",
  nowBtnRound: void 0
}, Gb = {
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`
}, Qo = {
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down"
}, Kb = {
  weekDays: [],
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] }
}, Zb = {
  month: "LLL",
  year: "yyyy",
  weekDay: "EEEEEE",
  quarter: "MMMM",
  day: "d",
  input: void 0,
  preview: void 0
}, Xb = {
  enableTimePicker: !0,
  ignoreTimeValidation: !1,
  enableSeconds: !1,
  enableMinutes: !0,
  is24: !0,
  noHoursOverlay: !1,
  noMinutesOverlay: !1,
  noSecondsOverlay: !1,
  hoursGridIncrement: 1,
  minutesGridIncrement: 5,
  secondsGridIncrement: 5,
  hoursIncrement: 1,
  minutesIncrement: 1,
  secondsIncrement: 1,
  timePickerInline: !1,
  startTime: void 0
}, Jb = {
  flowStep: 0,
  menuWrapRef: null,
  collapse: !1
}, Qb = {
  weekStart: Id.Monday,
  yearRange: () => [1900, 2100],
  ui: () => ({}),
  locale: () => Hb,
  dark: !1,
  transitions: !0,
  hideNavigation: () => [],
  vertical: !1,
  hideMonthYearSelect: !1,
  disableYearSelect: !1,
  autoApply: !1,
  disabledDates: () => [],
  hideOffsetDates: !1,
  noToday: !1,
  markers: () => [],
  presetDates: () => [],
  preventMinMaxNavigation: !1,
  reverseYears: !1,
  weekPicker: !1,
  arrowNavigation: !1,
  monthPicker: !1,
  yearPicker: !1,
  quarterPicker: !1,
  timePicker: !1,
  modelAuto: !1,
  multiDates: !1,
  range: !1,
  inline: !1,
  sixWeeks: !1,
  focusStartDate: !1,
  yearFirst: !1,
  loading: !1,
  centered: !1
}, eu = {
  name: void 0,
  required: !1,
  autocomplete: "off",
  state: void 0,
  clearable: !0,
  alwaysClearable: !1,
  hideInputIcon: !1,
  id: void 0,
  inputmode: "none"
}, rl = {
  type: "local",
  hideOnOffsetDates: !1,
  label: "W"
}, e0 = (e) => {
  const { getMapKey: n, getMapKeyType: t, getTimeObjFromCurrent: a } = _t();
  function s(K, ae) {
    let U;
    return e.timezone ? U = new Na(K ?? /* @__PURE__ */ new Date(), e.timezone) : U = K ? new Date(K) : /* @__PURE__ */ new Date(), ae ? je(U, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }) : U;
  }
  const l = () => {
    const K = H.value.enableSeconds ? ":ss" : "", ae = H.value.enableMinutes ? ":mm" : "";
    return H.value.is24 ? `HH${ae}${K}` : `hh${ae}${K} aa`;
  }, r = () => {
    var K;
    return e.monthPicker ? "MM/yyyy" : e.timePicker ? l() : e.weekPicker ? `${((K = C.value) == null ? void 0 : K.type) === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : H.value.enableTimePicker ? `MM/dd/yyyy, ${l()}` : "MM/dd/yyyy";
  }, i = (K) => a(s(), K, H.value.enableSeconds), o = () => P.value.enabled ? H.value.startTime && Array.isArray(H.value.startTime) ? [i(H.value.startTime[0]), i(H.value.startTime[1])] : null : H.value.startTime && !Array.isArray(H.value.startTime) ? i(H.value.startTime) : null, u = (K) => K ? typeof K == "boolean" ? K ? 2 : 0 : Math.max(+K, 2) : 0, c = (K) => {
    const ae = t(e.monthPicker, e.yearPicker);
    return new Map(
      K.map((U) => {
        const z = s(U, f.value);
        return [n(z, ae), z];
      })
    );
  }, f = M(() => e.monthPicker || e.yearPicker || e.quarterPicker), p = M(() => {
    const K = typeof e.multiCalendars == "object" && e.multiCalendars, ae = {
      static: !0,
      solo: !1
    };
    if (!e.multiCalendars) return { ...ae, count: u(!1) };
    const U = K ? e.multiCalendars : {}, z = K ? U.count ?? !0 : e.multiCalendars, J = u(z);
    return Object.assign(ae, U, { count: J });
  }), d = M(() => o()), g = M(() => ({ ...Gb, ...e.ariaLabels })), v = M(() => ({ ...Kb, ...e.filters })), k = M(() => typeof e.transitions == "boolean" ? e.transitions ? Qo : !1 : { ...Qo, ...e.transitions }), y = M(() => ({ ...jb, ...e.actionRow })), h = M(() => typeof e.textInput == "object" ? {
    ...Jo,
    ...e.textInput,
    format: typeof e.textInput.format == "string" ? e.textInput.format : B.value.input,
    pattern: e.textInput.format ?? B.value.input,
    enabled: !0
  } : {
    ...Jo,
    format: B.value.input,
    pattern: B.value.input,
    enabled: e.textInput
  }), w = M(() => {
    const K = { input: !1 };
    return typeof e.inline == "object" ? { ...K, ...e.inline, enabled: !0 } : {
      enabled: e.inline,
      ...K
    };
  }), S = M(() => ({ ...Ub, ...e.config })), x = M(() => typeof e.highlight == "function" ? e.highlight : {
    ...qb,
    ...e.highlight
  }), C = M(() => {
    var K, ae;
    return typeof e.weekNumbers == "object" ? {
      type: ((K = e.weekNumbers) == null ? void 0 : K.type) ?? rl.type,
      hideOnOffsetDates: ((ae = e.weekNumbers) == null ? void 0 : ae.hideOnOffsetDates) ?? rl.hideOnOffsetDates,
      label: e.weekNumbers.label ?? rl.label
    } : e.weekNumbers ? rl : void 0;
  }), _ = M(() => {
    var K, ae;
    return typeof e.multiDates == "boolean" ? { enabled: e.multiDates, dragSelect: !0, limit: null } : {
      enabled: !!e.multiDates,
      limit: (K = e.multiDates) != null && K.limit ? +e.multiDates.limit : null,
      dragSelect: ((ae = e.multiDates) == null ? void 0 : ae.dragSelect) ?? !0
    };
  }), O = M(() => {
    var K;
    return {
      minDate: e.minDate ? s(e.minDate) : null,
      maxDate: e.maxDate ? s(e.maxDate) : null,
      disabledDates: Array.isArray(e.disabledDates) ? c(e.disabledDates) : e.disabledDates,
      allowedDates: Array.isArray(e.allowedDates) ? c(e.allowedDates) : null,
      highlight: typeof x.value == "object" && Array.isArray(x.value.dates) ? c(x.value.dates) : x.value,
      markers: (K = e.markers) != null && K.length ? new Map(
        e.markers.map((ae) => {
          const U = s(ae.date);
          return [n(U, Ba.DATE), ae];
        })
      ) : null
    };
  }), P = M(() => typeof e.range == "object" ? { enabled: !0, ...Xo, ...e.range } : {
    enabled: e.range,
    ...Xo
  }), D = M(() => ({
    ...Object.fromEntries(
      Object.keys(e.ui).map((K) => {
        const ae = K, U = e.ui[ae];
        if (ae === "dayClass") return [ae, e.ui[ae]];
        const z = typeof e.ui[ae] == "string" ? { [U]: !0 } : Object.fromEntries(U.map((J) => [J, !0]));
        return [K, z];
      })
    )
  })), B = M(() => {
    var K, ae;
    return {
      ...Zb,
      ...e.formats,
      input: ((K = e.formats) == null ? void 0 : K.input) ?? r(),
      preview: ((ae = e.formats) == null ? void 0 : ae.preview) ?? r()
    };
  }), W = M(() => {
    if (e.teleport)
      return typeof e.teleport == "string" ? e.teleport : typeof e.teleport == "boolean" ? "body" : e.teleport;
  }), H = M(() => ({ ...Xb, ...e.timeConfig })), te = M(() => {
    if (e.flow)
      return { steps: [], partial: !1, ...e.flow };
  }), re = M(() => {
    const K = h.value.enabled ? "text" : "none";
    return e.inputAttrs ? { ...eu, inputmode: K, ...e.inputAttrs } : { ...eu, inputmode: K };
  }), oe = M(() => {
    var K, ae, U, z, J, de;
    return {
      offset: ((K = e.floating) == null ? void 0 : K.offset) ?? 10,
      arrow: ((ae = e.floating) == null ? void 0 : ae.arrow) ?? !0,
      strategy: ((U = e.floating) == null ? void 0 : U.strategy) ?? void 0,
      placement: ((z = e.floating) == null ? void 0 : z.placement) ?? void 0,
      flip: ((J = e.floating) == null ? void 0 : J.flip) ?? !0,
      shift: ((de = e.floating) == null ? void 0 : de.shift) ?? !0
    };
  });
  return {
    transitions: k,
    multiCalendars: p,
    startTime: d,
    ariaLabels: g,
    filters: v,
    actionRow: y,
    textInput: h,
    inline: w,
    config: S,
    highlight: x,
    weekNumbers: C,
    range: P,
    safeDates: O,
    multiDates: _,
    ui: D,
    formats: B,
    teleport: W,
    timeConfig: H,
    flow: te,
    inputAttrs: re,
    floatingConfig: oe,
    getDate: s
  };
}, _t = () => {
  const e = (h, w) => tn(h, w ?? Ba.DATE), n = (h, w) => h ? Ba.MONTH_AND_YEAR : w ? Ba.YEAR : Ba.DATE, t = (h, w, S) => w.get(e(h, S)), a = (h) => h, s = (h) => h === 0 ? h : !h || Number.isNaN(+h) ? null : +h, l = () => [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
    "[data-datepicker-instance]"
  ].join(", "), r = (h, w) => {
    let S = [...document.querySelectorAll(l())];
    S = S.filter((C) => !h.contains(C) || "datepicker-instance" in C.dataset);
    const x = S.indexOf(h);
    if (x >= 0 && (w ? x - 1 >= 0 : x + 1 <= S.length))
      return S[x + (w ? -1 : 1)];
  }, i = (h) => String(h).padStart(2, "0"), o = (h, w) => h == null ? void 0 : h.querySelector(`[data-dp-element="${w}"]`), u = (h, w, S = !1) => {
    h && w.allowStopPropagation && (S && h.stopImmediatePropagation(), h.stopPropagation());
  }, c = (h, w, S = !1, x) => {
    if (h.key === ct.enter || h.key === ct.space)
      return S && h.preventDefault(), w();
    if (x) return x(h);
  }, f = (h, w) => {
    w.allowStopPropagation && h.stopPropagation(), w.allowPreventDefault && h.preventDefault();
  }, p = (h) => {
    if (h)
      return [...h.querySelectorAll("input, button, select, textarea, a[href]")][0];
  }, d = () => "ontouchstart" in globalThis || navigator.maxTouchPoints > 0, g = (h) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][h], v = (h) => {
    const w = [], S = (x) => x.filter((C) => !!C);
    for (let x = 0; x < h.length; x += 3) {
      const C = [h[x], h[x + 1], h[x + 2]];
      w.push(S(C));
    }
    return w;
  }, k = {
    prop: (h) => `"${h}" prop must be enabled!`,
    dateArr: (h) => `You need to use array as "model-value" binding in order to support "${h}"`
  }, y = (h, w, S, x, C) => {
    const _ = {
      hours: An,
      minutes: Un,
      seconds: aa
    };
    if (!w) return x ? [_[h](S), _[h](S)] : _[h](S);
    if (Array.isArray(w) && x) {
      const O = w[0] ?? S, P = w[1];
      return [_[h](O), P ? _[h](P) : C[h][1] ?? _[h](S)];
    }
    return Array.isArray(w) && !x ? _[h](w[w.length - 1] ?? S) : _[h](w);
  };
  return {
    getMapKey: e,
    getMapKeyType: n,
    getMapDate: t,
    convertType: a,
    getNumVal: s,
    findNextFocusableElement: r,
    padZero: i,
    getElWithin: o,
    checkStopPropagation: u,
    checkKeyDown: c,
    handleEventPropagation: f,
    findFocusableEl: p,
    isTouchDevice: d,
    hoursToAmPmHours: g,
    getGroupedList: v,
    setTimeModelValue: (h, w, S, x) => {
      h.hours = y("hours", w, S, x, h), h.minutes = y("minutes", w, S, x, h), h.seconds = y("seconds", w, S, x, h);
    },
    getTimeObjFromCurrent: (h, w, S) => {
      const x = {
        hours: An(h),
        minutes: Un(h),
        seconds: S ? aa(h) : 0
      };
      return Object.assign(x, w);
    },
    errorMapper: k
  };
}, Lt = () => {
  const { getDate: e } = Ke(), { getMapDate: n, getGroupedList: t } = _t(), a = (y, h) => {
    if (!y) return e();
    const w = e(y), S = je(w, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
    return h ? og(S) : S;
  }, s = (y, h) => {
    const w = e(h);
    return je(w, {
      hours: +(y.hours ?? An(w)),
      minutes: +(y.minutes ?? Un(w)),
      seconds: +(y.seconds ?? aa(w)),
      milliseconds: 0
    });
  }, l = (y, h) => {
    const w = rn(y, { weekStartsOn: +h }), S = Mi(y, { weekStartsOn: +h });
    return [w, S];
  }, r = (y, h) => !y || !h ? !1 : Yn(a(y), a(h)), i = (y, h) => !y || !h ? !1 : La(a(y), a(h)), o = (y, h) => !y || !h ? !1 : Mn(a(y), a(h)), u = (y, h, w) => y != null && y[0] && (y != null && y[1]) ? o(w, y[0]) && r(w, y[1]) : y != null && y[0] && h ? o(w, y[0]) && r(w, h) || r(w, y[0]) && o(w, h) : !1, c = (y, h) => {
    const w = o(y, h) ? h : y, S = o(h, y) ? h : y;
    return $i({ start: w, end: S });
  }, f = (y) => `dp-${tn(y, "yyyy-MM-dd")}`, p = (y) => a(je(e(y), { date: 1 })), d = (y, h) => {
    if (h) {
      const w = ze(e(h));
      if (w > y) return 12;
      if (w === y) return Ze(e(h));
    }
  }, g = (y, h) => {
    if (h) {
      const w = ze(e(h));
      return w < y ? -1 : w === y ? Ze(e(h)) : void 0;
    }
  }, v = (y) => {
    if (y) return ze(e(y));
  }, k = (y) => ({
    hours: An(y),
    minutes: Un(y),
    seconds: aa(y)
  });
  return {
    resetDateTime: a,
    groupListAndMap: (y, h) => t(y).map((w) => w.map((S) => {
      const { active: x, disabled: C, isBetween: _, highlighted: O } = h(S);
      return {
        ...S,
        active: x,
        disabled: C,
        className: {
          dp__overlay_cell_active: x,
          dp__overlay_cell: !x,
          dp__overlay_cell_disabled: C,
          dp__overlay_cell_pad: !0,
          dp__overlay_cell_active_disabled: C && x,
          dp__cell_in_between: _,
          "dp--highlighted": O
        }
      };
    })),
    setTime: s,
    getWeekFromDate: l,
    isDateAfter: o,
    isDateBefore: r,
    isDateBetween: u,
    isDateEqual: i,
    getDaysInBetween: c,
    getCellId: f,
    resetDate: p,
    getMinMonth: d,
    getMaxMonth: g,
    getYearFromDate: v,
    getTimeObj: k,
    setTimeValue: (y) => je(e(), k(y)),
    sanitizeTime: (y, h, w) => h && (w || w === 0) ? Object.fromEntries(
      ["hours", "minutes", "seconds"].map((S) => S === h ? [S, w] : [S, Number.isNaN(+y[S]) ? void 0 : +y[S]])
    ) : {
      hours: Number.isNaN(+y.hours) ? void 0 : +y.hours,
      minutes: Number.isNaN(+y.minutes) ? void 0 : +y.minutes,
      seconds: Number.isNaN(+(y.seconds ?? "")) ? void 0 : +y.seconds
    },
    getBeforeAndAfterInRange: (y, h) => {
      const w = xd(a(h), y), S = nn(a(h), y);
      return { before: w, after: S };
    },
    isModelAuto: (y) => Array.isArray(y) ? !!y[0] && !!y[1] : !1,
    matchDate: (y, h) => y ? h ? h instanceof Map ? !!n(y, h) : h(e(y)) : !1 : !0,
    checkHighlightMonth: (y, h, w) => typeof y == "function" ? y({ month: h, year: w }) : y.months.some((S) => S.month === h && S.year === w),
    checkHighlightYear: (y, h) => typeof y == "function" ? y(h) : y.years.includes(h)
  };
}, Wl = () => {
  const {
    defaults: { config: e }
  } = Ke(), n = ee(0);
  et(() => {
    t(), globalThis.addEventListener("resize", t, { passive: !0 });
  }), Jt(() => {
    globalThis.removeEventListener("resize", t);
  });
  const t = () => {
    n.value = globalThis.document.documentElement.clientWidth;
  };
  return {
    isMobile: M(() => n.value <= e.value.mobileBreakpoint ? !0 : void 0)
  };
}, sa = () => {
  const {
    getDate: e,
    state: n,
    modelValue: t,
    rootProps: a,
    defaults: { formats: s, textInput: l }
  } = Ke(), r = (g) => tn(vn(e(), g), s.value.year, { locale: a.locale }), i = (g) => tn(Sd(e(), g), s.value.month, { locale: a.locale }), o = (g) => tn(g, s.value.weekDay, { locale: a.locale }), u = (g) => tn(g, s.value.quarter, { locale: a.locale }), c = (g, v) => [g, v].map((k) => u(k)).join("-"), f = (g) => tn(g, s.value.day, { locale: a.locale }), p = (g, v, k) => {
    const y = k ? s.value.preview : s.value.input;
    if (!g) return "";
    if (typeof y == "function") return y(g);
    const h = v ?? y, w = { locale: a.locale };
    return Array.isArray(g) ? `${tn(g[0], h, w)}${a.modelAuto && !g[1] ? "" : l.value.rangeSeparator}${g[1] ? tn(g[1], h, w) : ""}` : tn(g, h, w);
  }, d = () => {
    const g = (v) => tn(v, l.value.format);
    return Array.isArray(t.value) ? `${g(t.value[0])} ${l.value.rangeSeparator} ${t.value[1] ? g(t.value[1]) : ""}` : "";
  };
  return {
    formatYear: r,
    formatMonth: i,
    formatWeekDay: o,
    formatQuarter: u,
    formatSelectedDate: p,
    formatForTextInput: () => n.isInputFocused && t.value ? Array.isArray(t.value) ? d() : tn(t.value, l.value.format) : p(t.value),
    formatPreview: (g) => p(g, void 0, !0),
    formatQuarterText: c,
    formatDay: f
  };
}, Yl = () => {
  const { rootProps: e } = Ke(), { formatYear: n, formatMonth: t } = sa();
  return {
    getMonths: () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((a) => ({
      text: t(a),
      value: a
    })),
    getYears: () => {
      const a = [];
      for (let s = +e.yearRange[0]; s <= +e.yearRange[1]; s++)
        a.push({ value: +s, text: n(s) });
      return e.reverseYears ? a.reverse() : a;
    },
    isOutOfYearRange: (a) => a < +e.yearRange[0] || a > +e.yearRange[1]
  };
}, t0 = (e) => ({
  openMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.openMenu();
  },
  closeMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.closeMenu();
  },
  selectDate: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.selectDate();
  },
  clearValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.clearValue();
  },
  formatInputValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.formatInputValue();
  },
  updateInternalModelValue: (n) => {
    var t;
    return (t = e.value) == null ? void 0 : t.updateInternalModelValue(n);
  },
  setMonthYear: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.setMonthYear(n, t);
  },
  parseModel: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.parseModel();
  },
  switchView: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.switchView(n, t);
  },
  handleFlow: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.handleFlow();
  },
  toggleMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.toggleMenu();
  },
  dpMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpMenuRef();
  },
  dpWrapMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpWrapMenuRef();
  },
  inputRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.inputRef();
  }
}), ls = () => ({
  boolHtmlAttribute: (e) => e ? !0 : void 0
}), n0 = () => {
  const {
    getDate: e,
    rootProps: n,
    defaults: { textInput: t, startTime: a, timeConfig: s }
  } = Ke(), { getTimeObjFromCurrent: l } = _t(), r = ee(!1), i = M(
    () => Array.isArray(a.value) ? a.value[0] : a.value ?? l(e(), {}, s.value.enableSeconds)
  ), o = (c, f) => {
    var w, S;
    const p = /[^a-zA-Z]+/g, d = /\D+/g, g = f.split(d), v = c.split(p), k = c.match(p) || [], y = f.match(d) || [];
    let h = "";
    for (let x = 0; x < g.length && x < v.length; x++) {
      x > 0 && y[x - 1] && (h += k[x - 1] || y[x - 1]);
      const C = (w = g[x]) == null ? void 0 : w.length;
      h += (S = v[x]) == null ? void 0 : S.slice(0, C);
    }
    return h;
  }, u = (c, f, p) => {
    const d = Xr(c, o(f, c), e(), {
      locale: n.locale
    });
    return $s(d) && dd(d) ? p || r.value ? d : je(d, {
      hours: +i.value.hours,
      minutes: +i.value.minutes,
      seconds: +(i.value.seconds ?? 0),
      milliseconds: 0
    }) : null;
  };
  return {
    textPasted: r,
    parseFreeInput: (c, f) => {
      if (typeof t.value.pattern == "string")
        return u(c, t.value.pattern, f);
      if (Array.isArray(t.value.pattern)) {
        let p = null;
        for (const d of t.value.pattern)
          if (p = u(c, d, f), p)
            break;
        return p;
      }
      return typeof t.value.pattern == "function" ? t.value.pattern(c) : null;
    },
    applyMaxValues: (c, f) => {
      const p = {
        MM: 12,
        DD: 31,
        hh: 23,
        mm: 59,
        ss: 59
      };
      let d = "", g = 0;
      for (let v = 0; v < f.length; v++) {
        const k = f[v], y = k.length, h = c.slice(g, g + y);
        if (!h) break;
        if (h.length < y)
          d += h;
        else {
          let w = Number.parseInt(h, 10);
          p[k] && w > p[k] && (w = p[k]), d += w.toString().padStart(y, "0").slice(0, y);
        }
        g += y;
      }
      return d;
    },
    createMaskedValue: (c, f) => {
      const p = /(YYYY|MM|DD|hh|mm|ss)/g, d = [...f.matchAll(p)].map((h) => h[0]), g = f.replace(p, "|").split("|").filter(Boolean), v = d.map((h) => h.length);
      let k = "", y = 0;
      for (let h = 0; h < d.length; h++) {
        const w = v[h], S = c.slice(y, y + w);
        if (!S) break;
        k += S, S.length === w && g[h] && (k += g[h]), y += w;
      }
      return k;
    }
  };
};
var yn = /* @__PURE__ */ ((e) => (e.Input = "input", e.DatePicker = "date-picker", e.Calendar = "calendar", e.DatePickerHeader = "date-picker-header", e.Menu = "menu", e.ActionRow = "action-row", e.TimePicker = "time-picker", e.TimeInput = "time-input", e.PassTrough = "pass-trough", e.MonthPicker = "month-picker", e.YearMode = "year-mode", e.QuarterPicker = "quarter-picker", e.YearPicker = "year-picker", e))(yn || {});
const Aa = [
  "time-input",
  "time-picker",
  "pass-trough"
  /* PassTrough */
], Ad = [
  { name: "trigger", use: [
    "input"
    /* Input */
  ] },
  { name: "input-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "clear-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "dp-input", use: [
    "input"
    /* Input */
  ] },
  { name: "clock-icon", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "arrow-left", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "arrow-right", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  {
    name: "arrow-up",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "arrow-down",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "calendar-icon",
    use: [
      "date-picker-header",
      "time-picker",
      "pass-trough",
      "year-mode"
      /* YearMode */
    ]
  },
  { name: "day", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "month-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker"
      /* MonthPicker */
    ]
  },
  {
    name: "year-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "year-mode",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "year-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "hours-overlay-value",
    use: Aa
  },
  {
    name: "hours-overlay-header",
    use: Aa
  },
  {
    name: "minutes-overlay-value",
    use: Aa
  },
  {
    name: "minutes-overlay-header",
    use: Aa
  },
  {
    name: "seconds-overlay-value",
    use: Aa
  },
  {
    name: "seconds-overlay-header",
    use: Aa
  },
  { name: "hours", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "minutes", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "seconds", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "action-buttons", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "action-preview", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "calendar-header", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "marker-tooltip", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-extra", use: [
    "menu"
    /* Menu */
  ] },
  { name: "time-picker-overlay", use: [
    "time-picker",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "am-pm-button", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "left-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  { name: "right-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  {
    name: "month-year",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "time-picker", use: [
    "date-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-row", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "marker", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "quarter", use: [
    "quarter-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "top-extra",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "quarter-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  {
    name: "tp-inline-arrow-up",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "tp-inline-arrow-down",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  { name: "arrow", use: [
    "menu"
    /* Menu */
  ] },
  { name: "menu-header", use: [
    "menu"
    /* Menu */
  ] }
], _n = (e, n) => Ad.filter((t) => e[t.name] && t.use.includes(n)).map((t) => t.name), Pd = (e, n) => Ad.map((t) => t.name).concat((n == null ? void 0 : n.filter((t) => t.slot).map((t) => t.slot)) ?? []).filter((t) => !!e[t]), a0 = {
  key: 1,
  class: "dp__input_wrap"
}, s0 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], l0 = {
  key: 1,
  class: "dp--clear-btn"
}, r0 = ["aria-label"], i0 = /* @__PURE__ */ xe({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 }
  },
  emits: ["clear", "open", "set-input-date", "close", "select-date", "set-empty-date", "toggle", "focus", "blur", "real-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      inputValue: r,
      rootProps: i,
      defaults: { textInput: o, ariaLabels: u, inline: c, config: f, range: p, multiDates: d, ui: g, inputAttrs: v }
    } = Ke(), { checkMinMaxRange: k, isValidDate: y } = on(), { parseFreeInput: h, textPasted: w, createMaskedValue: S, applyMaxValues: x } = n0(), { checkKeyDown: C, checkStopPropagation: _ } = _t(), { boolHtmlAttribute: O } = ls(), P = Xe("dp-input"), D = ee(null), B = ee(!1), W = M(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !o.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !o.value.enabled,
        dp__input: !0,
        dp__input_not_clearable: !v.value.clearable,
        dp__input_icon_pad: !v.value.hideInputIcon,
        dp__input_valid: typeof v.value.state == "boolean" ? v.value.state : !1,
        dp__input_invalid: typeof v.value.state == "boolean" ? !v.value.state : !1,
        dp__input_focus: B.value || s.isMenuOpen,
        dp__input_reg: !o.value.enabled,
        ...g.value.input
      })
    ), H = () => {
      a("set-input-date", null), v && i.autoApply && (a("set-empty-date"), D.value = null);
    }, te = (V) => {
      var G;
      if ((G = o.value.separators) != null && G.length) {
        const he = new RegExp(
          o.value.separators.map((j) => j.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")
        );
        return V.split(he);
      }
      return V.split(o.value.rangeSeparator);
    }, re = (V) => {
      const [G, he] = te(V);
      if (G) {
        const j = h(G.trim(), r.value), se = he ? h(he.trim(), r.value) : void 0;
        if (Mn(j, se)) return;
        const me = j && se ? [j, se] : [j];
        k(se, me, 0) && (D.value = j ? me : null);
      }
    }, oe = () => {
      w.value = !0;
    }, K = (V) => {
      if (p.value.enabled)
        re(V);
      else if (d.value.enabled) {
        const G = V.split(";");
        D.value = G.map((he) => h(he.trim())).filter((he) => !!he);
      } else
        D.value = h(V, r.value);
    }, ae = (V) => {
      var se, me;
      const G = typeof V == "string" ? V : (se = V.target) == null ? void 0 : se.value, he = (me = o == null ? void 0 : o.value) == null ? void 0 : me.maskFormat;
      let j = G;
      if (typeof he == "string") {
        const I = /(YYYY|MM|DD|hh|mm|ss)/g, N = [...he.matchAll(I)].map((A) => A[0]), T = G.replace(/\D/g, ""), R = x(T, N);
        j = S(R, he);
      }
      j === "" ? H() : (o.value.openMenu && !s.isMenuOpen && a("open"), K(j), a("set-input-date", D.value)), w.value = !1, r.value = j, l("text-input", V, D.value);
    }, U = (V) => {
      o.value.enabled ? (K(V.target.value), o.value.enterSubmit && y(D.value) && r.value !== "" ? (a("set-input-date", D.value, !0), D.value = null) : o.value.enterSubmit && r.value === "" && (D.value = null, a("clear"))) : de(V);
    }, z = (V, G) => {
      o.value.enabled && o.value.tabSubmit && !G && K(V.target.value), o.value.tabSubmit && y(D.value) && r.value !== "" ? (a("set-input-date", D.value, !0, !0), D.value = null) : o.value.tabSubmit && r.value === "" && (D.value = null, a("clear"));
    }, J = () => {
      B.value = !0, a("focus"), Ge().then(() => {
        var V;
        o.value.enabled && o.value.selectOnFocus && ((V = P.value) == null || V.select());
      });
    }, de = (V) => {
      if (_(V, f.value, !0), o.value.enabled && o.value.openMenu && !c.value.input) {
        if (o.value.openMenu === "open" && !s.isMenuOpen) return a("open");
        if (o.value.openMenu === "toggle") return a("toggle");
      } else o.value.enabled || a("toggle");
    }, pe = () => {
      a("real-blur"), B.value = !1, (!s.isMenuOpen || c.value.enabled && c.value.input) && a("blur"), (i.autoApply && o.value.enabled && D.value && !s.isMenuOpen || o.value.applyOnBlur) && (a("set-input-date", D.value), a("select-date"), D.value = null);
    }, ge = (V) => {
      _(V, f.value, !0), a("clear");
    }, Me = () => {
      a("close");
    }, be = (V) => {
      if (V.key === "Tab" && z(V), V.key === "Enter" && U(V), V.key === "Escape" && o.value.escClose && Me(), !o.value.enabled) {
        if (V.code === "Tab") return;
        V.preventDefault();
      }
    }, q = () => {
      var V;
      (V = P.value) == null || V.focus({ preventScroll: !0 });
    }, ye = (V) => {
      D.value = V;
    }, Ce = (V) => {
      V.key === ct.tab && z(V, !0);
    };
    return n({
      focusInput: q,
      setParsedDate: ye
    }), (V, G) => {
      var he, j;
      return b(), $("div", { onClick: de }, [
        !V.$slots["dp-input"] && !m(c).enabled ? Y(V.$slots, "trigger", { key: 0 }) : F("", !0),
        !V.$slots.trigger && (!m(c).enabled || m(c).input) ? (b(), $("div", a0, [
          !V.$slots.trigger && (!m(c).enabled || m(c).enabled && m(c).input) ? Y(V.$slots, "dp-input", {
            key: 0,
            value: m(r),
            isMenuOpen: e.isMenuOpen,
            onInput: ae,
            onEnter: U,
            onTab: z,
            onClear: ge,
            onBlur: pe,
            onKeypress: be,
            onPaste: oe,
            onFocus: J,
            openMenu: () => V.$emit("open"),
            closeMenu: () => V.$emit("close"),
            toggleMenu: () => V.$emit("toggle")
          }, () => [
            E("input", {
              id: m(v).id,
              ref: "dp-input",
              "data-test-id": "dp-input",
              name: m(v).name,
              class: X(W.value),
              inputmode: m(v).inputmode,
              placeholder: m(i).placeholder,
              disabled: m(O)(m(i).disabled),
              readonly: m(O)(m(i).readonly),
              required: m(O)(m(v).required),
              value: m(r),
              autocomplete: m(v).autocomplete,
              "aria-label": m(u).input,
              "aria-disabled": m(i).disabled || void 0,
              "aria-invalid": m(v).state === !1 ? !0 : void 0,
              onInput: ae,
              onBlur: pe,
              onFocus: J,
              onKeypress: be,
              onKeydown: G[0] || (G[0] = (se) => be(se)),
              onPaste: oe,
              onInvalid: G[1] || (G[1] = (se) => m(l)("invalid", se))
            }, null, 42, s0)
          ]) : F("", !0),
          E("div", {
            onClick: G[4] || (G[4] = (se) => a("toggle"))
          }, [
            V.$slots["input-icon"] && !m(v).hideInputIcon ? (b(), $("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: G[2] || (G[2] = (se) => a("toggle"))
            }, [
              Y(V.$slots, "input-icon")
            ])) : F("", !0),
            !V.$slots["input-icon"] && !m(v).hideInputIcon && !V.$slots["dp-input"] ? (b(), ue(m(Ys), {
              key: 1,
              "aria-label": (he = m(u)) == null ? void 0 : he.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: G[3] || (G[3] = (se) => a("toggle"))
            }, null, 8, ["aria-label"])) : F("", !0)
          ]),
          V.$slots["clear-icon"] && (m(v).alwaysClearable || m(r) && m(v).clearable && !m(i).disabled && !m(i).readonly) ? (b(), $("span", l0, [
            Y(V.$slots, "clear-icon", { clear: ge })
          ])) : F("", !0),
          !V.$slots["clear-icon"] && (m(v).alwaysClearable || m(v).clearable && m(r) && !m(i).disabled && !m(i).readonly) ? (b(), $("button", {
            key: 2,
            "aria-label": (j = m(u)) == null ? void 0 : j.clearInput,
            class: "dp--clear-btn",
            type: "button",
            "data-test-id": "clear-input-value-btn",
            onKeydown: G[5] || (G[5] = (se) => m(C)(se, () => ge(se), !0, Ce)),
            onClick: G[6] || (G[6] = Ve((se) => ge(se), ["prevent"]))
          }, [
            le(m(rb), { class: "dp__input_icons" })
          ], 40, r0)) : F("", !0)
        ])) : F("", !0)
      ]);
    };
  }
}), o0 = {
  ref: "action-row",
  class: "dp__action_row"
}, u0 = ["title"], c0 = {
  ref: "action-buttons-container",
  class: "dp__action_buttons",
  "data-dp-element": "action-row"
}, d0 = ["disabled"], f0 = /* @__PURE__ */ xe({
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { default: 0 }
  },
  emits: ["close-picker", "select-date", "select-now"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      rootEmit: s,
      rootProps: l,
      modelValue: r,
      defaults: { actionRow: i, multiCalendars: o, inline: u, range: c, multiDates: f, formats: p }
    } = Ke(), { isTimeValid: d, isMonthValid: g } = on(), { formatPreview: v } = sa(), { checkKeyDown: k, convertType: y } = _t(), { boolHtmlAttribute: h } = ls(), w = Xe("action-buttons-container"), S = Xe("action-row"), x = ee(!1), C = ee({});
    et(() => {
      _(), globalThis.addEventListener("resize", _);
    }), Jt(() => {
      globalThis.removeEventListener("resize", _);
    });
    const _ = () => {
      x.value = !1, setTimeout(() => {
        var ae, U;
        const oe = (ae = w.value) == null ? void 0 : ae.getBoundingClientRect(), K = (U = S.value) == null ? void 0 : U.getBoundingClientRect();
        oe && K && (C.value.maxWidth = `${K.width - oe.width - 20}px`), x.value = !0;
      }, 0);
    }, O = M(() => c.value.enabled && !c.value.partialRange && r.value ? r.value.length === 2 : !0), P = M(
      () => !d.value(r.value) || !g.value(r.value) || !O.value
    ), D = () => {
      const oe = p.value.preview;
      return l.timePicker || l.monthPicker, oe(y(r.value));
    }, B = () => {
      const oe = r.value;
      return o.value.count > 0 ? `${v(oe[0])} - ${v(oe[1])}` : [v(oe[0]), v(oe[1])];
    }, W = M(() => !r.value || !a.menuMount ? "" : typeof p.value.preview == "string" ? Array.isArray(r.value) ? r.value.length === 2 && r.value[1] ? B() : f.value.enabled ? r.value.map((oe) => `${v(oe)}`) : l.modelAuto ? `${v(r.value[0])}` : `${v(r.value[0])} -` : v(r.value) : D()), H = () => f.value.enabled ? "; " : " - ", te = M(
      () => Array.isArray(W.value) ? W.value.join(H()) : W.value
    ), re = () => {
      d.value(r.value) && g.value(r.value) && O.value ? t("select-date") : s("invalid-select");
    };
    return (oe, K) => (b(), $("div", o0, [
      oe.$slots["action-row"] ? Y(oe.$slots, "action-row", Ct(lt({ key: 0 }, {
        modelValue: m(r),
        disabled: P.value,
        selectDate: () => oe.$emit("select-date"),
        closePicker: () => oe.$emit("close-picker")
      }))) : (b(), $(Te, { key: 1 }, [
        m(i).showPreview ? (b(), $("div", {
          key: 0,
          class: "dp__selection_preview",
          title: te.value || void 0,
          style: Fe(C.value)
        }, [
          oe.$slots["action-preview"] && x.value ? Y(oe.$slots, "action-preview", {
            key: 0,
            value: m(r),
            formatValue: te.value
          }) : F("", !0),
          !oe.$slots["action-preview"] && x.value ? (b(), $(Te, { key: 1 }, [
            Ye(ie(te.value), 1)
          ], 64)) : F("", !0)
        ], 12, u0)) : F("", !0),
        E("div", c0, [
          oe.$slots["action-buttons"] ? Y(oe.$slots, "action-buttons", {
            key: 0,
            value: m(r),
            selectDate: re,
            selectionDisabled: P.value
          }) : F("", !0),
          oe.$slots["action-buttons"] ? F("", !0) : (b(), $(Te, { key: 1 }, [
            !m(u).enabled && m(i).showCancel ? (b(), $("button", {
              key: 0,
              ref: "cancel-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: K[0] || (K[0] = (ae) => oe.$emit("close-picker")),
              onKeydown: K[1] || (K[1] = (ae) => m(k)(ae, () => oe.$emit("close-picker")))
            }, ie(m(i).cancelBtnLabel), 545)) : F("", !0),
            m(i).showNow ? (b(), $("button", {
              key: 1,
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: K[2] || (K[2] = (ae) => oe.$emit("select-now")),
              onKeydown: K[3] || (K[3] = (ae) => m(k)(ae, () => oe.$emit("select-now")))
            }, ie(m(i).nowBtnLabel), 33)) : F("", !0),
            m(i).showSelect ? (b(), $("button", {
              key: 2,
              ref: "select-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_select",
              disabled: m(h)(P.value),
              "data-test-id": "select-button",
              onKeydown: K[4] || (K[4] = (ae) => m(k)(ae, () => re())),
              onClick: re
            }, ie(m(i).selectBtnLabel), 41, d0)) : F("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Hl = () => {
  const {
    rootProps: e,
    defaults: { multiCalendars: n }
  } = Ke(), t = M(() => (l) => {
    var r;
    return (r = e.hideNavigation) == null ? void 0 : r.includes(l);
  }), a = M(() => (l) => n.value.count ? n.value.solo ? !0 : l === 0 : !0), s = M(() => (l) => n.value.count ? n.value.solo ? !0 : l === n.value.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: a, showRightIcon: s };
}, h0 = ["role", "aria-label", "tabindex"], m0 = { class: "dp__selection_grid_header" }, v0 = ["aria-selected", "aria-disabled", "data-dp-action-element", "data-dp-element-active", "data-test-id", "onClick", "onKeydown", "onMouseover"], p0 = ["aria-label", "data-dp-action-element"], qs = /* @__PURE__ */ xe({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    useRelative: { type: Boolean },
    height: {},
    overlayLabel: {},
    isLast: { type: Boolean },
    level: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      setState: s,
      defaults: { ariaLabels: l, config: r }
    } = Ke(), { hideNavigationButtons: i } = Hl(), { handleEventPropagation: o, checkKeyDown: u } = _t(), c = Xe("toggle-button"), f = Xe("overlay-container"), p = Xe("grid-wrap"), d = ee(!1), g = ee(null), v = ee(), k = ee(0);
    bf(() => {
      g.value = null;
    }), et(async () => {
      await Ge(), C(), s("arrowNavigationLevel", a.level ?? 1);
    }), Jt(() => {
      s("arrowNavigationLevel", (a.level ?? 1) - 1);
    });
    const y = M(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !a.useRelative,
        "dp--overlay-relative": a.useRelative
      })
    ), h = M(
      () => a.useRelative ? { height: `${a.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), w = M(() => ({
      dp__overlay_col: !0
    })), S = M(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: d.value,
        dp__button_bottom: a.isLast
      })
    ), x = M(() => {
      var H, te;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((H = a.items) == null ? void 0 : H.length) <= 6,
        dp__container_block: ((te = a.items) == null ? void 0 : te.length) > 6
      };
    });
    Be(
      () => a.items,
      () => C(!1),
      { deep: !0 }
    );
    const C = (H = !0) => {
      Ge().then(() => {
        const te = document.querySelector(`[data-dp-element-active="${a.level ?? 1}"]`), re = Kt(p), oe = Kt(c), K = Kt(f), ae = oe ? oe.getBoundingClientRect().height : 0;
        re && (re.getBoundingClientRect().height ? k.value = re.getBoundingClientRect().height - ae : k.value = r.value.modeHeight - ae), te && K && H && (K.scrollTop = te.offsetTop - K.offsetTop - (k.value / 2 - te.getBoundingClientRect().height) - ae);
      });
    }, _ = (H) => {
      H.disabled || t("selected", H.value);
    }, O = () => {
      t("toggle"), t("reset-flow");
    }, P = (H) => {
      r.value.escClose && (O(), o(H, r.value));
    }, D = (H) => {
      v.value = H, t("hover-value", H);
    }, B = (H) => {
      if (H.key === ct.esc) return P(H);
    }, W = (H) => {
      if (H.key === ct.enter) return O();
    };
    return (H, te) => {
      var re;
      return b(), $("div", {
        ref: "grid-wrap",
        class: X(y.value),
        style: Fe(h.value),
        role: e.useRelative ? void 0 : "dialog",
        "aria-label": e.overlayLabel,
        tabindex: e.useRelative ? void 0 : "0",
        onKeydown: B,
        onClick: te[0] || (te[0] = Ve(() => {
        }, ["prevent"]))
      }, [
        E("div", {
          ref: "overlay-container",
          class: X(x.value),
          style: Fe({ "--dp-overlay-height": `${k.value}px` }),
          role: "grid"
        }, [
          E("div", m0, [
            Y(H.$slots, "header")
          ]),
          Y(H.$slots, "overlay", {}, () => [
            (b(!0), $(Te, null, Ie(e.items, (oe, K) => (b(), $("div", {
              key: K,
              class: X(["dp__overlay_row", { dp__flex_row: e.items.length >= 3 }]),
              role: "row"
            }, [
              (b(!0), $(Te, null, Ie(oe, (ae) => (b(), $("div", {
                key: ae.value,
                role: "gridcell",
                class: X(w.value),
                "aria-selected": ae.active || void 0,
                "aria-disabled": ae.disabled || void 0,
                "data-dp-action-element": e.level ?? 1,
                "data-dp-element-active": ae.active ? e.level ?? 1 : void 0,
                tabindex: "0",
                "data-test-id": ae.text,
                onClick: Ve((U) => _(ae), ["prevent"]),
                onKeydown: (U) => m(u)(U, () => _(ae), !0),
                onMouseover: (U) => D(ae.value)
              }, [
                E("div", {
                  class: X(ae.className)
                }, [
                  Y(H.$slots, "item", { item: ae }, () => [
                    Ye(ie(ae.text), 1)
                  ])
                ], 2)
              ], 42, v0))), 128))
            ], 2))), 128))
          ])
        ], 6),
        H.$slots["button-icon"] ? an((b(), $("button", {
          key: 0,
          ref: "toggle-button",
          type: "button",
          "aria-label": (re = m(l)) == null ? void 0 : re.toggleOverlay,
          class: X(S.value),
          tabindex: "0",
          "data-dp-action-element": e.level ?? 1,
          onClick: O,
          onKeydown: W
        }, [
          Y(H.$slots, "button-icon")
        ], 42, p0)), [
          [Wn, !m(i)(e.type)]
        ]) : F("", !0)
      ], 46, h0);
    };
  }
}), g0 = ["data-dp-mobile"], Ul = /* @__PURE__ */ xe({
  __name: "InstanceWrap",
  props: {
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const {
      defaults: { multiCalendars: n }
    } = Ke(), { isMobile: t } = Wl(), a = M(
      () => n.value.count > 0 ? [...new Array(n.value.count).keys()] : [0]
    );
    return (s, l) => (b(), $("div", {
      class: X({
        dp__menu_inner: !e.stretch,
        "dp--menu--inner-stretched": e.stretch,
        dp__flex_display: m(n).count > 0,
        "dp--flex-display-collapsed": e.collapse
      }),
      "data-dp-mobile": m(t)
    }, [
      Y(s.$slots, "default", {
        instances: a.value,
        wrapClass: { dp__instance_calendar: m(n).count > 0 }
      })
    ], 10, g0));
  }
}), y0 = ["data-dp-element", "aria-label", "aria-disabled"], Ms = /* @__PURE__ */ xe({
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: n }) {
    const { checkKeyDown: t } = _t(), a = n;
    return (s, l) => (b(), $("button", {
      ref: "arrow-btn",
      type: "button",
      "data-dp-element": e.elName,
      "data-dp-action-element": "0",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled || void 0,
      onClick: l[0] || (l[0] = (r) => a("activate")),
      onKeydown: l[1] || (l[1] = (r) => m(t)(r, () => a("activate"), !0))
    }, [
      E("span", {
        class: X(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        Y(s.$slots, "default")
      ], 2)
    ], 40, y0));
  }
}), b0 = ["aria-label", "data-test-id"], Rd = /* @__PURE__ */ xe({
  __name: "YearModePicker",
  props: {
    items: {},
    instance: {},
    year: {},
    showYearPicker: { type: Boolean, default: !1 },
    isDisabled: {}
  },
  emits: ["handle-year", "year-select", "toggle-year-picker"],
  setup(e, { emit: n }) {
    const t = n, a = e, { showRightIcon: s, showLeftIcon: l } = Hl(), {
      rootProps: r,
      defaults: { config: i, ariaLabels: o, ui: u }
    } = Ke(), { showTransition: c, transitionName: f } = Hs(), { formatYear: p } = sa(), { boolHtmlAttribute: d } = ls(), g = ee(!1), v = M(() => p(a.year)), k = (w = !1, S) => {
      g.value = !g.value, t("toggle-year-picker", { flow: w, show: S });
    }, y = (w) => {
      g.value = !1, t("year-select", w);
    }, h = (w = !1) => {
      t("handle-year", w);
    };
    return (w, S) => {
      var x, C, _, O, P;
      return b(), $(Te, null, [
        E("div", {
          class: X(["dp--year-mode-picker", { "dp--hidden-el": g.value }])
        }, [
          m(l)(e.instance) ? (b(), ue(Ms, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (x = m(o)) == null ? void 0 : x.prevYear,
            disabled: m(d)(e.isDisabled(!1)),
            class: X((C = m(u)) == null ? void 0 : C.navBtnPrev),
            onActivate: S[0] || (S[0] = (D) => h(!1))
          }, {
            default: ce(() => [
              w.$slots["arrow-left"] ? Y(w.$slots, "arrow-left", { key: 0 }) : F("", !0),
              w.$slots["arrow-left"] ? F("", !0) : (b(), ue(m(Md), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : F("", !0),
          E("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${e.year}-${(_ = m(o)) == null ? void 0 : _.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${e.instance}`,
            "data-dp-action-element": "0",
            onClick: S[1] || (S[1] = () => k(!1)),
            onKeydown: S[2] || (S[2] = Pt(Ve(() => k(!1), ["prevent"]), ["enter"]))
          }, [
            w.$slots.year ? Y(w.$slots, "year", {
              key: 0,
              text: v.value,
              value: e.year
            }) : F("", !0),
            w.$slots.year ? F("", !0) : (b(), $(Te, { key: 1 }, [
              Ye(ie(e.year), 1)
            ], 64))
          ], 40, b0),
          m(s)(e.instance) ? (b(), ue(Ms, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (O = m(o)) == null ? void 0 : O.nextYear,
            disabled: m(d)(e.isDisabled(!0)),
            class: X((P = m(u)) == null ? void 0 : P.navBtnNext),
            onActivate: S[3] || (S[3] = (D) => h(!0))
          }, {
            default: ce(() => [
              w.$slots["arrow-right"] ? Y(w.$slots, "arrow-right", { key: 0 }) : F("", !0),
              w.$slots["arrow-right"] ? F("", !0) : (b(), ue(m(Cd), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : F("", !0)
        ], 2),
        le(St, {
          name: m(f)(e.showYearPicker),
          css: m(c)
        }, {
          default: ce(() => {
            var D, B;
            return [
              e.showYearPicker ? (b(), ue(qs, {
                key: 0,
                items: e.items,
                config: m(i),
                "is-last": m(r).autoApply && !m(i).keepActionRow,
                "overlay-label": (B = (D = m(o)) == null ? void 0 : D.yearPicker) == null ? void 0 : B.call(D, !0),
                type: "year",
                onToggle: k,
                onSelected: S[4] || (S[4] = (W) => y(W))
              }, dt({
                "button-icon": ce(() => [
                  w.$slots["calendar-icon"] ? Y(w.$slots, "calendar-icon", { key: 0 }) : F("", !0),
                  w.$slots["calendar-icon"] ? F("", !0) : (b(), ue(m(Ys), { key: 1 }))
                ]),
                _: 2
              }, [
                w.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: ce(({ item: W }) => [
                    Y(w.$slots, "year-overlay-value", {
                      text: W.text,
                      value: W.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "config", "is-last", "overlay-label"])) : F("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Fd = (e) => {
  const {
    getDate: n,
    rootEmit: t,
    state: a,
    month: s,
    year: l,
    modelValue: r,
    calendars: i,
    rootProps: o,
    defaults: { multiCalendars: u, range: c, safeDates: f, filters: p, highlight: d }
  } = Ke(), { resetDate: g, getYearFromDate: v, checkHighlightYear: k, groupListAndMap: y } = Lt(), { getYears: h } = Yl(), { validateMonthYear: w, checkMinMaxValue: S } = on(), x = ee([!1]), C = M(() => h()), _ = M(() => (z, J) => {
    const de = je(g(n()), {
      month: s.value(z),
      year: l.value(z)
    }), pe = J ? hd(de) : Ua(de);
    return w(pe, o.preventMinMaxNavigation, J);
  }), O = () => Array.isArray(r.value) && u.value.solo && r.value[1], P = () => {
    for (let z = 0; z < u.value.count; z++)
      if (z === 0)
        i.value[z] = i.value[0];
      else if (z === u.value.count - 1 && O())
        i.value[z] = {
          month: Ze(r.value[1]),
          year: ze(r.value[1])
        };
      else {
        const J = je(n(), i.value[z - 1]);
        i.value[z] = { month: Ze(J), year: ze(Ti(J, 1)) };
      }
  }, D = (z) => {
    if (!z) return P();
    const J = je(n(), i.value[z]);
    return i.value[0].year = ze(Td(J, u.value.count - 1)), P();
  }, B = (z, J) => {
    const de = rg(J, z);
    return c.value.showLastInRange && de > 1 ? J : z;
  }, W = (z) => o.focusStartDate || u.value.solo ? z[0] : z[1] ? B(z[0], z[1]) : z[0], H = () => {
    if (r.value) {
      const z = Array.isArray(r.value) ? W(r.value) : r.value;
      i.value[0] = { month: Ze(z), year: ze(z) };
    }
  }, te = () => {
    H(), u.value.count && P();
  };
  Be(r, (z, J) => {
    a.isTextInputDate && JSON.stringify(z ?? {}) !== JSON.stringify(J ?? {}) && te();
  }), et(() => {
    te();
  });
  const re = (z, J) => {
    i.value[J].year = z, t("update-month-year", { instance: J, year: z, month: i.value[J].month }), u.value.count && !u.value.solo && D(J);
  }, oe = M(() => (z) => y(C.value, (J) => {
    var Me;
    const de = l.value(z) === J.value, pe = S(
      J.value,
      v(f.value.minDate),
      v(f.value.maxDate)
    ) || ((Me = p.value.years) == null ? void 0 : Me.includes(l.value(z))), ge = k(d.value, J.value);
    return { active: de, disabled: pe, highlighted: ge };
  })), K = (z, J) => {
    re(z, J), U(J);
  }, ae = (z, J = !1) => {
    if (!_.value(z, J)) {
      const de = J ? l.value(z) + 1 : l.value(z) - 1;
      re(de, z);
    }
  }, U = (z, J = !1, de) => {
    J || e("reset-flow"), de === void 0 ? x.value[z] = !x.value[z] : x.value[z] = de, x.value[z] ? t("overlay-toggle", { open: !0, overlay: Nt.year }) : t("overlay-toggle", { open: !1, overlay: Nt.year });
  };
  return {
    isDisabled: _,
    groupedYears: oe,
    showYearPicker: x,
    selectYear: re,
    setStartDate: () => {
      o.startDate && (r.value && o.focusStartDate || !r.value) && re(ze(n(o.startDate)), 0);
    },
    toggleYearPicker: U,
    handleYearSelect: K,
    handleYear: ae
  };
}, ql = () => {
  const { isDateAfter: e, isDateBefore: n, isDateEqual: t } = Lt(), {
    getDate: a,
    rootEmit: s,
    rootProps: l,
    modelValue: r,
    defaults: { range: i }
  } = Ke();
  return {
    getRangeWithFixedDate: (o) => Array.isArray(r.value) && (r.value.length === 2 || r.value.length === 1 && i.value.partialRange) ? i.value.fixedStart && (e(o, r.value[0]) || t(o, r.value[0])) ? [r.value[0], o] : i.value.fixedEnd && (n(o, r.value[1]) || t(o, r.value[1])) ? [o, r.value[1]] : (s("invalid-fixed-range", o), r.value) : [],
    setPresetDate: (o) => {
      Array.isArray(o.value) && o.value.length <= 2 && i.value.enabled ? r.value = o.value.map((u) => a(u)) : Array.isArray(o.value) || (r.value = a(o.value));
    },
    checkRangeAutoApply: (o, u, c) => {
      i && (o[0] && o[1] && l.autoApply && u("auto-apply", c), o[0] && !o[1] && (l.modelAuto || i.value.partialRange) && l.autoApply && u("auto-apply", c));
    },
    setMonthOrYearRange: (o) => {
      let u = r.value ? r.value.slice() : [];
      return u.length === 2 && u[1] !== null && (u = []), u.length ? (n(o, u[0]) ? u.unshift(o) : u[1] = o, s("range-end", o)) : (u = [o], s("range-start", o)), u;
    },
    handleMultiDatesSelect: (o, u) => {
      if (r.value && Array.isArray(r.value))
        if (r.value.some((c) => t(o, c))) {
          const c = r.value.filter((f) => !t(f, o));
          r.value = c.length ? c : null;
        } else (u && +u > r.value.length || !u) && r.value.push(o);
      else
        r.value = [o];
    }
  };
}, w0 = (e, n) => {
  const {
    getDate: t,
    rootEmit: a,
    state: s,
    calendars: l,
    year: r,
    modelValue: i,
    rootProps: o,
    defaults: { range: u, highlight: c, safeDates: f, filters: p, multiDates: d }
  } = Ke();
  Us(() => {
    s.isTextInputDate && K(ze(t(o.startDate)), 0);
  });
  const { checkMinMaxRange: g, checkMinMaxValue: v } = on(), { isDateBetween: k, resetDateTime: y, resetDate: h, getMinMonth: w, getMaxMonth: S, checkHighlightMonth: x, groupListAndMap: C } = Lt(), { checkRangeAutoApply: _, getRangeWithFixedDate: O, handleMultiDatesSelect: P, setMonthOrYearRange: D, setPresetDate: B } = ql(), { padZero: W } = _t(), { getMonths: H, isOutOfYearRange: te } = Yl(), re = M(() => H()), oe = ee(null), {
    selectYear: K,
    groupedYears: ae,
    showYearPicker: U,
    toggleYearPicker: z,
    handleYearSelect: J,
    handleYear: de,
    isDisabled: pe,
    setStartDate: ge
  } = Fd(n);
  et(() => {
    ge();
  });
  const Me = (L) => L ? { month: Ze(L), year: ze(L) } : { month: null, year: null }, be = () => i.value ? Array.isArray(i.value) ? i.value.map((L) => Me(L)) : Me(i.value) : Me(), q = (L, fe) => {
    const $e = l.value[L], Re = be();
    return Array.isArray(Re) ? Re.some((_e) => _e.year === ($e == null ? void 0 : $e.year) && _e.month === fe) : ($e == null ? void 0 : $e.year) === Re.year && fe === Re.month;
  }, ye = (L, fe, $e) => {
    var _e, We;
    const Re = be();
    return Array.isArray(Re) ? r.value(fe) === ((_e = Re[$e]) == null ? void 0 : _e.year) && L === ((We = Re[$e]) == null ? void 0 : We.month) : !1;
  }, Ce = (L, fe) => {
    if (u.value.enabled) {
      const $e = be();
      if (Array.isArray(i.value) && Array.isArray($e)) {
        const Re = ye(L, fe, 0) || ye(L, fe, 1), _e = je(h(t()), { month: L, year: r.value(fe) });
        return k(i.value, oe.value, _e) && !Re;
      }
      return !1;
    }
    return !1;
  }, V = M(() => (L) => C(re.value, (fe) => {
    var Rt;
    const $e = q(L, fe.value), Re = v(
      fe.value,
      w(r.value(L), f.value.minDate),
      S(r.value(L), f.value.maxDate)
    ) || A(f.value.disabledDates, r.value(L), fe.value) || ((Rt = p.value.months) == null ? void 0 : Rt.includes(fe.value)) || !Z(f.value.allowedDates, r.value(L), fe.value) || te(r.value(L)), _e = Ce(fe.value, L), We = x(c.value, fe.value, r.value(L));
    return { active: $e, disabled: Re, isBetween: _e, highlighted: We };
  })), G = (L, fe) => je(h(t()), { month: L, year: r.value(fe) }), he = (L, fe) => {
    const $e = i.value ? i.value : h(t());
    i.value = je($e, { month: L, year: r.value(fe) }), n("auto-apply"), n("update-flow-step");
  }, j = (L, fe) => {
    const $e = G(L, fe);
    u.value.fixedEnd || u.value.fixedStart ? i.value = O($e) : i.value ? g($e, i.value) && (i.value = D(G(L, fe))) : i.value = [G(L, fe)], Ge().then(() => {
      _(i.value, n, i.value.length < 2);
    });
  }, se = (L, fe) => {
    P(G(L, fe), d.value.limit), n("auto-apply", !0);
  }, me = (L, fe) => (l.value[fe].month = L, N(fe, l.value[fe].year, L), d.value.enabled ? se(L, fe) : u.value.enabled ? j(L, fe) : he(L, fe)), I = (L, fe) => {
    K(L, fe), N(fe, L, null);
  }, N = (L, fe, $e) => {
    let Re = $e;
    if (!Re && Re !== 0) {
      const _e = be();
      Re = Array.isArray(_e) ? _e[L].month : _e.month;
    }
    a("update-month-year", { instance: L, year: fe, month: Re });
  }, T = (L, fe) => {
    oe.value = G(L, fe);
  }, R = (L) => {
    B({
      value: L
    }), n("auto-apply");
  }, A = (L, fe, $e) => {
    if (L instanceof Map) {
      const Re = `${W($e + 1)}-${fe}`;
      return L.size ? L.has(Re) : !1;
    }
    return typeof L == "function" ? L(y(je(t(), { month: $e, year: fe }), !0)) : !1;
  }, Z = (L, fe, $e) => {
    if (L instanceof Map) {
      const Re = `${W($e + 1)}-${fe}`;
      return L.size ? L.has(Re) : !0;
    }
    return !0;
  };
  return {
    groupedMonths: V,
    groupedYears: ae,
    year: r,
    isDisabled: pe,
    showYearPicker: U,
    modelValue: i,
    toggleYearPicker: z,
    handleYearSelect: J,
    handleYear: de,
    presetDate: R,
    setHoverDate: T,
    selectMonth: me,
    selectYear: I,
    getModelMonthYear: be
  };
}, k0 = /* @__PURE__ */ xe({
  __name: "MonthPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply", "update-flow-step", "mount"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, l = Ut(), {
      rootProps: r,
      defaults: { config: i }
    } = Ke(), o = _n(l, yn.YearMode);
    et(() => {
      a("mount");
    });
    const {
      groupedMonths: u,
      groupedYears: c,
      year: f,
      isDisabled: p,
      showYearPicker: d,
      modelValue: g,
      presetDate: v,
      setHoverDate: k,
      selectMonth: y,
      selectYear: h,
      toggleYearPicker: w,
      handleYearSelect: S,
      handleYear: x,
      getModelMonthYear: C
    } = w0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: g,
      year: f,
      getModelMonthYear: C,
      selectMonth: y,
      selectYear: h,
      handleYear: x
    }), presetDate: v, toggleYearPicker: (_) => w(0, _) }), (_, O) => (b(), ue(Ul, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: ce(({ instances: P, wrapClass: D }) => [
        (b(!0), $(Te, null, Ie(P, (B) => (b(), $("div", {
          key: B,
          class: X(D)
        }, [
          _.$slots["top-extra"] ? Y(_.$slots, "top-extra", {
            key: 0,
            value: m(g)
          }) : F("", !0),
          Y(_.$slots, "month-year", lt({ ref_for: !0 }, {
            year: m(f),
            months: m(u)(B),
            years: m(c)(B),
            selectMonth: m(y),
            selectYear: m(h),
            instance: B
          }), () => [
            le(qs, {
              items: m(u)(B),
              "is-last": m(r).autoApply && !m(i).keepActionRow,
              height: m(i).modeHeight,
              "no-overlay-focus": !!(e.noOverlayFocus || m(r).textInput),
              "use-relative": "",
              level: 0,
              type: "month",
              onSelected: (W) => m(y)(W, B),
              onHoverValue: (W) => m(k)(W, B)
            }, dt({
              header: ce(() => [
                le(Rd, {
                  items: m(c)(B),
                  instance: B,
                  "show-year-picker": m(d)[B],
                  year: m(f)(B),
                  "is-disabled": (W) => m(p)(B, W),
                  onHandleYear: (W) => m(x)(B, W),
                  onYearSelect: (W) => m(S)(W, B),
                  onToggleYearPicker: (W) => m(w)(B, W == null ? void 0 : W.flow, W == null ? void 0 : W.show)
                }, dt({ _: 2 }, [
                  Ie(m(o), (W, H) => ({
                    name: W,
                    fn: ce((te) => [
                      Y(_.$slots, W, lt({ ref_for: !0 }, te))
                    ])
                  }))
                ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
              ]),
              _: 2
            }, [
              _.$slots["month-overlay-value"] ? {
                name: "item",
                fn: ce(({ item: W }) => [
                  Y(_.$slots, "month-overlay-value", {
                    text: W.text,
                    value: W.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "onSelected", "onHoverValue"])
          ])
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), x0 = (e, n) => {
  const {
    rootEmit: t,
    getDate: a,
    state: s,
    modelValue: l,
    rootProps: r,
    defaults: { highlight: i, multiDates: o, filters: u, range: c, safeDates: f }
  } = Ke(), { getYears: p } = Yl(), { isDateBetween: d, resetDate: g, resetDateTime: v, getYearFromDate: k, checkHighlightYear: y, groupListAndMap: h } = Lt(), { checkRangeAutoApply: w, setMonthOrYearRange: S } = ql(), { checkMinMaxValue: x, checkMinMaxRange: C } = on();
  Us(() => {
    s.isTextInputDate && (O.value = ze(a(r.startDate)));
  });
  const _ = ee(null), O = ee();
  et(() => {
    r.startDate && (l.value && r.focusStartDate || !l.value) && (O.value = ze(a(r.startDate)));
  });
  const P = (re) => Array.isArray(l.value) ? l.value.some((oe) => ze(oe) === re) : l.value ? ze(l.value) === re : !1, D = (re) => c.value.enabled && Array.isArray(l.value) ? d(l.value, _.value, te(re)) : !1, B = (re) => {
    var oe;
    return (oe = f.value.allowedDates) != null && oe.size ? f.value.allowedDates.has(`${re}`) : !0;
  }, W = (re) => f.value.disabledDates instanceof Map ? f.value.disabledDates.size ? f.value.disabledDates.has(`${re}`) : !1 : typeof f.value.disabledDates == "function" ? f.value.disabledDates(vn(v(Ua(a())), re)) : !0, H = M(() => h(p(), (re) => {
    const oe = P(re.value), K = x(
      re.value,
      k(f.value.minDate),
      k(f.value.maxDate)
    ) || u.value.years.includes(re.value) || !B(re.value) || W(re.value), ae = D(re.value) && !oe, U = y(i.value, re.value);
    return { active: oe, disabled: K, isBetween: ae, highlighted: U };
  })), te = (re) => vn(g(Ua(a())), re);
  return {
    groupedYears: H,
    focusYear: O,
    setHoverValue: (re) => {
      _.value = vn(g(a()), re);
    },
    selectYear: (re) => {
      var oe;
      if (t("update-month-year", { instance: 0, year: re, month: Number.NaN }), o.value.enabled)
        return l.value ? Array.isArray(l.value) && (((oe = l.value) == null ? void 0 : oe.map((K) => ze(K))).includes(re) ? l.value = l.value.filter((K) => ze(K) !== re) : l.value.push(vn(v(a()), re))) : l.value = [vn(v(Ua(a())), re)], n("auto-apply", !0);
      c.value.enabled ? C(te(re), l.value) && (l.value = S(te(re)), Ge().then(() => {
        w(l.value, n, l.value.length < 2);
      })) : (l.value = te(re), n("auto-apply"));
    }
  };
}, S0 = /* @__PURE__ */ xe({
  __name: "YearPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      modelValue: l,
      defaults: { config: r },
      rootProps: i
    } = Ke(), { groupedYears: o, focusYear: u, selectYear: c, setHoverValue: f } = x0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: l,
      selectYear: c
    }) }), (p, d) => (b(), $("div", null, [
      p.$slots["top-extra"] ? Y(p.$slots, "top-extra", {
        key: 0,
        value: m(l)
      }) : F("", !0),
      p.$slots["month-year"] ? Y(p.$slots, "month-year", Ct(lt({ key: 1 }, {
        years: m(o),
        selectYear: m(c)
      }))) : (b(), ue(qs, {
        key: 2,
        items: m(o),
        "is-last": m(i).autoApply && !m(r).keepActionRow,
        height: m(r).modeHeight,
        "no-overlay-focus": !!(e.noOverlayFocus || m(i).textInput),
        "focus-value": m(u),
        type: "year",
        "use-relative": "",
        onSelected: m(c),
        onHoverValue: m(f)
      }, dt({ _: 2 }, [
        p.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ce(({ item: g }) => [
            Y(p.$slots, "year-overlay-value", {
              text: g.text,
              value: g.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), T0 = {
  key: 0,
  class: "dp__time_input"
}, $0 = ["data-compact", "data-collapsed"], M0 = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], C0 = ["aria-label", "disabled", "data-dp-action-element", "data-test-id", "onKeydown", "onClick"], D0 = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], _0 = { key: 0 }, O0 = ["aria-label", "data-dp-action-element", "data-compact"], E0 = /* @__PURE__ */ xe({
  __name: "TimeInput",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    order: {},
    closeTimePickerBtn: {},
    disabledTimesConfig: {},
    validateTime: {}
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "overlay-opened", "overlay-closed", "set-hours", "set-minutes", "reset-flow", "mounted"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: l,
      rootEmit: r,
      rootProps: i,
      defaults: { ariaLabels: o, filters: u, config: c, range: f, multiCalendars: p, timeConfig: d }
    } = Ke(), { checkKeyDown: g, hoursToAmPmHours: v } = _t(), { boolHtmlAttribute: k } = ls(), { sanitizeTime: y, groupListAndMap: h } = Lt(), { transitionName: w, showTransition: S } = Hs(), x = wa({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), C = ee("AM"), _ = ee(null), O = ee(), P = ee(!1);
    et(() => {
      a("mounted");
    });
    const D = (A) => je(l(), {
      hours: A.hours,
      minutes: A.minutes,
      seconds: d.value.enableSeconds ? A.seconds : 0,
      milliseconds: 0
    }), B = M(() => i.timePicker || d.value.timePickerInline ? 0 : 1), W = M(
      () => (A) => Me(A, s[A]) || te(A, s[A])
    ), H = M(() => ({ hours: s.hours, minutes: s.minutes, seconds: s.seconds })), te = (A, Z) => f.value.enabled && !f.value.disableTimeRangeValidation ? !s.validateTime(A, Z) : !1, re = (A, Z) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const L = Z ? +d.value[`${A}Increment`] : -+d.value[`${A}Increment`], fe = s[A] + L;
        return !s.validateTime(A, fe);
      }
      return !1;
    }, oe = M(() => (A) => !V(+s[A] + +d.value[`${A}Increment`], A) || re(A, !0)), K = M(() => (A) => !V(+s[A] - +d.value[`${A}Increment`], A) || re(A, !1)), ae = (A, Z) => od(je(l(), A), Z), U = (A, Z) => nb(je(l(), A), Z), z = M(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !d.value.timePickerInline,
        dp__time_col_reg_block: !d.value.enableSeconds && d.value.is24 && !d.value.timePickerInline,
        dp__time_col_reg_inline: !d.value.enableSeconds && d.value.is24 && d.value.timePickerInline,
        dp__time_col_reg_with_button: !d.value.enableSeconds && !d.value.is24,
        dp__time_col_sec: d.value.enableSeconds && d.value.is24,
        dp__time_col_sec_with_button: d.value.enableSeconds && !d.value.is24
      })
    ), J = M(
      () => d.value.timePickerInline && f.value.enabled && !p.value.count
    ), de = M(() => {
      const A = [{ type: "hours" }];
      return d.value.enableMinutes && A.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), d.value.enableSeconds && A.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), A;
    }), pe = M(() => de.value.filter((A) => !A.separator)), ge = M(() => (A) => {
      if (A === "hours") {
        const Z = I(+s.hours);
        return { text: Z < 10 ? `0${Z}` : `${Z}`, value: Z };
      }
      return { text: s[A] < 10 ? `0${s[A]}` : `${s[A]}`, value: s[A] };
    }), Me = (A, Z) => {
      var fe;
      if (!s.disabledTimesConfig) return !1;
      const L = s.disabledTimesConfig(s.order, A === "hours" ? Z : void 0);
      return L[A] ? !!((fe = L[A]) != null && fe.includes(Z)) : !0;
    }, be = (A, Z) => Z !== "hours" || C.value === "AM" ? A : A + 12, q = (A) => {
      const Z = d.value.is24 ? 24 : 12, L = A === "hours" ? Z : 60, fe = +d.value[`${A}GridIncrement`], $e = A === "hours" && !d.value.is24 ? fe : 0, Re = [];
      for (let _e = $e; _e < L; _e += fe)
        Re.push({
          value: d.value.is24 ? _e : be(_e, A),
          text: _e < 10 ? `0${_e}` : `${_e}`
        });
      return A === "hours" && !d.value.is24 && Re.unshift({ value: C.value === "PM" ? 12 : 0, text: "12" }), h(Re, (_e) => ({ active: !1, disabled: u.value.times[A].includes(_e.value) || !V(_e.value, A) || Me(A, _e.value) || te(A, _e.value) }));
    }, ye = (A) => A >= 0 ? A : 59, Ce = (A) => A >= 0 ? A : 23, V = (A, Z) => {
      const L = i.minTime ? D(y(i.minTime)) : null, fe = i.maxTime ? D(y(i.maxTime)) : null, $e = D(
        y(
          H.value,
          Z,
          Z === "minutes" || Z === "seconds" ? ye(A) : Ce(A)
        )
      );
      return L && fe ? (Yn($e, fe) || La($e, fe)) && (Mn($e, L) || La($e, L)) : L ? Mn($e, L) || La($e, L) : fe ? Yn($e, fe) || La($e, fe) : !0;
    }, G = (A) => d.value[`no${A[0].toUpperCase() + A.slice(1)}Overlay`], he = (A) => {
      G(A) || (x[A] = !x[A], x[A] ? (P.value = !0, a("overlay-opened", A)) : (P.value = !1, a("overlay-closed", A)));
    }, j = (A) => A === "hours" ? An : A === "minutes" ? Un : aa, se = () => {
      O.value && clearTimeout(O.value);
    }, me = (A, Z = !0, L) => {
      const fe = Z ? ae : U, $e = Z ? +d.value[`${A}Increment`] : -+d.value[`${A}Increment`];
      V(+s[A] + $e, A) && a(
        `update:${A}`,
        j(A)(
          fe({ [A]: +s[A] }, { [A]: +d.value[`${A}Increment`] })
        )
      ), !(L != null && L.keyboard) && c.value.timeArrowHoldThreshold && (O.value = setTimeout(() => {
        me(A, Z);
      }, c.value.timeArrowHoldThreshold));
    }, I = (A) => d.value.is24 ? A : (A >= 12 ? C.value = "PM" : C.value = "AM", v(A)), N = () => {
      C.value === "PM" ? (C.value = "AM", a("update:hours", s.hours - 12)) : (C.value = "PM", a("update:hours", s.hours + 12)), r("am-pm-change", C.value);
    }, T = (A) => {
      x[A] = !0;
    }, R = (A, Z) => (he(A), a(`update:${A}`, Z));
    return n({ openChildCmp: T }), (A, Z) => m(i).disabled ? F("", !0) : (b(), $("div", T0, [
      (b(!0), $(Te, null, Ie(de.value, (L, fe) => {
        var $e, Re, _e;
        return b(), $("div", {
          key: fe,
          class: X(z.value),
          "data-compact": J.value && !m(d).enableSeconds,
          "data-collapsed": J.value && m(d).enableSeconds
        }, [
          L.separator ? (b(), $(Te, { key: 0 }, [
            P.value ? F("", !0) : (b(), $(Te, { key: 0 }, [
              Ye(":")
            ], 64))
          ], 64)) : (b(), $(Te, { key: 1 }, [
            E("button", {
              type: "button",
              class: X({
                dp__btn: !0,
                dp__inc_dec_button: !m(d).timePickerInline,
                dp__inc_dec_button_inline: m(d).timePickerInline,
                dp__tp_inline_btn_top: m(d).timePickerInline,
                dp__inc_dec_button_disabled: oe.value(L.type),
                "dp--hidden-el": P.value
              }),
              "data-test-id": `${L.type}-time-inc-btn-${s.order}`,
              "aria-label": ($e = m(o)) == null ? void 0 : $e.incrementValue(L.type),
              tabindex: "0",
              "data-dp-action-element": B.value,
              onKeydown: (We) => m(g)(We, () => me(L.type, !0, { keyboard: !0 }), !0),
              onClick: (We) => m(c).timeArrowHoldThreshold ? void 0 : me(L.type, !0),
              onMousedown: (We) => m(c).timeArrowHoldThreshold ? me(L.type, !0) : void 0,
              onMouseup: se
            }, [
              m(d).timePickerInline ? Y(A.$slots, "tp-inline-arrow-up", { key: 1 }, () => [
                Z[2] || (Z[2] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                Z[3] || (Z[3] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : Y(A.$slots, "arrow-up", { key: 0 }, () => [
                le(m(_d))
              ])
            ], 42, M0),
            E("button", {
              type: "button",
              "aria-label": `${ge.value(L.type).text}-${(Re = m(o)) == null ? void 0 : Re.openTpOverlay(L.type)}`,
              class: X({
                dp__time_display: !0,
                dp__time_display_block: !m(d).timePickerInline,
                dp__time_display_inline: m(d).timePickerInline,
                "dp--time-invalid": W.value(L.type),
                "dp--time-overlay-btn": !W.value(L.type),
                "dp--hidden-el": P.value
              }),
              disabled: m(k)(G(L.type)),
              tabindex: "0",
              "data-dp-action-element": B.value,
              "data-test-id": `${L.type}-toggle-overlay-btn-${s.order}`,
              onKeydown: (We) => m(g)(We, () => he(L.type), !0),
              onClick: (We) => he(L.type)
            }, [
              Y(A.$slots, L.type, {
                text: ge.value(L.type).text,
                value: ge.value(L.type).value
              }, () => [
                Ye(ie(ge.value(L.type).text), 1)
              ])
            ], 42, C0),
            E("button", {
              type: "button",
              class: X({
                dp__btn: !0,
                dp__inc_dec_button: !m(d).timePickerInline,
                dp__inc_dec_button_inline: m(d).timePickerInline,
                dp__tp_inline_btn_bottom: m(d).timePickerInline,
                dp__inc_dec_button_disabled: K.value(L.type),
                "dp--hidden-el": P.value
              }),
              "data-test-id": `${L.type}-time-dec-btn-${s.order}`,
              "aria-label": (_e = m(o)) == null ? void 0 : _e.decrementValue(L.type),
              tabindex: "0",
              "data-dp-action-element": B.value,
              onKeydown: (We) => m(g)(We, () => me(L.type, !1, { keyboard: !0 }), !0),
              onClick: (We) => m(c).timeArrowHoldThreshold ? void 0 : me(L.type, !1),
              onMousedown: (We) => m(c).timeArrowHoldThreshold ? me(L.type, !1) : void 0,
              onMouseup: se
            }, [
              m(d).timePickerInline ? Y(A.$slots, "tp-inline-arrow-down", { key: 1 }, () => [
                Z[4] || (Z[4] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                Z[5] || (Z[5] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : Y(A.$slots, "arrow-down", { key: 0 }, () => [
                le(m(Od))
              ])
            ], 42, D0)
          ], 64))
        ], 10, $0);
      }), 128)),
      m(d).is24 ? F("", !0) : (b(), $("div", _0, [
        Y(A.$slots, "am-pm-button", {
          toggle: N,
          value: C.value
        }, () => {
          var L;
          return [
            E("button", {
              ref_key: "amPmButton",
              ref: _,
              type: "button",
              class: "dp__pm_am_button",
              role: "button",
              "aria-label": (L = m(o)) == null ? void 0 : L.amPmButton,
              tabindex: "0",
              "data-dp-action-element": B.value,
              "data-compact": J.value,
              onClick: N,
              onKeydown: Z[0] || (Z[0] = (fe) => m(g)(fe, () => N(), !0))
            }, ie(C.value), 41, O0)
          ];
        })
      ])),
      (b(!0), $(Te, null, Ie(pe.value, (L, fe) => (b(), ue(St, {
        key: fe,
        name: m(w)(x[L.type]),
        css: m(S)
      }, {
        default: ce(() => {
          var $e, Re;
          return [
            x[L.type] ? (b(), ue(qs, {
              key: 0,
              items: q(L.type),
              "is-last": m(i).autoApply && !m(c).keepActionRow,
              type: L.type,
              "aria-labels": m(o),
              level: m(d).timePickerInline || m(i).timePicker ? 1 : 2,
              "overlay-label": (Re = ($e = m(o)).timeOverlay) == null ? void 0 : Re.call($e, L.type),
              onSelected: (_e) => R(L.type, _e),
              onToggle: (_e) => he(L.type),
              onResetFlow: Z[1] || (Z[1] = (_e) => A.$emit("reset-flow"))
            }, dt({
              "button-icon": ce(() => [
                Y(A.$slots, "clock-icon", {}, () => [
                  A.$slots["clock-icon"] ? F("", !0) : (b(), ue(ht(m(d).timePickerInline ? m(Ys) : m(Dd)), { key: 0 }))
                ])
              ]),
              _: 2
            }, [
              A.$slots[`${L.type}-overlay-value`] ? {
                name: "item",
                fn: ce(({ item: _e }) => [
                  Y(A.$slots, `${L.type}-overlay-value`, {
                    text: _e.text,
                    value: _e.value
                  })
                ]),
                key: "0"
              } : void 0,
              A.$slots[`${L.type}-overlay-header`] ? {
                name: "header",
                fn: ce(() => [
                  Y(A.$slots, `${L.type}-overlay-header`, {
                    toggle: () => he(L.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "type", "aria-labels", "level", "overlay-label", "onSelected", "onToggle"])) : F("", !0)
          ];
        }),
        _: 2
      }, 1032, ["name", "css"]))), 128))
    ]));
  }
}), I0 = ["data-dp-mobile"], A0 = ["aria-label", "tabindex"], P0 = ["role", "aria-label", "tabindex"], R0 = ["aria-label"], Vd = /* @__PURE__ */ xe({
  __name: "TimePicker",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    disabledTimesConfig: { type: [Function, null] },
    noOverlayFocus: { type: Boolean },
    validateTime: { type: Function }
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "mount", "reset-flow"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      setState: r,
      modelValue: i,
      rootProps: o,
      defaults: { ariaLabels: u, textInput: c, config: f, range: p, timeConfig: d }
    } = Ke(), { isModelAuto: g } = Lt(), { checkKeyDown: v, findFocusableEl: k } = _t(), { transitionName: y, showTransition: h } = Hs(), { hideNavigationButtons: w } = Hl(), { isMobile: S } = Wl(), x = Ut(), C = Xe("overlay"), _ = Xe("close-tp-btn"), O = Xe("tp-input"), P = ee(!1);
    et(() => {
      a("mount");
    });
    const D = M(() => p.value.enabled && o.modelAuto ? g(i.value) : !0), B = ee(!1), W = (ge) => ({
      hours: Array.isArray(s.hours) ? s.hours[ge] : s.hours,
      minutes: Array.isArray(s.minutes) ? s.minutes[ge] : s.minutes,
      seconds: Array.isArray(s.seconds) ? s.seconds[ge] : s.seconds
    }), H = M(() => {
      const ge = [];
      if (p.value.enabled)
        for (let Me = 0; Me < 2; Me++)
          ge.push(W(Me));
      else
        ge.push(W(0));
      return ge;
    }), te = (ge, Me = !1, be = "") => {
      Me || a("reset-flow"), B.value = ge, r("arrowNavigationLevel", ge ? 1 : 0), l("overlay-toggle", { open: ge, overlay: Nt.time }), Ge(() => {
        var q;
        be !== "" && ((q = O.value) != null && q[0]) && O.value[0].openChildCmp(be);
      });
    }, re = M(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: o.autoApply && !f.value.keepActionRow
    })), oe = _n(x, yn.TimeInput), K = (ge, Me, be) => p.value.enabled ? Me === 0 ? [ge, H.value[1][be]] : [H.value[0][be], ge] : ge, ae = (ge) => {
      a("update:hours", ge);
    }, U = (ge) => {
      a("update:minutes", ge);
    }, z = (ge) => {
      a("update:seconds", ge);
    }, J = () => {
      if (C.value && !c.value.enabled && !s.noOverlayFocus) {
        const ge = k(C.value);
        ge && ge.focus({ preventScroll: !0 });
      }
    }, de = (ge) => {
      P.value = !1, l("overlay-toggle", { open: !1, overlay: ge });
    }, pe = (ge) => {
      P.value = !0, l("overlay-toggle", { open: !0, overlay: ge });
    };
    return n({ toggleTimePicker: te }), (ge, Me) => {
      var be;
      return b(), $("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": m(S)
      }, [
        !m(o).timePicker && !m(d).timePickerInline ? an((b(), $("button", {
          key: 0,
          ref: "open-tp-btn",
          type: "button",
          "data-dp-action-element": "0",
          class: X({ ...re.value, "dp--hidden-el": B.value }),
          "aria-label": (be = m(u)) == null ? void 0 : be.openTimePicker,
          tabindex: e.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: Me[0] || (Me[0] = (q) => m(v)(q, () => te(!0))),
          onClick: Me[1] || (Me[1] = (q) => te(!0))
        }, [
          Y(ge.$slots, "clock-icon", {}, () => [
            le(m(Dd))
          ])
        ], 42, A0)), [
          [Wn, !m(w)("time")]
        ]) : F("", !0),
        le(St, {
          name: m(y)(B.value),
          css: m(h) && !m(d).timePickerInline
        }, {
          default: ce(() => {
            var q, ye;
            return [
              B.value || m(o).timePicker || m(d).timePickerInline ? (b(), $("div", {
                key: 0,
                ref: "overlay",
                role: m(d).timePickerInline ? void 0 : "dialog",
                class: X({
                  dp__overlay: !m(d).timePickerInline,
                  "dp--overlay-absolute": !m(o).timePicker && !m(d).timePickerInline,
                  "dp--overlay-relative": m(o).timePicker
                }),
                style: Fe(m(o).timePicker ? { height: `${m(f).modeHeight}px` } : void 0),
                "aria-label": (q = m(u)) == null ? void 0 : q.timePicker,
                tabindex: m(d).timePickerInline ? void 0 : 0
              }, [
                E("div", {
                  class: X(
                    m(d).timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  Y(ge.$slots, "time-picker-overlay", {
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: ae,
                    setMinutes: U,
                    setSeconds: z
                  }, () => [
                    E("div", {
                      class: X(m(d).timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                    }, [
                      (b(!0), $(Te, null, Ie(H.value, (Ce, V) => an((b(), ue(E0, lt({ key: V }, { ref_for: !0 }, {
                        order: V,
                        hours: Ce.hours,
                        minutes: Ce.minutes,
                        seconds: Ce.seconds,
                        closeTimePickerBtn: _.value,
                        disabledTimesConfig: e.disabledTimesConfig,
                        disabled: V === 0 ? m(p).fixedStart : m(p).fixedEnd
                      }, {
                        ref_for: !0,
                        ref: "tp-input",
                        "validate-time": (G, he) => e.validateTime(G, K(he, V, G)),
                        "onUpdate:hours": (G) => ae(K(G, V, "hours")),
                        "onUpdate:minutes": (G) => U(K(G, V, "minutes")),
                        "onUpdate:seconds": (G) => z(K(G, V, "seconds")),
                        onMounted: J,
                        onOverlayClosed: de,
                        onOverlayOpened: pe
                      }), dt({ _: 2 }, [
                        Ie(m(oe), (G, he) => ({
                          name: G,
                          fn: ce((j) => [
                            Y(ge.$slots, G, lt({ ref_for: !0 }, j))
                          ])
                        }))
                      ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                        [Wn, V === 0 ? !0 : D.value]
                      ])), 128))
                    ], 2)
                  ]),
                  !m(o).timePicker && !m(d).timePickerInline ? an((b(), $("button", {
                    key: 0,
                    ref: "close-tp-btn",
                    "data-dp-action-element": "1",
                    type: "button",
                    class: X({ ...re.value, "dp--hidden-el": P.value }),
                    "aria-label": (ye = m(u)) == null ? void 0 : ye.closeTimePicker,
                    tabindex: "0",
                    onKeydown: Me[2] || (Me[2] = (Ce) => m(v)(Ce, () => te(!1))),
                    onClick: Me[3] || (Me[3] = (Ce) => te(!1))
                  }, [
                    Y(ge.$slots, "calendar-icon", {}, () => [
                      le(m(Ys))
                    ])
                  ], 42, R0)), [
                    [Wn, !m(w)("time")]
                  ]) : F("", !0)
                ], 2)
              ], 14, P0)) : F("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, I0);
    };
  }
}), Ld = (e) => {
  const {
    getDate: n,
    modelValue: t,
    time: a,
    rootProps: s,
    defaults: { range: l, timeConfig: r }
  } = Ke(), { isDateEqual: i, setTime: o } = Lt(), u = (_, O) => Array.isArray(a[_]) ? a[_][O] : a[_], c = (_) => r.value.enableSeconds ? Array.isArray(a.seconds) ? a.seconds[_] : a.seconds : 0, f = (_, O) => _ ? o(
    O !== void 0 ? { hours: u("hours", O), minutes: u("minutes", O), seconds: c(O) } : { hours: a.hours, minutes: a.minutes, seconds: c() },
    _
  ) : tb(n(), c(O)), p = (_, O) => {
    a[_] = O;
  }, d = M(() => s.modelAuto && l.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : l.value.enabled), g = (_, O) => {
    const P = Object.fromEntries(
      Object.keys(a).map((D) => D === _ ? [D, O] : [D, a[D]].slice())
    );
    if (d.value && !l.value.disableTimeRangeValidation) {
      const D = (W) => t.value ? o(
        {
          hours: P.hours[W],
          minutes: P.minutes[W],
          seconds: P.seconds[W]
        },
        t.value[W]
      ) : null, B = (W) => eb(t.value[W], 0);
      return !(i(D(0), D(1)) && (Mn(D(0), B(1)) || Yn(D(1), B(0))));
    }
    return !0;
  }, v = (_, O) => {
    g(_, O) && (p(_, O), e && e());
  }, k = (_) => {
    v("hours", _);
  }, y = (_) => {
    v("minutes", _);
  }, h = (_) => {
    v("seconds", _);
  }, w = (_, O) => {
    k(_.hours), y(_.minutes), h(_.seconds), t.value && O(t.value);
  }, S = (_) => {
    if (_) {
      const O = Array.isArray(_), P = O ? [+_[0].hours, +_[1].hours] : +_.hours, D = O ? [+_[0].minutes, +_[1].minutes] : +_.minutes, B = O ? [+(_[0].seconds ?? 0), +(_[1].seconds ?? 0)] : +(_.seconds ?? 0);
      p("hours", P), p("minutes", D), r.value.enableSeconds && p("seconds", B);
    }
  }, x = (_, O) => {
    const P = {
      hours: Array.isArray(a.hours) ? a.hours[_] : a.hours,
      disabledArr: []
    };
    return (O || O === 0) && (P.hours = O), Array.isArray(s.disabledTimes) && (P.disabledArr = l.value.enabled && Array.isArray(s.disabledTimes[_]) ? s.disabledTimes[_] : s.disabledTimes), P;
  }, C = M(() => (_, O) => {
    var P;
    if (Array.isArray(s.disabledTimes)) {
      const { disabledArr: D, hours: B } = x(_, O), W = D.filter((H) => +H.hours === B);
      return ((P = W[0]) == null ? void 0 : P.minutes) === "*" ? { hours: [B], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (W == null ? void 0 : W.map((H) => +H.minutes)) ?? [],
        seconds: (W == null ? void 0 : W.map((H) => H.seconds ? +H.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    assignTime: p,
    updateHours: k,
    updateMinutes: y,
    updateSeconds: h,
    getSetDateTime: f,
    updateTimeValues: w,
    getSecondsValue: c,
    assignStartTime: S,
    validateTime: g,
    disabledTimesConfig: C
  };
}, F0 = (e) => {
  const {
    getDate: n,
    time: t,
    modelValue: a,
    state: s,
    defaults: { startTime: l, range: r, timeConfig: i }
  } = Ke(), { getTimeObj: o } = Lt();
  Us(() => {
    s.isTextInputDate && x();
  });
  const { updateTimeValues: u, getSetDateTime: c, assignTime: f, assignStartTime: p, disabledTimesConfig: d, validateTime: g } = Ld(v);
  function v() {
    e("update-flow-step");
  }
  const k = (_) => {
    const { hours: O, minutes: P, seconds: D } = _;
    return { hours: +O, minutes: +P, seconds: D ? +D : 0 };
  }, y = () => {
    if (i.value.startTime) {
      if (Array.isArray(i.value.startTime)) {
        const O = k(i.value.startTime[0]), P = k(i.value.startTime[1]);
        return [je(n(), O), je(n(), P)];
      }
      const _ = k(i.value.startTime);
      return je(n(), _);
    }
    return r.value.enabled ? [null, null] : null;
  }, h = () => {
    if (r.value.enabled) {
      const [_, O] = y();
      a.value = [c(_, 0), c(O, 1)];
    } else
      a.value = c(y());
  }, w = (_) => Array.isArray(_) ? [o(n(_[0])), o(n(_[1]))] : [o(_ ?? n())], S = (_, O, P) => {
    f("hours", _), f("minutes", O), f("seconds", i.value.enableSeconds ? P : 0);
  }, x = () => {
    const [_, O] = w(a.value);
    return r.value.enabled ? S(
      [_.hours, O.hours],
      [_.minutes, O.minutes],
      [_.seconds, O.seconds]
    ) : S(_.hours, _.minutes, _.seconds);
  };
  et(() => (p(l.value), a.value ? x() : h()));
  const C = () => {
    Array.isArray(a.value) ? a.value = a.value.map((_, O) => _ && c(_, O)) : a.value = c(a.value), e("time-update");
  };
  return {
    modelValue: a,
    time: t,
    disabledTimesConfig: d,
    validateTime: g,
    updateTime: (_) => {
      u(_, C);
    }
  };
}, V0 = /* @__PURE__ */ xe({
  __name: "TimePickerSolo",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["time-update", "mount", "reset-flow", "update-flow-step"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Ut(), l = _n(s, yn.TimePicker), r = Xe("time-input"), { time: i, modelValue: o, disabledTimesConfig: u, updateTime: c, validateTime: f } = F0(a);
    return et(() => {
      a("mount");
    }), n({ getSidebarProps: () => ({
      modelValue: o,
      time: i,
      updateTime: c
    }), toggleTimePicker: (p, d = !1, g = "") => {
      var v;
      (v = r.value) == null || v.toggleTimePicker(p, d, g);
    } }), (p, d) => (b(), ue(Ul, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: ce(({ wrapClass: g }) => [
        E("div", {
          class: X(g)
        }, [
          le(Vd, lt({ ref: "time-input" }, p.$props, {
            hours: m(i).hours,
            minutes: m(i).minutes,
            seconds: m(i).seconds,
            "disabled-times-config": m(u),
            "validate-time": m(f),
            "onUpdate:hours": d[0] || (d[0] = (v) => m(c)({ hours: v, minutes: m(i).minutes, seconds: m(i).seconds })),
            "onUpdate:minutes": d[1] || (d[1] = (v) => m(c)({ hours: m(i).hours, minutes: v, seconds: m(i).seconds })),
            "onUpdate:seconds": d[2] || (d[2] = (v) => m(c)({ hours: m(i).hours, minutes: m(i).minutes, seconds: v })),
            onResetFlow: d[3] || (d[3] = (v) => p.$emit("reset-flow"))
          }), dt({ _: 2 }, [
            Ie(m(l), (v, k) => ({
              name: v,
              fn: ce((y) => [
                Y(p.$slots, v, Ct(Bt(y)))
              ])
            }))
          ]), 1040, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time"])
        ], 2)
      ]),
      _: 3
    }));
  }
}), L0 = (e, n) => {
  const {
    getDate: t,
    rootProps: a,
    defaults: { filters: s }
  } = Ke(), { validateMonthYearInRange: l, validateMonthYear: r } = on(), i = (p, d) => {
    let g = p;
    return s.value.months.includes(Ze(g)) ? (g = d ? gn(p, 1) : Ja(p, 1), i(g, d)) : g;
  }, o = (p, d) => {
    let g = p;
    return s.value.years.includes(ze(g)) ? (g = d ? Ti(p, 1) : Td(p, 1), o(g, d)) : g;
  }, u = (p, d = !1) => {
    const g = je(t(), { month: e.month, year: e.year });
    let v = p ? gn(g, 1) : Ja(g, 1);
    a.disableYearSelect && (v = vn(v, e.year));
    let k = Ze(v), y = ze(v);
    s.value.months.includes(k) && (v = i(v, p), k = Ze(v), y = ze(v)), s.value.years.includes(y) && (v = o(v, p), y = ze(v)), l(k, y, p, a.preventMinMaxNavigation) && c(k, y, d);
  }, c = (p, d, g = !1) => {
    n("update-month-year", { month: p, year: d, fromNav: g });
  }, f = M(() => (p) => r(
    je(t(), { month: e.month, year: e.year }),
    a.preventMinMaxNavigation,
    p
  ));
  return { handleMonthYearChange: u, isDisabled: f, updateMonthYear: c };
}, N0 = { class: "dp--header-wrap" }, B0 = {
  key: 0,
  class: "dp__month_year_wrap"
}, z0 = { key: 0 }, W0 = { class: "dp__month_year_wrap" }, Y0 = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], H0 = /* @__PURE__ */ xe({
  __name: "DpHeader",
  props: {
    month: {},
    year: {},
    instance: {},
    years: {},
    months: {},
    menuWrapRef: {}
  },
  emits: ["mount", "reset-flow", "update-month-year"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      rootProps: r,
      modelValue: i,
      defaults: { ariaLabels: o, filters: u, config: c, highlight: f, safeDates: p, ui: d }
    } = Ke(), { transitionName: g, showTransition: v } = Hs(), { showLeftIcon: k, showRightIcon: y } = Hl(), { handleMonthYearChange: h, isDisabled: w, updateMonthYear: S } = L0(s, a), { getMaxMonth: x, getMinMonth: C, getYearFromDate: _, groupListAndMap: O, checkHighlightYear: P, checkHighlightMonth: D } = Lt(), { checkKeyDown: B } = _t(), { formatYear: W } = sa(), { checkMinMaxValue: H } = on(), { boolHtmlAttribute: te } = ls(), re = ee(!1), oe = ee(!1), K = ee(!1);
    et(() => {
      a("mount");
    });
    const ae = (G) => ({
      get: () => s[G],
      set: (he) => {
        const j = G === hn.month ? hn.year : hn.month;
        a("update-month-year", { [G]: he, [j]: s[j] }), G === hn.month ? be(!0) : q(!0);
      }
    }), U = M(ae(hn.month)), z = M(ae(hn.year)), J = M(() => (G) => ({
      month: s.month,
      year: s.year,
      items: G === hn.month ? s.months : s.years,
      instance: s.instance,
      updateMonthYear: S,
      toggle: G === hn.month ? be : q
    })), de = M(() => s.months.find((he) => he.value === s.month) || { text: "", value: 0 }), pe = M(() => O(s.months, (G) => {
      const he = s.month === G.value, j = H(
        G.value,
        C(s.year, p.value.minDate),
        x(s.year, p.value.maxDate)
      ) || u.value.months.includes(G.value), se = D(f.value, G.value, s.year);
      return { active: he, disabled: j, highlighted: se };
    })), ge = M(() => O(s.years, (G) => {
      const he = s.year === G.value, j = H(
        G.value,
        _(p.value.minDate),
        _(p.value.maxDate)
      ) || u.value.years.includes(G.value), se = P(f.value, G.value);
      return { active: he, disabled: j, highlighted: se };
    })), Me = (G, he, j) => {
      j === void 0 ? G.value = !G.value : G.value = j, G.value ? (K.value = !0, l("overlay-toggle", { open: !0, overlay: he })) : (K.value = !1, l("overlay-toggle", { open: !1, overlay: he }));
    }, be = (G = !1, he) => {
      ye(G), Me(re, Nt.month, he);
    }, q = (G = !1, he) => {
      ye(G), Me(oe, Nt.year, he);
    }, ye = (G) => {
      G || a("reset-flow");
    }, Ce = M(() => {
      var G, he, j, se, me, I;
      return [
        {
          type: hn.month,
          index: 1,
          toggle: be,
          modelValue: U.value,
          updateModelValue: (N) => U.value = N,
          text: de.value.text,
          showSelectionGrid: re.value,
          items: pe.value,
          ariaLabel: (G = o.value) == null ? void 0 : G.openMonthsOverlay,
          overlayLabel: ((j = (he = o.value).monthPicker) == null ? void 0 : j.call(he, !0)) ?? void 0
        },
        {
          type: hn.year,
          index: 2,
          toggle: q,
          modelValue: z.value,
          updateModelValue: (N) => z.value = N,
          text: W(s.year),
          showSelectionGrid: oe.value,
          items: ge.value,
          ariaLabel: (se = o.value) == null ? void 0 : se.openYearsOverlay,
          overlayLabel: ((I = (me = o.value).yearPicker) == null ? void 0 : I.call(me, !0)) ?? void 0
        }
      ];
    }), V = M(() => r.disableYearSelect ? [Ce.value[0]] : r.yearFirst ? [...Ce.value].reverse() : Ce.value);
    return n({
      toggleMonthPicker: be,
      toggleYearPicker: q,
      handleMonthYearChange: h
    }), (G, he) => {
      var j, se, me, I, N, T;
      return b(), $("div", N0, [
        G.$slots["month-year"] ? (b(), $("div", B0, [
          Y(G.$slots, "month-year", Ct(Bt({
            month: e.month,
            year: e.year,
            months: e.months,
            years: e.years,
            updateMonthYear: m(S),
            handleMonthYearChange: m(h),
            instance: e.instance,
            isDisabled: m(w)
          })))
        ])) : (b(), $(Te, { key: 1 }, [
          G.$slots["top-extra"] ? (b(), $("div", z0, [
            Y(G.$slots, "top-extra", { value: m(i) })
          ])) : F("", !0),
          E("div", W0, [
            m(k)(e.instance) && !m(r).vertical ? (b(), ue(Ms, {
              key: 0,
              "aria-label": (j = m(o)) == null ? void 0 : j.prevMonth,
              disabled: m(te)(m(w)(!1)),
              class: X((se = m(d)) == null ? void 0 : se.navBtnPrev),
              "el-name": "action-prev",
              onActivate: he[0] || (he[0] = (R) => m(h)(!1, !0))
            }, {
              default: ce(() => [
                G.$slots["arrow-left"] ? Y(G.$slots, "arrow-left", { key: 0 }) : F("", !0),
                G.$slots["arrow-left"] ? F("", !0) : (b(), ue(m(Md), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : F("", !0),
            E("div", {
              class: X(["dp__month_year_wrap", {
                dp__year_disable_select: m(r).disableYearSelect
              }])
            }, [
              (b(!0), $(Te, null, Ie(V.value, (R) => (b(), $(Te, {
                key: R.type
              }, [
                E("button", {
                  type: "button",
                  "data-dp-element": `overlay-${R.type}`,
                  class: X(["dp__btn dp__month_year_select", { "dp--hidden-el": K.value }]),
                  "aria-label": `${R.text}-${R.ariaLabel}`,
                  "data-test-id": `${R.type}-toggle-overlay-${e.instance}`,
                  tabindex: "0",
                  "data-dp-action-element": "0",
                  onClick: (A) => R.toggle(!1),
                  onKeydown: (A) => m(B)(A, () => R.toggle(), !0)
                }, [
                  G.$slots[R.type] ? Y(G.$slots, R.type, {
                    key: 0,
                    text: R.text,
                    value: s[R.type]
                  }) : F("", !0),
                  G.$slots[R.type] ? F("", !0) : (b(), $(Te, { key: 1 }, [
                    Ye(ie(R.text), 1)
                  ], 64))
                ], 42, Y0),
                le(St, {
                  name: m(g)(R.showSelectionGrid),
                  css: m(v)
                }, {
                  default: ce(() => [
                    R.showSelectionGrid ? (b(), ue(qs, {
                      key: 0,
                      items: R.items,
                      "is-last": m(r).autoApply && !m(c).keepActionRow,
                      "skip-button-ref": !1,
                      type: R.type,
                      "header-refs": [],
                      "menu-wrap-ref": e.menuWrapRef,
                      "overlay-label": R.overlayLabel,
                      onSelected: R.updateModelValue,
                      onToggle: R.toggle
                    }, dt({
                      "button-icon": ce(() => [
                        G.$slots["calendar-icon"] ? Y(G.$slots, "calendar-icon", { key: 0 }) : F("", !0),
                        G.$slots["calendar-icon"] ? F("", !0) : (b(), ue(m(Ys), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      G.$slots[`${R.type}-overlay-value`] ? {
                        name: "item",
                        fn: ce(({ item: A }) => [
                          Y(G.$slots, `${R.type}-overlay-value`, {
                            text: A.text,
                            value: A.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      G.$slots[`${R.type}-overlay`] ? {
                        name: "overlay",
                        fn: ce(() => [
                          Y(G.$slots, `${R.type}-overlay`, lt({ ref_for: !0 }, J.value(R.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      G.$slots[`${R.type}-overlay-header`] ? {
                        name: "header",
                        fn: ce(() => [
                          Y(G.$slots, `${R.type}-overlay-header`, {
                            toggle: R.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "is-last", "type", "menu-wrap-ref", "overlay-label", "onSelected", "onToggle"])) : F("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            m(k)(e.instance) && m(r).vertical ? (b(), ue(Ms, {
              key: 1,
              "aria-label": (me = m(o)) == null ? void 0 : me.prevMonth,
              "el-name": "action-prev",
              disabled: m(te)(m(w)(!1)),
              class: X((I = m(d)) == null ? void 0 : I.navBtnPrev),
              onActivate: he[1] || (he[1] = (R) => m(h)(!1, !0))
            }, {
              default: ce(() => [
                G.$slots["arrow-up"] ? Y(G.$slots, "arrow-up", { key: 0 }) : F("", !0),
                G.$slots["arrow-up"] ? F("", !0) : (b(), ue(m(_d), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : F("", !0),
            m(y)(e.instance) ? (b(), ue(Ms, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: m(te)(m(w)(!0)),
              "aria-label": (N = m(o)) == null ? void 0 : N.nextMonth,
              class: X((T = m(d)) == null ? void 0 : T.navBtnNext),
              onActivate: he[2] || (he[2] = (R) => m(h)(!0, !0))
            }, {
              default: ce(() => [
                G.$slots[m(r).vertical ? "arrow-down" : "arrow-right"] ? Y(G.$slots, m(r).vertical ? "arrow-down" : "arrow-right", { key: 0 }) : F("", !0),
                G.$slots[m(r).vertical ? "arrow-down" : "arrow-right"] ? F("", !0) : (b(), ue(ht(m(r).vertical ? m(Od) : m(Cd)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : F("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), U0 = {
  class: "dp__calendar_header",
  role: "row"
}, q0 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, j0 = ["aria-label"], G0 = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, K0 = { class: "dp__cell_inner" }, Z0 = ["id", "aria-selected", "aria-disabled", "aria-label", "tabindex", "data-test-id", "data-dp-element-active", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], X0 = /* @__PURE__ */ xe({
  __name: "DpCalendar",
  props: {
    instance: {},
    mappedDates: {},
    month: {},
    year: {}
  },
  emits: ["mount", "select-date", "set-hover-date", "handle-scroll", "handle-swipe"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: l,
      rootEmit: r,
      rootProps: i,
      defaults: { transitions: o, config: u, ariaLabels: c, multiCalendars: f, weekNumbers: p, multiDates: d, ui: g }
    } = Ke(), { isDateAfter: v, isDateEqual: k, resetDateTime: y, getCellId: h } = Lt(), { checkKeyDown: w, checkStopPropagation: S, isTouchDevice: x } = _t(), { formatWeekDay: C } = sa(), _ = Xe("calendar-wrap"), O = Xe("active-tooltip"), P = ee([]), D = ee(null), B = ee(!0), W = ee(!1), H = ee(""), te = ee({
      bottom: "",
      left: "",
      transform: ""
    }), re = ee({ left: "50%" });
    Jv(_, {
      onSwipeEnd: (T, R) => {
        u.value.noSwipe || (i.vertical ? (R === "up" || R === "down") && a("handle-swipe", R === "up" ? "left" : "right") : (R === "left" || R === "right") && a("handle-swipe", R === "right" ? "left" : "right"));
      }
    });
    const oe = M(() => i.calendar ? i.calendar(s.mappedDates) : s.mappedDates), K = M(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames() : N());
    et(() => {
      a("mount", { cmp: "calendar", dayRefs: P.value }), u.value.monthChangeOnScroll && _.value && _.value.addEventListener("wheel", G, { passive: !1 });
    }), Jt(() => {
      u.value.monthChangeOnScroll && _.value && _.value.removeEventListener("wheel", G);
    });
    const ae = (T) => T ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", U = (T, R) => {
      if (i.transitions) {
        const A = y(je(l(), { month: s.month, year: s.year }));
        H.value = v(y(je(l(), { month: T, year: R })), A) ? o.value[ae(!0)] : o.value[ae(!1)], B.value = !1, Ge(() => {
          B.value = !0;
        });
      }
    }, z = M(
      () => ({
        ...g.value.calendar
      })
    ), J = (T) => ({ type: "dot", ...T }), de = M(() => (T) => {
      const R = J(T);
      return {
        dp__marker_dot: R.type === "dot",
        dp__marker_line: R.type === "line"
      };
    }), pe = M(() => (T) => k(T, D.value)), ge = M(() => ({
      dp__calendar: !0,
      dp__calendar_next: f.value.count > 0 && s.instance !== 0
    })), Me = M(() => (T) => i.hideOffsetDates ? T.current : !0), be = async (T, R) => {
      var $e;
      const { width: A, height: Z } = T.getBoundingClientRect();
      D.value = R.value;
      let L = { left: `${A / 2}px` }, fe = -50;
      if (await Ge(), ($e = O.value) == null ? void 0 : $e[0]) {
        const { left: Re, width: _e } = O.value[0].getBoundingClientRect();
        Re < 0 && (L = { left: "0" }, fe = 0, re.value.left = `${A / 2}px`), globalThis.innerWidth < Re + _e && (L = { right: "0" }, fe = 0, re.value.left = `${_e - A / 2}px`);
      }
      te.value = {
        bottom: `${Z}px`,
        ...L,
        transform: `translateX(${fe}%)`
      };
    }, q = async (T, R, A) => {
      var L, fe, $e, Re, _e;
      const Z = Kt((fe = (L = P.value) == null ? void 0 : L[R]) == null ? void 0 : fe[A]);
      Z && (($e = T.marker) != null && $e.customPosition && ((_e = (Re = T.marker) == null ? void 0 : Re.tooltip) != null && _e.length) ? te.value = T.marker.customPosition(Z) : await be(Z, T), r("tooltip-open", T.marker));
    }, ye = async (T, R, A) => {
      var Z, L;
      if (W.value && d.value.enabled && d.value.dragSelect)
        return a("select-date", T);
      if (a("set-hover-date", T), (L = (Z = T.marker) == null ? void 0 : Z.tooltip) == null ? void 0 : L.length) {
        if (i.hideOffsetDates && !T.current) return;
        await q(T, R, A);
      }
    }, Ce = (T) => {
      D.value && (D.value = null, te.value = structuredClone({ bottom: "", left: "", transform: "" }), r("tooltip-close", T.marker));
    }, V = (T, R, A) => {
      T && (Array.isArray(P.value[R]) ? P.value[R][A] = T : P.value[R] = [T]);
    }, G = (T) => {
      u.value.monthChangeOnScroll && (T.preventDefault(), a("handle-scroll", T));
    }, he = (T) => p.value ? p.value.type === "local" ? _i(T.value, {
      weekStartsOn: +i.weekStart,
      locale: i.locale
    }) : p.value.type === "iso" ? Ci(T.value) : typeof p.value.type == "function" ? p.value.type(T.value) : "" : "", j = (T) => {
      var A;
      const R = T[0];
      return (A = p.value) != null && A.hideOnOffsetDates ? T.some((Z) => Z.current) ? he(R) : "" : he(R);
    }, se = (T, R, A = !0) => {
      !A && x() || (!d.value.enabled || u.value.allowPreventDefault) && (S(T, u.value), a("select-date", R));
    }, me = (T) => {
      S(T, u.value);
    }, I = (T) => {
      d.value.enabled && d.value.dragSelect ? (W.value = !0, a("select-date", T)) : d.value.enabled && a("select-date", T);
    }, N = () => {
      const T = l(), R = rn(T, { locale: i.locale, weekStartsOn: +i.weekStart }), A = Mi(T, { locale: i.locale, weekStartsOn: +i.weekStart });
      return $i({ start: R, end: A }).map((Z) => C(Z));
    };
    return n({ triggerTransition: U }), (T, R) => (b(), $("div", {
      class: X(ge.value)
    }, [
      E("div", {
        ref: "calendar-wrap",
        class: X(z.value),
        role: "grid"
      }, [
        E("div", U0, [
          m(p) ? (b(), $("div", q0, ie(m(p).label), 1)) : F("", !0),
          (b(!0), $(Te, null, Ie(K.value, (A, Z) => {
            var L, fe;
            return b(), $("div", {
              key: Z,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (fe = (L = m(c)) == null ? void 0 : L.weekDay) == null ? void 0 : fe.call(L, Z)
            }, [
              Y(T.$slots, "calendar-header", {
                day: A,
                index: Z
              }, () => [
                Ye(ie(A), 1)
              ])
            ], 8, j0);
          }), 128))
        ]),
        R[2] || (R[2] = E("div", { class: "dp__calendar_header_separator" }, null, -1)),
        le(St, {
          name: H.value,
          css: !!m(o)
        }, {
          default: ce(() => [
            B.value ? (b(), $("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: R[1] || (R[1] = (A) => W.value = !1)
            }, [
              (b(!0), $(Te, null, Ie(oe.value, (A, Z) => (b(), $("div", {
                key: Z,
                class: "dp__calendar_row",
                role: "row"
              }, [
                m(p) ? (b(), $("div", G0, [
                  E("div", K0, ie(j(A.days)), 1)
                ])) : F("", !0),
                (b(!0), $(Te, null, Ie(A.days, (L, fe) => {
                  var $e, Re, _e;
                  return b(), $("div", {
                    id: m(h)(L.value),
                    ref_for: !0,
                    ref: (We) => V(We, Z, fe),
                    key: fe + Z,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-selected": (L.classData.dp__active_date || L.classData.dp__range_start || L.classData.dp__range_end) ?? void 0,
                    "aria-disabled": L.classData.dp__cell_disabled || void 0,
                    "aria-label": (Re = ($e = m(c)) == null ? void 0 : $e.day) == null ? void 0 : Re.call($e, L),
                    tabindex: !L.current && m(i).hideOffsetDates ? void 0 : 0,
                    "data-test-id": m(h)(L.value),
                    "data-dp-element-active": L.classData.dp__active_date ? 0 : void 0,
                    "data-dp-action-element": "0",
                    onClick: Ve((We) => se(We, L), ["prevent"]),
                    onTouchend: (We) => se(We, L, !1),
                    onKeydown: (We) => m(w)(We, () => T.$emit("select-date", L)),
                    onMouseenter: (We) => ye(L, Z, fe),
                    onMouseleave: (We) => Ce(L),
                    onMousedown: (We) => I(L),
                    onMouseup: R[0] || (R[0] = (We) => W.value = !1)
                  }, [
                    E("div", {
                      class: X(["dp__cell_inner", L.classData])
                    }, [
                      T.$slots.day && Me.value(L) ? Y(T.$slots, "day", {
                        key: 0,
                        day: +L.text,
                        date: L.value
                      }) : F("", !0),
                      T.$slots.day ? F("", !0) : (b(), $(Te, { key: 1 }, [
                        Ye(ie(L.text), 1)
                      ], 64)),
                      L.marker && Me.value(L) ? Y(T.$slots, "marker", {
                        key: 2,
                        marker: L.marker,
                        day: +L.text,
                        date: L.value
                      }, () => [
                        E("div", {
                          class: X(de.value(L.marker)),
                          style: Fe(L.marker.color ? { backgroundColor: L.marker.color } : {})
                        }, null, 6)
                      ]) : F("", !0),
                      pe.value(L.value) ? (b(), $("div", {
                        key: 3,
                        ref_for: !0,
                        ref: "active-tooltip",
                        class: "dp__marker_tooltip",
                        style: Fe(te.value)
                      }, [
                        (_e = L.marker) != null && _e.tooltip ? (b(), $("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: me
                        }, [
                          (b(!0), $(Te, null, Ie(L.marker.tooltip, (We, Rt) => (b(), $("div", {
                            key: Rt,
                            class: "dp__tooltip_text"
                          }, [
                            Y(T.$slots, "marker-tooltip", {
                              tooltip: We,
                              day: L.value
                            }, () => [
                              E("div", {
                                class: "dp__tooltip_mark",
                                style: Fe(We.color ? { backgroundColor: We.color } : {})
                              }, null, 4),
                              E("div", null, ie(We.text), 1)
                            ])
                          ]))), 128)),
                          E("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Fe(re.value)
                          }, null, 4)
                        ])) : F("", !0)
                      ], 4)) : F("", !0)
                    ], 2)
                  ], 40, Z0);
                }), 128))
              ]))), 128))
            ], 32)) : F("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), J0 = (e, n, t, a) => {
  const s = ee([]), l = ee(/* @__PURE__ */ new Date()), r = ee(), {
    getDate: i,
    rootEmit: o,
    calendars: u,
    month: c,
    year: f,
    time: p,
    modelValue: d,
    rootProps: g,
    today: v,
    state: k,
    defaults: { multiCalendars: y, startTime: h, range: w, config: S, safeDates: x, multiDates: C, timeConfig: _, flow: O }
  } = Ke(), { validateMonthYearInRange: P, isDisabled: D, isDateRangeAllowed: B, checkMinMaxRange: W } = on(), { updateTimeValues: H, getSetDateTime: te, assignTime: re, assignStartTime: oe, validateTime: K, disabledTimesConfig: ae } = Ld(a), { formatDay: U } = sa(), { resetDateTime: z, setTime: J, isDateBefore: de, isDateEqual: pe, getDaysInBetween: ge } = Lt(), { checkRangeAutoApply: Me, getRangeWithFixedDate: be, handleMultiDatesSelect: q, setPresetDate: ye } = ql(), { getMapDate: Ce } = _t();
  Us(() => I(k.isTextInputDate));
  const V = (Q) => !S.value.keepViewOnOffsetClick || Q ? !0 : !r.value, G = (Q, ve, Pe, He = !1) => {
    var tt, qt, jt;
    V(He) && ((tt = u.value)[Q] ?? (tt[Q] = u.value[Q] = { month: 0, year: 0 }), u.value[Q].month = ve ?? ((qt = u.value[Q]) == null ? void 0 : qt.month), u.value[Q].year = Pe ?? ((jt = u.value[Q]) == null ? void 0 : jt.year));
  }, he = () => {
    g.autoApply && n("select-date");
  }, j = () => {
    h.value && oe(h.value);
  };
  et(() => {
    d.value || (Rt(), j()), I(!0), g.focusStartDate && g.startDate && Rt();
  });
  const se = M(() => {
    var Q, ve, Pe;
    return (ve = (Q = O.value) == null ? void 0 : Q.steps) != null && ve.length && !((Pe = O.value) != null && Pe.partial) ? e.flowStep === O.value.steps.length : !0;
  }), me = () => {
    var Q, ve, Pe;
    g.autoApply && se.value && n("auto-apply", (Q = O.value) != null && Q.partial ? e.flowStep !== ((Pe = (ve = O.value) == null ? void 0 : ve.steps) == null ? void 0 : Pe.length) : !1);
  }, I = (Q = !1) => {
    if (d.value)
      return Array.isArray(d.value) ? (s.value = d.value, $e(Q)) : A(d.value, Q);
    if (y.value.count && Q && !g.startDate)
      return R(i(), Q);
  }, N = () => Array.isArray(d.value) && w.value.enabled ? Ze(d.value[0]) === Ze(d.value[1] ?? d.value[0]) : !1, T = (Q) => {
    const ve = gn(Q, 1);
    return { month: Ze(ve), year: ze(ve) };
  }, R = (Q = i(), ve = !1) => {
    if ((!y.value.count || !y.value.static || ve) && G(0, Ze(Q), ze(Q)), y.value.count && (!d.value || N() || !y.value.solo) && (!y.value.solo || ve))
      for (let Pe = 1; Pe < y.value.count; Pe++) {
        const He = je(i(), { month: c.value(Pe - 1), year: f.value(Pe - 1) }), tt = od(He, { months: 1 });
        u.value[Pe] = { month: Ze(tt), year: ze(tt) };
      }
  }, A = (Q, ve) => {
    R(Q), re("hours", An(Q)), re("minutes", Un(Q)), re("seconds", aa(Q)), y.value.count && ve && We();
  }, Z = (Q) => {
    if (y.value.count) {
      if (y.value.solo) return 0;
      const ve = Ze(Q[0]), Pe = Ze(Q[1]);
      return Math.abs(Pe - ve) < y.value.count ? 0 : 1;
    }
    return 1;
  }, L = (Q, ve) => {
    Q[1] && w.value.showLastInRange ? R(Q[Z(Q)], ve) : R(Q[0], ve);
    const Pe = (He, tt) => [
      He(Q[0]),
      Q != null && Q[1] ? He(Q[1]) : p[tt][1]
    ];
    re("hours", Pe(An, "hours")), re("minutes", Pe(Un, "minutes")), re("seconds", Pe(aa, "seconds"));
  }, fe = (Q, ve) => {
    if ((w.value.enabled || g.weekPicker) && !C.value.enabled)
      return L(Q, ve);
    if (C.value.enabled && ve) {
      const Pe = Q[Q.length - 1];
      return A(Pe, ve);
    }
  }, $e = (Q) => {
    const ve = d.value;
    fe(ve, Q), y.value.count && y.value.solo && We();
  }, Re = (Q, ve) => {
    const Pe = je(i(), { month: c.value(ve), year: f.value(ve) }), He = Q < 0 ? gn(Pe, 1) : Ja(Pe, 1);
    P(Ze(He), ze(He), Q < 0, g.preventMinMaxNavigation) && (G(ve, Ze(He), ze(He)), o("update-month-year", { instance: ve, month: Ze(He), year: ze(He) }), y.value.count && !y.value.solo && _e(ve), t());
  }, _e = (Q) => {
    for (let ve = Q - 1; ve >= 0; ve--) {
      const Pe = Ja(je(i(), { month: c.value(ve + 1), year: f.value(ve + 1) }), 1);
      G(ve, Ze(Pe), ze(Pe));
    }
    for (let ve = Q + 1; ve <= y.value.count - 1; ve++) {
      const Pe = gn(je(i(), { month: c.value(ve - 1), year: f.value(ve - 1) }), 1);
      G(ve, Ze(Pe), ze(Pe));
    }
  }, We = () => {
    if (Array.isArray(d.value) && d.value.length === 2) {
      const Q = i(i(d.value[1] ?? gn(d.value[0], 1))), [ve, Pe] = [Ze(d.value[0]), ze(d.value[0])], [He, tt] = [Ze(d.value[1]), ze(d.value[1])];
      (ve !== He || ve === He && Pe !== tt) && y.value.solo && G(1, Ze(Q), ze(Q));
    } else d.value && !Array.isArray(d.value) && (G(0, Ze(d.value), ze(d.value)), R(i()));
  }, Rt = () => {
    g.startDate && (G(0, Ze(i(g.startDate)), ze(i(g.startDate))), y.value.count && _e(0));
  }, un = (Q, ve) => {
    if (S.value.monthChangeOnScroll) {
      const Pe = Date.now() - l.value.getTime(), He = Math.abs(Q.deltaY);
      let tt = 500;
      He > 1 && (tt = 100), He > 100 && (tt = 0), Pe > tt && (l.value = /* @__PURE__ */ new Date(), Re(
        S.value.monthChangeOnScroll === "inverse" ? Q.deltaY : -Q.deltaY,
        ve
      ));
    }
  }, cn = (Q, ve, Pe = !1) => {
    S.value.monthChangeOnArrows && g.vertical === Pe && Fn(Q, ve);
  }, Fn = (Q, ve) => {
    Re(Q === "right" ? -1 : 1, ve);
  }, At = (Q) => {
    if (x.value.markers)
      return Ce(Q.value, x.value.markers);
  }, Wt = (Q, ve) => {
    switch (g.sixWeeks === !0 ? "append" : g.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [Q == 0, !0];
      case "fair":
        return [Q == 0 || ve > Q, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Vn = (Q, ve, Pe, He) => {
    if (g.sixWeeks && Q.length < 6) {
      const tt = 6 - Q.length, qt = (ve.getDay() + 7 - He) % 7, jt = 6 - (Pe.getDay() + 7 - He) % 7, [ra, Ca] = Wt(qt, jt);
      for (let ia = 1; ia <= tt; ia++)
        if (Ca ? !!(ia % 2) == ra : ra) {
          const ne = Q[0].days[0], Se = xn(nn(ne.value, -7), Ze(ve));
          Q.unshift({ days: Se });
        } else {
          const ne = Q[Q.length - 1], Se = ne.days[ne.days.length - 1], qe = xn(nn(Se.value, 1), Ze(ve));
          Q.push({ days: qe });
        }
    }
    return Q;
  }, xn = (Q, ve) => {
    const Pe = i(Q), He = [];
    for (let tt = 0; tt < 7; tt++) {
      const qt = nn(Pe, tt), jt = Ze(qt) !== ve;
      He.push({
        text: g.hideOffsetDates && jt ? "" : U(qt),
        value: qt,
        current: !jt,
        classData: {}
      });
    }
    return He;
  }, Tt = (Q, ve) => {
    const Pe = [], He = i(new Date(ve, Q)), tt = i(new Date(ve, Q + 1, 0)), qt = g.weekStart, jt = rn(He, { weekStartsOn: qt }), ra = (Ca) => {
      const ia = xn(Ca, Q);
      if (Pe.push({ days: ia }), !Pe[Pe.length - 1].days.some((ne) => pe(i(ne.value), z(tt)))) {
        const ne = nn(Ca, 7);
        ra(ne);
      }
    };
    return ra(jt), Vn(Pe, He, tt, qt);
  }, $t = (Q) => {
    const ve = J(
      { hours: p.hours, minutes: p.minutes, seconds: Ma() },
      i(Q.value)
    );
    o("date-click", ve), C.value.enabled ? q(ve, C.value.limit) : d.value = ve, a(), Ge().then(() => {
      me();
    });
  }, yt = (Q) => w.value.noDisabledRange ? ge(s.value[0], Q).some((ve) => D(ve)) : !1, Ee = () => {
    s.value = d.value ? d.value.slice().filter((Q) => !!Q) : [], s.value.length === 2 && !(w.value.fixedStart || w.value.fixedEnd) && (s.value = []);
  }, ut = (Q, ve) => {
    const Pe = [i(Q.value), nn(i(Q.value), +w.value.autoRange)];
    B(Pe) ? (ve && Dt(Q.value), s.value = Pe) : o("invalid-date", Q.value);
  }, Dt = (Q) => {
    const ve = Ze(i(Q)), Pe = ze(i(Q));
    if (G(0, ve, Pe), y.value.count > 0)
      for (let He = 1; He < y.value.count; He++) {
        const tt = T(
          je(i(Q), { year: f.value(He - 1), month: c.value(He - 1) })
        );
        G(He, tt.month, tt.year);
      }
  }, Sn = (Q) => {
    if (yt(Q.value) || !W(Q.value, d.value, w.value.fixedStart ? 0 : 1))
      return o("invalid-date", Q.value);
    s.value = be(i(Q.value));
  }, Ln = (Q, ve) => {
    if (Ee(), w.value.autoRange) return ut(Q, ve);
    if (w.value.fixedStart || w.value.fixedEnd) return Sn(Q);
    s.value[0] ? W(i(Q.value), d.value) && !yt(Q.value) ? de(i(Q.value), i(s.value[0])) ? w.value.autoSwitchStartEnd ? (s.value.unshift(i(Q.value)), o("range-end", s.value[0])) : (s.value[0] = i(Q.value), o("range-start", s.value[0])) : (s.value[1] = i(Q.value), o("range-end", s.value[1])) : o("invalid-date", Q.value) : (s.value[0] = i(Q.value), o("range-start", s.value[0]));
  }, Ma = (Q = !0) => _.value.enableSeconds ? Array.isArray(p.seconds) ? Q ? p.seconds[0] : p.seconds[1] : p.seconds : 0, os = (Q) => {
    s.value[Q] = J(
      {
        hours: p.hours[Q],
        minutes: p.minutes[Q],
        seconds: Ma(Q !== 1)
      },
      s.value[Q]
    );
  }, Ks = () => {
    var Q, ve;
    s.value[0] && s.value[1] && +((Q = s.value) == null ? void 0 : Q[0]) > +((ve = s.value) == null ? void 0 : ve[1]) && (s.value.reverse(), o("range-start", s.value[0]), o("range-end", s.value[1]));
  }, Jl = () => {
    var Q, ve, Pe;
    s.value.length && (s.value[0] && !s.value[1] ? os(0) : (os(0), os(1), a()), Ks(), d.value = s.value.slice(), Me(
      s.value,
      n,
      s.value.length < 2 || (Q = O.value) != null && Q.steps.length ? e.flowStep !== ((Pe = (ve = O.value) == null ? void 0 : ve.steps) == null ? void 0 : Pe.length) : !1
    ));
  }, Ql = (Q, ve = !1) => {
    if (D(Q.value) || !Q.current && g.hideOffsetDates)
      return o("invalid-date", Q.value);
    if (r.value = structuredClone(Q), !w.value.enabled) return $t(Q);
    Array.isArray(p.hours) && Array.isArray(p.minutes) && !C.value.enabled && (Ln(Q, ve), Jl());
  }, er = (Q, ve) => {
    var He, tt;
    G(Q, ve.month, ve.year, !0), y.value.count && !y.value.solo && _e(Q), o("update-month-year", { instance: Q, month: ve.month, year: ve.year }), t(y.value.solo ? Q : void 0);
    const Pe = (tt = (He = O.value) == null ? void 0 : He.steps) != null && tt.length ? O.value.steps[e.flowStep] : void 0;
    !ve.fromNav && (Pe === Nt.month || Pe === Nt.year) && a();
  }, Zs = (Q) => {
    ye({
      value: Q
    }), he(), g.multiCalendars && Ge().then(() => I(!0));
  }, qn = () => {
    var ve;
    let Q = i();
    return (ve = g.actionRow) != null && ve.nowBtnRound && (Q = Qy(Q, {
      roundingMethod: g.actionRow.nowBtnRound.rounding ?? "ceil",
      nearestTo: g.actionRow.nowBtnRound.roundTo ?? 15
    })), Q;
  }, Xs = () => {
    const Q = qn();
    !w.value.enabled && !C.value.enabled ? d.value = Q : d.value && Array.isArray(d.value) && d.value[0] ? C.value.enabled ? d.value = [...d.value, Q] : d.value = de(Q, d.value[0]) ? [Q, d.value[0]] : [d.value[0], Q] : d.value = [Q], he();
  }, Bi = () => {
    if (Array.isArray(d.value))
      if (C.value.enabled) {
        const Q = bt();
        d.value[d.value.length - 1] = te(Q);
      } else
        d.value = d.value.map((Q, ve) => Q && te(Q, ve));
    else
      d.value = te(d.value);
    n("time-update");
  }, bt = () => Array.isArray(d.value) && d.value.length ? d.value[d.value.length - 1] : null, tr = (Q) => {
    let ve = "";
    if (w.value.enabled && Array.isArray(d.value))
      for (const Pe of Object.keys(Q)) {
        const He = Q[Pe];
        Array.isArray(He) && (p[Pe][0] !== He[0] && (ve = "range-start"), p[Pe][1] !== He[1] && (ve = "range-start"));
      }
    return ve;
  };
  return {
    calendars: u,
    modelValue: d,
    month: c,
    year: f,
    time: p,
    disabledTimesConfig: ae,
    today: v,
    validateTime: K,
    getCalendarDays: Tt,
    getMarker: At,
    handleScroll: un,
    handleSwipe: Fn,
    handleArrow: cn,
    selectDate: Ql,
    updateMonthYear: er,
    presetDate: Zs,
    selectCurrentDate: Xs,
    updateTime: (Q) => {
      const ve = tr(Q);
      H(Q, Bi), ve && o(ve, d.value[ve === "range-start" ? 0 : 1]);
    },
    assignMonthAndYear: R,
    setStartTime: j
  };
}, Q0 = () => {
  const {
    isModelAuto: e,
    matchDate: n,
    isDateAfter: t,
    isDateBefore: a,
    isDateBetween: s,
    isDateEqual: l,
    getWeekFromDate: r,
    getBeforeAndAfterInRange: i
  } = Lt(), {
    getDate: o,
    today: u,
    rootProps: c,
    defaults: { multiCalendars: f, multiDates: p, ui: d, highlight: g, safeDates: v, range: k },
    modelValue: y
  } = Ke(), { isDisabled: h } = on(), w = ee(null), S = (T) => {
    !T.current && c.hideOffsetDates || (w.value = T.value);
  }, x = () => {
    w.value = null;
  }, C = (T) => Array.isArray(y.value) && k.value.enabled && y.value[0] && w.value ? T ? t(w.value, y.value[0]) : a(w.value, y.value[0]) : !0, _ = (T, R) => {
    const A = () => y.value ? R ? y.value[0] || null : y.value[1] : null, Z = y.value && Array.isArray(y.value) ? A() : null;
    return l(o(T.value), Z);
  }, O = (T) => {
    const R = Array.isArray(y.value) ? y.value[0] : null;
    return T ? !a(w.value, R) : !0;
  }, P = (T, R = !0) => (k.value.enabled || c.weekPicker) && Array.isArray(y.value) && y.value.length === 2 ? c.hideOffsetDates && !T.current ? !1 : l(o(T.value), y.value[R ? 0 : 1]) : k.value.enabled ? _(T, R) && O(R) || l(T.value, Array.isArray(y.value) ? y.value[0] : null) && C(R) : !1, D = (T, R) => {
    if (Array.isArray(y.value) && y.value[0] && y.value.length === 1) {
      const A = l(T.value, w.value);
      return R ? t(y.value[0], T.value) && A : a(y.value[0], T.value) && A;
    }
    return !1;
  }, B = (T) => !y.value || c.hideOffsetDates && !T.current ? !1 : k.value.enabled ? c.modelAuto && Array.isArray(y.value) ? l(T.value, y.value[0] ?? u) : !1 : p.value.enabled && Array.isArray(y.value) ? y.value.some((R) => l(R, T.value)) : l(T.value, y.value ? y.value : u), W = (T) => {
    if (k.value.autoRange || c.weekPicker) {
      if (w.value) {
        if (c.hideOffsetDates && !T.current) return !1;
        const R = nn(w.value, +k.value.autoRange), A = r(o(w.value), c.weekStart);
        return c.weekPicker ? l(A[1], o(T.value)) : l(R, o(T.value));
      }
      return !1;
    }
    return !1;
  }, H = (T) => {
    if (k.value.autoRange || c.weekPicker) {
      if (w.value) {
        const R = nn(w.value, +k.value.autoRange);
        if (c.hideOffsetDates && !T.current) return !1;
        const A = r(o(w.value), c.weekStart);
        return c.weekPicker ? t(T.value, A[0]) && a(T.value, A[1]) : t(T.value, w.value) && a(T.value, R);
      }
      return !1;
    }
    return !1;
  }, te = (T) => {
    if (k.value.autoRange || c.weekPicker) {
      if (w.value) {
        if (c.hideOffsetDates && !T.current) return !1;
        const R = r(o(w.value), c.weekStart);
        return c.weekPicker ? l(R[0], T.value) : l(w.value, T.value);
      }
      return !1;
    }
    return !1;
  }, re = (T) => s(y.value, w.value, T.value), oe = () => c.modelAuto && Array.isArray(y.value) ? !!y.value[0] : !1, K = () => c.modelAuto ? e(y.value) : !0, ae = (T) => {
    if (c.weekPicker) return !1;
    const R = k.value.enabled ? !P(T) && !P(T, !1) : !0;
    return !h(T.value) && !B(T) && !(!T.current && c.hideOffsetDates) && R;
  }, U = (T) => k.value.enabled ? c.modelAuto ? oe() && B(T) : !1 : B(T), z = (T) => g.value ? n(T.value, v.value.highlight) : !1, J = (T) => {
    const R = h(T.value);
    return R && (typeof g.value == "function" ? !g.value(T.value, R) : !g.value.options.highlightDisabled);
  }, de = (T) => {
    var R;
    return typeof g.value == "function" ? g.value(T.value) : (R = g.value.weekdays) == null ? void 0 : R.includes(T.value.getDay());
  }, pe = (T) => (k.value.enabled || c.weekPicker) && (!(f.value.count > 0) || T.current) && K() && !(!T.current && c.hideOffsetDates) && !B(T) ? re(T) : !1, ge = (T) => {
    if (Array.isArray(y.value) && y.value.length === 1) {
      const { before: R, after: A } = i(+k.value.maxRange, y.value[0]);
      return Yn(T.value, R) || Mn(T.value, A);
    }
    return !1;
  }, Me = (T) => {
    if (Array.isArray(y.value) && y.value.length === 1) {
      const { before: R, after: A } = i(+k.value.minRange, y.value[0]);
      return s([R, A], y.value[0], T.value);
    }
    return !1;
  }, be = (T) => k.value.enabled && (k.value.maxRange || k.value.minRange) ? k.value.maxRange && k.value.minRange ? ge(T) || Me(T) : k.value.maxRange ? ge(T) : Me(T) : !1, q = (T) => {
    const { isRangeStart: R, isRangeEnd: A } = G(T), Z = k.value.enabled ? R || A : !1;
    return {
      dp__cell_offset: !T.current,
      dp__pointer: !c.disabled && !(!T.current && c.hideOffsetDates) && !h(T.value) && !be(T),
      dp__cell_disabled: h(T.value) || be(T),
      dp__cell_highlight: !J(T) && (z(T) || de(T)) && !U(T) && !Z && !te(T) && !(pe(T) && c.weekPicker) && !A,
      dp__cell_highlight_active: !J(T) && (z(T) || de(T)) && U(T),
      dp__today: !c.noToday && l(T.value, u) && T.current,
      "dp--past": a(T.value, u),
      "dp--future": t(T.value, u)
    };
  }, ye = (T) => ({
    dp__active_date: U(T),
    dp__date_hover: ae(T)
  }), Ce = (T) => {
    if (y.value && !Array.isArray(y.value)) {
      const R = r(y.value, c.weekStart);
      return {
        ...I(T),
        dp__range_start: l(R[0], T.value),
        dp__range_end: l(R[1], T.value),
        dp__range_between_week: t(T.value, R[0]) && a(T.value, R[1])
      };
    }
    return {
      ...I(T)
    };
  }, V = (T) => {
    if (y.value && Array.isArray(y.value)) {
      const R = r(y.value[0], c.weekStart), A = y.value[1] ? r(y.value[1], c.weekStart) : [];
      return {
        ...I(T),
        dp__range_start: l(R[0], T.value) || l(A[0], T.value),
        dp__range_end: l(R[1], T.value) || l(A[1], T.value),
        dp__range_between_week: t(T.value, R[0]) && a(T.value, R[1]) || t(T.value, A[0]) && a(T.value, A[1]),
        dp__range_between: t(T.value, R[1]) && a(T.value, A[0])
      };
    }
    return {
      ...I(T)
    };
  }, G = (T) => {
    const R = f.value.count > 0 ? T.current && P(T) && K() : P(T) && K(), A = f.value.count > 0 ? T.current && P(T, !1) && K() : P(T, !1) && K();
    return { isRangeStart: R, isRangeEnd: A };
  }, he = (T) => k.value.enabled && (k.value.fixedStart || k.value.fixedEnd) && Array.isArray(y.value) && y.value.length === 2, j = (T, R, A, Z) => !he(y.value) || !w.value ? !1 : R ? k.value.fixedEnd && l(T.value, w.value) && Yn(T.value, y.value[0]) && !A : k.value.fixedStart && l(T.value, w.value) && Mn(T.value, y.value[1]) && !Z, se = (T, R) => !he(y.value) || !w.value ? !1 : R ? k.value.fixedEnd && Mn(T.value, w.value) && Yn(T.value, y.value[0]) : k.value.fixedStart && Yn(T.value, w.value) && Mn(T.value, y.value[1]), me = (T) => {
    const { isRangeStart: R, isRangeEnd: A } = G(T);
    return {
      dp__range_start: R,
      dp__range_end: A,
      dp__range_between: pe(T),
      dp__date_hover: l(T.value, w.value) && !R && !A && !c.weekPicker,
      dp__date_hover_start: D(T, !0) || j(T, !0, R, A),
      dp__date_hover_end: D(T, !1) || j(T, !1, R, A),
      "dp--extended-fixed-start": se(T, !0),
      "dp--extended-fixed-end": se(T, !1)
    };
  }, I = (T) => ({
    ...me(T),
    dp__cell_auto_range: H(T),
    dp__cell_auto_range_start: te(T),
    dp__cell_auto_range_end: W(T)
  }), N = (T) => k.value.enabled ? k.value.autoRange ? I(T) : c.modelAuto ? { ...ye(T), ...me(T) } : c.weekPicker ? V(T) : me(T) : c.weekPicker ? Ce(T) : ye(T);
  return {
    setHoverDate: S,
    clearHoverDate: x,
    getDayClassData: (T) => c.hideOffsetDates && !T.current ? {} : {
      ...q(T),
      ...N(T),
      [d.value.dayClass ? d.value.dayClass(T.value, y.value) : ""]: !0,
      ...d.value.calendarCell
    }
  };
}, ew = { key: 0 }, tw = /* @__PURE__ */ xe({
  __name: "DatePicker",
  props: /* @__PURE__ */ Mu({
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  }, Jb),
  emits: ["mount", "update-flow-step", "reset-flow", "focus-menu", "select-date", "time-update", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      month: l,
      year: r,
      modelValue: i,
      time: o,
      disabledTimesConfig: u,
      today: c,
      validateTime: f,
      getCalendarDays: p,
      getMarker: d,
      handleArrow: g,
      handleScroll: v,
      handleSwipe: k,
      selectDate: y,
      updateMonthYear: h,
      presetDate: w,
      selectCurrentDate: S,
      updateTime: x,
      assignMonthAndYear: C,
      setStartTime: _
    } = J0(s, a, ye, Ce), O = Ut(), { setHoverDate: P, getDayClassData: D, clearHoverDate: B } = Q0(), {
      getDate: W,
      rootEmit: H,
      rootProps: te,
      defaults: { multiCalendars: re, timeConfig: oe }
    } = Ke(), { getYears: K, getMonths: ae } = Yl(), { getCellId: U } = Lt(), z = Xe("calendar-header"), J = Xe("calendar"), de = Xe("time-picker"), pe = _n(O, yn.Calendar), ge = _n(O, yn.DatePickerHeader), Me = _n(O, yn.TimePicker), be = (N) => {
      a("mount", N);
    };
    Be(
      re,
      (N, T) => {
        N.count - T.count > 0 && C();
      },
      { deep: !0 }
    );
    const q = M(() => (N) => p(l.value(N), r.value(N)).map((T) => ({
      ...T,
      days: T.days.map((R) => (R.marker = d(R), R.classData = D(R), R))
    })));
    function ye(N) {
      var T, R, A;
      N || N === 0 ? (R = (T = J.value) == null ? void 0 : T[N]) == null || R.triggerTransition(l.value(N), r.value(N)) : (A = J.value) == null || A.forEach((Z, L) => Z == null ? void 0 : Z.triggerTransition(l.value(L), r.value(L)));
    }
    function Ce() {
      a("update-flow-step");
    }
    const V = (N, T, R = 0) => {
      var A, Z;
      (Z = (A = z.value) == null ? void 0 : A[R]) == null || Z.toggleMonthPicker(N, T);
    }, G = (N, T, R = 0) => {
      var A, Z;
      (Z = (A = z.value) == null ? void 0 : A[R]) == null || Z.toggleYearPicker(N, T);
    }, he = (N, T, R) => {
      var A;
      (A = de.value) == null || A.toggleTimePicker(N, T, R);
    }, j = (N, T) => {
      var R;
      if (!te.range) {
        const A = i.value ? i.value : c, Z = T ? W(T) : A, L = N ? rn(Z, { weekStartsOn: 1 }) : Mi(Z, { weekStartsOn: 1 });
        y({
          value: L,
          current: Ze(Z) === l.value(0),
          text: "",
          classData: {}
        }), (R = document.getElementById(U(L))) == null || R.focus();
      }
    }, se = (N) => {
      var T, R;
      (R = (T = z.value) == null ? void 0 : T[0]) == null || R.handleMonthYearChange(N, !0);
    }, me = (N) => {
      h(0, { month: l.value(0), year: r.value(0) + (N ? 1 : -1), fromNav: !0 });
    }, I = (N) => {
      H("overlay-toggle", { open: !1, overlay: N }), a("focus-menu");
    };
    return n({
      clearHoverDate: B,
      presetDate: w,
      selectCurrentDate: S,
      handleArrow: g,
      updateMonthYear: h,
      setStartTime: _,
      toggleMonthPicker: V,
      toggleYearPicker: G,
      toggleTimePicker: he,
      getSidebarProps: () => ({
        modelValue: i,
        month: l,
        year: r,
        time: o,
        updateTime: x,
        updateMonthYear: h,
        selectDate: y,
        presetDate: w
      }),
      changeMonth: se,
      changeYear: me,
      selectWeekDate: j
    }), (N, T) => (b(), $(Te, null, [
      le(Ul, { collapse: e.collapse }, {
        default: ce(({ instances: R, wrapClass: A }) => [
          (b(!0), $(Te, null, Ie(R, (Z) => (b(), $("div", {
            key: Z,
            class: X(A)
          }, [
            m(te).hideMonthYearSelect ? F("", !0) : (b(), ue(H0, {
              key: 0,
              ref_for: !0,
              ref: "calendar-header",
              months: m(ae)(),
              years: m(K)(),
              month: m(l)(Z),
              year: m(r)(Z),
              instance: Z,
              "menu-wrap-ref": e.menuWrapRef,
              onMount: T[0] || (T[0] = (L) => be(m(ba).header)),
              onResetFlow: T[1] || (T[1] = (L) => N.$emit("reset-flow")),
              onUpdateMonthYear: (L) => m(h)(Z, L),
              onOverlayClosed: I
            }, dt({ _: 2 }, [
              Ie(m(ge), (L, fe) => ({
                name: L,
                fn: ce(($e) => [
                  Y(N.$slots, L, lt({ ref_for: !0 }, $e))
                ])
              }))
            ]), 1032, ["months", "years", "month", "year", "instance", "menu-wrap-ref", "onUpdateMonthYear"])),
            le(X0, {
              ref_for: !0,
              ref: "calendar",
              "mapped-dates": q.value(Z),
              instance: Z,
              month: m(l)(Z),
              year: m(r)(Z),
              onSelectDate: (L) => m(y)(L, Z !== 1),
              onSetHoverDate: T[2] || (T[2] = (L) => m(P)(L)),
              onHandleScroll: (L) => m(v)(L, Z),
              onHandleSwipe: (L) => m(k)(L, Z),
              onMount: T[3] || (T[3] = (L) => be(m(ba).calendar))
            }, dt({ _: 2 }, [
              Ie(m(pe), (L, fe) => ({
                name: L,
                fn: ce(($e) => [
                  Y(N.$slots, L, lt({ ref_for: !0 }, $e))
                ])
              }))
            ]), 1032, ["mapped-dates", "instance", "month", "year", "onSelectDate", "onHandleScroll", "onHandleSwipe"])
          ], 2))), 128))
        ]),
        _: 3
      }, 8, ["collapse"]),
      m(oe).enableTimePicker ? (b(), $("div", ew, [
        Y(N.$slots, "time-picker", Ct(Bt({ time: m(o), updateTime: m(x) })), () => [
          le(Vd, {
            ref: "time-picker",
            hours: m(o).hours,
            minutes: m(o).minutes,
            seconds: m(o).seconds,
            "disabled-times-config": m(u),
            "validate-time": m(f),
            "no-overlay-focus": e.noOverlayFocus,
            onMount: T[4] || (T[4] = (R) => be(m(ba).timePicker)),
            "onUpdate:hours": T[5] || (T[5] = (R) => m(x)({ hours: R, minutes: m(o).minutes, seconds: m(o).seconds })),
            "onUpdate:minutes": T[6] || (T[6] = (R) => m(x)({ hours: m(o).hours, minutes: R, seconds: m(o).seconds })),
            "onUpdate:seconds": T[7] || (T[7] = (R) => m(x)({ hours: m(o).hours, minutes: m(o).minutes, seconds: R })),
            onResetFlow: T[8] || (T[8] = (R) => N.$emit("reset-flow"))
          }, dt({ _: 2 }, [
            Ie(m(Me), (R, A) => ({
              name: R,
              fn: ce((Z) => [
                Y(N.$slots, R, Ct(Bt(Z)))
              ])
            }))
          ]), 1032, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time", "no-overlay-focus"])
        ])
      ])) : F("", !0)
    ], 64));
  }
}), nw = (e, n) => {
  const {
    getDate: t,
    modelValue: a,
    year: s,
    calendars: l,
    defaults: { highlight: r, range: i, multiDates: o }
  } = Ke(), { isDateBetween: u, isDateEqual: c } = Lt(), { checkRangeAutoApply: f, handleMultiDatesSelect: p, setMonthOrYearRange: d } = ql();
  Us();
  const { isDisabled: g } = on(), { formatQuarterText: v } = sa(), {
    selectYear: k,
    groupedYears: y,
    showYearPicker: h,
    isDisabled: w,
    toggleYearPicker: S,
    handleYearSelect: x,
    handleYear: C,
    setStartDate: _
  } = Fd(n), O = ee();
  et(() => {
    _();
  });
  const P = M(() => (K) => a.value ? Array.isArray(a.value) ? a.value.some((ae) => Go(K, ae)) : Go(a.value, K) : !1), D = (K) => {
    if (i.value.enabled) {
      if (Array.isArray(a.value)) {
        const ae = c(K, a.value[0]) || c(K, a.value[1]);
        return u(a.value, O.value, K) && !ae;
      }
      return !1;
    }
    return !1;
  }, B = (K, ae) => K.quarter === Wo(ae) && K.year === ze(ae), W = (K) => typeof r.value == "function" ? r.value({ quarter: Wo(K), year: ze(K) }) : r.value.quarters.some((ae) => B(ae, K)), H = M(() => (K) => {
    const ae = je(t(), { year: s.value(K) });
    return ig({
      start: Ua(ae),
      end: hd(ae)
    }).map((U) => {
      const z = va(U), J = Yo(U), de = g(U), pe = D(z), ge = W(z);
      return {
        text: v(z, J),
        value: z,
        active: P.value(z),
        highlighted: ge,
        disabled: de,
        isBetween: pe
      };
    });
  }), te = (K) => {
    p(K, o.value.limit), n("auto-apply", !0);
  }, re = (K) => {
    a.value = d(K), f(a.value, n, a.value.length < 2);
  }, oe = (K) => {
    a.value = K, n("auto-apply");
  };
  return {
    groupedYears: y,
    year: s,
    isDisabled: w,
    quarters: H,
    showYearPicker: h,
    modelValue: a,
    selectYear: k,
    toggleYearPicker: S,
    handleYearSelect: x,
    handleYear: C,
    setHoverDate: (K) => {
      O.value = K;
    },
    selectQuarter: (K, ae, U) => {
      if (!U)
        return l.value[ae].month = Ze(Yo(K)), o.value.enabled ? te(K) : i.value.enabled ? re(K) : oe(K);
    }
  };
}, aw = { class: "dp--quarter-items" }, sw = ["data-test-id", "disabled", "onClick", "onMouseover"], lw = /* @__PURE__ */ xe({
  __name: "QuarterPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      defaults: { config: l }
    } = Ke(), r = Ut(), { boolHtmlAttribute: i } = ls(), o = _n(r, yn.YearMode), {
      groupedYears: u,
      year: c,
      isDisabled: f,
      quarters: p,
      modelValue: d,
      showYearPicker: g,
      setHoverDate: v,
      selectQuarter: k,
      toggleYearPicker: y,
      handleYearSelect: h,
      handleYear: w
    } = nw(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: d,
      year: c,
      selectQuarter: k,
      handleYearSelect: h,
      handleYear: w
    }) }), (S, x) => (b(), ue(Ul, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: ce(({ instances: C, wrapClass: _ }) => [
        (b(!0), $(Te, null, Ie(C, (O) => (b(), $("div", {
          key: O,
          class: X(_)
        }, [
          E("div", {
            class: "dp-quarter-picker-wrap",
            style: Fe({ minHeight: `${m(l).modeHeight}px` })
          }, [
            S.$slots["top-extra"] ? Y(S.$slots, "top-extra", {
              key: 0,
              value: m(d)
            }) : F("", !0),
            E("div", null, [
              le(Rd, {
                items: m(u)(O),
                instance: O,
                "show-year-picker": m(g)[O],
                year: m(c)(O),
                "is-disabled": (P) => m(f)(O, P),
                onHandleYear: (P) => m(w)(O, P),
                onYearSelect: (P) => m(h)(P, O),
                onToggleYearPicker: (P) => m(y)(O, P == null ? void 0 : P.flow, P == null ? void 0 : P.show)
              }, dt({ _: 2 }, [
                Ie(m(o), (P, D) => ({
                  name: P,
                  fn: ce((B) => [
                    Y(S.$slots, P, lt({ ref_for: !0 }, B))
                  ])
                }))
              ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
            ]),
            E("div", aw, [
              (b(!0), $(Te, null, Ie(m(p)(O), (P, D) => (b(), $("div", { key: D }, [
                E("button", {
                  type: "button",
                  class: X(["dp--qr-btn", {
                    "dp--qr-btn-active": P.active,
                    "dp--qr-btn-between": P.isBetween,
                    "dp--qr-btn-disabled": P.disabled,
                    "dp--highlighted": P.highlighted
                  }]),
                  "data-dp-action-element": "0",
                  "data-test-id": P.value,
                  disabled: m(i)(P.disabled),
                  onClick: (B) => m(k)(P.value, O, P.disabled),
                  onMouseover: (B) => m(v)(P.value)
                }, [
                  Y(S.$slots, "quarter", {
                    value: P.value,
                    text: P.text
                  }, () => [
                    Ye(ie(P.text), 1)
                  ])
                ], 42, sw)
              ]))), 128))
            ])
          ], 4)
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), rw = ["id", "tabindex", "role", "aria-label"], iw = {
  key: 0,
  class: "dp--menu-load-container"
}, ow = {
  key: 1,
  class: "dp--menu-header"
}, uw = ["data-dp-mobile"], cw = {
  key: 0,
  class: "dp__sidebar_left"
}, dw = ["data-dp-mobile"], fw = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], hw = { class: "dp__instance_calendar" }, mw = {
  key: 2,
  class: "dp__sidebar_right"
}, vw = {
  key: 2,
  class: "dp__action_extra"
}, pw = /* @__PURE__ */ xe({
  __name: "DatepickerMenu",
  props: {
    collapse: { type: Boolean },
    noOverlayFocus: { type: Boolean },
    getInputRect: { type: Function }
  },
  emits: ["close-picker", "select-date", "auto-apply", "time-update", "menu-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Ut(), {
      state: l,
      rootProps: r,
      defaults: { textInput: i, inline: o, config: u, ui: c, ariaLabels: f },
      setState: p
    } = Ke(), { isMobile: d } = Wl(), { handleEventPropagation: g, getElWithin: v, checkStopPropagation: k, checkKeyDown: y } = _t();
    ub();
    const h = Xe("inner-menu"), w = Xe("dp-menu"), S = Xe("dyn-cmp"), x = ee(0), C = ee(!1), _ = ee(!1), { flowStep: O, updateFlowStep: P, childMount: D, resetFlow: B, handleFlow: W } = db(S), H = (I) => {
      _.value = !0, u.value.allowPreventDefault && I.preventDefault(), k(I, u.value, !0);
    };
    et(() => {
      C.value = !0, te(), globalThis.addEventListener("resize", te);
      const I = Kt(w);
      I && !i.value.enabled && !o.value.enabled && p("menuFocused", !0), I && (I.addEventListener("pointerdown", H), I.addEventListener("mousedown", H)), document.addEventListener("mousedown", me);
    }), Jt(() => {
      globalThis.removeEventListener("resize", te), document.removeEventListener("mousedown", me);
      const I = Kt(w);
      I && (I.removeEventListener("pointerdown", H), I.removeEventListener("mousedown", H));
    });
    const te = () => {
      const I = Kt(h);
      I && (x.value = I.getBoundingClientRect().width);
    }, re = M(() => r.monthPicker ? k0 : r.yearPicker ? S0 : r.timePicker ? V0 : r.quarterPicker ? lw : tw), oe = () => {
      const I = Kt(w);
      I && I.focus({ preventScroll: !0 });
    }, K = M(() => {
      var I;
      return ((I = S.value) == null ? void 0 : I.getSidebarProps()) || {};
    }), ae = _n(s, yn.ActionRow), U = _n(s, yn.PassTrough), z = M(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly,
      "dp-menu-loading": r.loading
    })), J = M(
      () => ({
        dp__menu: !0,
        dp__menu_index: !o.value.enabled,
        dp__relative: o.value.enabled,
        ...c.value.menu
      })
    ), de = (I) => {
      k(I, u.value, !0);
    }, pe = (I) => {
      u.value.escClose && (a("close-picker"), g(I, u.value));
    }, ge = (I) => {
      r.arrowNavigation || (I === mn.left || I === mn.up ? ye("handleArrow", mn.left, 0, I === mn.up) : ye("handleArrow", mn.right, 0, I === mn.down));
    }, Me = (I) => {
      p("shiftKeyInMenu", I.shiftKey), !r.hideMonthYearSelect && I.code === ct.tab && I.target.classList.contains("dp__menu") && l.shiftKeyInMenu && (I.preventDefault(), k(I, u.value, !0), a("close-picker"));
    }, be = (I) => {
      var N, T, R;
      (N = S.value) == null || N.toggleTimePicker(!1, !1), (T = S.value) == null || T.toggleMonthPicker(!1, !1, I), (R = S.value) == null || R.toggleYearPicker(!1, !1, I);
    }, q = (I, N = 0) => {
      var T, R, A;
      return I === "month" ? (T = S.value) == null ? void 0 : T.toggleMonthPicker(!1, !0, N) : I === "year" ? (R = S.value) == null ? void 0 : R.toggleYearPicker(!1, !0, N) : I === "time" ? (A = S.value) == null ? void 0 : A.toggleTimePicker(!0, !1) : be(N);
    }, ye = (I, ...N) => {
      var T, R;
      (T = S.value) != null && T[I] && ((R = S.value) == null || R[I](...N));
    }, Ce = () => {
      ye("selectCurrentDate");
    }, V = (I) => {
      ye("presetDate", Qe(I));
    }, G = () => {
      ye("clearHoverDate");
    }, he = (I, N) => {
      ye("updateMonthYear", I, N);
    }, j = (I, N) => {
      I.preventDefault(), ge(N);
    }, se = (I) => {
      var N, T, R;
      if (Me(I), I.key === ct.home || I.key === ct.end)
        return ye(
          "selectWeekDate",
          I.key === ct.home,
          I.target.getAttribute("id")
        );
      switch ((I.key === ct.pageUp || I.key === ct.pageDown) && (I.shiftKey ? (ye("changeYear", I.key === ct.pageUp), (N = v(w.value, "overlay-year")) == null || N.focus()) : (ye("changeMonth", I.key === ct.pageUp), (T = v(w.value, I.key === ct.pageUp ? "action-prev" : "action-next")) == null || T.focus()), I.target.getAttribute("id") && ((R = w.value) == null || R.focus({ preventScroll: !0 }))), I.key) {
        case ct.esc:
          return pe(I);
        case ct.arrowLeft:
          return j(I, mn.left);
        case ct.arrowRight:
          return j(I, mn.right);
        case ct.arrowUp:
          return j(I, mn.up);
        case ct.arrowDown:
          return j(I, mn.down);
        default:
          return;
      }
    }, me = (I) => {
      var N;
      o.value.enabled && !o.value.input && !((N = w.value) != null && N.contains(I.target)) && _.value && (_.value = !1, a("menu-blur"));
    };
    return n({
      updateMonthYear: he,
      switchView: q,
      onValueCleared: () => {
        var I, N;
        (N = (I = S.value) == null ? void 0 : I.setStartTime) == null || N.call(I);
      },
      handleFlow: W
    }), (I, N) => {
      var T, R, A;
      return b(), $("div", {
        id: m(r).menuId,
        ref: "dp-menu",
        tabindex: m(o).enabled ? void 0 : "0",
        role: m(o).enabled ? void 0 : "dialog",
        "aria-label": (T = m(f)) == null ? void 0 : T.menu,
        class: X(J.value),
        onMouseleave: G,
        onClick: de,
        onKeydown: se
      }, [
        (m(r).disabled || m(r).readonly) && m(o).enabled || m(r).loading ? (b(), $("div", {
          key: 0,
          class: X(z.value)
        }, [
          m(r).loading ? (b(), $("div", iw, [...N[5] || (N[5] = [
            E("span", { class: "dp--menu-loader" }, null, -1)
          ])])) : F("", !0)
        ], 2)) : F("", !0),
        I.$slots["menu-header"] ? (b(), $("div", ow, [
          Y(I.$slots, "menu-header")
        ])) : F("", !0),
        Y(I.$slots, "arrow"),
        E("div", {
          ref: "inner-menu",
          class: X({
            dp__menu_content_wrapper: ((R = m(r).presetDates) == null ? void 0 : R.length) || !!I.$slots["left-sidebar"] || !!I.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((A = m(r).presetDates) == null ? void 0 : A.length) || !!I.$slots["left-sidebar"] || !!I.$slots["right-sidebar"])
          }),
          "data-dp-mobile": m(d),
          style: Fe({ "--dp-menu-width": `${x.value}px` })
        }, [
          I.$slots["left-sidebar"] ? (b(), $("div", cw, [
            Y(I.$slots, "left-sidebar", Ct(Bt(K.value)))
          ])) : F("", !0),
          m(r).presetDates.length ? (b(), $("div", {
            key: 1,
            class: X({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": m(d)
          }, [
            (b(!0), $(Te, null, Ie(m(r).presetDates, (Z, L) => (b(), $(Te, { key: L }, [
              Z.slot ? Y(I.$slots, Z.slot, {
                key: 0,
                presetDate: V,
                label: Z.label,
                value: Z.value
              }) : (b(), $("button", {
                key: 1,
                type: "button",
                style: Fe(Z.style || {}),
                class: X(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test-id": Z.testId ?? void 0,
                "data-dp-mobile": m(d),
                onClick: Ve((fe) => V(Z.value), ["prevent"]),
                onKeydown: (fe) => m(y)(fe, () => V(Z.value), !0)
              }, ie(Z.label), 47, fw))
            ], 64))), 128))
          ], 10, dw)) : F("", !0),
          E("div", hw, [
            (b(), ue(ht(re.value), {
              ref: "dyn-cmp",
              "flow-step": m(O),
              collapse: e.collapse,
              "no-overlay-focus": e.noOverlayFocus,
              "menu-wrap-ref": w.value,
              onMount: m(D),
              onUpdateFlowStep: m(P),
              onResetFlow: m(B),
              onFocusMenu: oe,
              onSelectDate: N[0] || (N[0] = (Z) => I.$emit("select-date")),
              onAutoApply: N[1] || (N[1] = (Z) => I.$emit("auto-apply", Z)),
              onTimeUpdate: N[2] || (N[2] = (Z) => I.$emit("time-update"))
            }, dt({ _: 2 }, [
              Ie(m(U), (Z, L) => ({
                name: Z,
                fn: ce((fe) => [
                  Y(I.$slots, Z, Ct(Bt({ ...fe })))
                ])
              }))
            ]), 1064, ["flow-step", "collapse", "no-overlay-focus", "menu-wrap-ref", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ]),
          I.$slots["right-sidebar"] ? (b(), $("div", mw, [
            Y(I.$slots, "right-sidebar", Ct(Bt(K.value)))
          ])) : F("", !0)
        ], 14, uw),
        I.$slots["action-extra"] ? (b(), $("div", vw, [
          I.$slots["action-extra"] ? Y(I.$slots, "action-extra", {
            key: 0,
            selectCurrentDate: Ce
          }) : F("", !0)
        ])) : F("", !0),
        !m(r).autoApply || m(u).keepActionRow ? (b(), ue(f0, {
          key: 3,
          "menu-mount": C.value,
          "calendar-width": x.value,
          onClosePicker: N[3] || (N[3] = (Z) => I.$emit("close-picker")),
          onSelectDate: N[4] || (N[4] = (Z) => I.$emit("select-date")),
          onSelectNow: Ce
        }, dt({ _: 2 }, [
          Ie(m(ae), (Z, L) => ({
            name: Z,
            fn: ce((fe) => [
              Y(I.$slots, Z, Ct(Bt(fe)))
            ])
          }))
        ]), 1032, ["menu-mount", "calendar-width"])) : F("", !0)
      ], 42, rw);
    };
  }
}), gw = ["data-dp-mobile"], yw = /* @__PURE__ */ xe({
  __name: "VueDatePicker",
  setup(e, { expose: n }) {
    const {
      rootEmit: t,
      setState: a,
      inputValue: s,
      modelValue: l,
      rootProps: r,
      defaults: { inline: i, config: o, textInput: u, range: c, multiDates: f, teleport: p, floatingConfig: d }
    } = Ke(), { validateDate: g, isValidTime: v } = on(), { menuTransition: k, showTransition: y } = Hs(), { isMobile: h } = Wl(), { findNextFocusableElement: w, getNumVal: S } = _t(), x = Ut(), C = ee(!1), _ = ee(i.value.enabled || r.centered), O = pl(r, "modelValue"), P = pl(r, "timezone"), D = Xe("dp-menu-wrap"), B = Xe("dp-menu"), W = Xe("input-cmp"), H = Xe("picker-wrapper"), te = Xe("menu-arrow"), re = ee(!1), oe = ee(!1), K = ee(!1), ae = ee(!0), U = (Ee) => (d.value.arrow && Ee.push(
      Kp({ element: d.value.arrow === !0 ? te : d.value.arrow })
    ), d.value.flip && Ee.push(Up(typeof d.value.flip == "object" ? d.value.flip : {})), d.value.shift && Ee.push(Hp(typeof d.value.shift == "object" ? d.value.shift : {})), Ee), { floatingStyles: z, middlewareData: J, placement: de, y: pe } = Zp(
      W,
      D,
      {
        strategy: d.value.strategy,
        placement: d.value.placement,
        middleware: U([Yp(d.value.offset)]),
        whileElementsMounted: Wp
      }
    );
    et(() => {
      be(r.modelValue), Ge().then(() => {
        i.value.enabled || globalThis.addEventListener("resize", me);
      }), i.value.enabled && (C.value = !0), globalThis.addEventListener("keyup", I), globalThis.addEventListener("keydown", N);
    }), Jt(() => {
      i.value.enabled || globalThis.removeEventListener("resize", me), globalThis.removeEventListener("keyup", I), globalThis.removeEventListener("keydown", N);
    });
    const ge = Pd(x, r.presetDates), Me = _n(x, yn.Input);
    Be(
      [O, P],
      () => {
        be(O.value);
      },
      { deep: !0 }
    ), Be([de, pe], () => {
      !i.value.enabled && !r.centered && ae.value && (_.value = !1, Ge().then(() => {
        ae.value = !1, _.value = !0;
      }));
    });
    const { parseExternalModelValue: be, emitModelValue: q, formatInputValue: ye, checkBeforeEmit: Ce } = cb(), V = M(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: i.value.enabled,
        "dp--flex-display-collapsed": K.value,
        dp__flex_display_with_input: i.value.input
      })
    ), G = M(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), he = M(() => i.value.enabled && (r.timePicker || r.monthPicker || r.yearPicker || r.quarterPicker)), j = () => {
      var Ee, ut;
      return ((ut = (Ee = W.value) == null ? void 0 : Ee.$el) == null ? void 0 : ut.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, se = () => {
      C.value && o.value.closeOnScroll && _e();
    }, me = () => {
      var ut;
      const Ee = ((ut = B.value) == null ? void 0 : ut.$el.getBoundingClientRect().width) ?? 0;
      K.value = document.body.offsetWidth <= Ee;
    }, I = (Ee) => {
      Ee.key === "Tab" && !i.value.enabled && !r.teleport && o.value.tabOutClosesMenu && (H.value.contains(document.activeElement) || _e()), oe.value = Ee.shiftKey;
    }, N = (Ee) => {
      oe.value = Ee.shiftKey;
    }, T = () => {
      !r.disabled && !r.readonly && (ae.value = !0, C.value = !0, C.value && t("open"), C.value || Re(), be(r.modelValue));
    }, R = () => {
      var Ee, ut;
      s.value = "", Re(), (Ee = B.value) == null || Ee.onValueCleared(), (ut = W.value) == null || ut.setParsedDate(null), t("update:model-value", null), t("cleared"), o.value.closeOnClearValue && _e();
    }, A = () => {
      const Ee = l.value;
      return !Ee || !Array.isArray(Ee) && g(Ee) ? !0 : Array.isArray(Ee) ? f.value.enabled || Ee.length === 2 && g(Ee[0]) && g(Ee[1]) ? !0 : c.value.partialRange && !r.timePicker ? g(Ee[0]) : !1 : !1;
    }, Z = () => {
      Ce() && A() ? (q(), _e()) : t("invalid-select");
    }, L = (Ee) => {
      fe(), q(), o.value.closeOnAutoApply && !Ee && _e();
    }, fe = () => {
      W.value && u.value.enabled && W.value.setParsedDate(l.value);
    }, $e = (Ee = !1) => {
      r.autoApply && v(l.value) && A() && (c.value.enabled && Array.isArray(l.value) ? (c.value.partialRange || l.value.length === 2) && L(Ee) : L(Ee));
    }, Re = () => {
      u.value.enabled || (l.value = null);
    }, _e = (Ee = !1) => {
      ae.value = !0, Ee && l.value && o.value.setDateOnMenuClose && Z(), i.value.enabled || (C.value && (C.value = !1, a("menuFocused", !1), a("shiftKeyInMenu", !1), t("closed"), s.value && be(O.value)), Re(), t("blur"));
    }, We = (Ee, ut, Dt = !1) => {
      if (!Ee) {
        l.value = null;
        return;
      }
      const Sn = Array.isArray(Ee) ? Ee.every((Ma) => g(Ma)) : g(Ee), Ln = v(Ee);
      Sn && Ln ? (a("isTextInputDate", !0), l.value = Ee, ut ? (re.value = Dt, Z(), t("text-submit")) : r.autoApply && $e(!0), Ge().then(() => {
        a("isTextInputDate", !1);
      })) : t("invalid-date", Ee);
    }, Rt = () => {
      r.autoApply && v(l.value) && q(), fe();
    }, un = () => C.value ? _e() : T(), cn = (Ee) => {
      l.value = Ee;
    }, Fn = () => {
      u.value.enabled && (a("isInputFocused", !0), ye()), t("focus");
    }, At = () => {
      var Ee;
      u.value.enabled && (a("isInputFocused", !1), be(r.modelValue), re.value && ((Ee = w(H.value, oe.value)) == null || Ee.focus())), t("blur");
    }, Wt = (Ee, ut) => {
      B.value && B.value.updateMonthYear(ut ?? 0, {
        month: S(Ee.month),
        year: S(Ee.year)
      });
    }, Vn = (Ee) => {
      be(Ee ?? r.modelValue);
    }, xn = (Ee, ut) => {
      var Dt;
      (Dt = B.value) == null || Dt.switchView(Ee, ut);
    }, Tt = (Ee, ut) => {
      if (C.value)
        return o.value.onClickOutside ? o.value.onClickOutside(Ee, ut) : _e(!0);
    }, $t = (Ee = 0) => {
      var ut;
      (ut = B.value) == null || ut.handleFlow(Ee);
    }, yt = () => D;
    return Xv(D, (Ee) => Tt(A, Ee), {
      ignore: [W]
    }), n({
      closeMenu: _e,
      selectDate: Z,
      clearValue: R,
      openMenu: T,
      onScroll: se,
      formatInputValue: ye,
      // exposed for testing purposes
      updateInternalModelValue: cn,
      // modify internal modelValue
      setMonthYear: Wt,
      parseModel: Vn,
      switchView: xn,
      toggleMenu: un,
      handleFlow: $t,
      getDpWrapMenuRef: yt,
      dpMenuRef: () => B,
      dpWrapMenuRef: () => D,
      inputRef: () => W
    }), (Ee, ut) => (b(), $("div", {
      ref: "picker-wrapper",
      class: X(V.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": m(h)
    }, [
      le(i0, {
        ref: "input-cmp",
        "is-menu-open": C.value,
        onClear: R,
        onOpen: T,
        onSetInputDate: We,
        onSetEmptyDate: m(q),
        onSelectDate: Z,
        onToggle: un,
        onClose: _e,
        onFocus: Fn,
        onBlur: At,
        onRealBlur: ut[0] || (ut[0] = (Dt) => m(a)("isInputFocused", !1))
      }, dt({ _: 2 }, [
        Ie(m(Me), (Dt, Sn) => ({
          name: Dt,
          fn: ce((Ln) => [
            Y(Ee.$slots, Dt, Ct(Bt(Ln)))
          ])
        }))
      ]), 1032, ["is-menu-open", "onSetEmptyDate"]),
      le(Pn, {
        to: m(p),
        disabled: !m(p)
      }, {
        default: ce(() => [
          E("div", {
            ref: "dp-menu-wrap",
            class: X({
              "dp--menu-wrapper": !m(i).enabled,
              dp__outer_menu_wrap: !0,
              "dp--centered": m(r).centered
            }),
            style: Fe(!m(i).enabled && !m(r).centered ? m(z) : void 0)
          }, [
            le(St, {
              name: m(k)(m(de).startsWith("top")),
              css: m(y) && !m(i).enabled && !m(r).centered && _.value
            }, {
              default: ce(() => [
                C.value && _.value ? (b(), ue(pw, {
                  key: 0,
                  ref: "dp-menu",
                  class: X({ [G.value]: !0 }),
                  "no-overlay-focus": he.value,
                  collapse: K.value,
                  "get-input-rect": j,
                  onClosePicker: _e,
                  onSelectDate: Z,
                  onAutoApply: $e,
                  onTimeUpdate: Rt,
                  onMenuBlur: ut[1] || (ut[1] = (Dt) => m(t)("blur"))
                }, dt({ _: 2 }, [
                  Ie(m(ge), (Dt, Sn) => ({
                    name: Dt,
                    fn: ce((Ln) => [
                      Y(Ee.$slots, Dt, Ct(Bt({ ...Ln })))
                    ])
                  })),
                  !m(i).enabled && !m(r).centered && m(d).arrow === !0 ? {
                    name: "arrow",
                    fn: ce(() => {
                      var Dt, Sn;
                      return [
                        E("div", {
                          ref: "menu-arrow",
                          class: X({
                            dp__arrow_top: m(de) === "bottom",
                            dp__arrow_bottom: m(de) === "top"
                          }),
                          style: Fe({
                            left: ((Dt = m(J).arrow) == null ? void 0 : Dt.x) != null ? `${m(J).arrow.x}px` : "",
                            top: ((Sn = m(J).arrow) == null ? void 0 : Sn.y) != null ? `${m(J).arrow.y}px` : ""
                          })
                        }, null, 6)
                      ];
                    }),
                    key: "0"
                  } : void 0
                ]), 1032, ["class", "no-overlay-focus", "collapse"])) : F("", !0)
              ]),
              _: 3
            }, 8, ["name", "css"])
          ], 6)
        ]),
        _: 3
      }, 8, ["to", "disabled"])
    ], 10, gw));
  }
}), bw = /* @__PURE__ */ xe({
  __name: "VueDatePickerRoot",
  props: /* @__PURE__ */ Mu({
    multiCalendars: { type: [Boolean, Number, String, Object] },
    modelValue: {},
    modelType: {},
    dark: { type: Boolean },
    transitions: { type: [Boolean, Object] },
    ariaLabels: {},
    hideNavigation: {},
    timezone: {},
    vertical: { type: Boolean },
    hideMonthYearSelect: { type: Boolean },
    disableYearSelect: { type: Boolean },
    yearRange: {},
    autoApply: { type: Boolean },
    disabledDates: { type: [Array, Function] },
    startDate: {},
    hideOffsetDates: { type: Boolean },
    noToday: { type: Boolean },
    allowedDates: {},
    markers: {},
    presetDates: {},
    flow: {},
    preventMinMaxNavigation: { type: Boolean },
    reverseYears: { type: Boolean },
    weekPicker: { type: Boolean },
    filters: {},
    arrowNavigation: { type: Boolean },
    highlight: { type: [Function, Object] },
    teleport: { type: [String, Boolean] },
    centered: { type: Boolean },
    locale: {},
    weekStart: {},
    weekNumbers: { type: [Boolean, Object] },
    dayNames: { type: [Function, Array] },
    monthPicker: { type: Boolean },
    yearPicker: { type: Boolean },
    modelAuto: { type: Boolean },
    formats: {},
    multiDates: { type: [Boolean, Object] },
    minDate: {},
    maxDate: {},
    minTime: {},
    maxTime: {},
    inputAttrs: {},
    timeConfig: {},
    placeholder: {},
    timePicker: { type: Boolean },
    range: { type: [Boolean, Object] },
    menuId: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    inline: { type: [Boolean, Object] },
    textInput: { type: [Boolean, Object] },
    sixWeeks: { type: [Boolean, String] },
    actionRow: {},
    focusStartDate: { type: Boolean },
    disabledTimes: { type: [Function, Array] },
    calendar: { type: Function },
    config: {},
    quarterPicker: { type: Boolean },
    yearFirst: { type: Boolean },
    loading: { type: Boolean },
    ui: {},
    floating: {}
  }, Qb),
  emits: ["update:model-value", "internal-model-change", "text-submit", "text-input", "open", "closed", "focus", "blur", "cleared", "flow-step", "update-month-year", "invalid-select", "invalid-fixed-range", "invalid-date", "tooltip-open", "tooltip-close", "am-pm-change", "range-start", "range-end", "date-click", "overlay-toggle", "invalid"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e;
    ib(s, a);
    const l = Ut(), r = Pd(l, s.presetDates), i = Xe("date-picker");
    return n(t0(i)), (o, u) => (b(), ue(yw, { ref: "date-picker" }, dt({ _: 2 }, [
      Ie(m(r), (c, f) => ({
        name: c,
        fn: ce((p) => [
          Y(o.$slots, c, Ct(Bt(p)))
        ])
      }))
    ]), 1536));
  }
}), tu = "theme-mode", ww = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", Nd = $f("theme", () => {
  const e = ee("light"), n = ee("light"), t = M(() => n.value === "dark"), a = M(() => n.value === "light"), s = (o) => {
    document.documentElement.setAttribute("data-theme", o);
  }, l = (o) => {
    e.value = o, n.value = o, s(o), localStorage.setItem(tu, o);
  };
  return {
    themeMode: e,
    resolvedTheme: n,
    isDark: t,
    isLight: a,
    setThemeMode: l,
    toggleTheme: () => {
      l(e.value === "dark" ? "light" : "dark");
    },
    initTheme: () => {
      const o = localStorage.getItem(tu);
      l(o === "light" || o === "dark" ? o : ww());
    }
  };
}), kw = {
  key: 0,
  class: "v-datepicker-label"
}, xw = { class: "v-datepicker-icon-wrapper" }, Sw = { class: "v-datepicker-clear-wrapper" }, Tw = {
  key: 1,
  class: "v-datepicker-helper-text"
}, $w = {
  key: 0,
  class: "form-error"
}, Mw = /* @__PURE__ */ xe({
  inheritAttrs: !1,
  __name: "VDatepicker",
  props: /* @__PURE__ */ Ht({
    name: { default: "" },
    helperText: { default: "" },
    validation: { default: void 0 },
    size: { default: "md" },
    icon: { default: "lucide:calendar" },
    autoApply: { type: Boolean, default: !0 },
    clearable: { type: Boolean, default: !1 },
    width: { default: "100%" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Nd(), t = En(e, "modelValue"), a = Ut(), s = [
      "input-icon",
      "clear-icon",
      "arrow-left",
      "arrow-right",
      "arrow-up",
      "arrow-down",
      "clock-icon",
      "calendar-icon"
    ], l = e;
    return (r, i) => {
      var o, u, c, f;
      return b(), $("div", {
        class: X([`v-datepicker--${e.size}`, "v-datepicker-wrapper"]),
        style: Fe({ width: l.width })
      }, [
        l.name ? (b(), $("label", kw, ie(l.name), 1)) : F("", !0),
        le(m(bw), lt({
          modelValue: t.value,
          "onUpdate:modelValue": i[0] || (i[0] = (p) => t.value = p),
          "auto-apply": l.autoApply,
          "calendar-class-name": "v-datepicker-calendar",
          class: [
            "v-datepicker",
            {
              "v-datepicker-error": (o = e.validation) == null ? void 0 : o.$error,
              "v-datepicker-no-clear": !l.clearable
            }
          ],
          dark: m(n).isDark,
          "input-class-name": [
            "v-datepicker-input",
            {
              "v-datepicker-input-error": (u = e.validation) == null ? void 0 : u.$error
            }
          ],
          "menu-class-name": "v-datepicker-menu",
          timezone: "UTC",
          "week-start": 0
        }, r.$attrs), dt({ _: 2 }, [
          m(a)["input-icon"] ? {
            name: "input-icon",
            fn: ce(() => [
              Y(r.$slots, "input-icon", {}, void 0, !0)
            ]),
            key: "0"
          } : {
            name: "input-icon",
            fn: ce(() => [
              E("div", xw, [
                le(we, {
                  icon: e.icon,
                  class: "v-datepicker-icon"
                }, null, 8, ["icon"])
              ])
            ]),
            key: "1"
          },
          l.clearable ? l.clearable && m(a)["clear-icon"] ? {
            name: "clear-icon",
            fn: ce((p) => [
              Y(r.$slots, "clear-icon", Ct(Bt(p)), void 0, !0)
            ]),
            key: "3"
          } : {
            name: "clear-icon",
            fn: ce(({ clear: p }) => [
              E("div", Sw, [
                le(we, {
                  class: "v-datepicker-clear-icon",
                  icon: "lucide:x",
                  onClick: p
                }, null, 8, ["onClick"])
              ])
            ]),
            key: "4"
          } : {
            name: "clear-icon",
            fn: ce(() => []),
            key: "2"
          },
          m(a)["arrow-left"] ? {
            name: "arrow-left",
            fn: ce(() => [
              Y(r.$slots, "arrow-left", {}, void 0, !0)
            ]),
            key: "5"
          } : {
            name: "arrow-left",
            fn: ce(() => [
              le(we, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-left"
              })
            ]),
            key: "6"
          },
          m(a)["arrow-right"] ? {
            name: "arrow-right",
            fn: ce(() => [
              Y(r.$slots, "arrow-right", {}, void 0, !0)
            ]),
            key: "7"
          } : {
            name: "arrow-right",
            fn: ce(() => [
              le(we, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-right"
              })
            ]),
            key: "8"
          },
          m(a)["arrow-up"] ? {
            name: "arrow-up",
            fn: ce(() => [
              Y(r.$slots, "arrow-up", {}, void 0, !0)
            ]),
            key: "9"
          } : {
            name: "arrow-up",
            fn: ce(() => [
              le(we, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-up"
              })
            ]),
            key: "10"
          },
          m(a)["arrow-down"] ? {
            name: "arrow-down",
            fn: ce(() => [
              Y(r.$slots, "arrow-down", {}, void 0, !0)
            ]),
            key: "11"
          } : {
            name: "arrow-down",
            fn: ce(() => [
              le(we, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-down"
              })
            ]),
            key: "12"
          },
          m(a)["clock-icon"] ? {
            name: "clock-icon",
            fn: ce(() => [
              Y(r.$slots, "clock-icon", {}, void 0, !0)
            ]),
            key: "13"
          } : {
            name: "clock-icon",
            fn: ce(() => [
              le(we, {
                class: "v-datepicker-clock-icon",
                icon: "lucide:clock"
              })
            ]),
            key: "14"
          },
          m(a)["calendar-icon"] ? {
            name: "calendar-icon",
            fn: ce(() => [
              Y(r.$slots, "calendar-icon", {}, void 0, !0)
            ]),
            key: "15"
          } : {
            name: "calendar-icon",
            fn: ce(() => [
              le(we, {
                icon: e.icon,
                class: "v-datepicker-calendar-icon"
              }, null, 8, ["icon"])
            ]),
            key: "16"
          },
          Ie(m(a), (p, d) => ({
            name: d,
            fn: ce((g) => [
              s.includes(d) ? F("", !0) : Y(r.$slots, d, Ct(lt({ key: 0 }, g)), void 0, !0)
            ])
          }))
        ]), 1040, ["modelValue", "auto-apply", "class", "dark", "input-class-name"]),
        E("fieldset", {
          class: X([{ "v-datepicker-fieldset--error": (c = e.validation) == null ? void 0 : c.$error }, "v-datepicker-fieldset"]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: X([{ "v-datepicker-legend--visible": !!l.name }, "v-datepicker-legend"])
          }, [
            E("span", null, ie(l.name), 1)
          ], 2)
        ], 2),
        e.helperText && !((f = e.validation) != null && f.$error) ? (b(), $("p", Tw, ie(e.helperText), 1)) : F("", !0),
        le(St, {
          mode: "out-in",
          name: "error-slide"
        }, {
          default: ce(() => {
            var p, d, g, v;
            return [
              (p = e.validation) != null && p.$error ? (b(), $("p", $w, ie((v = (g = (d = e.validation) == null ? void 0 : d.$errors) == null ? void 0 : g[0]) == null ? void 0 : v.$message), 1)) : F("", !0)
            ];
          }),
          _: 1
        })
      ], 6);
    };
  }
}), FD = /* @__PURE__ */ Ue(Mw, [["__scopeId", "data-v-7925760e"]]), js = (e) => e == null, Bd = (e, n) => e.length <= n ? e : `${e.slice(0, n)}...`, Cs = (e, n = 2) => {
  if (e === 0) return "0 Bytes";
  const t = 1024, a = n < 0 ? 0 : n, s = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], l = Math.floor(Math.log(e) / Math.log(t));
  return `${parseFloat((e / Math.pow(t, l)).toFixed(a))} ${s[l]}`;
}, zd = (e) => e.slice((e.lastIndexOf(".") - 1 >>> 0) + 2), VD = (e) => {
  const n = zd(e).toLowerCase();
  return [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "svg",
    "bmp"
  ].includes(n);
}, Cw = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  UAH: "₴",
  JPY: "¥",
  CNY: "¥"
}, Ds = (e, n = "USD") => {
  if (js(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  let a, s, l;
  typeof n == "string" ? n === "compact" || n === "chart" || n === "default" ? (l = n, a = "USD") : a = n : (a = n.code ?? "USD", s = n.decimals, l = n.format);
  const r = Cw[a] || a, i = t < 0, o = Math.abs(t);
  if (l === "compact") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 0,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${r}${c}` : `${r}${c}`;
  }
  if (l === "chart") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 1,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${r}${c}` : `${r}${c}`;
  }
  const u = o.toLocaleString("en-US", {
    minimumFractionDigits: s ?? 0,
    maximumFractionDigits: s ?? 0
  });
  return i ? `-${r}${u}` : `${r}${u}`;
}, Wd = (e, n) => {
  if (js(e)) return { text: "" };
  const t = !!e, a = (n == null ? void 0 : n.trueText) ?? "Yes", s = (n == null ? void 0 : n.falseText) ?? "No", l = (n == null ? void 0 : n.colored) ?? !0, r = t ? a : s;
  return l ? { text: r, class: t ? "text-success" : "text-negative" } : { text: r };
}, Ii = (e, n) => {
  if (js(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  return `${((typeof n == "object" ? n.multiplier ?? !1 : !1) ? t * 100 : t).toLocaleString("en-US", {
    minimumFractionDigits: a,
    maximumFractionDigits: a
  })}%`;
}, qa = (e, n) => {
  if (js(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.type) ?? "default", s = typeof n == "object" ? n.decimals : void 0, l = typeof n == "object" ? n.multiply : void 0, r = l !== void 0 ? t * l : t;
  switch (a) {
    case "compact":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 1
      }).format(r);
    case "chart":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 1,
        maximumFractionDigits: s ?? 1
      }).format(r);
    case "percent":
      return `${r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      })}%`;
    case "decimal":
      return r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      });
    case "default":
    default:
      return r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 0
      });
  }
}, Yd = (e, n) => {
  if (!e) return "";
  let t;
  if (e instanceof Date)
    t = Oe.fromJSDate(e).toUTC();
  else if (typeof e == "string") {
    const s = Oe.fromISO(e, { zone: "utc" });
    if (s.isValid)
      t = s;
    else {
      const l = new Date(e);
      if (isNaN(l.getTime())) return String(e);
      t = Oe.fromJSDate(l).toUTC();
    }
  } else if (typeof e == "number")
    t = Oe.fromMillis(e).toUTC();
  else
    return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.format) ?? "short";
  switch (a) {
    case "short":
      return t.toFormat("MM/dd/yyyy");
    case "long":
      return t.toFormat("MMMM dd, yyyy");
    case "time":
      return t.toFormat("h:mm:ss a");
    case "datetime":
      return t.toFormat("MM/dd/yyyy h:mm:ss a");
    default:
      return t.toFormat(a);
  }
}, Hd = (e, n) => {
  if (js(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  if (t === 0) return "0 Bytes";
  const s = 1024, l = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], r = Math.floor(Math.log(t) / Math.log(s));
  return `${parseFloat((t / Math.pow(s, r)).toFixed(a))} ${l[r]}`;
}, LD = (e) => typeof e != "string" ? String(e || "") : e.replace(/[_-]/g, " ").replace(/\s+/g, " ").trim().toLowerCase().split(" ").map((n) => n.charAt(0).toUpperCase() + n.slice(1)).join(" "), Dw = {
  key: 0,
  class: "loader-message"
}, _w = /* @__PURE__ */ xe({
  __name: "VLoader",
  props: {
    size: { default: "medium" },
    message: { default: "" },
    fullscreen: { type: Boolean, default: !1 },
    variant: { default: "primary" }
  },
  setup(e) {
    const n = e, t = M(() => `loader-${n.size}`), a = M(() => `loader-${n.variant}`), s = M(() => ({
      "loader-fullscreen": n.fullscreen
    }));
    return (l, r) => (b(), $("div", {
      class: X([s.value, "loader-container"]),
      role: "status"
    }, [
      E("div", {
        class: X([[t.value, a.value], "loader"])
      }, [...r[0] || (r[0] = [
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1)
      ])], 2),
      e.message ? (b(), $("span", Dw, ie(e.message), 1)) : F("", !0),
      r[1] || (r[1] = E("span", { class: "sr-only" }, "Loading...", -1))
    ], 2));
  }
}), jl = /* @__PURE__ */ Ue(_w, [["__scopeId", "data-v-6ca9fde0"]]), Ow = { class: "drag-n-drop" }, Ew = ["id", "accept", "disabled", "multiple"], Iw = {
  key: 0,
  class: "drag-n-drop__loading"
}, Aw = {
  key: 1,
  class: "drag-n-drop__content"
}, Pw = { class: "drag-n-drop__icon-wrapper" }, Rw = { class: "drag-n-drop__text" }, Fw = {
  key: 0,
  class: "text-primary font-medium text-base"
}, Vw = { class: "text-secondaryText text-sm" }, Lw = { key: 0 }, Nw = { key: 1 }, Bw = { key: 2 }, zw = {
  key: 2,
  class: "drag-n-drop__preview"
}, Ww = { class: "drag-n-drop__preview-header" }, Yw = { class: "text-mainText font-medium" }, Hw = { class: "text-secondaryText text-xs mt-1" }, Uw = { class: "drag-n-drop__file-icon" }, qw = { class: "drag-n-drop__file-info" }, jw = ["title"], Gw = { class: "drag-n-drop__file-size" }, Kw = ["disabled", "onClick"], Zw = {
  key: 1,
  class: "drag-n-drop__actions"
}, Xw = /* @__PURE__ */ xe({
  __name: "DragNDrop",
  props: {
    loading: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    id: { default: "drag-n-drop" },
    accept: { default: "" },
    maxSize: { default: 10 * 1024 * 1024 },
    maxFiles: { default: 10 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["upload", "submit", "error"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(!1), l = ee([]), r = ee(null), i = M(() => l.value.length > 0), o = M(() => !t.multiple || l.value.length < t.maxFiles), u = (S) => {
      const x = zd(S).toLowerCase();
      return {
        pdf: "mdi:file-pdf-box",
        doc: "mdi:file-word-box",
        docx: "mdi:file-word-box",
        xls: "mdi:file-excel-box",
        xlsx: "mdi:file-excel-box",
        ppt: "mdi:file-powerpoint-box",
        pptx: "mdi:file-powerpoint-box",
        zip: "mdi:folder-zip",
        rar: "mdi:folder-zip",
        jpg: "mdi:file-image",
        jpeg: "mdi:file-image",
        png: "mdi:file-image",
        gif: "mdi:file-image",
        svg: "mdi:file-image",
        txt: "mdi:file-document",
        csv: "mdi:file-delimited"
      }[x] || "mdi:file-document-outline";
    }, c = (S) => t.maxSize && S.size > t.maxSize ? `File "${S.name}" exceeds maximum size of ${Cs(t.maxSize)}` : null, f = () => {
      l.value = [];
    }, p = (S) => {
      l.value.splice(S, 1), a("upload", l.value, () => {
      });
    }, d = (S) => {
      const x = [];
      for (const C of S) {
        const _ = c(C);
        if (_) {
          a("error", _);
          continue;
        }
        x.push(C);
      }
      if (x.length !== 0) {
        if (!t.multiple)
          l.value = [x[0]];
        else {
          const C = t.maxFiles - l.value.length, _ = x.slice(0, C);
          x.length > C && a("error", `Maximum ${t.maxFiles} files allowed`), l.value = [...l.value, ..._];
        }
        console.log("Files added:", l.value), console.log("hasFiles:", i.value), a("upload", l.value, () => {
        });
      }
    }, g = (S) => {
      t.disabled || t.loading || (S.preventDefault(), s.value = !0);
    }, v = (S) => {
      S.preventDefault(), s.value = !1;
    }, k = (S) => {
      var C;
      if (S.preventDefault(), s.value = !1, t.disabled || t.loading || !o.value) return;
      const x = Array.from(((C = S.dataTransfer) == null ? void 0 : C.files) || []);
      d(x);
    }, y = (S) => {
      const x = S.target, C = Array.from(x.files || []);
      d(C), r.value && (r.value.value = "");
    }, h = () => {
      l.value.length !== 0 && a("submit", l.value, f);
    }, w = () => {
      var S;
      t.disabled || t.loading || !o.value || (S = r.value) == null || S.click();
    };
    return (S, x) => (b(), $("div", Ow, [
      E("input", lt({
        id: `fileInput-${t.id}`,
        ref_key: "fileRef",
        ref: r,
        accept: t.accept,
        disabled: t.disabled || t.loading,
        multiple: t.multiple,
        class: "drag-n-drop__input",
        name: "file",
        type: "file"
      }, S.$attrs, { onChange: y }), null, 16, Ew),
      E("div", {
        class: X([{
          "drag-n-drop__dropzone--dragging": s.value,
          "drag-n-drop__dropzone--disabled": t.disabled || t.loading,
          "drag-n-drop__dropzone--has-files": i.value
        }, "drag-n-drop__dropzone"]),
        onClick: w,
        onDragleave: v,
        onDragover: g,
        onDrop: k
      }, [
        t.loading ? (b(), $("div", Iw, [
          le(jl, { class: "w-8 h-8" }),
          x[0] || (x[0] = E("p", { class: "text-secondaryText text-sm mt-2" }, " Processing files... ", -1))
        ])) : i.value ? (b(), $("div", zw, [
          E("div", Ww, [
            le(we, {
              size: 24,
              class: "text-primary",
              icon: "mdi:file-multiple-outline"
            }),
            E("span", Yw, ie(l.value.length) + " file" + ie(l.value.length > 1 ? "s" : "") + " selected ", 1)
          ]),
          E("p", Hw, " Click to add " + ie(t.multiple ? "more" : "another") + " file" + ie(t.multiple ? "s" : ""), 1)
        ])) : (b(), $("div", Aw, [
          E("div", Pw, [
            le(we, {
              icon: s.value ? "mdi:cloud-download" : "mdi:cloud-upload-outline",
              size: 48,
              class: "drag-n-drop__icon"
            }, null, 8, ["icon"])
          ]),
          E("div", Rw, [
            s.value ? (b(), $("p", Fw, " Release to drop files here ")) : (b(), $(Te, { key: 1 }, [
              Y(S.$slots, "title", {}, () => [
                x[1] || (x[1] = E("p", { class: "text-mainText font-medium text-base mb-1" }, " Drop files here or click to browse ", -1))
              ], !0),
              Y(S.$slots, "subtitle", {}, () => [
                E("p", Vw, [
                  t.accept ? (b(), $("span", Lw, "Supported: " + ie(t.accept), 1)) : F("", !0),
                  t.accept && t.maxSize ? (b(), $("span", Nw, " • ")) : F("", !0),
                  t.maxSize ? (b(), $("span", Bw, "Max: " + ie(m(Cs)(t.maxSize)), 1)) : F("", !0)
                ])
              ], !0)
            ], 64))
          ]),
          Y(S.$slots, "action", {}, () => [
            le(Et, {
              class: "mt-2",
              icon: "mdi:folder-open-outline",
              text: "Browse Files",
              variant: "primary",
              onClick: Ve(w, ["stop"])
            })
          ], !0)
        ]))
      ], 34),
      i.value && !t.loading ? (b(), ue(Dr, {
        key: 0,
        class: "drag-n-drop__files",
        name: "file-list",
        tag: "div"
      }, {
        default: ce(() => [
          (b(!0), $(Te, null, Ie(l.value, (C, _) => (b(), $("div", {
            key: `${C.name}-${C.size}-${_}`,
            class: "drag-n-drop__file-item"
          }, [
            E("div", Uw, [
              le(we, {
                icon: u(C.name),
                size: 20,
                class: "text-primary"
              }, null, 8, ["icon"])
            ]),
            E("div", qw, [
              E("p", {
                title: C.name,
                class: "drag-n-drop__file-name"
              }, ie(m(Bd)(C.name, 40)), 9, jw),
              E("p", Gw, ie(m(Cs)(C.size)), 1)
            ]),
            E("button", {
              disabled: t.loading,
              class: "drag-n-drop__file-remove",
              type: "button",
              onClick: Ve((O) => p(_), ["stop"])
            }, [
              le(we, {
                size: 20,
                icon: "mdi:close-circle"
              })
            ], 8, Kw)
          ]))), 128))
        ]),
        _: 1
      })) : F("", !0),
      i.value && t.button && !t.loading ? (b(), $("div", Zw, [
        le(Et, {
          class: "w-full",
          icon: "mdi:check-circle-outline",
          text: "Submit Files",
          variant: "primary",
          onClick: h
        })
      ])) : F("", !0)
    ]));
  }
}), ND = /* @__PURE__ */ Ue(Xw, [["__scopeId", "data-v-3b9bd88e"]]), Jw = { class: "v-file-upload w-full" }, Qw = ["accept", "disabled", "multiple"], e1 = { class: "v-file-upload__icon-wrapper" }, t1 = { class: "v-file-upload__text-container" }, n1 = {
  key: 0,
  class: "v-file-upload__loading"
}, a1 = {
  key: 0,
  class: "v-file-upload__list"
}, s1 = { class: "flex items-center gap-3 overflow-hidden" }, l1 = { class: "v-file-upload__item-icon" }, r1 = { class: "flex flex-col min-w-0" }, i1 = ["title"], o1 = { class: "text-xs text-secondaryText" }, u1 = ["disabled", "onClick"], c1 = /* @__PURE__ */ xe({
  __name: "VFileUpload",
  props: {
    modelValue: { default: () => [] },
    accept: { default: "*" },
    multiple: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    maxSize: { default: void 0 },
    label: { default: "Click to upload or drag and drop" },
    subLabel: { default: "SVG, PNG, JPG" },
    showList: { type: Boolean, default: !0 },
    variant: { default: "default" },
    immediate: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "upload", "error", "file-select"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(!1), l = ee(null), r = ee(t.modelValue), i = M({
      get: () => t.modelValue.length ? t.modelValue : r.value,
      set: (g) => {
        r.value = g, a("update:modelValue", g);
      }
    }), o = () => {
      i.value = [], l.value && (l.value.value = "");
    }, u = (g) => {
      if (!(t.loading || t.disabled)) {
        if (t.maxSize && g.filter((k) => k.size > t.maxSize).length) {
          a("error", `File size exceeds limit of ${Cs(t.maxSize)}`);
          return;
        }
        if (t.immediate) {
          const v = g[0] || null;
          a("file-select", v), a("upload", g, o);
          return;
        }
        t.multiple ? i.value = [...i.value, ...g] : i.value = g.slice(0, 1), a("change", i.value), a("upload", i.value, o);
      }
    }, c = (g) => {
      var k;
      s.value = !1;
      const v = Array.from(((k = g.dataTransfer) == null ? void 0 : k.files) || []);
      v.length && u(v);
    }, f = (g) => {
      const v = g.target, k = Array.from(v.files || []);
      k.length && u(k);
    }, p = (g) => {
      if (t.loading || t.disabled) return;
      const v = [...i.value];
      v.splice(g, 1), i.value = v, a("change", v);
    }, d = () => {
      var g;
      !t.loading && !t.disabled && ((g = l.value) == null || g.click());
    };
    return (g, v) => (b(), $("div", Jw, [
      E("div", {
        class: X([{
          "v-file-upload__dropzone--dragging": s.value,
          "v-file-upload__dropzone--loading": e.loading,
          "v-file-upload__dropzone--disabled": e.disabled,
          "v-file-upload__dropzone--compact": e.variant === "compact"
        }, "v-file-upload__dropzone"]),
        onClick: d,
        onDragenter: v[0] || (v[0] = Ve((k) => s.value = !0, ["prevent"])),
        onDragleave: v[1] || (v[1] = Ve((k) => s.value = !1, ["prevent"])),
        onDragover: v[2] || (v[2] = Ve((k) => s.value = !0, ["prevent"])),
        onDrop: Ve(c, ["prevent"])
      }, [
        E("input", {
          ref_key: "inputRef",
          ref: l,
          accept: e.accept,
          disabled: e.disabled || e.loading,
          multiple: e.multiple,
          class: "hidden",
          type: "file",
          onChange: f
        }, null, 40, Qw),
        E("div", {
          class: X([{ "v-file-upload__content--loading": e.loading }, "v-file-upload__content"])
        }, [
          E("div", e1, [
            Y(g.$slots, "icon", {}, () => [
              le(we, {
                size: e.variant === "compact" ? 20 : 28,
                class: "text-secondaryText",
                icon: "lucide:cloud-upload"
              }, null, 8, ["size"])
            ], !0)
          ]),
          E("div", t1, [
            v[3] || (v[3] = E("div", { class: "v-file-upload__text" }, [
              E("span", { class: "font-medium text-primary hover:text-primary-dark transition-colors" }, " Click to upload "),
              E("span", { class: "text-secondaryText" }, " or drag and drop ")
            ], -1)),
            e.subLabel ? (b(), $("p", {
              key: 0,
              class: X([{ "mt-1": e.variant !== "compact" }, "text-xs text-secondaryText"])
            }, ie(e.subLabel), 3)) : F("", !0)
          ])
        ], 2),
        e.loading ? (b(), $("div", n1, [
          le(jl, {
            size: e.variant === "compact" ? "small" : "medium",
            variant: "primary"
          }, null, 8, ["size"]),
          v[4] || (v[4] = E("p", { class: "text-secondaryText text-sm" }, " Uploading... ", -1))
        ])) : F("", !0)
      ], 34),
      e.showList && i.value.length > 0 && !e.immediate ? (b(), $("div", a1, [
        (b(!0), $(Te, null, Ie(i.value, (k, y) => (b(), $("div", {
          key: y,
          class: "v-file-upload__item"
        }, [
          E("div", s1, [
            E("div", l1, [
              le(we, {
                class: "text-primary",
                icon: "lucide:file"
              })
            ]),
            E("div", r1, [
              E("span", {
                title: k.name,
                class: "text-sm font-medium text-mainText truncate"
              }, ie(m(Bd)(k.name, 30)), 9, i1),
              E("span", o1, ie(m(Cs)(k.size)), 1)
            ])
          ]),
          E("button", {
            disabled: e.loading || e.disabled,
            class: "v-file-upload__remove",
            onClick: Ve((h) => p(y), ["stop"])
          }, [
            le(we, {
              size: 20,
              icon: "lucide:trash-2"
            })
          ], 8, u1)
        ]))), 128))
      ])) : F("", !0)
    ]));
  }
}), BD = /* @__PURE__ */ Ue(c1, [["__scopeId", "data-v-45cd08de"]]);
function Ud(e) {
  return $u() ? (Ol(e), !0) : !1;
}
const yr = /* @__PURE__ */ new WeakMap(), d1 = (...e) => {
  var n;
  const t = e[0], a = (n = si()) == null ? void 0 : n.proxy;
  if (a == null && !Cu())
    throw new Error("injectLocal must be called in setup");
  return a && yr.has(a) && t in yr.get(a) ? yr.get(a)[t] : On(...e);
}, Ai = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const f1 = Object.prototype.toString, h1 = (e) => f1.call(e) === "[object Object]", nu = () => {
};
function m1(e, n) {
  function t(...a) {
    return new Promise((s, l) => {
      Promise.resolve(e(() => n.apply(this, a), { fn: n, thisArg: this, args: a })).then(s).catch(l);
    });
  }
  return t;
}
function v1(e, n = {}) {
  let t, a, s = nu;
  const l = (o) => {
    clearTimeout(o), s(), s = nu;
  };
  let r;
  return (o) => {
    const u = Qe(e), c = Qe(n.maxWait);
    return t && l(t), u <= 0 || c !== void 0 && c <= 0 ? (a && (l(a), a = null), Promise.resolve(o())) : new Promise((f, p) => {
      s = n.rejectOnCancel ? p : f, r = o, c && !a && (a = setTimeout(() => {
        t && l(t), a = null, f(r());
      }, c)), t = setTimeout(() => {
        a && l(a), a = null, f(o());
      }, u);
    });
  };
}
function p1(e) {
  let n;
  function t() {
    return n || (n = e()), n;
  }
  return t.reset = async () => {
    const a = n;
    n = void 0, a && await a;
  }, t;
}
function au(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function g1(e) {
  return si();
}
function br(e) {
  return Array.isArray(e) ? e : [e];
}
function y1(e, n = 200, t = {}) {
  return m1(
    v1(n, t),
    e
  );
}
function b1(e, n = !0, t) {
  g1() ? et(e, t) : n ? e() : Ge(e);
}
function Qr(e, n, t = {}) {
  const {
    immediate: a = !0,
    immediateCallback: s = !1
  } = t, l = It(!1);
  let r = null;
  function i() {
    r && (clearTimeout(r), r = null);
  }
  function o() {
    l.value = !1, i();
  }
  function u(...c) {
    s && e(), i(), l.value = !0, r = setTimeout(() => {
      l.value = !1, r = null, e(...c);
    }, Qe(n));
  }
  return a && (l.value = !0, Ai && u()), Ud(o), {
    isPending: ai(l),
    start: u,
    stop: o
  };
}
function w1(e, n, t) {
  return Be(
    e,
    n,
    {
      ...t,
      immediate: !0
    }
  );
}
const Pi = Ai ? window : void 0, qd = Ai ? window.navigator : void 0;
function k1(e) {
  var n;
  const t = Qe(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
function Is(...e) {
  const n = [], t = () => {
    n.forEach((i) => i()), n.length = 0;
  }, a = (i, o, u, c) => (i.addEventListener(o, u, c), () => i.removeEventListener(o, u, c)), s = M(() => {
    const i = br(Qe(e[0])).filter((o) => o != null);
    return i.every((o) => typeof o != "string") ? i : void 0;
  }), l = w1(
    () => {
      var i, o;
      return [
        (o = (i = s.value) == null ? void 0 : i.map((u) => k1(u))) != null ? o : [Pi].filter((u) => u != null),
        br(Qe(s.value ? e[1] : e[0])),
        br(m(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Qe(s.value ? e[3] : e[2])
      ];
    },
    ([i, o, u, c]) => {
      if (t(), !(i != null && i.length) || !(o != null && o.length) || !(u != null && u.length))
        return;
      const f = h1(c) ? { ...c } : c;
      n.push(
        ...i.flatMap(
          (p) => o.flatMap(
            (d) => u.map((g) => a(p, d, g, f))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    l(), t();
  };
  return Ud(t), r;
}
function x1() {
  const e = It(!1), n = si();
  return n && et(() => {
    e.value = !0;
  }, n), e;
}
function Ri(e) {
  const n = x1();
  return M(() => (n.value, !!e()));
}
const S1 = Symbol("vueuse-ssr-width");
function T1() {
  const e = Cu() ? d1(S1, null) : null;
  return typeof e == "number" ? e : void 0;
}
function $1(e, n = {}) {
  const { window: t = Pi, ssrWidth: a = T1() } = n, s = Ri(() => t && "matchMedia" in t && typeof t.matchMedia == "function"), l = It(typeof a == "number"), r = It(), i = It(!1), o = (u) => {
    i.value = u.matches;
  };
  return Gt(() => {
    if (l.value) {
      l.value = !s.value;
      const u = Qe(e).split(",");
      i.value = u.some((c) => {
        const f = c.includes("not all"), p = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), d = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let g = !!(p || d);
        return p && g && (g = a >= au(p[1])), d && g && (g = a <= au(d[1])), f ? !g : g;
      });
      return;
    }
    s.value && (r.value = t.matchMedia(Qe(e)), i.value = r.value.matches);
  }), Is(r, "change", o, { passive: !0 }), M(() => i.value);
}
function su(e, n = {}) {
  const {
    controls: t = !1,
    navigator: a = qd
  } = n, s = Ri(() => a && "permissions" in a), l = It(), r = typeof e == "string" ? { name: e } : e, i = It(), o = () => {
    var c, f;
    i.value = (f = (c = l.value) == null ? void 0 : c.state) != null ? f : "prompt";
  };
  Is(l, "change", o, { passive: !0 });
  const u = p1(async () => {
    if (s.value) {
      if (!l.value)
        try {
          l.value = await a.permissions.query(r);
        } catch {
          l.value = void 0;
        } finally {
          o();
        }
      if (t)
        return Du(l.value);
    }
  });
  return u(), t ? {
    state: i,
    isSupported: s,
    query: u
  } : i;
}
function jd(e = {}) {
  const {
    navigator: n = qd,
    read: t = !1,
    source: a,
    copiedDuring: s = 1500,
    legacy: l = !1
  } = e, r = Ri(() => n && "clipboard" in n), i = su("clipboard-read"), o = su("clipboard-write"), u = M(() => r.value || l), c = It(""), f = It(!1), p = Qr(() => f.value = !1, s, { immediate: !1 });
  async function d() {
    let h = !(r.value && y(i.value));
    if (!h)
      try {
        c.value = await n.clipboard.readText();
      } catch {
        h = !0;
      }
    h && (c.value = k());
  }
  u.value && t && Is(["copy", "cut"], d, { passive: !0 });
  async function g(h = Qe(a)) {
    if (u.value && h != null) {
      let w = !(r.value && y(o.value));
      if (!w)
        try {
          await n.clipboard.writeText(h);
        } catch {
          w = !0;
        }
      w && v(h), c.value = h, f.value = !0, p.start();
    }
  }
  function v(h) {
    const w = document.createElement("textarea");
    w.value = h ?? "", w.style.position = "absolute", w.style.opacity = "0", document.body.appendChild(w), w.select(), document.execCommand("copy"), w.remove();
  }
  function k() {
    var h, w, S;
    return (S = (w = (h = document == null ? void 0 : document.getSelection) == null ? void 0 : h.call(document)) == null ? void 0 : w.toString()) != null ? S : "";
  }
  function y(h) {
    return h === "granted" || h === "prompt";
  }
  return {
    isSupported: u,
    text: c,
    copied: f,
    copy: g
  };
}
function M1(e = {}) {
  const {
    window: n = Pi,
    initialWidth: t = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: l = !0,
    type: r = "inner"
  } = e, i = It(t), o = It(a), u = () => {
    if (n)
      if (r === "outer")
        i.value = n.outerWidth, o.value = n.outerHeight;
      else if (r === "visual" && n.visualViewport) {
        const { width: f, height: p, scale: d } = n.visualViewport;
        i.value = Math.round(f * d), o.value = Math.round(p * d);
      } else l ? (i.value = n.innerWidth, o.value = n.innerHeight) : (i.value = n.document.documentElement.clientWidth, o.value = n.document.documentElement.clientHeight);
  };
  u(), b1(u);
  const c = { passive: !0 };
  if (Is("resize", u, c), n && r === "visual" && n.visualViewport && Is(n.visualViewport, "resize", u, c), s) {
    const f = $1("(orientation: portrait)");
    Be(f, () => u());
  }
  return { width: i, height: o };
}
const C1 = { class: "v-input-container" }, D1 = ["for"], _1 = {
  key: 0,
  class: "v-input-helper-text"
}, O1 = {
  key: 0,
  class: "v-input-error-message"
}, E1 = /* @__PURE__ */ xe({
  __name: "VInput",
  props: /* @__PURE__ */ Ht({
    name: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    helperText: { default: "" },
    validation: {},
    error: { default: void 0 },
    icon: { default: "" },
    size: { default: "md" },
    id: {},
    debounce: { type: [Boolean, Number], default: !1 },
    loading: { type: Boolean, default: !1 },
    textarea: { type: Boolean, default: !1 },
    rows: { default: 4 },
    showClearButton: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    modern: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ht(["clear"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = M(() => !!t.name), s = M(() => {
      var H;
      return !!((H = t.validation) != null && H.$error || t.error);
    }), l = M(() => {
      var H, te;
      return ((te = (H = t.validation) == null ? void 0 : H.$errors[0]) == null ? void 0 : te.$message) ?? t.error ?? "";
    }), r = En(e, "modelValue"), i = n, o = Ut(), u = As(), c = ee(!1), f = ee(!1), p = ee(null), d = M(() => t.id || `v-input-${u}`), g = typeof t.debounce == "number" ? t.debounce : t.debounce ? 800 : 0, v = ee(r.value ?? "");
    Be(r, (H) => {
      H !== v.value && (v.value = H ?? "");
    });
    const k = y1((H) => {
      r.value = H;
    }, g), y = (H) => {
      const te = H.target.value;
      v.value = te;
      let re = te;
      if (t.type === "number" && te !== "") {
        const oe = Number(te);
        isNaN(oe) || (re = oe);
      }
      k(re);
    }, h = () => {
      var H;
      v.value = "", r.value = t.type === "number" ? void 0 : "", i("clear"), (H = p.value) == null || H.focus();
    }, w = M(() => t.type === "password" ? c.value ? "text" : "password" : t.type), S = () => {
      c.value = !c.value;
    }, x = M(() => ({
      sm: "v-input-field--sm",
      md: "v-input-field--md",
      lg: "v-input-field--lg"
    })[t.size]), C = M(() => t.type === "search"), _ = M(() => t.icon || C.value || !!o["icon-left"] || t.loading), O = M(() => t.type === "password" || P.value || !!o["icon-right"]), P = M(
      () => t.type !== "password" && v.value !== "" && t.showClearButton
    ), D = M(() => t.icon ? t.icon : C.value ? "mdi:search" : ""), B = M(
      () => v.value !== "" && v.value !== null && v.value !== void 0
    ), W = M(() => t.name ? f.value ? t.placeholder : "" : t.placeholder);
    return (H, te) => (b(), $("div", {
      class: X(["v-input-wrapper", { "v-input--modern": t.modern }])
    }, [
      E("div", C1, [
        a.value ? (b(), $("label", {
          key: 0,
          class: X([
            "v-label",
            {
              "v-label--active": f.value || B.value,
              "v-label--error": s.value,
              "v-label--with-icon": _.value && !(f.value || B.value),
              "v-label--textarea": e.textarea
            }
          ]),
          for: d.value
        }, ie(t.name), 11, D1)) : F("", !0),
        _.value ? (b(), $("div", {
          key: 1,
          class: X([
            "v-input-icon v-input-icon-left",
            {
              "v-input-icon-textarea": e.textarea,
              "v-input-icon--active": f.value && C.value || e.loading
            }
          ])
        }, [
          Y(H.$slots, "icon-left", {}, () => [
            D.value || e.loading ? (b(), ue(we, {
              key: 0,
              icon: D.value,
              loading: e.loading,
              class: "v-input-icon-svg"
            }, null, 8, ["icon", "loading"])) : F("", !0)
          ], !0)
        ], 2)) : F("", !0),
        (b(), ue(ht(e.textarea ? "textarea" : "input"), lt({
          id: d.value,
          key: `${e.textarea ? "textarea" : "input"}-${d.value}`,
          ref_key: "inputRef",
          ref: p,
          class: [
            "v-input-field",
            x.value,
            {
              "v-input-field--textarea": e.textarea,
              "v-input-field--with-left-icon": _.value,
              "v-input-field--with-right-icon": O.value,
              "v-input-field--date": e.type === "date" && !e.textarea,
              "v-input-field--disabled": e.disabled
            }
          ],
          disabled: e.disabled,
          placeholder: W.value,
          value: v.value
        }, {
          ...H.$attrs,
          type: e.textarea ? void 0 : w.value,
          rows: e.textarea ? e.rows : void 0
        }, {
          onBlur: te[0] || (te[0] = (re) => f.value = !1),
          onFocus: te[1] || (te[1] = (re) => f.value = !0),
          onInput: y
        }), null, 16, ["id", "class", "disabled", "placeholder", "value"])),
        O.value ? (b(), $("div", {
          key: 2,
          class: X([
            "v-input-icon v-input-icon-right",
            { "v-input-icon-textarea": e.textarea }
          ])
        }, [
          Y(H.$slots, "icon-right", {}, () => [
            P.value ? (b(), $("button", {
              key: 0,
              class: "v-input-clear-btn",
              title: "Clear",
              type: "button",
              onClick: h
            }, [
              le(we, {
                class: "v-input-icon-svg v-input-icon-svg--sm",
                icon: "lucide:x"
              })
            ])) : t.type === "password" ? (b(), $("div", {
              key: 1,
              class: "v-input-password-toggle",
              role: "button",
              tabindex: "0",
              onClick: S,
              onKeydown: Pt(S, ["enter", "space"])
            }, [
              le(we, {
                icon: w.value === "text" ? "lucide:eye-off" : "lucide:eye",
                class: "v-input-icon-svg"
              }, null, 8, ["icon"])
            ], 32)) : F("", !0)
          ], !0)
        ], 2)) : F("", !0),
        E("fieldset", {
          class: X([
            "v-fieldset",
            {
              "v-fieldset--active": f.value,
              "v-fieldset--error": s.value,
              "v-fieldset--disabled": e.disabled,
              "v-fieldset--flat": !e.shadow
            }
          ]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: X(["v-legend", { "v-legend--visible": a.value && (B.value || f.value) }])
          }, [
            E("span", null, ie(t.name), 1)
          ], 2)
        ], 2)
      ]),
      Y(H.$slots, "helper-text", {}, () => [
        e.helperText && !s.value ? (b(), $("p", _1, ie(e.helperText), 1)) : F("", !0)
      ], !0),
      le(St, {
        mode: "out-in",
        name: "error-slide"
      }, {
        default: ce(() => [
          Y(H.$slots, "error-message", {}, () => [
            s.value ? (b(), $("p", O1, ie(l.value), 1)) : F("", !0)
          ], !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Cl = /* @__PURE__ */ Ue(E1, [["__scopeId", "data-v-0f5804ce"]]), I1 = { class: "v-collapse__wrap" }, A1 = ["aria-hidden"], P1 = /* @__PURE__ */ xe({
  __name: "VCollapse",
  props: /* @__PURE__ */ Ht({
    duration: { default: 200 },
    unmount: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = En(e, "modelValue");
    return (t, a) => (b(), $("div", {
      class: X([{ "v-collapse--expanded": n.value }, "v-collapse"]),
      style: Fe({ "--v-collapse-duration": `${e.duration}ms` })
    }, [
      E("div", I1, [
        !e.unmount || n.value ? (b(), $("div", {
          key: 0,
          "aria-hidden": !n.value,
          class: "v-collapse__content"
        }, [
          Y(t.$slots, "default", {}, void 0, !0)
        ], 8, A1)) : F("", !0)
      ])
    ], 6));
  }
}), R1 = /* @__PURE__ */ Ue(P1, [["__scopeId", "data-v-d2e88ce5"]]), F1 = { class: "v-composer__preview" }, V1 = {
  key: 1,
  class: "v-composer__meta"
}, L1 = {
  key: 0,
  class: "v-composer__edited"
}, N1 = { class: "v-composer__meta-actions" }, B1 = ["inert"], z1 = ["id", "aria-invalid", "aria-label", "placeholder", "rows"], W1 = {
  key: 0,
  class: "v-composer__message v-composer__message--error"
}, Y1 = {
  key: 1,
  class: "v-composer__message"
}, H1 = { class: "v-composer__footer" }, U1 = {
  key: 0,
  class: "v-composer__failed"
}, q1 = {
  key: 1,
  class: "v-composer__hint"
}, j1 = { class: "v-composer__footer-actions" }, G1 = /* @__PURE__ */ xe({
  __name: "VComposer",
  props: /* @__PURE__ */ Ht({
    initialValue: { default: "" },
    preview: { default: "" },
    placeholder: { default: "" },
    openLabel: { default: "Write" },
    submitLabel: { default: "Send" },
    status: { default: "idle" },
    validation: {},
    error: {},
    helperText: { default: "" },
    copyable: { type: Boolean, default: !1 },
    rows: { default: 5 }
  }, {
    modelValue: { default: "" },
    modelModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ht(["submit", "expand"], ["update:modelValue", "update:open"]),
  setup(e, { emit: n }) {
    const t = n, { copy: a, copied: s, isSupported: l } = jd({ copiedDuring: 2e3 }), r = As(), i = Xe("field"), o = Xe("root"), u = En(e, "modelValue"), c = En(e, "open");
    let f = !1;
    const p = M(() => {
      var O;
      return !!((O = e.validation) != null && O.$error || e.error);
    }), d = M(() => {
      var O, P;
      return ((P = (O = e.validation) == null ? void 0 : O.$errors[0]) == null ? void 0 : P.$message) ?? e.error ?? "";
    }), g = M(() => e.initialValue !== "" && u.value !== e.initialValue), v = M(() => e.status === "sending"), k = M(() => e.status === "sent"), y = M(() => e.status === "error" ? "Retry" : k.value ? "Send again" : e.submitLabel), h = () => {
      c.value || (c.value = !0, t("expand"));
    }, w = () => {
      var O;
      return ((O = o.value) == null ? void 0 : O.contains(document.activeElement)) ?? !1;
    }, S = ({ restoreFocus: O } = {}) => {
      const P = O ?? w();
      c.value = !1, P && Ge(() => {
        var D, B;
        (B = (D = o.value) == null ? void 0 : D.querySelector(".v-composer__row button")) == null || B.focus();
      });
    }, x = () => {
      var O;
      u.value = e.initialValue, (O = i.value) == null || O.focus();
    }, C = (O) => {
      if (!v.value) {
        if (f = !0, O) {
          O();
          return;
        }
        t("submit", u.value);
      }
    }, _ = (O) => {
      if (O.key === "Enter" && (O.metaKey || O.ctrlKey)) {
        O.preventDefault(), C();
        return;
      }
      O.key === "Escape" && (O.preventDefault(), O.stopPropagation(), S());
    };
    return Be(c, async (O) => {
      if (!O) return;
      await Ge();
      const P = i.value;
      P && (P.focus(), P.setSelectionRange(P.value.length, P.value.length));
    }), Be(() => e.status, (O, P) => {
      if (O !== "sent" || P !== "sending") return;
      const D = f || w();
      f = !1, S({ restoreFocus: D });
    }), (O, P) => (b(), $("div", {
      ref_key: "root",
      ref: o,
      class: X([{
        "v-composer--open": c.value,
        "v-composer--sent": k.value && !c.value,
        "v-composer--error": p.value,
        "v-composer--failed": e.status === "error" && !c.value
      }, "v-composer"])
    }, [
      c.value ? (b(), $("div", V1, [
        Y(O.$slots, "meta", {}, void 0, !0),
        g.value ? (b(), $("span", L1, "edited")) : F("", !0),
        E("span", N1, [
          e.copyable && m(l) ? (b(), ue(Et, {
            key: 0,
            "aria-label": m(s) ? "Copied" : "Copy to clipboard",
            icon: m(s) ? "lucide:check" : "lucide:copy",
            modern: "",
            variant: "neutral",
            onClick: P[0] || (P[0] = (D) => m(a)(u.value))
          }, null, 8, ["aria-label", "icon"])) : F("", !0),
          le(Et, {
            "aria-label": "Collapse",
            icon: "lucide:x",
            modern: "",
            variant: "neutral",
            onClick: P[1] || (P[1] = (D) => S())
          })
        ])
      ])) : (b(), $("div", {
        key: 0,
        class: "v-composer__row",
        onClick: h
      }, [
        le(we, {
          icon: k.value ? "lucide:check" : "lucide:pen-line",
          size: 15,
          class: "v-composer__icon"
        }, null, 8, ["icon"]),
        E("span", F1, [
          Y(O.$slots, "preview", {}, () => [
            Ye(ie(e.preview || e.placeholder), 1)
          ], !0)
        ]),
        le(Et, {
          "aria-controls": m(r),
          icon: k.value ? void 0 : "lucide:send",
          text: k.value ? "View" : e.openLabel,
          variant: k.value ? "neutral" : "primary",
          "aria-expanded": "false",
          modern: "",
          onClick: Ve(h, ["stop"])
        }, null, 8, ["aria-controls", "icon", "text", "variant"])
      ])),
      le(R1, { "model-value": c.value }, {
        default: ce(() => [
          E("div", {
            inert: !c.value,
            class: "v-composer__body"
          }, [
            an(E("textarea", {
              id: m(r),
              ref_key: "field",
              ref: i,
              "onUpdate:modelValue": P[2] || (P[2] = (D) => u.value = D),
              "aria-invalid": p.value,
              "aria-label": e.placeholder || e.submitLabel,
              placeholder: e.placeholder,
              rows: e.rows,
              class: "v-composer__field",
              onKeydown: _
            }, null, 40, z1), [
              [_u, u.value]
            ]),
            p.value ? (b(), $("p", W1, ie(d.value), 1)) : e.helperText ? (b(), $("p", Y1, ie(e.helperText), 1)) : F("", !0),
            E("div", H1, [
              e.status === "error" ? (b(), $("span", U1, "Couldn't send — your text is kept")) : (b(), $("span", q1, [
                Y(O.$slots, "hint", {}, () => [
                  P[4] || (P[4] = E("kbd", null, "⌘/Ctrl", -1)),
                  P[5] || (P[5] = Ye()),
                  P[6] || (P[6] = E("kbd", null, "↵", -1)),
                  P[7] || (P[7] = Ye(" to send · ", -1)),
                  P[8] || (P[8] = E("kbd", null, "Esc", -1)),
                  P[9] || (P[9] = Ye(" to collapse ", -1))
                ], !0)
              ])),
              E("span", j1, [
                e.initialValue ? (b(), ue(Et, {
                  key: 0,
                  disabled: !g.value,
                  class: "v-composer__reset",
                  modern: "",
                  text: "Reset",
                  variant: "neutral",
                  onClick: x
                }, null, 8, ["disabled"])) : F("", !0),
                Y(O.$slots, "actions", { submit: C }, () => [
                  le(Et, {
                    loading: v.value,
                    text: y.value,
                    class: "v-composer__submit",
                    icon: "lucide:send",
                    modern: "",
                    variant: "primary",
                    onClick: P[3] || (P[3] = (D) => C())
                  }, null, 8, ["loading", "text"])
                ], !0)
              ])
            ])
          ], 8, B1)
        ]),
        _: 3
      }, 8, ["model-value"])
    ], 2));
  }
}), zD = /* @__PURE__ */ Ue(G1, [["__scopeId", "data-v-670d3534"]]), K1 = ["innerHTML"], Z1 = { key: 1 }, zn = 12, Zn = 8, X1 = 200, Qa = /* @__PURE__ */ xe({
  __name: "VTooltip",
  props: {
    text: {},
    allowHtml: { type: Boolean, default: !1 },
    placement: { default: "right" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    tooltipClass: { default: "" },
    wrapperClass: { default: "" },
    maxWidth: { default: "800px" }
  },
  setup(e) {
    const n = e, t = ee(!1), a = ee(null), s = ee(null), l = ee(null), r = ee({ top: 0, left: 0 }), i = ee(n.placement), o = ee(null), u = (g, v, k, y, h, w) => {
      const S = g.top, x = h - g.bottom, C = g.left, _ = y - g.right, O = S >= k + Zn + zn, P = x >= k + Zn + zn, D = C >= v + Zn + zn, B = _ >= v + Zn + zn;
      if (w === "top" && O) return "top";
      if (w === "bottom" && P) return "bottom";
      if (w === "left" && D) return "left";
      if (w === "right" && B) return "right";
      const W = [
        { placement: "right", fits: B, space: _ },
        { placement: "left", fits: D, space: C },
        { placement: "bottom", fits: P, space: x },
        { placement: "top", fits: O, space: S }
      ], H = W.find((te) => te.fits);
      return H ? H.placement : (W.sort((te, re) => re.space - te.space), W[0].placement);
    }, c = async () => {
      if (!s.value) return;
      const g = s.value.getBoundingClientRect(), v = window.innerWidth, k = window.innerHeight;
      if (o.value = null, r.value = { top: -9999, left: -9999 }, i.value = n.placement, await Ge(), !l.value) return;
      const y = l.value.getBoundingClientRect(), h = Math.max(y.width, X1), w = y.height, S = u(
        g,
        h,
        w,
        v,
        k,
        n.placement
      );
      let x, C;
      switch (S) {
        case "top":
          x = g.top - Zn - w, C = g.left + g.width / 2 - h / 2;
          break;
        case "bottom":
          x = g.bottom + Zn, C = g.left + g.width / 2 - h / 2;
          break;
        case "left":
          x = g.top + g.height / 2 - w / 2, C = g.left - Zn - h;
          break;
        case "right":
        default:
          x = g.top + g.height / 2 - w / 2, C = g.right + Zn;
          break;
      }
      const _ = v - h - zn;
      C = Math.max(zn, Math.min(C, _));
      const O = k - w - zn;
      x = Math.max(zn, Math.min(x, O));
      const P = v - zn * 2;
      h > P && (o.value = `${P}px`), r.value = { top: x, left: C }, S && (i.value = S);
    }, f = () => {
      n.disabled || !n.text || (a.value = setTimeout(async () => {
        t.value = !0, await Ge(), c();
      }, n.delay));
    }, p = () => {
      a.value && (clearTimeout(a.value), a.value = null), t.value = !1, i.value = n.placement;
    }, d = M(() => ({
      top: `${r.value.top}px`,
      left: `${r.value.left}px`,
      maxWidth: o.value ?? n.maxWidth
    }));
    return (g, v) => (b(), $("div", {
      ref_key: "triggerRef",
      ref: s,
      class: X(["relative inline-block cursor-pointer", e.wrapperClass]),
      onBlur: p,
      onFocus: f,
      onMouseenter: f,
      onMouseleave: p
    }, [
      Y(g.$slots, "default"),
      (b(), ue(Pn, { to: "body" }, [
        le(St, {
          "enter-active-class": "transition-opacity duration-200 ease-out",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "transition-opacity duration-150 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: ce(() => [
            t.value && e.text ? (b(), $("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: l,
              style: Fe(d.value),
              class: "fixed z-[10001] pointer-events-none"
            }, [
              E("div", {
                class: X([
                  "bg-base-100/100 text-mainText text-sm font-medium px-3 py-1.5 rounded-lg shadow-lg break-words w-fit min-w-[200px] card",
                  e.tooltipClass
                ])
              }, [
                n.allowHtml ? (b(), $("span", {
                  key: 0,
                  innerHTML: e.text
                }, null, 8, K1)) : (b(), $("span", Z1, ie(e.text), 1))
              ], 2)
            ], 4)) : F("", !0)
          ]),
          _: 1
        })
      ]))
    ], 34));
  }
}), J1 = (e) => e.map((n) => n.text.trim()).filter((n) => n.length > 0), WD = (e) => e.map((n) => ({ text: n })), Q1 = { class: "inline-flex items-center gap-1 bg-base-200 rounded-lg p-1 shadow-md border border-base-400" }, ek = ["disabled", "onClick"], tk = /* @__PURE__ */ xe({
  __name: "VToggleGroup",
  props: {
    modelValue: {},
    options: {},
    size: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = {
      sm: "px-2 py-1 text-xs gap-1",
      md: "px-3 py-1.5 text-sm gap-1.5",
      lg: "px-4 py-2 text-base gap-2"
    }, s = {
      sm: "w-3 h-3",
      md: "w-4 h-4",
      lg: "w-5 h-5"
    }, l = (r) => {
      r.disabled || t("update:modelValue", r.value);
    };
    return (r, i) => (b(), $("div", Q1, [
      (b(!0), $(Te, null, Ie(e.options, (o) => (b(), ue(Qa, {
        key: String(o.value),
        "allow-html": !0,
        text: o.tooltip || "",
        class: "flex items-center"
      }, {
        default: ce(() => [
          E("button", {
            class: X([[
              a[e.size],
              e.modelValue === o.value ? "bg-primary text-white shadow-sm" : "text-secondaryText hover:text-mainText hover:bg-base-300",
              o.disabled && "opacity-50 cursor-not-allowed"
            ], "flex items-center rounded-md font-medium transition-all whitespace-nowrap"]),
            disabled: o.disabled,
            type: "button",
            onClick: (u) => l(o)
          }, [
            o.icon ? (b(), ue(we, {
              key: 0,
              class: X(s[e.size]),
              icon: o.icon
            }, null, 8, ["class", "icon"])) : F("", !0),
            E("span", null, ie(o.label), 1)
          ], 10, ek)
        ]),
        _: 2
      }, 1032, ["text"]))), 128))
    ]));
  }
}), nk = { class: "v-list-editor" }, ak = { class: "v-list-editor__header" }, sk = {
  key: 0,
  class: "v-list-editor__label"
}, lk = { class: "v-list-editor__tools" }, rk = ["disabled"], ik = {
  key: 0,
  class: "v-list-editor__manual"
}, ok = ["onClick"], uk = {
  key: 0,
  class: "v-list-editor__error"
}, ck = {
  key: 1,
  class: "v-list-editor__bulk"
}, dk = { class: "v-list-editor__hint" }, fk = { class: "v-list-editor__hint-detected" }, hk = { class: "v-list-editor__summary" }, mk = { class: "v-list-editor__count" }, vk = ["onClick"], pk = /* @__PURE__ */ xe({
  __name: "VListEditor",
  props: /* @__PURE__ */ Ht({
    label: { default: () => {
    } },
    itemLabel: { default: "Item" },
    itemLabelPlural: { default: () => {
    } },
    placeholder: { default: () => {
    } },
    markerClass: { default: () => {
    } },
    maxItems: { default: () => {
    } },
    maxLength: { default: () => {
    } },
    modes: { default: "both" },
    validation: { default: () => {
    } },
    itemError: { type: Function, default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: n }) {
    const t = En(e, "modelValue"), a = Xe("inputs"), s = e.modes === "both", l = ee(e.modes === "bulk" ? "bulk" : "manual"), r = ee(""), i = [
      { value: "manual", label: "Manual", icon: "lucide:plus" },
      { value: "bulk", label: "Bulk", icon: "lucide:list" }
    ], o = /* @__PURE__ */ new WeakMap();
    let u = 0;
    const c = (U) => {
      const z = Du(U);
      let J = o.get(z);
      return J || (J = `item-${++u}`, o.set(z, J)), J;
    }, f = M(() => e.maxItems === void 0 || t.value.length < e.maxItems), p = M(() => `Add ${e.itemLabel.toLowerCase()}`), d = M(() => e.itemLabelPlural ?? `${e.itemLabel}s`), g = (U) => U === 0 ? e.placeholder ?? `${e.itemLabel} 1` : `${e.itemLabel} ${U + 1}`, v = M(() => {
      var U;
      return !!((U = e.validation) != null && U.$error);
    }), k = M(() => {
      var U, z, J;
      return ((J = (z = (U = e.validation) == null ? void 0 : U.$errors) == null ? void 0 : z[0]) == null ? void 0 : J.$message) ?? "";
    }), y = () => {
      var U, z;
      (z = (U = e.validation) == null ? void 0 : U.$touch) == null || z.call(U);
    }, h = (U, z) => {
      var J;
      return ((J = e.itemError) == null ? void 0 : J.call(e, U, z)) ?? void 0;
    }, w = async (U) => {
      var J, de, pe;
      await Ge();
      const z = (J = a.value) == null ? void 0 : J[U];
      (pe = (de = z == null ? void 0 : z.$el) == null ? void 0 : de.querySelector("textarea, input")) == null || pe.focus();
    }, S = (U) => {
      if (!f.value) return;
      const z = U === void 0 ? t.value.length : U + 1;
      t.value.splice(z, 0, { text: "" }), w(z);
    }, x = (U) => {
      t.value.length <= 1 || (t.value.splice(U, 1), y(), w(Math.max(0, U - 1)));
    }, C = (U) => {
      S(U);
    }, _ = (U, z) => {
      z.length > 0 || x(U);
    }, O = () => {
      S();
    }, P = [
      { char: `
`, label: "newline", regex: /\n/ },
      { char: ",", label: "comma", regex: /,/ },
      { char: ";", label: "semicolon", regex: /;/ },
      { char: "|", label: "pipe", regex: /\|/ },
      { char: "/", label: "slash", regex: /\// },
      { char: "	", label: "tab", regex: /\t/ }
    ], D = M(() => P.filter((U) => U.regex.test(r.value))), B = M(() => {
      const U = r.value.trim();
      if (!U) return [];
      const z = D.value.length ? new RegExp(D.value.map((de) => de.regex.source).join("|")) : /\s+/, J = [...new Set(U.split(z).map((de) => de.trim()).filter(Boolean))].map((de) => e.maxLength ? de.slice(0, e.maxLength) : de);
      return e.maxItems ? J.slice(0, e.maxItems) : J;
    }), W = (U) => {
      const z = [...t.value];
      return U.map((J) => {
        const de = z.findIndex((pe) => pe.text === J);
        if (de !== -1) {
          const [pe] = z.splice(de, 1);
          return pe;
        }
        return { text: J };
      });
    }, H = M(() => {
      if (!e.itemError) return {};
      const U = {};
      return B.value.forEach((z) => {
        const J = t.value.findIndex((de) => de.text === z);
        J !== -1 && (U[z] = e.itemError(t.value[J], J) ?? void 0);
      }), U;
    }), te = (U) => {
      r.value = U, t.value = W(B.value);
    }, re = (U) => {
      te(String(U ?? ""));
    }, oe = () => {
      te("");
    }, K = (U) => {
      te(B.value.filter((z) => z !== U).join(`
`));
    }, ae = (U) => {
      if (U !== l.value) {
        if (U === "bulk")
          r.value = J1(t.value).join(`
`);
        else {
          const z = W(B.value);
          t.value = z.length ? z : [{ text: "" }], r.value = "";
        }
        l.value = U;
      }
    };
    return n({ focusRow: w }), (U, z) => (b(), $("div", nk, [
      E("div", ak, [
        e.label ? (b(), $("span", sk, ie(e.label), 1)) : F("", !0),
        E("div", lk, [
          l.value === "manual" ? (b(), ue(Qa, {
            key: 0,
            placement: "top",
            text: f.value ? "" : `Up to ${e.maxItems} ${d.value.toLowerCase()}`
          }, {
            default: ce(() => [
              E("button", {
                disabled: !f.value,
                class: "v-list-editor__add",
                type: "button",
                onClick: O
              }, [
                le(we, {
                  icon: "lucide:plus",
                  size: "14"
                }),
                Ye(" " + ie(p.value), 1)
              ], 8, rk)
            ]),
            _: 1
          }, 8, ["text"])) : F("", !0),
          s ? (b(), ue(tk, {
            key: 1,
            "model-value": l.value,
            options: i,
            size: "sm",
            "onUpdate:modelValue": ae
          }, null, 8, ["model-value"])) : F("", !0)
        ])
      ]),
      l.value === "manual" ? (b(), $("div", ik, [
        E("div", {
          class: X([{ "v-list-editor__box--error": v.value }, "v-list-editor__box"])
        }, [
          le(Dr, {
            class: "v-list-editor__rows",
            name: "v-list-editor-row",
            tag: "div"
          }, {
            default: ce(() => [
              (b(!0), $(Te, null, Ie(t.value, (J, de) => (b(), $("div", {
                key: c(J),
                class: "v-list-editor__row"
              }, [
                e.markerClass ? (b(), $("span", {
                  key: 0,
                  class: X([e.markerClass, "v-list-editor__marker"])
                }, null, 2)) : F("", !0),
                le(Cl, {
                  ref_for: !0,
                  ref: "inputs",
                  modelValue: J.text,
                  "onUpdate:modelValue": (pe) => J.text = pe,
                  error: h(J, de),
                  maxlength: e.maxLength,
                  placeholder: g(de),
                  "show-clear-button": !1,
                  class: "flex-1 min-w-0",
                  name: "",
                  onBlur: y,
                  onKeydown: [
                    Pt(Ve((pe) => C(de), ["exact", "prevent", "stop"]), ["enter"]),
                    Pt(Ve((pe) => _(de, J.text), ["stop"]), ["backspace"])
                  ]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "maxlength", "placeholder", "onKeydown"]),
                t.value.length > 1 ? (b(), $("button", {
                  key: 1,
                  "aria-label": "Remove",
                  class: "v-list-editor__remove",
                  type: "button",
                  onClick: (pe) => x(de)
                }, [
                  le(we, {
                    icon: "lucide:x",
                    size: "14"
                  })
                ], 8, ok)) : F("", !0)
              ]))), 128))
            ]),
            _: 1
          })
        ], 2),
        v.value ? (b(), $("p", uk, ie(k.value), 1)) : F("", !0)
      ])) : (b(), $("div", ck, [
        le(Cl, {
          error: v.value ? k.value : void 0,
          "model-value": r.value,
          placeholder: `Enter ${d.value.toLowerCase()}, one per line or comma-separated`,
          rows: 4,
          textarea: !0,
          name: "",
          onBlur: y,
          "onUpdate:modelValue": re
        }, null, 8, ["error", "model-value", "placeholder"]),
        E("p", dk, [
          z[1] || (z[1] = Ye(" Separate by: newline · , · ; · | · / · tab ", -1)),
          D.value.length ? (b(), $(Te, { key: 0 }, [
            z[0] || (z[0] = Ye(" · ", -1)),
            E("span", fk, " Detected: " + ie(D.value.map((J) => J.label).join(", ")), 1)
          ], 64)) : F("", !0)
        ]),
        B.value.length > 0 ? (b(), $(Te, { key: 0 }, [
          E("div", hk, [
            E("span", mk, ie(B.value.length) + " " + ie(B.value.length === 1 ? "item" : "items") + " detected ", 1),
            E("button", {
              class: "v-list-editor__clear",
              type: "button",
              onClick: oe
            }, " Clear all ")
          ]),
          le(Dr, {
            class: "v-list-editor__preview",
            name: "v-list-editor-chip",
            tag: "div"
          }, {
            default: ce(() => [
              (b(!0), $(Te, null, Ie(B.value, (J) => (b(), ue(Qa, {
                key: J,
                placement: "top",
                text: H.value[J] ?? ""
              }, {
                default: ce(() => [
                  le(ju, {
                    color: H.value[J] ? "error" : "primary",
                    label: J,
                    class: "v-list-editor__chip",
                    size: "md",
                    variant: "outline"
                  }, {
                    "icon-right": ce(() => [
                      E("button", {
                        class: "v-list-editor__chip-remove",
                        type: "button",
                        onClick: (de) => K(J)
                      }, [
                        le(we, {
                          class: "size-2.5",
                          icon: "lucide:x"
                        })
                      ], 8, vk)
                    ]),
                    _: 2
                  }, 1032, ["color", "label"])
                ]),
                _: 2
              }, 1032, ["text"]))), 128))
            ]),
            _: 1
          })
        ], 64)) : F("", !0)
      ]))
    ]));
  }
}), YD = /* @__PURE__ */ Ue(pk, [["__scopeId", "data-v-c9ecd31d"]]), gk = ["aria-busy"], yk = {
  ref: "pill",
  class: "sliding-pill absolute left-0 top-1 rounded-md pointer-events-none bg-primary/15 ring-1 ring-inset ring-primary/40 shadow-sm"
}, bk = ["aria-label", "aria-pressed", "title", "disabled", "onClick"], wk = { key: 1 }, kk = {
  key: 0,
  "aria-hidden": "true",
  class: "absolute inset-0 flex items-center justify-center"
}, xk = /* @__PURE__ */ xe({
  __name: "VSegmentedControl",
  props: {
    modelValue: {},
    options: {},
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    deselectable: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = Xe("container"), s = Xe("pill");
    let l = null;
    const r = {
      primary: "bg-primary-100 text-primary-700",
      success: "bg-success-100 text-success-700",
      warning: "bg-warning-100 text-warning-700",
      error: "bg-error-100 text-error-700",
      info: "bg-info-100 text-info-700",
      neutral: "bg-base-300 text-secondaryText",
      violet: "bg-violet-100 text-violet-700"
    }, i = (d) => {
      const g = !!(d.icon && !d.label);
      switch (e.size) {
        case "none":
          return "";
        case "sm":
          return g ? "p-1" : "text-xs px-2 py-1";
        case "lg":
          return g ? "p-2.5" : "text-base px-4 py-2.5";
        default:
          return g ? "p-2" : "text-sm px-3 py-2";
      }
    }, o = M(() => {
      switch (e.size) {
        case "sm":
          return 14;
        case "lg":
          return 20;
        default:
          return 16;
      }
    }), u = (d) => d.value === e.modelValue, c = (d) => e.loading && u(d), f = () => {
      const d = a.value, g = s.value;
      if (!d || !g) return;
      const v = d.querySelectorAll("button"), k = e.options.findIndex((h) => h.value === e.modelValue), y = v[k];
      if (!y) {
        g.style.opacity = "0";
        return;
      }
      g.style.opacity = "1", g.style.transform = `translateX(${y.offsetLeft}px)`, g.style.width = `${y.offsetWidth}px`;
    }, p = (d) => {
      if (!(d.disabled || e.disabled || e.loading)) {
        if (e.deselectable && u(d)) {
          t("update:modelValue", null);
          return;
        }
        t("update:modelValue", d.value);
      }
    };
    return et(() => {
      Ge(f);
      const d = a.value;
      !d || typeof ResizeObserver > "u" || (l = new ResizeObserver(() => f()), l.observe(d));
    }), wf(f), Jt(() => {
      l == null || l.disconnect(), l = null;
    }), (d, g) => (b(), $("div", {
      ref: "container",
      "aria-busy": e.loading,
      class: X([{
        "w-full": e.fullWidth,
        "opacity-50 pointer-events-none": e.disabled,
        // No dimming while loading: the spinner already says the control is busy, and fading the
        // whole track would hide the option the user just picked.
        "pointer-events-none": e.loading
      }, "v-segmented-control relative inline-flex items-center rounded-lg bg-base-200 p-1 border-[1px] border-base-400 shadow-md gap-1"])
    }, [
      E("span", yk, null, 512),
      (b(!0), $(Te, null, Ie(e.options, (v) => (b(), $("button", {
        key: v.value,
        "aria-label": v.ariaLabel,
        "aria-pressed": u(v),
        title: v.ariaLabel,
        class: X([[
          i(v),
          e.fullWidth ? "flex-1" : "",
          u(v) ? "text-primary" : "text-secondaryText hover:text-mainText",
          v.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        ], "relative z-10 flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-base-200"]),
        disabled: v.disabled || e.disabled,
        type: "button",
        onClick: (k) => p(v)
      }, [
        Y(d.$slots, `option-${v.value}`, {
          option: v,
          selected: u(v)
        }, () => [
          E("span", {
            class: X([{ "opacity-0": c(v) }, "flex items-center gap-1.5 transition-opacity duration-150"])
          }, [
            v.icon ? (b(), ue(we, {
              key: 0,
              icon: v.icon,
              size: o.value
            }, null, 8, ["icon", "size"])) : F("", !0),
            v.label ? (b(), $("span", wk, ie(v.label), 1)) : F("", !0),
            v.badge !== void 0 ? (b(), $("span", {
              key: 2,
              class: X([r[v.badgeColor ?? "neutral"], "ml-0.5 rounded-full px-1.5 py-0.5 text-[11px] font-semibold leading-none"])
            }, ie(v.badge), 3)) : F("", !0)
          ], 2),
          c(v) ? (b(), $("span", kk, [
            le(we, {
              size: o.value,
              icon: "lucide:loader-2",
              loading: ""
            }, null, 8, ["size"])
          ])) : F("", !0)
        ], !0)
      ], 10, bk))), 128))
    ], 10, gk));
  }
}), HD = /* @__PURE__ */ Ue(xk, [["__scopeId", "data-v-42087df2"]]);
function wr(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function Sk(e) {
  return (...n) => !e(...n);
}
function Tk(e, n) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(n.trim()) !== -1;
}
function $k(e) {
  return e.filter((n) => !n.$isLabel);
}
function kr(e, n) {
  return (t) => t.reduce((a, s) => s[e] && s[e].length ? (a.push({
    $groupLabel: s[n],
    $isLabel: !0
  }), a.concat(s[e])) : a, []);
}
const lu = (...e) => (n) => e.reduce((t, a) => a(t), n);
var Mk = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, n) {
        return wr(e) ? "" : n ? e[n] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", n = e.toLowerCase().trim();
      let t = this.options.concat();
      return this.internalSearch ? t = this.groupValues ? this.filterAndFlat(t, n, this.label) : this.filterOptions(t, n, this.label, this.customLabel) : t = this.groupValues ? kr(this.groupValues, this.groupLabel)(t) : t, t = this.hideSelected ? t.filter(Sk(this.isSelected)) : t, this.taggable && n.length && !this.isExistingOption(n) && (this.tagPosition === "bottom" ? t.push({ isTag: !0, label: e }) : t.unshift({ isTag: !0, label: e })), t.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((n) => this.customLabel(n, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, n, t) {
      return lu(
        this.filterGroups(n, t, this.groupValues, this.groupLabel, this.customLabel),
        kr(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return lu(
        kr(this.groupValues, this.groupLabel),
        $k
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const n = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(n) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (wr(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const n = this.customLabel(e, this.label);
      return wr(n) ? "" : n;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, n) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(n) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(n === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            n !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const n = this.options.find((t) => t[this.groupLabel] === e.$groupLabel);
      if (n) {
        if (this.wholeGroupSelected(n)) {
          this.$emit("remove", n[this.groupValues], this.id);
          const t = this.trackBy ? n[this.groupValues].map((s) => s[this.trackBy]) : n[this.groupValues], a = this.internalValue.filter(
            (s) => t.indexOf(this.trackBy ? s[this.trackBy] : s) === -1
          );
          this.$emit("update:modelValue", a);
        } else {
          const t = n[this.groupValues].filter(
            (a) => !(this.isOptionDisabled(a) || this.isSelected(a))
          );
          this.max && t.splice(this.max - this.internalValue.length), this.$emit("select", t, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(t)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (n) => this.isSelected(n) || this.isOptionDisabled(n)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, n = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const t = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const a = this.internalValue.slice(0, t).concat(this.internalValue.slice(t + 1));
        this.$emit("update:modelValue", a);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && n && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, n = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      n > this.maxHeight || n > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(n - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(e, n, t, a) {
      return n ? e.filter((s) => Tk(a(s, t), n)).sort((s, l) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(s, l) : a(s, t).length - a(l, t).length) : e;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(e, n, t, a, s) {
      return (l) => l.map((r) => {
        if (!r[t])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const i = this.filterOptions(r[t], e, n, s);
        return i.length ? {
          [a]: r[a],
          [t]: i
        } : [];
      });
    }
  }
}, Ck = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, n) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(n)
      };
    },
    groupHighlight(e, n) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": n.$isLabel }
        ];
      const t = this.options.find((a) => a[this.groupLabel] === n.$groupLabel);
      return t && !this.wholeGroupDisabled(t) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(t) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      var e;
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      var e;
      this.pointer > 0 ? (this.pointer--, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, Gd = {
  name: "vue-multiselect",
  mixins: [Mk, Ck],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Uses Vue Teleport's feature. Teleports the open dropdown to the bottom of the body element
     * @default false
     * @type {Boolean}
     */
    useTeleport: {
      type: Boolean,
      default: !1
    },
    /**
     * Classes to apply to the `multiselect__content-wrapper` element. This element is a teleport element (when enabled), so can be used to specifically target
     * the teleported element
     */
    contentWrapperClass: {
      type: [String, Array, Object],
      default: ""
    }
  },
  data() {
    return {
      dropdownStyles: {},
      ready: !1
    };
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  },
  watch: {
    isOpen(e) {
      e && (this.useTeleport ? (this.ready = !1, this.$nextTick(() => {
        const n = this.$el.getBoundingClientRect();
        this.dropdownStyles = {
          position: "absolute",
          top: `${n.bottom + window.scrollY}px`,
          left: `${n.left + window.scrollX}px`,
          width: `${n.width}px`,
          zIndex: 9999
        }, this.ready = !0;
      })) : this.ready = !0);
    }
  }
};
const Dk = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], _k = {
  ref: "tags",
  class: "multiselect__tags"
}, Ok = { class: "multiselect__tags-wrap" }, Ek = ["textContent"], Ik = ["onKeydown", "onMousedown"], Ak = ["textContent"], Pk = { class: "multiselect__spinner" }, Rk = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], Fk = ["id", "aria-multiselectable"], Vk = { key: 0 }, Lk = { class: "multiselect__option" }, Nk = ["aria-selected", "id", "role"], Bk = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], zk = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], Wk = { class: "multiselect__option" }, Yk = { class: "multiselect__option" };
function Hk(e, n, t, a, s, l) {
  return b(), $("div", {
    tabindex: e.searchable ? -1 : t.tabindex,
    class: X([{ "multiselect--active": e.isOpen, "multiselect--disabled": t.disabled, "multiselect--above": l.isAbove, "multiselect--has-options-group": l.hasOptionGroup }, "multiselect"]),
    onFocus: n[14] || (n[14] = (r) => e.activate()),
    onBlur: n[15] || (n[15] = (r) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      n[16] || (n[16] = Pt(Ve((r) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      n[17] || (n[17] = Pt(Ve((r) => e.pointerBackward(), ["self", "prevent"]), ["up"])),
      n[18] || (n[18] = Pt(Ve((r) => e.addPointerElement(r), ["stop", "self"]), ["enter", "tab"]))
    ],
    onKeyup: n[19] || (n[19] = Pt((r) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": e.isOpen,
    "aria-owns": "listbox-" + e.id,
    "aria-activedescendant": e.isOpen && e.pointer !== null ? e.id + "-" + e.pointer : null
  }, [
    Y(e.$slots, "caret", { toggle: e.toggle }, () => [
      E(
        "div",
        {
          onMousedown: n[0] || (n[0] = Ve((r) => e.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    Y(e.$slots, "clear", { search: e.search }),
    E(
      "div",
      _k,
      [
        Y(e.$slots, "selection", {
          search: e.search,
          remove: e.removeElement,
          values: l.visibleValues,
          isOpen: e.isOpen
        }, () => [
          an(E(
            "div",
            Ok,
            [
              (b(!0), $(
                Te,
                null,
                Ie(l.visibleValues, (r, i) => Y(e.$slots, "tag", {
                  option: r,
                  search: e.search,
                  remove: e.removeElement
                }, () => [
                  (b(), $(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: i,
                      onMousedown: n[1] || (n[1] = Ve(() => {
                      }, ["prevent"]))
                    },
                    [
                      E("span", {
                        textContent: ie(e.getOptionLabel(r))
                      }, null, 8, Ek),
                      E("i", {
                        tabindex: "1",
                        onKeydown: Pt(Ve((o) => e.removeElement(r), ["prevent"]), ["enter"]),
                        onMousedown: Ve((o) => e.removeElement(r), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, Ik)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [Wn, l.visibleValues.length > 0]
          ]),
          e.internalValue && e.internalValue.length > t.limit ? Y(e.$slots, "limit", { key: 0 }, () => [
            E("strong", {
              class: "multiselect__strong",
              textContent: ie(t.limitText(e.internalValue.length - t.limit))
            }, null, 8, Ak)
          ]) : F("v-if", !0)
        ]),
        le(St, { name: "multiselect__loading" }, {
          default: ce(() => [
            Y(e.$slots, "loading", {}, () => [
              an(E(
                "div",
                Pk,
                null,
                512
                /* NEED_PATCH */
              ), [
                [Wn, t.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        e.searchable ? (b(), $("input", {
          key: 0,
          ref: "search",
          name: t.name,
          id: e.id,
          type: "text",
          autocomplete: "off",
          spellcheck: t.spellcheck,
          placeholder: e.placeholder,
          required: l.isRequired,
          style: Fe(l.inputStyle),
          value: e.search,
          disabled: t.disabled,
          tabindex: t.tabindex,
          "aria-label": t.name + "-searchbox",
          onInput: n[2] || (n[2] = (r) => e.updateSearch(r.target.value)),
          onFocus: n[3] || (n[3] = Ve((r) => e.activate(), ["prevent"])),
          onBlur: n[4] || (n[4] = Ve((r) => e.deactivate(), ["prevent"])),
          onKeyup: n[5] || (n[5] = Pt((r) => e.deactivate(), ["esc"])),
          onKeydown: [
            n[6] || (n[6] = Pt(Ve((r) => e.pointerForward(), ["prevent"]), ["down"])),
            n[7] || (n[7] = Pt(Ve((r) => e.pointerBackward(), ["prevent"]), ["up"])),
            n[8] || (n[8] = Pt(Ve((r) => e.addPointerElement(r), ["prevent", "stop", "self"]), ["enter"])),
            n[9] || (n[9] = Pt(Ve((r) => e.removeLastElement(), ["stop"]), ["delete"]))
          ],
          class: "multiselect__input",
          "aria-controls": "listbox-" + e.id
        }, null, 44, Rk)) : F("v-if", !0),
        l.isSingleLabelVisible ? (b(), $(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: n[10] || (n[10] = Ve((...r) => e.toggle && e.toggle(...r), ["prevent"]))
          },
          [
            Y(e.$slots, "singleLabel", { option: l.singleValue }, () => [
              Ye(
                ie(e.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : F("v-if", !0),
        l.isPlaceholderVisible ? (b(), $(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: n[11] || (n[11] = Ve((...r) => e.toggle && e.toggle(...r), ["prevent"]))
          },
          [
            Y(e.$slots, "placeholder", {}, () => [
              Ye(
                ie(e.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : F("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    (b(), ue(Pn, {
      to: "body",
      disabled: !t.useTeleport
    }, [
      le(St, { name: "multiselect" }, {
        default: ce(() => [
          e.isOpen && s.ready ? (b(), $(
            "div",
            {
              key: 0,
              class: X(["multiselect__content-wrapper", t.contentWrapperClass]),
              onFocus: n[12] || (n[12] = (...r) => e.activate && e.activate(...r)),
              tabindex: "-1",
              onMousedown: n[13] || (n[13] = Ve(() => {
              }, ["prevent"])),
              style: Fe([s.dropdownStyles, { maxHeight: e.optimizedHeight + "px" }]),
              ref: "list"
            },
            [
              E("ul", {
                class: "multiselect__content",
                style: Fe(l.contentStyle),
                role: "listbox",
                id: "listbox-" + e.id,
                "aria-multiselectable": e.multiple
              }, [
                Y(e.$slots, "beforeList"),
                e.multiple && e.max === e.internalValue.length ? (b(), $("li", Vk, [
                  E("span", Lk, [
                    Y(e.$slots, "maxElements", {}, () => [
                      Ye(
                        "Maximum of " + ie(e.max) + " options selected. First remove a selected option to select another.",
                        1
                        /* TEXT */
                      )
                    ])
                  ])
                ])) : F("v-if", !0),
                !e.max || e.internalValue.length < e.max ? (b(!0), $(
                  Te,
                  { key: 1 },
                  Ie(e.filteredOptions, (r, i) => (b(), $("li", {
                    class: "multiselect__element",
                    key: i,
                    "aria-selected": e.isSelected(r),
                    id: e.id + "-" + i,
                    role: r && (r.$isLabel || r.$isDisabled) ? null : "option"
                  }, [
                    r && (r.$isLabel || r.$isDisabled) ? F("v-if", !0) : (b(), $("span", {
                      key: 0,
                      class: X([e.optionHighlight(i, r), "multiselect__option"]),
                      onClick: Ve((o) => e.select(r), ["stop"]),
                      onMouseenter: Ve((o) => e.pointerSet(i), ["self"]),
                      "data-select": r && r.isTag ? e.tagPlaceholder : l.selectLabelText,
                      "data-selected": l.selectedLabelText,
                      "data-deselect": l.deselectLabelText
                    }, [
                      Y(e.$slots, "option", {
                        option: r,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          ie(e.getOptionLabel(r)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, Bk)),
                    r && (r.$isLabel || r.$isDisabled) ? (b(), $("span", {
                      key: 1,
                      "data-select": e.groupSelect && l.selectGroupLabelText,
                      "data-deselect": e.groupSelect && l.deselectGroupLabelText,
                      class: X([e.groupHighlight(i, r), "multiselect__option"]),
                      onMouseenter: Ve((o) => e.groupSelect && e.pointerSet(i), ["self"]),
                      onMousedown: Ve((o) => e.selectGroup(r), ["prevent"])
                    }, [
                      Y(e.$slots, "option", {
                        option: r,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          ie(e.getOptionLabel(r)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, zk)) : F("v-if", !0)
                  ], 8, Nk))),
                  128
                  /* KEYED_FRAGMENT */
                )) : F("v-if", !0),
                an(E(
                  "li",
                  null,
                  [
                    E("span", Wk, [
                      Y(e.$slots, "noResult", { search: e.search }, () => [
                        n[20] || (n[20] = Ye("No elements found. Consider changing the search query."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Wn, t.showNoResults && e.filteredOptions.length === 0 && e.search && !t.loading]
                ]),
                an(E(
                  "li",
                  null,
                  [
                    E("span", Yk, [
                      Y(e.$slots, "noOptions", {}, () => [
                        n[21] || (n[21] = Ye("List is empty."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Wn, t.showNoOptions && (e.options.length === 0 || l.hasOptionGroup === !0 && e.filteredOptions.length === 0) && !e.search && !t.loading]
                ]),
                Y(e.$slots, "afterList")
              ], 12, Fk)
            ],
            38
            /* CLASS, STYLE, NEED_HYDRATION */
          )) : F("v-if", !0)
        ]),
        _: 3
        /* FORWARDED */
      })
    ], 8, ["disabled"]))
  ], 42, Dk);
}
Gd.render = Hk;
const Uk = { class: "v-select" }, qk = { class: "multiselect__select" }, jk = {
  key: 0,
  class: "v-select__helper-text"
}, Gk = {
  key: 0,
  class: "v-select__error-message"
}, Kk = /* @__PURE__ */ xe({
  __name: "VSelect",
  props: {
    modelValue: { default: null },
    options: { default: () => [] },
    placeholder: { default: "Select option" },
    disabled: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !0 },
    clearOnSelect: { type: Boolean, default: !0 },
    closeOnSelect: { type: Boolean, default: !0 },
    label: { default: "label" },
    trackBy: { default: "value" },
    loading: { type: Boolean, default: !1 },
    taggable: { type: Boolean, default: !1 },
    maxHeight: { default: 300 },
    optionsLimit: { default: 1e3 },
    teleportToBody: { type: Boolean, default: !0 },
    name: { default: "" },
    allowEmpty: { type: Boolean, default: !1 },
    noResultsText: { default: "No results found" },
    helperText: { default: "" },
    validation: { default: void 0 },
    error: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "select", "remove", "search-change", "open", "close"],
  setup(e, { emit: n }) {
    const t = e, a = ["noResult", "helper-text", "error-message"], s = (D) => !a.includes(D), l = M(() => {
      var D;
      return !!((D = t.validation) != null && D.$error || t.error);
    }), r = M(() => {
      var D, B;
      return ((B = (D = t.validation) == null ? void 0 : D.$errors[0]) == null ? void 0 : B.$message) ?? t.error ?? "";
    }), i = M(() => !!t.name), o = M(() => i.value ? u.value ? t.placeholder : "" : t.placeholder), u = ee(!1), c = M(() => Array.isArray(t.modelValue) ? t.modelValue.length > 0 : t.modelValue && typeof t.modelValue == "object" ? !0 : t.modelValue !== null && t.modelValue !== void 0), f = n, p = (D) => {
      f("update:modelValue", D);
    }, d = (D) => {
      f("select", D);
    }, g = (D) => {
      f("remove", D);
    }, v = (D) => {
      f("search-change", D);
    }, k = ee(null);
    let y = null, h = null, w = null;
    const S = () => {
      var oe;
      if (!y || !k.value) return;
      const D = (oe = k.value.$el) == null ? void 0 : oe.querySelector(".multiselect__tags");
      if (!D) return;
      const B = D.getBoundingClientRect(), W = window.innerHeight - B.bottom, H = Math.min(y.scrollHeight, t.maxHeight), te = W < H && B.top > W, re = te ? Math.max(4, B.top - H - 4) : Math.min(window.innerHeight - H - 4, B.bottom + 4);
      Object.assign(y.style, {
        position: "fixed",
        top: `${re}px`,
        left: `${B.left}px`,
        width: `${B.width}px`,
        maxHeight: `${t.maxHeight}px`,
        zIndex: "10000"
      }), y.classList.toggle("opened-above", te);
    }, x = () => requestAnimationFrame(S), C = () => {
      t.teleportToBody && Ge(() => {
        var D, B;
        y = (B = (D = k.value) == null ? void 0 : D.$el) == null ? void 0 : B.querySelector(".multiselect__content-wrapper"), y && (h || (w = y.parentElement, h = document.createComment("v-multiselect-anchor"), w == null || w.replaceChild(h, y), document.body.appendChild(y)), y.classList.add("v-ms-floating"), t.modern && y.classList.add("v-ms-modern"), S(), window.addEventListener("scroll", x, { passive: !0 }), window.addEventListener("resize", x, { passive: !0 }));
      });
    }, _ = () => {
      y && (window.removeEventListener("scroll", x), window.removeEventListener("resize", x), y.classList.remove("v-ms-floating", "v-ms-modern", "opened-above"), y.removeAttribute("style"), h && w && w.replaceChild(y, h), h = null, w = null, y = null);
    }, O = () => {
      C(), u.value = !0, f("open");
    }, P = () => {
      var D;
      _(), u.value = !1, (D = t.validation) == null || D.$touch(), f("close");
    };
    return Ps(() => _()), (D, B) => (b(), $("div", {
      class: X([{ "v-select--modern": t.modern }, "v-select-wrapper"])
    }, [
      E("div", Uk, [
        i.value ? (b(), $("label", {
          key: 0,
          class: X([{
            "v-select__label--active": u.value || c.value,
            "v-select__label--error": l.value
          }, "v-select__label"])
        }, ie(t.name), 3)) : F("", !0),
        le(m(Gd), lt({
          ref_key: "msRef",
          ref: k,
          "allow-empty": t.allowEmpty,
          "clear-on-select": t.clearOnSelect,
          "close-on-select": t.closeOnSelect,
          disabled: t.disabled,
          label: t.label,
          loading: t.loading,
          "max-height": t.maxHeight,
          "model-value": t.modelValue,
          multiple: t.multiple,
          options: t.options,
          "options-limit": t.optionsLimit,
          placeholder: o.value,
          searchable: t.searchable,
          "show-labels": !1,
          taggable: t.taggable,
          "track-by": t.trackBy
        }, D.$attrs, {
          onClose: P,
          onOpen: O,
          onRemove: g,
          onSelect: d,
          "onUpdate:modelValue": p,
          onSearchChange: v
        }), dt({
          caret: ce(() => [
            E("div", qk, [
              le(we, {
                loading: t.loading,
                class: "v-select__caret-icon",
                icon: "mdi:chevron-down"
              }, null, 8, ["loading"])
            ])
          ]),
          noResult: ce(() => [
            Y(D.$slots, "noResult", {}, () => [
              Ye(ie(t.noResultsText || "No results found"), 1)
            ], !0)
          ]),
          _: 2
        }, [
          Ie(Object.keys(D.$slots).filter(s), (W, H) => ({
            name: W,
            fn: ce((te) => [
              Y(D.$slots, W, Ct(Bt(te)), void 0, !0)
            ])
          }))
        ]), 1040, ["allow-empty", "clear-on-select", "close-on-select", "disabled", "label", "loading", "max-height", "model-value", "multiple", "options", "options-limit", "placeholder", "searchable", "taggable", "track-by"]),
        E("fieldset", {
          class: X([{
            "v-select__fieldset--active": u.value,
            "v-select__fieldset--error": l.value
          }, "v-select__fieldset"]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: X([{ "v-select__legend--visible": i.value && (c.value || u.value) }, "v-select__legend"])
          }, [
            E("span", null, ie(t.name), 1)
          ], 2)
        ], 2)
      ]),
      Y(D.$slots, "helper-text", {}, () => [
        t.helperText && !l.value ? (b(), $("p", jk, ie(t.helperText), 1)) : F("", !0)
      ], !0),
      le(St, {
        mode: "out-in",
        name: "error-slide"
      }, {
        default: ce(() => [
          Y(D.$slots, "error-message", {}, () => [
            l.value ? (b(), $("p", Gk, ie(r.value), 1)) : F("", !0)
          ], !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Zk = /* @__PURE__ */ Ue(Kk, [["__scopeId", "data-v-435100dd"]]), Xk = ["for"], Jk = { class: "v-switch__container" }, Qk = ["id", "checked", "disabled"], ex = { class: "v-switch__label" }, tx = /* @__PURE__ */ xe({
  __name: "VSwitch",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    trueIcon: {},
    falseIcon: {},
    trueLabel: {},
    falseLabel: {},
    color: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = li(), l = M(() => t.id || `v-switch-${As()}`), r = M({
      get: () => !!t.modelValue,
      set: (c) => a("update:modelValue", c)
    }), i = {
      positive: "success",
      negative: "error"
    }, o = (c) => /^#|^rgb|^hsl|^oklch|^color/.test(c) ? c : `rgb(var(--color-${i[c] ?? c}) / 1)`, u = M(() => {
      if (t.disabled)
        return {
          backgroundColor: "#d1d5db",
          borderColor: "#d1d5db"
        };
      if (t.color && r.value) {
        const c = o(t.color);
        return {
          backgroundColor: c,
          borderColor: c
        };
      }
      return {};
    });
    return (c, f) => (b(), $("label", {
      class: X([{
        "v-switch--disabled": t.disabled,
        "v-switch--loading": t.loading && !t.disabled
      }, "v-switch"]),
      for: l.value
    }, [
      E("span", Jk, [
        E("input", lt({
          id: l.value,
          checked: r.value,
          disabled: t.disabled || t.loading,
          class: "v-switch__input",
          type: "checkbox"
        }, m(s), {
          onChange: f[0] || (f[0] = (p) => r.value = p.target.checked)
        }), null, 16, Qk),
        E("span", {
          class: X([
            "v-switch__track",
            { "v-switch__track--checked": r.value },
            { "v-switch__track--disabled": t.disabled },
            { "v-switch__track--custom-color": t.color && r.value }
          ]),
          style: Fe(u.value)
        }, [
          E("span", {
            class: X(["v-switch__thumb", { "v-switch__thumb--checked": r.value }])
          }, [
            t.loading ? (b(), ue(we, {
              key: 0,
              loading: !0,
              size: 12,
              class: "v-switch__spinner",
              icon: "lucide:loading"
            })) : c.$slots.icon ? Y(c.$slots, "icon", { key: 1 }, () => [
              Y(c.$slots, r.value ? "true-icon" : "false-icon", {}, void 0, !0)
            ], !0) : (b(), $(Te, { key: 2 }, [
              r.value && t.trueIcon ? (b(), ue(we, {
                key: 0,
                icon: t.trueIcon,
                size: 16
              }, null, 8, ["icon"])) : !r.value && t.falseIcon ? (b(), ue(we, {
                key: 1,
                icon: t.falseIcon,
                size: 16
              }, null, 8, ["icon"])) : F("", !0)
            ], 64))
          ], 2)
        ], 6)
      ]),
      E("span", ex, [
        Y(c.$slots, "default", {}, () => [
          Ye(ie(r.value ? t.trueLabel : t.falseLabel), 1)
        ], !0)
      ])
    ], 10, Xk));
  }
}), UD = /* @__PURE__ */ Ue(tx, [["__scopeId", "data-v-851e4181"]]), en = ee(/* @__PURE__ */ new Map());
let ru = 1e3;
const Kd = () => {
  const e = M(() => (f) => en.value.get(f)), n = M(() => (f) => {
    const p = en.value.get(f);
    return p ? p.isOpen : !1;
  }), t = M(() => (f) => {
    const p = en.value.get(f);
    return p ? p.zIndex : 1e3;
  }), a = M(() => Array.from(en.value.values()).filter((f) => f.isOpen)), s = M(() => a.value.length > 0), l = (f) => {
    en.value.has(f) || en.value.set(f, {
      id: f,
      isOpen: !1,
      zIndex: 1e3
    });
  }, r = (f) => {
    en.value.delete(f);
  }, i = (f) => {
    l(f);
    const p = en.value.get(f);
    p && (ru += 10, p.zIndex = ru, p.isOpen = !0);
  }, o = (f) => {
    const p = en.value.get(f);
    p && (p.isOpen = !1);
  };
  return {
    modals: en,
    getModal: e,
    isOpen: n,
    getZIndex: t,
    openModals: a,
    hasOpenModals: s,
    register: l,
    unregister: r,
    open: i,
    close: o,
    toggle: (f) => {
      const p = en.value.get(f);
      p && (p.isOpen ? o(f) : i(f));
    },
    closeAll: () => {
      en.value.forEach((f) => {
        f.isOpen = !1;
      });
    }
  };
}, Gl = (e, n = !0) => {
  const t = Kd();
  t.register(e);
  const a = M(() => t.isOpen.value(e)), s = M(() => t.getZIndex.value(e)), l = M(() => t.getModal.value(e)), r = () => t.open(e), i = () => t.close(e), o = () => t.toggle(e);
  return n && Ps(() => {
    t.unregister(e);
  }), {
    isOpen: a,
    zIndex: s,
    modal: l,
    open: r,
    close: i,
    toggle: o
  };
}, iu = { duration: 200, easing: "cubic-bezier(0, 0, 0.2, 1)" }, ou = { duration: 160, easing: "cubic-bezier(0.4, 0, 1, 1)" }, il = 0, xr = () => {
  const { innerWidth: e, innerHeight: n } = window;
  return {
    top: n * il,
    left: e * il,
    width: e * (1 - 2 * il),
    height: n * (1 - 2 * il)
  };
}, uu = (e) => e instanceof HTMLElement ? e : void 0, nx = (e) => {
  var t;
  const n = uu(e);
  return n ? n.offsetHeight : ((t = uu(e == null ? void 0 : e.$el)) == null ? void 0 : t.offsetHeight) ?? 0;
}, ei = "v-table-fullscreen", ys = ee(!1);
let Sr = null;
const cu = (e, n, t) => {
  const a = n.width / t.width, s = n.height / t.height, l = n.left - t.left, r = n.top - t.top;
  e.style.transformOrigin = "top left", e.style.transform = `translate(${l}px, ${r}px) scale(${a}, ${s})`;
}, ax = (e) => {
  const { wrapperRef: n, placeholderRef: t } = e, a = ee(!1), s = ee(null), l = ee(null), r = ee(0);
  let i = null, o = null, u = 0, c = !1;
  const { zIndex: f, open: p, close: d } = Gl(ei, !1), g = Kd(), v = () => {
    r.value = (e.chromeRefs ?? []).reduce((D, B) => D + nx(B.value), 0);
  }, k = async () => {
    const D = n.value;
    if (!D) return;
    const B = ++u, W = D.getBoundingClientRect();
    s.value = W, l.value = xr(), v();
    const H = window.scrollX, te = window.scrollY;
    if (a.value = !0, await Ge(), B !== u) return;
    (window.scrollX !== H || window.scrollY !== te) && window.scrollTo({ left: H, top: te, behavior: "instant" }), D.style.transition = "none";
    const re = D.getBoundingClientRect();
    cu(D, W, re), D.offsetHeight, D.style.transition = `transform ${iu.duration}ms ${iu.easing}`, D.style.transform = "translate(0, 0) scale(1, 1)";
    const oe = (K) => {
      K.target !== D || K.propertyName !== "transform" || (D.removeEventListener("transitionend", oe), o = null, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    o = { el: D, handler: oe }, D.addEventListener("transitionend", oe);
  }, y = async () => {
    var K;
    const D = n.value;
    if (!D) return;
    const B = ++u, W = window.scrollX, H = window.scrollY;
    if (await Ge(), B !== u) return;
    (window.scrollX !== W || window.scrollY !== H) && window.scrollTo({ left: W, top: H, behavior: "instant" }), o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null);
    const te = D.getBoundingClientRect(), re = ((K = t == null ? void 0 : t.value) == null ? void 0 : K.getBoundingClientRect()) ?? s.value ?? te;
    D.style.transition = `transform ${ou.duration}ms ${ou.easing}`, cu(D, re, te);
    const oe = (ae) => {
      ae.target !== D || ae.propertyName !== "transform" || (D.removeEventListener("transitionend", oe), i = null, a.value = !1, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    i = { el: D, handler: oe }, D.addEventListener("transitionend", oe);
  }, h = () => {
    a.value ? y() : k();
  }, w = () => {
    a.value && y();
  };
  Be(a, (D) => {
    D ? p() : c || d();
  });
  const S = (D) => {
    D.key !== "Escape" || !a.value || Math.max(
      0,
      ...g.openModals.value.filter((W) => W.id !== ei).map((W) => W.zIndex)
    ) > f.value || h();
  };
  Be(a, (D) => {
    D ? window.addEventListener("keydown", S) : window.removeEventListener("keydown", S);
  });
  const x = () => {
    a.value && (l.value = xr(), v());
  };
  Be(a, (D) => {
    D ? window.addEventListener("resize", x) : window.removeEventListener("resize", x);
  }), Be(a, async (D) => {
    var B;
    await Ge(), await ((B = e.onToggle) == null ? void 0 : B.call(e, D));
  });
  const C = () => {
    v(), s.value = Sr, l.value = xr(), a.value = !0;
  };
  Ou(() => {
    a.value && (c = !0, l.value = null, a.value = !1, u += 1, o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null), ys.value = !0, Sr = s.value, Ge().then(() => {
      c = !1, ys.value && (ys.value = !1, Sr = null, d());
    }));
  }), Eu(() => {
    ys.value && Qe(e.isEnabled) && (ys.value = !1, C());
  }), Jt(() => {
    a.value && d(), window.removeEventListener("keydown", S), window.removeEventListener("resize", x), i && (i.el.removeEventListener("transitionend", i.handler), i = null), o && (o.el.removeEventListener("transitionend", o.handler), o = null);
  });
  const _ = M(() => !a.value || !s.value ? null : {
    width: `${s.value.width}px`,
    height: `${s.value.height}px`
  }), O = M(() => {
    if (!a.value || !l.value) return null;
    const { top: D, left: B, width: W, height: H } = l.value;
    return {
      top: `${D}px`,
      left: `${B}px`,
      width: `${W}px`,
      height: `${H}px`
    };
  }), P = M(() => !a.value || !l.value ? 0 : l.value.height - r.value);
  return {
    isFullscreen: ai(a),
    isEnabled: M(() => Qe(e.isEnabled)),
    zIndex: f,
    placeholderStyle: _,
    panelStyle: O,
    contentHeight: P,
    toggle: h,
    close: w
  };
}, sx = { class: "v-bulk-action-bar__count" }, lx = { class: "v-bulk-action-bar__badge" }, rx = /* @__PURE__ */ xe({
  __name: "VBulkActionBar",
  props: /* @__PURE__ */ Ht({
    items: {},
    clearOn: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ht(["clear"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = En(e, "modelValue"), a = n, { isOpen: s, zIndex: l } = Gl(
      ei,
      !1
    ), r = M(() => t.value.length), i = M(() => r.value > 0), o = M(() => {
      var g;
      return ((g = e.items) == null ? void 0 : g.length) ?? null;
    }), u = M(
      () => o.value !== null && r.value < o.value
    ), c = M(() => s.value ? l.value + 2 : 50), f = M(() => JSON.stringify(e.clearOn ?? null)), p = () => {
      t.value = [], a("clear");
    }, d = () => {
      e.items && (t.value = [...e.items]);
    };
    return Be(f, () => {
      r.value && p();
    }), (g, v) => (b(), ue(Pn, { to: "body" }, [
      le(St, { name: "v-bulk-action-bar" }, {
        default: ce(() => [
          i.value ? (b(), $("div", {
            key: 0,
            style: Fe({ zIndex: c.value }),
            class: "v-bulk-action-bar"
          }, [
            E("div", sx, [
              E("span", lx, ie(r.value), 1),
              v[0] || (v[0] = E("span", { class: "v-bulk-action-bar__label" }, "selected", -1))
            ]),
            u.value ? (b(), $("button", {
              key: 0,
              class: "v-bulk-action-bar__select-all",
              type: "button",
              onClick: d
            }, " Select all " + ie(o.value), 1)) : F("", !0),
            v[1] || (v[1] = E("div", { class: "v-bulk-action-bar__divider" }, null, -1)),
            Y(g.$slots, "actions", {}, void 0, !0),
            E("button", {
              "aria-label": "Clear selection",
              class: "v-bulk-action-bar__clear",
              type: "button",
              onClick: p
            }, [
              le(we, {
                size: 16,
                icon: "lucide:x"
              })
            ])
          ], 4)) : F("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), qD = /* @__PURE__ */ Ue(rx, [["__scopeId", "data-v-8ce37d17"]]), ix = ["data-overlay-open"], ox = {
  key: 0,
  class: "v-drawer__header"
}, ux = {
  key: 0,
  class: "v-drawer__title"
}, cx = { class: "v-drawer__content" }, dx = {
  key: 1,
  class: "v-drawer__footer"
}, fx = /* @__PURE__ */ xe({
  __name: "VDrawer",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    position: { default: "right" },
    width: { default: "md" },
    backdropBlur: { default: "xs" },
    keepAlive: { type: Boolean, default: !1 }
  },
  emits: ["close", "open"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: l, zIndex: r } = Gl(t.id), i = M(() => `v-drawer__container--width-${t.width}`), o = M(() => `v-drawer__container--${t.position}`), u = M(() => t.backdropBlur === "none" ? "" : `v-drawer__backdrop--blur-${t.backdropBlur}`), c = () => {
      l(), a("close");
    }, f = () => {
      t.closeOnBackdrop && c();
    }, p = (d) => {
      t.closeOnEscape && d.key === "Escape" && c();
    };
    return (d, g) => (b(), ue(Pn, { to: "body" }, [
      le(St, {
        name: "v-drawer",
        onAfterEnter: g[1] || (g[1] = (v) => a("open"))
      }, {
        default: ce(() => [
          e.keepAlive || m(s) ? an((b(), $("div", {
            key: 0,
            class: X([u.value, "v-drawer__backdrop"]),
            "data-overlay-open": m(s) || void 0,
            style: Fe({ zIndex: m(r) }),
            onClick: f,
            onKeydown: p
          }, [
            E("div", {
              class: X([[i.value, o.value], "v-drawer__container"]),
              onClick: g[0] || (g[0] = Ve(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || d.$slots.header ? (b(), $("div", ox, [
                Y(d.$slots, "header", {}, () => [
                  e.title ? (b(), $("h3", ux, ie(e.title), 1)) : F("", !0)
                ], !0),
                e.showCloseButton ? (b(), $("button", {
                  key: 0,
                  "aria-label": "Close drawer",
                  class: "v-drawer__close-btn",
                  type: "button",
                  onClick: c
                }, [...g[2] || (g[2] = [
                  E("svg", {
                    fill: "none",
                    height: "24",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    })
                  ], -1)
                ])])) : F("", !0)
              ])) : F("", !0),
              E("div", cx, [
                Y(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer ? (b(), $("div", dx, [
                Y(d.$slots, "footer", {}, void 0, !0)
              ])) : F("", !0)
            ], 2)
          ], 46, ix)), [
            [Wn, e.keepAlive ? m(s) : !0]
          ]) : F("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), jD = /* @__PURE__ */ Ue(fx, [["__scopeId", "data-v-fa565216"]]), hx = { class: "v-floating" }, mx = ["disabled", "onClick"], vx = {
  key: 0,
  class: "v-floating-item-icon"
}, px = { class: "v-floating-item-label" }, gx = 120, yx = /* @__PURE__ */ xe({
  __name: "VFloating",
  props: {
    placement: { default: "bottom-right" },
    teleport: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    offset: { default: 8 },
    openOnHover: { type: Boolean, default: !1 },
    hoverDelay: { default: 200 },
    items: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    closeOnSelect: { type: Boolean, default: !0 },
    unstyled: { type: Boolean, default: !1 },
    contentClass: { default: "" }
  },
  emits: ["select"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, l = ee(!1), r = ee(null), i = ee(null), o = ee({ top: 0, left: 0, right: 0 }), u = ee(!1);
    let c = !1, f = null;
    function p() {
      !l.value || !i.value || c || (c = !0, requestAnimationFrame(() => {
        c = !1, y();
      }));
    }
    const d = M(() => a.items.length > 0), g = M(() => a.disabled), v = M(() => {
      const be = a.placement, q = {
        "v-floating--bottom-left": be === "bottom-left",
        "v-floating--bottom-right": be === "bottom-right",
        "v-floating--top-left": be === "top-left",
        "v-floating--top-right": be === "top-right",
        "v-floating--teleported": a.teleport
      };
      return a.unstyled ? {
        ...q,
        "v-floating--unstyled": !0,
        [a.contentClass]: !!a.contentClass
      } : {
        ...q,
        "v-floating--dropdown": d.value,
        "v-floating--popover": !d.value,
        "v-floating--styled": !0,
        [a.contentClass]: !!a.contentClass
      };
    }), k = M(() => a.teleport ? u.value ? {
      position: "fixed",
      zIndex: "9999",
      top: `${o.value.top}px`,
      left: o.value.left !== void 0 ? `${o.value.left}px` : void 0,
      right: o.value.right !== void 0 ? `${o.value.right}px` : void 0
      // Prevent following scroll by using fixed positioning as-is
      // The dropdown will stay in place relative to viewport, not following the trigger
    } : {} : {}), y = () => {
      if (!(!r.value || !i.value)) {
        if (a.teleport) {
          const be = r.value.getBoundingClientRect(), q = i.value.offsetWidth, ye = i.value.offsetHeight, [Ce, V] = a.placement.split("-"), G = a.offset;
          let he;
          Ce === "bottom" ? he = be.bottom + G : he = be.top - ye - G;
          let j;
          V === "left" ? j = be.left : j = be.right - q, o.value.top = he, o.value.left = j, o.value.right = void 0;
        } else
          o.value.top = 0, o.value.left = 0;
        u.value = !0;
      }
    }, h = () => {
      g.value || (l.value = !l.value, l.value ? (u.value = !1, Ge(() => {
        i.value && r.value && (y(), ge());
      })) : Me());
    }, w = () => {
      l.value && (l.value = !1, u.value = !1, Me());
    }, S = () => {
      g.value || l.value || (l.value = !0, u.value = !1, Ge(() => {
        i.value && r.value && (y(), ge());
      }));
    }, x = typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    let C = null, _ = null;
    const O = () => {
      C && (clearTimeout(C), C = null);
    }, P = () => {
      _ && (clearTimeout(_), _ = null);
    }, D = () => {
      O(), P();
    }, B = () => {
      P(), !l.value && (O(), C = setTimeout(() => {
        C = null, S();
      }, a.hoverDelay));
    }, W = () => {
      D(), _ = setTimeout(() => {
        _ = null, w();
      }, gx);
    }, H = () => {
      !a.openOnHover || !x || B();
    }, te = () => {
      !a.openOnHover || !x || W();
    }, re = () => {
      !a.openOnHover || !x || P();
    }, oe = () => {
      !a.openOnHover || !x || W();
    }, K = () => {
      a.openOnHover && (D(), S());
    }, ae = () => {
      a.openOnHover && (D(), w());
    }, U = (be) => {
      be.disabled || be.loading || (s("select", be.value), a.closeOnSelect && !be.loading && w());
    }, z = (be) => {
      be.key === "Escape" && l.value && w();
    }, J = (be) => {
      if (!a.closeOnClickOutside || !l.value) return;
      const q = be.composedPath(), ye = r.value && q.includes(r.value), Ce = i.value && q.includes(i.value);
      !ye && !Ce && w();
    };
    et(() => {
      document.addEventListener("click", J, !0);
    }), Ps(() => {
      document.removeEventListener("click", J, !0), Me(), D();
    });
    const de = () => {
      !l.value || !a.teleport || p();
    }, pe = () => {
      !l.value || !a.teleport || p();
    };
    function ge() {
      a.teleport && (window.addEventListener("scroll", de, {
        passive: !0,
        capture: !0
      }), window.addEventListener("resize", pe, { passive: !0 }), r.value && (f = new ResizeObserver(() => p()), f.observe(r.value)), document.addEventListener("keydown", z));
    }
    function Me() {
      window.removeEventListener("scroll", de, { capture: !0 }), window.removeEventListener("resize", pe), document.removeEventListener("keydown", z), f && (f.disconnect(), f = null);
    }
    return n({
      isOpen: l,
      open: S,
      close: w,
      toggle: h
    }), (be, q) => (b(), $("div", hx, [
      E("div", {
        ref_key: "triggerRef",
        ref: r,
        class: X([{ "v-floating-trigger--disabled": g.value }, "v-floating-trigger"]),
        onClick: h,
        onFocusin: K,
        onFocusout: ae,
        onMouseenter: H,
        onMouseleave: te
      }, [
        Y(be.$slots, "trigger", {
          isDisabled: g.value,
          isOpen: l.value
        }, void 0, !0)
      ], 34),
      (b(), ue(Pn, {
        disabled: !e.teleport,
        to: "body"
      }, [
        l.value ? (b(), $("div", {
          key: 0,
          ref_key: "floatingRef",
          ref: i,
          class: X([[
            v.value,
            { "v-floating--positioning": !u.value }
          ], "v-floating-content"]),
          style: Fe(k.value),
          onMouseenter: re,
          onMouseleave: oe
        }, [
          Y(be.$slots, "content", { close: w }, () => [
            d.value ? (b(!0), $(Te, { key: 0 }, Ie(e.items, (ye) => (b(), $("button", {
              key: ye.value,
              class: X([{
                "v-floating-item--loading": ye.loading,
                "v-floating-item--active": ye.active,
                "v-floating-item--disabled": ye.disabled
              }, "v-floating-item"]),
              disabled: ye.disabled || ye.loading,
              onClick: (Ce) => U(ye)
            }, [
              Y(be.$slots, "item-icon", { item: ye }, () => [
                ye.icon ? (b(), $("span", vx, [
                  le(we, {
                    icon: ye.icon,
                    loading: ye.loading,
                    size: 16
                  }, null, 8, ["icon", "loading"])
                ])) : F("", !0)
              ], !0),
              E("span", px, ie(ye.label), 1)
            ], 10, mx))), 128)) : F("", !0)
          ], !0)
        ], 38)) : F("", !0)
      ], 8, ["disabled"]))
    ]));
  }
}), Dl = /* @__PURE__ */ Ue(yx, [["__scopeId", "data-v-66563b51"]]), bx = ["data-overlay-open"], wx = {
  key: 0,
  class: "modal-header"
}, kx = {
  key: 0,
  class: "modal-title"
}, xx = { class: "modal-content" }, Sx = {
  key: 1,
  class: "modal-footer"
}, Tx = {
  key: 0,
  class: "modal-footer-actions"
}, $x = /* @__PURE__ */ xe({
  __name: "VModal",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    maxWidth: { default: "md" },
    footerActions: { type: [Boolean, Object], default: void 0 },
    loading: { type: Boolean }
  },
  emits: ["close", "open", "confirm"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: l, zIndex: r } = Gl(t.id), i = M(() => `modal-container--${t.maxWidth}`), o = {
      confirmText: "Confirm",
      cancelText: "Cancel",
      confirmVariant: "primary",
      cancelVariant: "default",
      showConfirm: !0,
      showCancel: !0
    }, u = M(() => t.footerActions ? t.footerActions === !0 ? o : { ...o, ...t.footerActions } : null), c = () => {
      l(), a("close");
    }, f = () => {
      t.closeOnBackdrop && c();
    }, p = (d) => {
      t.closeOnEscape && d.key === "Escape" && c();
    };
    return (d, g) => (b(), ue(Pn, { to: "body" }, [
      le(St, {
        name: "modal",
        onAfterEnter: g[2] || (g[2] = (v) => a("open"))
      }, {
        default: ce(() => [
          m(s) ? (b(), $("div", {
            key: 0,
            "data-overlay-open": m(s) || void 0,
            style: Fe({ zIndex: m(r) }),
            class: "modal-backdrop",
            onClick: f,
            onKeydown: p
          }, [
            E("div", {
              class: X([i.value, "modal-container"]),
              onClick: g[1] || (g[1] = Ve(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || d.$slots.header ? (b(), $("div", wx, [
                Y(d.$slots, "header", {}, () => [
                  e.title ? (b(), $("h3", kx, ie(e.title), 1)) : F("", !0)
                ], !0),
                e.showCloseButton ? (b(), $("button", {
                  key: 0,
                  "aria-label": "Close modal",
                  class: "modal-close-btn",
                  type: "button",
                  onClick: c
                }, [...g[3] || (g[3] = [
                  E("svg", {
                    fill: "none",
                    height: "24",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    })
                  ], -1)
                ])])) : F("", !0)
              ])) : F("", !0),
              E("div", xx, [
                Y(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer || u.value ? (b(), $("div", Sx, [
                Y(d.$slots, "footer", {}, () => [
                  u.value ? (b(), $("div", Tx, [
                    u.value.showCancel ? (b(), ue(Et, {
                      key: 0,
                      disabled: t.loading,
                      variant: u.value.cancelVariant,
                      type: "button",
                      onClick: c
                    }, {
                      default: ce(() => [
                        Ye(ie(u.value.cancelText), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "variant"])) : F("", !0),
                    u.value.showConfirm ? (b(), ue(Et, {
                      key: 1,
                      loading: t.loading,
                      variant: u.value.confirmVariant,
                      type: "button",
                      onClick: g[0] || (g[0] = (v) => a("confirm"))
                    }, {
                      default: ce(() => [
                        Ye(ie(u.value.confirmText), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "variant"])) : F("", !0)
                  ])) : F("", !0)
                ], !0)
              ])) : F("", !0)
            ], 2)
          ], 44, bx)) : F("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), GD = /* @__PURE__ */ Ue($x, [["__scopeId", "data-v-431e5fe3"]]), Mx = (e) => {
  const n = Pu(), t = ee(!0), a = ee(!1), s = ee(null), l = () => t.value && Qe((e == null ? void 0 : e.when) ?? !0);
  Tf((c) => c.meta.requiresAuth === !1 || !l() ? !0 : (a.value = !0, s.value = c, !1)), Be(
    [() => Qe((e == null ? void 0 : e.when) ?? !0), t],
    ([c, f]) => {
      (!c || !f) && a.value && i();
    }
  );
  const r = () => {
    if (!s.value) return;
    const c = s.value;
    t.value = !1, a.value = !1, s.value = null, n.push(c).finally(() => {
      t.value = !0;
    });
  }, i = () => {
    a.value = !1, s.value = null;
  };
  return { isPending: a, pendingTo: s, isEnabled: t, confirm: r, cancel: i, enable: () => {
    t.value = !0;
  }, disable: () => {
    t.value = !1;
  } };
}, Cx = ["aria-label"], Dx = {
  key: 0,
  class: "unsaved-changes__card mx-4 flex w-full max-w-sm overflow-hidden rounded-xl"
}, _x = { class: "flex flex-1 flex-col p-5" }, Ox = { class: "flex items-start gap-3" }, Ex = { class: "min-w-0 flex-1" }, Ix = { class: "mb-1 text-sm font-semibold leading-snug text-mainText" }, Ax = { class: "text-xs leading-relaxed text-secondaryText" }, Px = { class: "mt-4 flex items-center justify-end gap-2 border-t border-base-300 pt-4" }, Rx = /* @__PURE__ */ xe({
  __name: "VUnsavedChangesModal",
  props: {
    open: { type: Boolean, default: !1 },
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" },
    zIndex: { default: 50 }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: n }) {
    const t = n, a = Xe("dialog");
    return Be(() => e.open, (s) => {
      s && Ge(() => {
        var l;
        return (l = a.value) == null ? void 0 : l.focus();
      });
    }), (s, l) => (b(), ue(Pn, { to: "body" }, [
      le(St, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: ce(() => [
          e.open ? (b(), $("div", {
            key: 0,
            ref: "dialog",
            "aria-label": e.title,
            style: Fe({ "--_z-index": e.zIndex }),
            "aria-modal": "true",
            class: "unsaved-changes__backdrop fixed inset-0 flex items-center justify-center",
            role: "dialog",
            tabindex: "-1",
            onClick: l[3] || (l[3] = Ve((r) => t("cancel"), ["self"])),
            onKeydown: l[4] || (l[4] = Pt((r) => t("cancel"), ["esc"]))
          }, [
            le(St, {
              appear: "",
              "enter-active-class": "transition duration-200 ease-out",
              "enter-from-class": "opacity-0 scale-95 -translate-y-2",
              "enter-to-class": "opacity-100 scale-100 translate-y-0",
              "leave-active-class": "transition duration-150 ease-in",
              "leave-from-class": "opacity-100 scale-100 translate-y-0",
              "leave-to-class": "opacity-0 scale-95 -translate-y-2"
            }, {
              default: ce(() => [
                e.open ? (b(), $("div", Dx, [
                  l[7] || (l[7] = E("div", { class: "w-1 flex-shrink-0 bg-gradient-to-b from-warning via-warning/60 to-warning/10" }, null, -1)),
                  E("div", _x, [
                    E("div", Ox, [
                      l[6] || (l[6] = E("div", { class: "mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border border-warning-200 bg-warning-50" }, [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-4 w-4 text-warning",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.2",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" }),
                          E("path", { d: "M12 9v4" }),
                          E("path", { d: "M12 17h.01" })
                        ])
                      ], -1)),
                      E("div", Ex, [
                        E("h2", Ix, ie(e.title), 1),
                        E("div", Ax, [
                          Y(s.$slots, "description", {}, () => [
                            Ye(ie(e.description), 1)
                          ], !0)
                        ])
                      ]),
                      E("button", {
                        "aria-label": "Cancel and keep editing",
                        class: "-mr-1 -mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md text-secondaryText transition-colors hover:bg-base-200",
                        type: "button",
                        onClick: l[0] || (l[0] = (r) => t("cancel"))
                      }, [...l[5] || (l[5] = [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-3.5 w-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "M18 6 6 18M6 6l12 12" })
                        ], -1)
                      ])])
                    ]),
                    E("div", Px, [
                      E("button", {
                        class: "h-8 rounded-md border border-error/25 bg-transparent px-3 text-xs text-error transition-all hover:border-error/40 hover:bg-error/5 active:scale-95",
                        type: "button",
                        onClick: l[1] || (l[1] = (r) => t("confirm"))
                      }, ie(e.leaveLabel), 1),
                      E("button", {
                        class: "h-8 rounded-md border-2 border-primary bg-primary px-4 text-xs text-white shadow-sm transition-all hover:border-primary-dark hover:bg-primary-dark active:scale-95",
                        type: "button",
                        onClick: l[2] || (l[2] = (r) => t("cancel"))
                      }, ie(e.confirmLabel), 1)
                    ])
                  ])
                ])) : F("", !0)
              ]),
              _: 3
            })
          ], 44, Cx)) : F("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Fx = /* @__PURE__ */ Ue(Rx, [["__scopeId", "data-v-4050f9cd"]]), KD = /* @__PURE__ */ xe({
  __name: "NavigationGuardModal",
  props: {
    when: {},
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" }
  },
  setup(e) {
    const { isPending: n, confirm: t, cancel: a } = Mx({ when: () => Qe(e.when) });
    return (s, l) => (b(), ue(Fx, {
      "confirm-label": e.confirmLabel,
      description: e.description,
      "leave-label": e.leaveLabel,
      open: m(n),
      title: e.title,
      onCancel: m(a),
      onConfirm: m(t)
    }, dt({ _: 2 }, [
      s.$slots.description ? {
        name: "description",
        fn: ce(() => [
          Y(s.$slots, "description")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["confirm-label", "description", "leave-label", "open", "title", "onCancel", "onConfirm"]));
  }
}), Vx = { class: "v-meter" }, Lx = ["aria-valuemax", "aria-valuenow"], Nx = /* @__PURE__ */ xe({
  __name: "VMeter",
  props: {
    value: {},
    max: {},
    goal: { default: "reach" },
    label: {},
    hint: {},
    pending: { type: Boolean, default: !1 },
    size: { default: "sm" }
  },
  setup(e) {
    const n = M(() => e.value !== null), t = M(() => e.value === null ? !1 : e.goal === "reach" ? e.value >= e.max : e.value <= e.max), a = M(() => e.value === null || e.max <= 0 ? 0 : Math.min(1, e.value / e.max)), s = M(() => e.value === null ? "Not measured" : `${e.value.toLocaleString("en-US")} / ${e.max.toLocaleString("en-US")}`), l = M(() => n.value ? t.value ? "lucide:circle-check" : "lucide:triangle-alert" : "lucide:circle-help");
    return (r, i) => (b(), $("div", Vx, [
      n.value || e.pending ? (b(), $("div", {
        key: 0,
        class: X([`v-meter__track--${e.size}`, "v-meter__track"])
      }, [
        E("div", {
          "aria-valuemax": e.max,
          "aria-valuenow": e.value ?? void 0,
          class: X([t.value ? "v-meter__fill--met" : "v-meter__fill--unmet", "v-meter__fill"]),
          style: Fe({ "--v-meter-fill": a.value }),
          "aria-valuemin": "0",
          role: "meter"
        }, null, 14, Lx)
      ], 2)) : F("", !0),
      le(Qa, {
        disabled: !e.hint,
        text: e.hint ?? ""
      }, {
        default: ce(() => [
          E("span", {
            class: X([{ "v-meter__value--pending": e.pending, "v-meter__value--help": !!e.hint }, "v-meter__value"])
          }, [
            e.pending ? (b(), ue(we, {
              key: 0,
              loading: !0,
              size: 14,
              icon: "lucide:loading"
            })) : (b(), ue(we, {
              key: 1,
              class: X(n.value ? t.value ? "v-meter__icon--met" : "v-meter__icon--unmet" : ""),
              icon: l.value,
              size: 14
            }, null, 8, ["class", "icon"])),
            Y(r.$slots, "label", {}, () => [
              Ye(ie(e.label ?? s.value), 1)
            ], !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["disabled", "text"])
    ]));
  }
}), ZD = /* @__PURE__ */ Ue(Nx, [["__scopeId", "data-v-f009ff9b"]]), Bx = { class: "v-progress-bar" }, zx = {
  key: 0,
  class: "v-progress-bar__header"
}, Wx = {
  key: 0,
  class: "v-progress-bar__step"
}, Yx = { key: 1 }, Hx = {
  key: 2,
  class: "v-progress-bar__percentage"
}, Ux = {
  key: 0,
  class: "v-progress-bar__shine"
}, qx = /* @__PURE__ */ xe({
  __name: "VProgressBar",
  props: {
    percentage: {},
    step: { default: null },
    size: { default: "md" },
    showPercentage: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = M(() => Math.max(0, Math.min(100, n.percentage))), a = M(() => t.value >= 100), s = M(() => ({ sm: "4px", md: "6px", lg: "8px" })[n.size]);
    return (l, r) => (b(), $("div", Bx, [
      e.step || e.showPercentage ? (b(), $("div", zx, [
        e.step ? (b(), $("span", Wx, ie(e.step), 1)) : (b(), $("span", Yx)),
        e.showPercentage ? (b(), $("div", Hx, [
          E("span", {
            class: X({ "text-success": a.value })
          }, ie(Math.round(t.value)) + "% ", 3),
          a.value ? (b(), ue(we, {
            key: 0,
            size: 14,
            class: "text-success ml-1",
            icon: "lucide:check-circle"
          })) : F("", !0)
        ])) : F("", !0)
      ])) : F("", !0),
      E("div", {
        style: Fe({ height: s.value }),
        class: "v-progress-bar__track"
      }, [
        E("div", {
          class: X([{ "v-progress-bar__fill--completed": a.value }, "v-progress-bar__fill"]),
          style: Fe({ width: `${t.value}%` })
        }, [
          a.value ? F("", !0) : (b(), $("div", Ux))
        ], 6)
      ], 4)
    ]));
  }
}), XD = /* @__PURE__ */ Ue(qx, [["__scopeId", "data-v-d74c8912"]]), jx = ["aria-checked", "aria-label", "title", "onClick"], Gx = /* @__PURE__ */ xe({
  __name: "VThemeToggle",
  props: /* @__PURE__ */ Ht({
    compact: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = En(e, "modelValue"), t = [
      { value: "light", icon: "lucide:sun", label: "Light theme" },
      { value: "dark", icon: "lucide:moon", label: "Dark theme" }
    ], a = (s) => {
      n.value !== s && (n.value = s);
    };
    return (s, l) => (b(), $("div", {
      class: X([{ "theme-toggle--compact": e.compact, "theme-toggle--dark": n.value === "dark" }, "theme-toggle"]),
      "aria-label": "Theme",
      role: "radiogroup"
    }, [
      l[0] || (l[0] = E("span", {
        "aria-hidden": "true",
        class: "theme-toggle__thumb"
      }, null, -1)),
      (b(), $(Te, null, Ie(t, (r) => E("button", {
        key: r.value,
        "aria-checked": n.value === r.value,
        "aria-label": r.label,
        class: X([{ "theme-toggle__option--active": n.value === r.value }, "theme-toggle__option"]),
        title: r.label,
        role: "radio",
        type: "button",
        onClick: (i) => a(r.value)
      }, [
        le(we, {
          icon: r.icon,
          size: 14
        }, null, 8, ["icon"])
      ], 10, jx)), 64))
    ], 2));
  }
}), JD = /* @__PURE__ */ Ue(Gx, [["__scopeId", "data-v-7284576c"]]);
let ti = 1;
var Kx = class {
  constructor() {
    ke(this, "subscribers");
    ke(this, "toasts");
    ke(this, "dismissedToasts");
    ke(this, "subscribe", (e) => (this.subscribers.push(e), () => {
      const n = this.subscribers.indexOf(e);
      this.subscribers.splice(n, 1);
    }));
    ke(this, "publish", (e) => {
      this.subscribers.forEach((n) => n(e));
    });
    ke(this, "addToast", (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    });
    ke(this, "create", (e) => {
      var r;
      const { message: n, ...t } = e, a = typeof e.id == "number" || e.id && ((r = e.id) == null ? void 0 : r.length) > 0 ? e.id : ti++, s = this.toasts.find((i) => i.id === a), l = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), s ? this.toasts = this.toasts.map((i) => i.id === a ? (this.publish({
        ...i,
        ...e,
        id: a,
        title: n
      }), {
        ...i,
        ...e,
        id: a,
        dismissible: l,
        title: n
      }) : i) : this.addToast({
        title: n,
        ...t,
        dismissible: l,
        id: a
      }), a;
    });
    ke(this, "dismiss", (e) => (e ? (this.dismissedToasts.add(e), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: e,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((t) => t({
        id: n.id,
        dismiss: !0
      }));
    }), e));
    ke(this, "message", (e, n) => this.create({
      ...n,
      message: e,
      type: "default"
    }));
    ke(this, "error", (e, n) => this.create({
      ...n,
      type: "error",
      message: e
    }));
    ke(this, "success", (e, n) => this.create({
      ...n,
      type: "success",
      message: e
    }));
    ke(this, "info", (e, n) => this.create({
      ...n,
      type: "info",
      message: e
    }));
    ke(this, "warning", (e, n) => this.create({
      ...n,
      type: "warning",
      message: e
    }));
    ke(this, "loading", (e, n) => this.create({
      ...n,
      type: "loading",
      message: e
    }));
    ke(this, "promise", (e, n) => {
      if (!n) return;
      let t;
      n.loading !== void 0 && (t = this.create({
        ...n,
        promise: e,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const a = Promise.resolve(e instanceof Function ? e() : e);
      let s = t !== void 0, l;
      const r = a.then(async (o) => {
        if (l = ["resolve", o], cs(o))
          s = !1, this.create({
            id: t,
            type: "default",
            message: o
          });
        else if (Xx(o) && !o.ok) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(`HTTP error! status: ${o.status}`) : n.error, f = typeof n.description == "function" ? await n.description(`HTTP error! status: ${o.status}`) : n.description, d = typeof c == "object" && !cs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: f,
            ...d
          });
        } else if (o instanceof Error) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(o) : n.error, f = typeof n.description == "function" ? await n.description(o) : n.description, d = typeof c == "object" && !cs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: f,
            ...d
          });
        } else if (n.success !== void 0) {
          s = !1;
          const c = typeof n.success == "function" ? await n.success(o) : n.success, f = typeof n.description == "function" ? await n.description(o) : n.description, d = typeof c == "object" && !cs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "success",
            description: f,
            ...d
          });
        }
      }).catch(async (o) => {
        if (l = ["reject", o], n.error !== void 0) {
          s = !1;
          const u = typeof n.error == "function" ? await n.error(o) : n.error, c = typeof n.description == "function" ? await n.description(o) : n.description, p = typeof u == "object" && !cs(u) ? u : {
            message: u || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: c,
            ...p
          });
        }
      }).finally(() => {
        var o;
        s && (this.dismiss(t), t = void 0), (o = n.finally) == null || o.call(n);
      }), i = () => new Promise((o, u) => r.then(() => l[0] === "reject" ? u(l[1]) : o(l[1])).catch(u));
      return typeof t != "string" && typeof t != "number" ? { unwrap: i } : Object.assign(t, { unwrap: i });
    });
    ke(this, "custom", (e, n) => {
      const t = (n == null ? void 0 : n.id) || ti++, a = this.toasts.find((l) => l.id === t), s = (n == null ? void 0 : n.dismissible) === void 0 ? !0 : n.dismissible;
      return this.dismissedToasts.has(t) && this.dismissedToasts.delete(t), a ? this.toasts = this.toasts.map((l) => l.id === t ? (this.publish({
        ...l,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), {
        ...l,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }) : l) : this.addToast({
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), t;
    });
    ke(this, "getActiveToasts", () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)));
    this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
};
const Yt = new Kx();
function Zx(e, n) {
  const t = (n == null ? void 0 : n.id) || ti++;
  return Yt.create({
    message: e,
    id: t,
    type: "default",
    ...n
  }), t;
}
const Xx = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", Jx = Zx, Qx = () => Yt.toasts, eS = () => Yt.getActiveToasts(), ca = Object.assign(Jx, {
  success: Yt.success,
  info: Yt.info,
  warning: Yt.warning,
  error: Yt.error,
  custom: Yt.custom,
  message: Yt.message,
  promise: Yt.promise,
  dismiss: Yt.dismiss,
  loading: Yt.loading
}, {
  getHistory: Qx,
  getToasts: eS
});
function ol(e) {
  return e.label !== void 0;
}
const tS = 3, Zd = "24px", Xd = "16px", du = 4e3, nS = 356, aS = 14, sS = 45, Jd = 200;
function lS() {
  const e = ee(!1);
  return Gt(() => {
    const n = () => {
      e.value = document.hidden;
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }), { isDocumentHidden: e };
}
function Xn(...e) {
  return e.filter(Boolean).join(" ");
}
function rS(e) {
  const [n, t] = e.split("-"), a = [];
  return n && a.push(n), t && a.push(t), a;
}
function iS(e, n) {
  const t = {};
  return [e, n].forEach((a, s) => {
    const l = s === 1, r = l ? "--mobile-offset" : "--offset", i = l ? Xd : Zd;
    function o(u) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((c) => {
        t[`${r}-${c}`] = typeof u == "number" ? `${u}px` : u;
      });
    }
    typeof a == "number" || typeof a == "string" ? o(a) : typeof a == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((u) => {
      a[u] === void 0 ? t[`${r}-${u}`] = i : t[`${r}-${u}`] = typeof a[u] == "number" ? `${a[u]}px` : a[u];
    }) : o(i);
  }), t;
}
const oS = [
  "data-rich-colors",
  "data-styled",
  "data-mounted",
  "data-promise",
  "data-swiped",
  "data-removed",
  "data-visible",
  "data-y-position",
  "data-x-position",
  "data-index",
  "data-front",
  "data-swiping",
  "data-dismissible",
  "data-type",
  "data-invert",
  "data-swipe-out",
  "data-swipe-direction",
  "data-expanded",
  "data-testid"
], uS = [
  "aria-label",
  "data-disabled",
  "data-close-button-position"
];
var cS = /* @__PURE__ */ xe({
  __name: "Toast",
  props: {
    toast: {},
    toasts: {},
    index: {},
    swipeDirections: {},
    expanded: { type: Boolean },
    invert: { type: Boolean },
    heights: {},
    gap: {},
    position: {},
    closeButtonPosition: {},
    visibleToasts: {},
    expandByDefault: { type: Boolean },
    closeButton: { type: Boolean },
    interacting: { type: Boolean },
    style: {},
    cancelButtonStyle: {},
    actionButtonStyle: {},
    duration: {},
    class: {},
    unstyled: { type: Boolean },
    descriptionClass: {},
    loadingIcon: {},
    classes: {},
    icons: {},
    closeButtonAriaLabel: {},
    defaultRichColors: { type: Boolean }
  },
  emits: [
    "update:heights",
    "update:height",
    "removeToast"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(null), l = ee(null), r = ee(!1), i = ee(!1), o = ee(!1), u = ee(!1), c = ee(!1), f = ee(0), p = ee(0), d = ee(t.toast.duration || t.duration || du), g = ee(null), v = ee(null), k = M(() => t.index === 0), y = M(() => t.index + 1 <= t.visibleToasts), h = M(() => t.toast.type), w = M(() => t.toast.dismissible !== !1), S = M(() => t.toast.class || ""), x = M(() => t.descriptionClass || ""), C = M(() => {
      const q = t.toast.position || t.position, Ce = t.heights.filter((V) => V.position === q).findIndex((V) => V.toastId === t.toast.id);
      return Ce >= 0 ? Ce : 0;
    }), _ = M(() => {
      const q = t.toast.position || t.position;
      return t.heights.filter((Ce) => Ce.position === q).reduce((Ce, V, G) => G >= C.value ? Ce : Ce + V.height, 0);
    }), O = M(() => C.value * t.gap + _.value || 0), P = M(() => t.toast.closeButton ?? t.closeButton), D = M(() => t.toast.duration || t.duration || du), B = ee(0), W = ee(0), H = ee(null), te = M(() => t.position.split("-")), re = M(() => te.value[0]), oe = M(() => te.value[1]), K = M(() => typeof t.toast.title != "string"), ae = M(() => typeof t.toast.description != "string"), { isDocumentHidden: U } = lS(), z = M(() => h.value && h.value === "loading");
    et(() => {
      r.value = !0, d.value = D.value;
    }), Gt(async () => {
      if (!r.value || !v.value) return;
      await Ge();
      const q = v.value, ye = q.style.height;
      q.style.height = "auto";
      const Ce = q.getBoundingClientRect().height;
      q.style.height = ye, p.value = Ce, a("update:height", {
        toastId: t.toast.id,
        height: Ce,
        position: t.toast.position || t.position
      });
    });
    function J() {
      i.value = !0, f.value = O.value, setTimeout(() => {
        a("removeToast", t.toast);
      }, Jd);
    }
    function de() {
      var q, ye;
      if (z.value || !w.value) return {};
      J(), (ye = (q = t.toast).onDismiss) == null || ye.call(q, t.toast);
    }
    function pe(q) {
      q.button !== 2 && (z.value || !w.value || (g.value = /* @__PURE__ */ new Date(), f.value = O.value, q.target.setPointerCapture(q.pointerId), q.target.tagName !== "BUTTON" && (o.value = !0, H.value = {
        x: q.clientX,
        y: q.clientY
      })));
    }
    function ge() {
      var he, j, se, me, I, N, T;
      if (u.value || !w.value) return;
      H.value = null;
      const q = Number(((he = v.value) == null ? void 0 : he.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), ye = Number(((j = v.value) == null ? void 0 : j.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Ce = (/* @__PURE__ */ new Date()).getTime() - (((se = g.value) == null ? void 0 : se.getTime()) || 0), V = s.value === "x" ? q : ye, G = Math.abs(V) / Ce;
      if (Math.abs(V) >= sS || G > 0.11) {
        f.value = O.value, (I = (me = t.toast).onDismiss) == null || I.call(me, t.toast), s.value === "x" ? l.value = q > 0 ? "right" : "left" : l.value = ye > 0 ? "down" : "up", J(), u.value = !0;
        return;
      } else
        (N = v.value) == null || N.style.setProperty("--swipe-amount-x", "0px"), (T = v.value) == null || T.style.setProperty("--swipe-amount-y", "0px");
      c.value = !1, o.value = !1, s.value = null;
    }
    function Me(q) {
      var se, me, I, N;
      if (!H.value || !w.value || (((me = (se = window == null ? void 0 : window.getSelection()) == null ? void 0 : se.toString()) == null ? void 0 : me.length) ?? !1)) return;
      const Ce = q.clientY - H.value.y, V = q.clientX - H.value.x, G = t.swipeDirections ?? rS(t.position);
      !s.value && (Math.abs(V) > 1 || Math.abs(Ce) > 1) && (s.value = Math.abs(V) > Math.abs(Ce) ? "x" : "y");
      let he = {
        x: 0,
        y: 0
      };
      const j = (T) => 1 / (1.5 + Math.abs(T) / 20);
      if (s.value === "y") {
        if (G.includes("top") || G.includes("bottom")) if (G.includes("top") && Ce < 0 || G.includes("bottom") && Ce > 0) he.y = Ce;
        else {
          const T = Ce * j(Ce);
          he.y = Math.abs(T) < Math.abs(Ce) ? T : Ce;
        }
      } else if (s.value === "x" && (G.includes("left") || G.includes("right")))
        if (G.includes("left") && V < 0 || G.includes("right") && V > 0) he.x = V;
        else {
          const T = V * j(V);
          he.x = Math.abs(T) < Math.abs(V) ? T : V;
        }
      (Math.abs(he.x) > 0 || Math.abs(he.y) > 0) && (c.value = !0), (I = v.value) == null || I.style.setProperty("--swipe-amount-x", `${he.x}px`), (N = v.value) == null || N.style.setProperty("--swipe-amount-y", `${he.y}px`);
    }
    et(() => {
      if (r.value = !0, !v.value) return;
      const q = v.value.getBoundingClientRect().height;
      p.value = q;
      const ye = [{
        toastId: t.toast.id,
        height: q,
        position: t.toast.position
      }, ...t.heights];
      a("update:heights", ye);
    }), Ps(() => {
      v.value && a("removeToast", t.toast);
    }), Gt((q) => {
      if (t.toast.promise && h.value === "loading" || t.toast.duration === 1 / 0 || t.toast.type === "loading") return;
      let ye;
      const Ce = () => {
        if (W.value < B.value) {
          const G = (/* @__PURE__ */ new Date()).getTime() - B.value;
          d.value = d.value - G;
        }
        W.value = (/* @__PURE__ */ new Date()).getTime();
      }, V = () => {
        d.value !== 1 / 0 && (B.value = (/* @__PURE__ */ new Date()).getTime(), ye = setTimeout(() => {
          var G, he;
          (he = (G = t.toast).onAutoClose) == null || he.call(G, t.toast), J();
        }, d.value));
      };
      t.expanded || t.interacting || U.value ? Ce() : V(), q(() => {
        clearTimeout(ye);
      });
    }), Be(() => t.toast.delete, (q) => {
      var ye, Ce;
      q !== void 0 && q && (J(), (Ce = (ye = t.toast).onDismiss) == null || Ce.call(ye, t.toast));
    }, { deep: !0 });
    function be() {
      o.value = !1, s.value = null, H.value = null;
    }
    return (q, ye) => {
      var Ce, V, G, he, j, se, me, I, N, T, R, A, Z, L, fe, $e, Re, _e, We, Rt, un, cn, Fn, At, Wt, Vn, xn;
      return b(), $("li", {
        tabindex: "0",
        ref_key: "toastRef",
        ref: v,
        class: X(m(Xn)(t.class, S.value, (Ce = q.classes) == null ? void 0 : Ce.toast, (V = q.toast.classes) == null ? void 0 : V.toast, (G = q.classes) == null ? void 0 : G[h.value], (j = (he = q.toast) == null ? void 0 : he.classes) == null ? void 0 : j[h.value])),
        "data-sonner-toast": "",
        "data-rich-colors": q.toast.richColors ?? q.defaultRichColors,
        "data-styled": !(q.toast.component || (se = q.toast) != null && se.unstyled || q.unstyled),
        "data-mounted": r.value,
        "data-promise": !!q.toast.promise,
        "data-swiped": c.value,
        "data-removed": i.value,
        "data-visible": y.value,
        "data-y-position": re.value,
        "data-x-position": oe.value,
        "data-index": q.index,
        "data-front": k.value,
        "data-swiping": o.value,
        "data-dismissible": w.value,
        "data-type": h.value,
        "data-invert": q.toast.invert || q.invert,
        "data-swipe-out": u.value,
        "data-swipe-direction": l.value,
        "data-expanded": !!(q.expanded || q.expandByDefault && r.value),
        "data-testid": q.toast.testId,
        style: Fe({
          "--index": q.index,
          "--toasts-before": q.index,
          "--z-index": q.toasts.length - q.index,
          "--offset": `${i.value ? f.value : O.value}px`,
          "--initial-height": q.expandByDefault ? "auto" : `${p.value}px`,
          ...q.style,
          ...t.toast.style
        }),
        onDragend: be,
        onPointerdown: pe,
        onPointerup: ge,
        onPointermove: Me
      }, [P.value && !q.toast.component && h.value !== "loading" ? (b(), $("button", {
        key: 0,
        "aria-label": q.closeButtonAriaLabel || "Close toast",
        "data-disabled": z.value,
        "data-close-button": "true",
        "data-close-button-position": q.closeButtonPosition,
        class: X(m(Xn)((me = q.classes) == null ? void 0 : me.closeButton, (N = (I = q.toast) == null ? void 0 : I.classes) == null ? void 0 : N.closeButton)),
        onClick: de
      }, [(T = q.icons) != null && T.close ? (b(), ue(ht((R = q.icons) == null ? void 0 : R.close), { key: 0 })) : Y(q.$slots, "close-icon", { key: 1 })], 10, uS)) : F("v-if", !0), q.toast.component ? (b(), ue(ht(q.toast.component), lt({ key: 1 }, q.toast.componentProps, {
        onCloseToast: de,
        isPaused: q.$props.expanded || q.$props.interacting || m(U)
      }), null, 16, ["isPaused"])) : (b(), $(Te, { key: 2 }, [
        h.value !== "default" || q.toast.icon || q.toast.promise ? (b(), $("div", {
          key: 0,
          "data-icon": "",
          class: X(m(Xn)((A = q.classes) == null ? void 0 : A.icon, (L = (Z = q.toast) == null ? void 0 : Z.classes) == null ? void 0 : L.icon))
        }, [q.toast.icon ? (b(), ue(ht(q.toast.icon), { key: 0 })) : (b(), $(Te, { key: 1 }, [h.value === "loading" ? Y(q.$slots, "loading-icon", { key: 0 }) : h.value === "success" ? Y(q.$slots, "success-icon", { key: 1 }) : h.value === "error" ? Y(q.$slots, "error-icon", { key: 2 }) : h.value === "warning" ? Y(q.$slots, "warning-icon", { key: 3 }) : h.value === "info" ? Y(q.$slots, "info-icon", { key: 4 }) : F("v-if", !0)], 64))], 2)) : F("v-if", !0),
        E("div", {
          "data-content": "",
          class: X(m(Xn)((fe = q.classes) == null ? void 0 : fe.content, (Re = ($e = q.toast) == null ? void 0 : $e.classes) == null ? void 0 : Re.content))
        }, [E("div", {
          "data-title": "",
          class: X(m(Xn)((_e = q.classes) == null ? void 0 : _e.title, (We = q.toast.classes) == null ? void 0 : We.title))
        }, [K.value ? (b(), ue(ht(q.toast.title), Ct(lt({ key: 0 }, q.toast.componentProps)), null, 16)) : (b(), $(Te, { key: 1 }, [Ye(ie(q.toast.title), 1)], 64))], 2), q.toast.description ? (b(), $("div", {
          key: 0,
          "data-description": "",
          class: X(m(Xn)(q.descriptionClass, x.value, (Rt = q.classes) == null ? void 0 : Rt.description, (un = q.toast.classes) == null ? void 0 : un.description))
        }, [ae.value ? (b(), ue(ht(q.toast.description), Ct(lt({ key: 0 }, q.toast.componentProps)), null, 16)) : (b(), $(Te, { key: 1 }, [Ye(ie(q.toast.description), 1)], 64))], 2)) : F("v-if", !0)], 2),
        q.toast.cancel ? (b(), $("button", {
          key: 1,
          style: Fe(q.toast.cancelButtonStyle || q.cancelButtonStyle),
          class: X(m(Xn)((cn = q.classes) == null ? void 0 : cn.cancelButton, (Fn = q.toast.classes) == null ? void 0 : Fn.cancelButton)),
          "data-button": "",
          "data-cancel": "",
          onClick: ye[0] || (ye[0] = (Tt) => {
            var $t, yt;
            m(ol)(q.toast.cancel) && w.value && ((yt = ($t = q.toast.cancel).onClick) == null || yt.call($t, Tt), J());
          })
        }, ie(m(ol)(q.toast.cancel) ? (At = q.toast.cancel) == null ? void 0 : At.label : q.toast.cancel), 7)) : F("v-if", !0),
        q.toast.action ? (b(), $("button", {
          key: 2,
          style: Fe(q.toast.actionButtonStyle || q.actionButtonStyle),
          class: X(m(Xn)((Wt = q.classes) == null ? void 0 : Wt.actionButton, (Vn = q.toast.classes) == null ? void 0 : Vn.actionButton)),
          "data-button": "",
          "data-action": "",
          onClick: ye[1] || (ye[1] = (Tt) => {
            var $t, yt;
            m(ol)(q.toast.action) && ((yt = ($t = q.toast.action).onClick) == null || yt.call($t, Tt), !Tt.defaultPrevented && J());
          })
        }, ie(m(ol)(q.toast.action) ? (xn = q.toast.action) == null ? void 0 : xn.label : q.toast.action), 7)) : F("v-if", !0)
      ], 64))], 46, oS);
    };
  }
}), dS = cS, Gs = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n) t[a] = s;
  return t;
};
const fS = {}, hS = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stoke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function mS(e, n) {
  return b(), $("svg", hS, n[0] || (n[0] = [E("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }, null, -1), E("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }, null, -1)]));
}
var vS = /* @__PURE__ */ Gs(fS, [["render", mS]]);
const pS = ["data-visible"], gS = { class: "sonner-spinner" };
var yS = /* @__PURE__ */ xe({
  __name: "Loader",
  props: { visible: { type: Boolean } },
  setup(e) {
    const n = Array(12).fill(0);
    return (t, a) => (b(), $("div", {
      class: "sonner-loading-wrapper",
      "data-visible": t.visible
    }, [E("div", gS, [(b(!0), $(Te, null, Ie(m(n), (s) => (b(), $("div", {
      key: `spinner-bar-${s}`,
      class: "sonner-loading-bar"
    }))), 128))])], 8, pS));
  }
}), bS = yS;
const wS = {}, kS = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function xS(e, n) {
  return b(), $("svg", kS, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var SS = /* @__PURE__ */ Gs(wS, [["render", xS]]);
const TS = {}, $S = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function MS(e, n) {
  return b(), $("svg", $S, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var CS = /* @__PURE__ */ Gs(TS, [["render", MS]]);
const DS = {}, _S = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function OS(e, n) {
  return b(), $("svg", _S, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var ES = /* @__PURE__ */ Gs(DS, [["render", OS]]);
const IS = {}, AS = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function PS(e, n) {
  return b(), $("svg", AS, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var RS = /* @__PURE__ */ Gs(IS, [["render", PS]]);
const FS = ["aria-label"], VS = [
  "data-sonner-theme",
  "dir",
  "data-theme",
  "data-rich-colors",
  "data-y-position",
  "data-x-position"
], LS = typeof window < "u" && typeof document < "u";
function NS() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
var BS = /* @__PURE__ */ xe({
  name: "Toaster",
  inheritAttrs: !1,
  __name: "Toaster",
  props: {
    id: {},
    invert: {
      type: Boolean,
      default: !1
    },
    theme: { default: "light" },
    position: { default: "bottom-right" },
    closeButtonPosition: { default: "top-left" },
    hotkey: { default: () => ["altKey", "KeyT"] },
    richColors: {
      type: Boolean,
      default: !1
    },
    expand: {
      type: Boolean,
      default: !1
    },
    duration: {},
    gap: { default: aS },
    visibleToasts: { default: tS },
    closeButton: {
      type: Boolean,
      default: !1
    },
    toastOptions: { default: () => ({}) },
    class: { default: "" },
    style: {},
    offset: { default: Zd },
    mobileOffset: { default: Xd },
    dir: { default: "auto" },
    swipeDirections: {},
    icons: {},
    containerAriaLabel: { default: "Notifications" }
  },
  setup(e) {
    const n = e, t = li(), a = ee([]), s = M(() => n.id ? a.value.filter((D) => D.toasterId === n.id) : a.value.filter((D) => !D.toasterId));
    function l(D, B) {
      return s.value.filter((W) => !W.position && B === 0 || W.position === D);
    }
    const r = M(() => {
      const D = s.value.filter((B) => B.position).map((B) => B.position);
      return D.length > 0 ? Array.from(new Set([n.position].concat(D))) : [n.position];
    }), i = M(() => {
      const D = {};
      return r.value.forEach((B) => {
        D[B] = a.value.filter((W) => W.position === B);
      }), D;
    }), o = ee([]), u = ee({}), c = ee(!1);
    Gt(() => {
      r.value.forEach((D) => {
        D in u.value || (u.value[D] = !1);
      });
    });
    const f = ee(n.theme !== "system" ? n.theme : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), p = ee(null), d = ee(null), g = ee(!1), v = n.hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    function k(D) {
      var B;
      (B = a.value.find((W) => W.id === D.id)) != null && B.delete || Yt.dismiss(D.id), a.value = a.value.filter(({ id: W }) => W !== D.id), setTimeout(() => {
        a.value.find((W) => W.id === D.id) || (o.value = o.value.filter((W) => W.toastId !== D.id));
      }, Jd + 50);
    }
    function y(D) {
      var B, W;
      g.value && !((W = (B = D.currentTarget) == null ? void 0 : B.contains) != null && W.call(B, D.relatedTarget)) && (g.value = !1, d.value && (d.value.focus({ preventScroll: !0 }), d.value = null));
    }
    function h(D) {
      D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || g.value || (g.value = !0, d.value = D.relatedTarget);
    }
    function w(D) {
      D.target && D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || (c.value = !0);
    }
    Gt((D) => {
      const B = Yt.subscribe((W) => {
        if (W.dismiss) {
          requestAnimationFrame(() => {
            a.value = a.value.map((H) => H.id === W.id ? {
              ...H,
              delete: !0
            } : H);
          });
          return;
        }
        Ge(() => {
          const H = a.value.findIndex((te) => te.id === W.id);
          H !== -1 ? a.value = [
            ...a.value.slice(0, H),
            {
              ...a.value[H],
              ...W
            },
            ...a.value.slice(H + 1)
          ] : a.value = [W, ...a.value];
        });
      });
      D(B);
    }), Gt((D) => {
      if (typeof window > "u") return;
      if (n.theme !== "system") {
        f.value = n.theme;
        return;
      }
      const B = window.matchMedia("(prefers-color-scheme: dark)"), W = (te) => {
        f.value = te ? "dark" : "light";
      };
      W(B.matches);
      const H = (te) => {
        W(te.matches);
      };
      try {
        B.addEventListener("change", H);
      } catch {
        B.addListener(H);
      }
      D(() => {
        try {
          B.removeEventListener("change", H);
        } catch {
          B.removeListener(H);
        }
      });
    }), Gt(() => {
      p.value && d.value && (d.value.focus({ preventScroll: !0 }), d.value = null, g.value = !1);
    }), Gt(() => {
      a.value.length <= 1 && Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }), Gt((D) => {
      function B(W) {
        const H = n.hotkey.every((oe) => W[oe] || W.code === oe), te = Array.isArray(p.value) ? p.value[0] : p.value;
        H && (r.value.forEach((oe) => {
          u.value[oe] = !0;
        }), te == null || te.focus());
        const re = document.activeElement === p.value || (te == null ? void 0 : te.contains(document.activeElement));
        W.code === "Escape" && re && r.value.forEach((oe) => {
          u.value[oe] = !1;
        });
      }
      LS && (document.addEventListener("keydown", B), D(() => {
        document.removeEventListener("keydown", B);
      }));
    });
    function S(D) {
      const B = D.currentTarget, W = B.getAttribute("data-y-position") + "-" + B.getAttribute("data-x-position");
      u.value[W] = !0;
    }
    function x(D) {
      if (!c.value) {
        const B = D.currentTarget, W = B.getAttribute("data-y-position") + "-" + B.getAttribute("data-x-position");
        u.value[W] = !1;
      }
    }
    function C() {
      Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }
    function _() {
      c.value = !1;
    }
    function O(D) {
      o.value = D;
    }
    function P(D) {
      const B = o.value.findIndex((W) => W.toastId === D.toastId);
      if (B !== -1) o.value[B] = D;
      else {
        const W = o.value.findIndex((H) => H.position === D.position);
        W !== -1 ? o.value.splice(W, 0, D) : o.value.unshift(D);
      }
    }
    return (D, B) => (b(), $(Te, null, [F(" Remove item from normal navigation flow, only available via hotkey "), E("section", {
      "aria-label": `${D.containerAriaLabel} ${m(v)}`,
      tabIndex: -1,
      "aria-live": "polite",
      "aria-relevant": "additions text",
      "aria-atomic": "false"
    }, [(b(!0), $(Te, null, Ie(r.value, (W, H) => {
      var te;
      return b(), $("ol", lt({
        key: W,
        ref_for: !0,
        ref_key: "listRef",
        ref: p,
        "data-sonner-toaster": "",
        "data-sonner-theme": f.value,
        class: n.class,
        dir: D.dir === "auto" ? NS() : D.dir,
        tabIndex: -1,
        "data-theme": D.theme,
        "data-rich-colors": D.richColors,
        "data-y-position": W.split("-")[0],
        "data-x-position": W.split("-")[1],
        style: {
          "--front-toast-height": `${((te = o.value[0]) == null ? void 0 : te.height) || 0}px`,
          "--width": `${m(nS)}px`,
          "--gap": `${D.gap}px`,
          ...D.style,
          ...m(t).style,
          ...m(iS)(D.offset, D.mobileOffset)
        }
      }, { ref_for: !0 }, D.$attrs, {
        onBlur: y,
        onFocus: h,
        onMouseenter: S,
        onMousemove: S,
        onMouseleave: x,
        onDragend: C,
        onPointerdown: w,
        onPointerup: _
      }), [(b(!0), $(Te, null, Ie(l(W, H), (re, oe) => {
        var K, ae, U, z, J, de, pe, ge, Me, be, q;
        return b(), ue(dS, {
          key: re.id,
          heights: o.value,
          icons: D.icons,
          index: oe,
          toast: re,
          defaultRichColors: D.richColors,
          duration: ((K = D.toastOptions) == null ? void 0 : K.duration) ?? D.duration,
          class: X(((ae = D.toastOptions) == null ? void 0 : ae.class) ?? ""),
          descriptionClass: (U = D.toastOptions) == null ? void 0 : U.descriptionClass,
          invert: D.invert,
          visibleToasts: D.visibleToasts,
          closeButton: ((z = D.toastOptions) == null ? void 0 : z.closeButton) ?? D.closeButton,
          interacting: c.value,
          position: W,
          closeButtonPosition: ((J = D.toastOptions) == null ? void 0 : J.closeButtonPosition) ?? D.closeButtonPosition,
          style: Fe((de = D.toastOptions) == null ? void 0 : de.style),
          unstyled: (pe = D.toastOptions) == null ? void 0 : pe.unstyled,
          classes: (ge = D.toastOptions) == null ? void 0 : ge.classes,
          cancelButtonStyle: (Me = D.toastOptions) == null ? void 0 : Me.cancelButtonStyle,
          actionButtonStyle: (be = D.toastOptions) == null ? void 0 : be.actionButtonStyle,
          "close-button-aria-label": (q = D.toastOptions) == null ? void 0 : q.closeButtonAriaLabel,
          toasts: i.value[W],
          expandByDefault: D.expand,
          gap: D.gap,
          expanded: u.value[W] || !1,
          swipeDirections: n.swipeDirections,
          "onUpdate:heights": O,
          "onUpdate:height": P,
          onRemoveToast: k
        }, {
          "close-icon": ce(() => [Y(D.$slots, "close-icon", {}, () => [le(vS)])]),
          "loading-icon": ce(() => [Y(D.$slots, "loading-icon", {}, () => [le(bS, { visible: re.type === "loading" }, null, 8, ["visible"])])]),
          "success-icon": ce(() => [Y(D.$slots, "success-icon", {}, () => [le(SS)])]),
          "error-icon": ce(() => [Y(D.$slots, "error-icon", {}, () => [le(RS)])]),
          "warning-icon": ce(() => [Y(D.$slots, "warning-icon", {}, () => [le(ES)])]),
          "info-icon": ce(() => [Y(D.$slots, "info-icon", {}, () => [le(CS)])]),
          _: 2
        }, 1032, [
          "heights",
          "icons",
          "index",
          "toast",
          "defaultRichColors",
          "duration",
          "class",
          "descriptionClass",
          "invert",
          "visibleToasts",
          "closeButton",
          "interacting",
          "position",
          "closeButtonPosition",
          "style",
          "unstyled",
          "classes",
          "cancelButtonStyle",
          "actionButtonStyle",
          "close-button-aria-label",
          "toasts",
          "expandByDefault",
          "gap",
          "expanded",
          "swipeDirections"
        ]);
      }), 128))], 16, VS);
    }), 128))], 8, FS)], 2112));
  }
}), zS = BS;
const WS = /* @__PURE__ */ xe({
  __name: "VToaster",
  setup(e) {
    const n = Nd(), t = M(() => n.resolvedTheme);
    return (a, s) => (b(), ue(m(zS), {
      duration: 4e3,
      theme: t.value,
      "toast-options": {
        unstyled: !0,
        classes: {
          toast: "toast-custom",
          title: "toast-title",
          description: "toast-description",
          actionButton: "toast-action",
          cancelButton: "toast-cancel",
          closeButton: "toast-close",
          error: "toast-error",
          success: "toast-success",
          warning: "toast-warning",
          info: "toast-info"
        }
      },
      "close-button": "",
      position: "top-right"
    }, null, 8, ["theme"]));
  }
}), QD = /* @__PURE__ */ Ue(WS, [["__scopeId", "data-v-9305e752"]]), YS = ["id"], HS = ["id", "aria-controls", "aria-expanded", "disabled", "onClick"], US = { class: "v-expansion-panel-header__content" }, qS = { class: "v-expansion-panel-title" }, jS = {
  key: 0,
  class: "v-expansion-panel-subtitle"
}, GS = { class: "v-expansion-panel-header__icon-wrapper" }, KS = ["id", "aria-hidden", "aria-labelledby"], ZS = { class: "v-expansion-panel-content__wrap" }, XS = { class: "v-expansion-panel-text" }, JS = /* @__PURE__ */ xe({
  __name: "VAccordion",
  props: /* @__PURE__ */ Ht({
    items: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    flat: { type: Boolean, default: !1 },
    accordion: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: () => [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ht(["change"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = n, s = As(), l = En(e, "modelValue"), r = (u) => l.value.includes(u), i = (u) => {
      l.value = u, a("change", u);
    }, o = (u, c) => {
      if (t.disabled || c) return;
      const f = r(u);
      if (t.accordion || !t.multiple) {
        i(f ? [] : [u]);
        return;
      }
      i(
        f ? l.value.filter((p) => p !== u) : [...l.value, u]
      );
    };
    return et(() => {
      if (l.value.length) return;
      const u = t.items.filter((c) => c.defaultOpen).map((c) => c.id);
      u.length && (l.value = t.accordion || !t.multiple ? [u[0]] : u);
    }), (u, c) => (b(), $("div", {
      id: m(s),
      class: X([[
        `v-expansion-panels--${e.variant}`,
        {
          "v-expansion-panels--flat": e.flat,
          "v-expansion-panels--disabled": e.disabled
        }
      ], "v-expansion-panels"])
    }, [
      (b(!0), $(Te, null, Ie(e.items, (f, p) => (b(), $("div", {
        key: f.id,
        class: X([{
          "v-expansion-panel--active": r(f.id),
          "v-expansion-panel--disabled": f.disabled || e.disabled
        }, "v-expansion-panel"])
      }, [
        E("button", {
          id: `${m(s)}-header-${f.id}`,
          "aria-controls": `${m(s)}-content-${f.id}`,
          "aria-expanded": r(f.id),
          disabled: f.disabled || e.disabled,
          class: "v-expansion-panel-header",
          type: "button",
          onClick: (d) => o(f.id, f.disabled)
        }, [
          Y(u.$slots, `header-${f.id}`, {
            index: p,
            isOpen: r(f.id),
            item: f
          }, () => [
            Y(u.$slots, "header", {
              index: p,
              isOpen: r(f.id),
              item: f
            }, () => [
              f.icon ? (b(), ue(we, {
                key: 0,
                icon: f.icon,
                class: "v-expansion-panel-header__icon"
              }, null, 8, ["icon"])) : F("", !0),
              E("div", US, [
                E("div", qS, ie(f.title), 1),
                f.subtitle ? (b(), $("div", jS, ie(f.subtitle), 1)) : F("", !0)
              ]),
              E("div", GS, [
                le(we, {
                  class: X(
                    r(f.id) ? "v-expansion-panel-header__expand-icon v-expansion-panel-header__expand-icon--active" : "v-expansion-panel-header__expand-icon"
                  ),
                  icon: "mdi:chevron-down"
                }, null, 8, ["class"])
              ])
            ], !0)
          ], !0)
        ], 8, HS),
        E("div", {
          id: `${m(s)}-content-${f.id}`,
          "aria-hidden": !r(f.id),
          "aria-labelledby": `${m(s)}-header-${f.id}`,
          class: "v-expansion-panel-content",
          role: "region"
        }, [
          E("div", ZS, [
            Y(u.$slots, `content-${f.id}`, {
              index: p,
              item: f
            }, () => [
              Y(u.$slots, "content", {
                index: p,
                item: f
              }, () => [
                E("div", XS, ie(f.content), 1)
              ], !0)
            ], !0)
          ])
        ], 8, KS)
      ], 2))), 128))
    ], 10, YS));
  }
}), e2 = /* @__PURE__ */ Ue(JS, [["__scopeId", "data-v-e6564450"]]), t2 = /* @__PURE__ */ xe({
  __name: "VAnimatedBackground",
  setup(e) {
    const n = ee(null);
    let t, a = null;
    const s = [], l = (i) => {
      s.length = 0;
      const o = [
        "rgba(37, 99, 235, 0.3)",
        // primary
        "rgba(251, 191, 36, 0.3)",
        // accent
        "rgba(14, 165, 233, 0.3)",
        // info
        "rgba(34, 197, 94, 0.3)"
        // success
      ];
      for (let u = 0; u < 15; u++)
        s.push({
          x: Math.random() * i.width,
          y: Math.random() * i.height,
          radius: Math.random() * 200 + 100,
          vx: Math.random() - 0.5,
          vy: Math.random() - 0.5,
          color: o[u % o.length]
        });
    }, r = (i, o) => {
      o.clearRect(0, 0, i.width, i.height), s.forEach((u) => {
        u.x += u.vx, u.y += u.vy, (u.x < -u.radius || u.x > i.width + u.radius) && (u.vx *= -1), (u.y < -u.radius || u.y > i.height + u.radius) && (u.vy *= -1);
        const c = o.createRadialGradient(
          u.x,
          u.y,
          0,
          u.x,
          u.y,
          u.radius * 0.7
        ), f = u.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (f) {
          const [, p, d, g] = f;
          c.addColorStop(0, `rgba(${p}, ${d}, ${g}, 0.5)`), c.addColorStop(0.5, `rgba(${p}, ${d}, ${g}, 0.25)`), c.addColorStop(1, `rgba(${p}, ${d}, ${g}, 0)`);
        }
        o.fillStyle = c, o.beginPath(), o.arc(u.x, u.y, u.radius, 0, Math.PI * 2), o.fill();
      }), t = requestAnimationFrame(() => r(i, o));
    };
    return et(() => {
      const i = n.value;
      if (!i) return;
      const o = i.getContext("2d");
      if (!o) return;
      const u = () => {
        i && (i.width = window.innerWidth, i.height = window.innerHeight, s.length === 0 && l(i));
      };
      a = u, u(), window.addEventListener("resize", u), r(i, o);
    }), Jt(() => {
      a && window.removeEventListener("resize", a), t && cancelAnimationFrame(t), s.length = 0;
    }), (i, o) => (b(), $(Te, null, [
      E("canvas", {
        ref_key: "canvasRef",
        ref: n,
        class: "fixed inset-0 z-10 pointer-events-none"
      }, null, 512),
      o[0] || (o[0] = E("div", { class: "fixed inset-0 z-10 bg-gradient-to-br from-primary/5 via-accent/5 to-info/5" }, null, -1))
    ], 64));
  }
}), QS = {
  key: 0,
  class: "v-card__loading"
}, eT = {
  key: 0,
  class: "v-card__header"
}, tT = { class: "v-card__header-content" }, nT = {
  key: 2,
  class: "v-card__header-text"
}, aT = {
  key: 0,
  class: "v-card__title"
}, sT = {
  key: 1,
  class: "v-card__subtitle"
}, lT = {
  key: 0,
  class: "v-card__description"
}, rT = { class: "v-card__content" }, iT = {
  key: 1,
  class: "v-card__footer"
}, oT = /* @__PURE__ */ xe({
  __name: "VCard",
  props: {
    title: { default: "" },
    subtitle: { default: "" },
    description: { default: "" },
    variant: { default: "default" },
    size: { default: "full" },
    radius: { default: "xl" },
    padding: { default: "sm" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    clickable: { type: Boolean },
    icon: { default: "" },
    as: { default: "div" },
    href: { default: "" },
    target: { default: "_self" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = M(() => t.title || t.subtitle || t.icon || !!c.header), l = M(() => !!c.footer), r = M(() => t.clickable || t.href || t.as === "button"), i = M(() => t.href ? "a" : t.as), o = M(() => {
      const p = ["v-card"];
      return p.push(`v-card--${t.variant}`), p.push(`v-card--${t.size}`), p.push(`v-card--radius-${t.radius}`), t.padding && p.push(`v-card--padding-${t.padding}`), t.disabled && p.push("v-card--disabled"), t.loading && p.push("v-card--loading"), r.value && p.push("v-card--interactive"), p;
    }), u = M(() => t.href ? {
      href: t.href,
      target: t.target,
      rel: t.target === "_blank" ? "noopener noreferrer" : void 0
    } : {}), c = Ut(), f = (p) => {
      if (t.disabled || t.loading) {
        p.preventDefault();
        return;
      }
      a("click", p);
    };
    return (p, d) => (b(), ue(ht(i.value), lt({ class: o.value }, u.value, { onClick: f }), {
      default: ce(() => [
        e.loading ? (b(), $("div", QS, [
          Y(p.$slots, "loading", {}, () => [
            le(jl)
          ], !0)
        ])) : (b(), $(Te, { key: 1 }, [
          s.value ? (b(), $("header", eT, [
            Y(p.$slots, "header", {}, () => [
              E("div", tT, [
                t.icon ? (b(), ue(we, {
                  key: 0,
                  icon: t.icon,
                  class: "v-card__icon"
                }, null, 8, ["icon"])) : e.icon && typeof e.icon != "string" ? (b(), ue(ht(e.icon), {
                  key: 1,
                  class: "v-card__icon"
                })) : F("", !0),
                e.title || e.subtitle ? (b(), $("div", nT, [
                  e.title ? (b(), $("h3", aT, ie(e.title), 1)) : F("", !0),
                  e.subtitle ? (b(), $("p", sT, ie(e.subtitle), 1)) : F("", !0)
                ])) : F("", !0)
              ]),
              e.description ? (b(), $("p", lT, ie(e.description), 1)) : F("", !0)
            ], !0)
          ])) : F("", !0),
          E("main", rT, [
            Y(p.$slots, "default", {}, void 0, !0)
          ]),
          l.value ? (b(), $("footer", iT, [
            Y(p.$slots, "footer", {}, void 0, !0)
          ])) : F("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), uT = /* @__PURE__ */ Ue(oT, [["__scopeId", "data-v-6a462504"]]), cT = {
  key: 0,
  class: "space-y-4"
}, dT = {
  key: 0,
  class: "flex gap-3 items-start"
}, fT = { class: "flex-1" }, hT = {
  key: 0,
  class: "font-semibold text-mainText"
}, mT = {
  key: 1,
  class: "text-sm text-secondaryText mt-0.5"
}, vT = { class: "grid grid-cols-2 md:grid-cols-4 gap-3" }, pT = { class: "min-w-0" }, gT = { class: "font-medium text-sm text-mainText truncate" }, yT = {
  key: 0,
  class: "text-xs text-secondaryText truncate"
}, bT = {
  key: 1,
  class: "flex items-center gap-2 text-sm text-secondaryText pt-2 border-t border-base-400/30"
}, wT = {
  key: 1,
  class: "flex gap-3 items-start"
}, kT = { class: "flex-1 text-sm leading-relaxed" }, xT = {
  key: 0,
  class: "font-semibold mb-1 text-mainText"
}, ST = {
  key: 1,
  class: "text-secondaryText"
}, TT = {
  key: 2,
  class: "text-secondaryText"
}, $T = {
  key: 0,
  class: "flex-shrink-0"
}, n2 = /* @__PURE__ */ xe({
  __name: "VInfoNotice",
  props: {
    icon: { default: "lucide:info" },
    iconColor: { default: "primary" },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    card: { type: Boolean, default: !0 },
    size: { default: "50px" },
    features: { default: void 0 },
    hint: { default: void 0 }
  },
  setup(e) {
    const n = e, t = M(() => {
      const r = {
        primary: "text-primary",
        success: "text-success",
        warning: "text-warning",
        error: "text-error",
        info: "text-info",
        muted: "text-secondaryText"
      };
      return r[n.iconColor] || r.primary;
    }), a = (r) => ({
      primary: "bg-primary/10",
      success: "bg-success/10",
      warning: "bg-warning/10",
      error: "bg-error/10",
      info: "bg-info/10",
      muted: "bg-muted/10"
    })[r || "primary"], s = (r) => ({
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
      info: "text-info",
      muted: "text-secondaryText"
    })[r || "primary"], l = M(() => n.features && n.features.length > 0);
    return (r, i) => (b(), ue(ht(e.card ? uT : "div"), {
      class: X({ "p-4": !e.card })
    }, {
      default: ce(() => [
        l.value ? (b(), $("div", cT, [
          e.title || e.subtitle || r.$slots.title || r.$slots.subtitle ? (b(), $("div", dT, [
            Y(r.$slots, "icon", {}, () => [
              le(we, {
                class: X(t.value),
                icon: e.icon,
                size: 24
              }, null, 8, ["class", "icon"])
            ]),
            E("div", fT, [
              e.title || r.$slots.title ? (b(), $("p", hT, [
                Y(r.$slots, "title", {}, () => [
                  Ye(ie(e.title), 1)
                ])
              ])) : F("", !0),
              e.subtitle || r.$slots.subtitle ? (b(), $("p", mT, [
                Y(r.$slots, "subtitle", {}, () => [
                  Ye(ie(e.subtitle), 1)
                ])
              ])) : F("", !0)
            ])
          ])) : F("", !0),
          E("div", vT, [
            (b(!0), $(Te, null, Ie(e.features, (o, u) => (b(), $("div", {
              key: u,
              class: "flex items-center gap-3 p-3 rounded-lg bg-cardBg/50 border border-base-400/50"
            }, [
              E("div", {
                class: X([a(o.color), "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"])
              }, [
                le(we, {
                  class: X(s(o.color)),
                  icon: o.icon,
                  size: 20
                }, null, 8, ["class", "icon"])
              ], 2),
              E("div", pT, [
                E("p", gT, ie(o.title), 1),
                o.description ? (b(), $("p", yT, ie(o.description), 1)) : F("", !0)
              ])
            ]))), 128))
          ]),
          e.hint || r.$slots.hint ? (b(), $("div", bT, [
            le(we, {
              size: 16,
              class: "text-secondaryText flex-shrink-0",
              icon: "lucide:info"
            }),
            E("span", null, [
              Y(r.$slots, "hint", {}, () => [
                Ye(ie(e.hint), 1)
              ])
            ])
          ])) : F("", !0)
        ])) : (b(), $("div", wT, [
          Y(r.$slots, "icon", {}, () => [
            le(we, {
              class: X(t.value),
              icon: e.icon,
              size: e.size
            }, null, 8, ["class", "icon", "size"])
          ]),
          E("div", kT, [
            e.title || r.$slots.title ? (b(), $("p", xT, [
              Y(r.$slots, "title", {}, () => [
                Ye(ie(e.title), 1)
              ])
            ])) : F("", !0),
            e.subtitle || r.$slots.subtitle ? (b(), $("p", ST, [
              Y(r.$slots, "subtitle", {}, () => [
                Ye(ie(e.subtitle), 1)
              ])
            ])) : F("", !0),
            r.$slots.default ? (b(), $("div", TT, [
              Y(r.$slots, "default")
            ])) : F("", !0)
          ]),
          r.$slots.actions ? (b(), $("div", $T, [
            Y(r.$slots, "actions")
          ])) : F("", !0)
        ]))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), MT = { class: "scroll-panel overflow-y-auto p-2.5" }, CT = {
  key: 0,
  class: "scroll-panel__copy"
}, DT = ["aria-label"], _T = { class: "scroll-panel__copy-glyph" }, OT = { class: "scroll-panel__copy-glyph scroll-panel__copy-glyph--check" }, ET = /* @__PURE__ */ xe({
  __name: "VScrollPanel",
  props: {
    copyText: {},
    copyLabel: { default: "Copy to clipboard" }
  },
  setup(e) {
    const { copy: n, copied: t, isSupported: a } = jd({ copiedDuring: 2e3 });
    return (s, l) => (b(), $("div", MT, [
      e.copyText !== void 0 && m(a) ? (b(), $("div", CT, [
        E("button", {
          "aria-label": m(t) ? "Copied" : e.copyLabel,
          class: X([{ "scroll-panel__copy-btn--copied": m(t) }, "scroll-panel__copy-btn"]),
          type: "button",
          onClick: l[0] || (l[0] = (r) => m(n)(e.copyText))
        }, [
          E("span", _T, [
            le(we, {
              size: 14,
              icon: "lucide:copy"
            })
          ]),
          E("span", OT, [
            le(we, {
              size: 14,
              icon: "lucide:check"
            })
          ])
        ], 10, DT)
      ])) : F("", !0),
      Y(s.$slots, "default", {}, void 0, !0)
    ]));
  }
}), a2 = /* @__PURE__ */ Ue(ET, [["__scopeId", "data-v-baccb9e0"]]), IT = { class: "v-tabs" }, AT = {
  key: 0,
  class: "v-tabs__header"
}, PT = {
  key: 0,
  "aria-busy": "true",
  class: "v-tabs__skeleton"
}, RT = { class: "v-tabs__list" }, FT = {
  "aria-label": "Tabs navigation",
  class: "v-tabs__nav",
  role: "tablist"
}, VT = ["aria-disabled", "aria-selected", "data-tab-id", "tabindex", "onClick", "onKeydown"], LT = { class: "v-tabs__tab-label" }, NT = {
  key: 0,
  class: "v-tabs__more"
}, BT = {
  key: 1,
  class: "v-tabs__actions"
}, zT = ["id"], WT = ["aria-labelledby"], YT = { class: "v-tabs__panel" }, HT = 70, UT = /* @__PURE__ */ xe({
  __name: "VTabs",
  props: {
    tabs: {},
    loading: { type: Boolean },
    reset: { type: Boolean },
    useHash: { type: Boolean, default: !0 },
    tabSelectionMode: { default: "auto" },
    actionsTargetId: { default: void 0 }
  },
  emits: ["tabSelected"],
  setup(e, { expose: n, emit: t }) {
    const a = Pu(), s = ri(), l = e, r = t, o = ee((() => {
      var C;
      if (l.useHash && (s != null && s.hash)) {
        const _ = s.hash.replace("#tab-", ""), O = l.tabs.find((P) => String(P.id) === _);
        if (O)
          return O.id;
      }
      const x = l.tabs.find((_) => _.activeByDefault);
      return (x == null ? void 0 : x.id) || ((C = l.tabs[0]) == null ? void 0 : C.id);
    })()), u = M(() => l.tabs.find((x) => x.id === o.value)), c = (x, C = !0) => {
      const _ = l.tabs.find((P) => P.id === x);
      if (!_ || _.disabled) return;
      const O = () => {
        o.value = x, l.useHash && C && s && a && s.hash !== `#tab-${x}` && a.push({
          hash: `#tab-${x}`,
          query: s.query
        });
      };
      l.tabSelectionMode === "controlled" ? r("tabSelected", {
        tabId: x,
        callback: O,
        tab: _
      }) : (O(), r("tabSelected", {
        tabId: x,
        callback: () => {
        },
        // Already switched, callback is no-op
        tab: _
      }));
    };
    Be(
      () => l.reset,
      (x) => {
        x && l.tabs.length > 0 && c(l.tabs[0].id);
      }
    ), et(() => {
      const x = () => {
        l.useHash && s && a && s.hash !== `#tab-${o.value}` && a.replace({
          hash: `#tab-${o.value}`,
          query: s.query
        });
      }, C = l.tabs.find((_) => _.id === o.value);
      x(), r("tabSelected", {
        tabId: o.value,
        callback: () => {
        },
        // Already initialized, callback is no-op
        tab: C
      });
    });
    const f = (x) => o.value === x, p = ee(null), d = ee([...l.tabs]), g = ee([]), v = ee(/* @__PURE__ */ new Map()), k = () => {
      if (!p.value || l.tabs.length === 0) return;
      const x = p.value, C = x.offsetWidth;
      if (C === 0) return;
      x.querySelectorAll(".tab-button:not(.more-button)").forEach((H) => {
        const te = H.getAttribute("data-tab-id");
        if (!te) return;
        const re = l.tabs.find((oe) => String(oe.id) === te);
        re && H && v.value.set(re.id, H.offsetWidth);
      });
      let O = 0;
      const P = [];
      for (const H of l.tabs) {
        const te = v.value.get(H.id) || 150;
        P.push(te), O += te;
      }
      if (O <= C) {
        d.value = [...l.tabs], g.value = [];
        return;
      }
      const D = C - HT;
      let B = 0, W = 0;
      for (let H = 0; H < l.tabs.length; H++) {
        const te = P[H];
        if (B + te <= D)
          B += te, W = H + 1;
        else
          break;
      }
      d.value = l.tabs.slice(0, W), g.value = l.tabs.slice(W);
    }, y = M(() => g.value.map((x) => ({
      label: x.label,
      value: x.id,
      icon: x.icon,
      disabled: x.disabled,
      active: x.id === o.value
    }))), h = (x) => {
      c(x);
    };
    let w = null, S = null;
    return et(async () => {
      await Ge(), await Ge(), p.value && (k(), w = new ResizeObserver(() => {
        S && clearTimeout(S), S = setTimeout(() => {
          k();
        }, 100);
      }), w.observe(p.value));
    }), Ps(() => {
      S && clearTimeout(S), w && p.value && (w.unobserve(p.value), w.disconnect());
    }), Be(() => l.tabs, async () => {
      await Ge(), k();
    }, { deep: !0 }), n({
      currentTabId: o,
      selectTab: c
    }), (x, C) => (b(), $("div", IT, [
      l.tabs.length > 0 ? (b(), $("div", AT, [
        l.loading ? (b(), $("section", PT, [
          (b(!0), $(Te, null, Ie(l.tabs.length, (_) => (b(), $("div", {
            key: _,
            class: "v-tabs__skeleton-item"
          }))), 128))
        ])) : F("", !0),
        E("div", RT, [
          E("div", {
            ref_key: "tabsContainerRef",
            ref: p,
            class: "v-tabs__scroll"
          }, [
            E("nav", FT, [
              (b(!0), $(Te, null, Ie(d.value, (_) => (b(), $("button", {
                key: _.id,
                "aria-disabled": _.disabled,
                "aria-selected": f(_.id),
                class: X([
                  "v-tabs__tab",
                  {
                    "v-tabs__tab--active": f(_.id),
                    "v-tabs__tab--disabled": _.disabled
                  },
                  _.styles
                ]),
                "data-tab-id": _.id,
                tabindex: _.disabled ? -1 : 0,
                role: "tab",
                type: "button",
                onClick: (O) => c(_.id),
                onKeydown: [
                  Pt((O) => c(_.id), ["enter"]),
                  Pt(Ve((O) => c(_.id), ["prevent"]), ["space"])
                ]
              }, [
                _.icon ? (b(), ue(we, {
                  key: 1,
                  icon: _.icon,
                  class: "v-tabs__tab-icon"
                }, null, 8, ["icon"])) : Y(x.$slots, `tab-icon-${_.id}`, { key: 0 }, void 0, !0),
                E("span", LT, ie(_.label), 1)
              ], 42, VT))), 128))
            ])
          ], 512),
          g.value.length > 0 ? (b(), $("div", NT, [
            le(Dl, {
              items: y.value,
              placement: "bottom-right",
              onSelect: h
            }, {
              trigger: ce(() => [
                le(Et, { icon: "mdi:dots-horizontal" })
              ]),
              _: 1
            }, 8, ["items"])
          ])) : F("", !0)
        ]),
        x.$slots["tabs-right"] || e.actionsTargetId ? (b(), $("div", BT, [
          Y(x.$slots, "tabs-right", { currentTabId: o.value }, void 0, !0),
          e.actionsTargetId ? (b(), $("div", {
            key: 0,
            id: e.actionsTargetId,
            class: "v-tabs__actions-target"
          }, null, 8, zT)) : F("", !0)
        ])) : F("", !0)
      ])) : F("", !0),
      l.loading ? F("", !0) : (b(), $("div", {
        key: 1,
        "aria-labelledby": `tab-${o.value}`,
        class: "v-tabs__content",
        role: "tabpanel"
      }, [
        E("div", YT, [
          Y(x.$slots, `${o.value}`, {}, () => {
            var _;
            return [
              (_ = u.value) != null && _.component ? (b(), ue(ht(u.value.component), { key: 0 })) : F("", !0)
            ];
          }, !0)
        ])
      ], 8, WT))
    ]));
  }
}), s2 = /* @__PURE__ */ Ue(UT, [["__scopeId", "data-v-b840b472"]]), qT = ["title"], fu = /* @__PURE__ */ xe({
  __name: "TableCell",
  props: {
    value: {},
    align: { default: "left" },
    depth: { default: 0 },
    isFirstColumn: { type: Boolean, default: !1 },
    row: {},
    column: {},
    colIndex: {},
    rowIndex: {},
    interactive: { type: Boolean, default: !1 },
    isExpanded: { type: Boolean, default: !1 }
  },
  emits: ["toggle-expand"],
  setup(e, { emit: n }) {
    const t = n, a = Ut(), s = On("tableCellMetadata", void 0), l = M(() => !e.row || !e.column || e.colIndex === void 0 || e.rowIndex === void 0 || !s ? null : s(e.row, e.column, e.colIndex, e.rowIndex)), r = M(() => {
      if (e.isFirstColumn && e.depth > 0)
        return `${e.depth * 24 + 16}px`;
    }), i = M(
      () => l.value ? l.value.formattedValue : e.value
    ), o = () => {
      if (!(e.interactive || a.default))
        return String(i.value);
    }, u = M(() => {
      var g;
      return !!((g = l.value) != null && g.isExpandable);
    }), c = M(() => !!e.row && !!e.column), f = M(() => {
      var g;
      return [
        {
          "v-table-cell--left": e.align === "left",
          "v-table-cell--center": e.align === "center",
          "v-table-cell--right": e.align === "right",
          "v-table-cell--indented": e.isFirstColumn && e.depth > 0
        },
        (g = l.value) == null ? void 0 : g.cssClass
      ];
    }), p = M(() => {
      var v, k;
      const g = (v = l.value) == null ? void 0 : v.indentStyle;
      return {
        paddingLeft: r.value,
        ...g ? { "--cell-indent": g.paddingLeft } : {},
        ...(k = l.value) == null ? void 0 : k.customStyle
      };
    }), d = () => {
      t("toggle-expand");
    };
    return (g, v) => (b(), $("div", {
      class: X([f.value, "v-table-cell"]),
      style: Fe(p.value)
    }, [
      c.value ? (b(), $(Te, { key: 0 }, [
        Y(g.$slots, "pin"),
        u.value ? (b(), $("button", {
          key: 0,
          class: "v-table-cell-expand-btn",
          onClick: Ve(d, ["stop"])
        }, [
          le(m(we), {
            icon: e.isExpanded ? "lucide:chevron-down" : "lucide:chevron-right",
            size: 18
          }, null, 8, ["icon"])
        ])) : F("", !0),
        E("span", {
          title: o(),
          class: X([{ "v-table-cell-text--truncate": !e.interactive }, "v-table-cell-text"])
        }, [
          Y(g.$slots, "default", {}, () => [
            Ye(ie(i.value), 1)
          ])
        ], 10, qT)
      ], 64)) : Y(g.$slots, "default", { key: 1 })
    ], 6));
  }
}), jT = ["title"], GT = /* @__PURE__ */ xe({
  __name: "TableCellValue",
  props: {
    value: {},
    interactive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = M(() => e.interactive ? void 0 : String(e.value));
    return (t, a) => (b(), $("span", { title: n.value }, ie(e.value), 9, jT));
  }
}), KT = /* @__PURE__ */ xe({
  __name: "TableCheckboxCell",
  props: {
    checked: { type: Boolean },
    indeterminate: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = () => {
      t("toggle");
    };
    return (s, l) => (b(), $("div", {
      class: "v-table-checkbox-cell",
      onClick: l[0] || (l[0] = Ve(() => {
      }, ["stop"]))
    }, [
      le(m(Kc), {
        disabled: e.disabled,
        indeterminate: e.indeterminate,
        "model-value": e.checked,
        "onUpdate:modelValue": a
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), ZT = /* @__PURE__ */ Ue(KT, [["__scopeId", "data-v-499acbc1"]]), XT = [
  { key: "text", label: "Text", icon: "lucide:align-left", color: "secondaryText" },
  { key: "multi-text", label: "Multi-text", icon: "lucide:align-justify", color: "secondaryText" },
  { key: "number", label: "Number", icon: "lucide:hash", color: "primary" },
  { key: "decimal", label: "Decimal", icon: "lucide:percent", color: "primary" },
  { key: "boolean", label: "Boolean", icon: "lucide:toggle-right", color: "success" },
  { key: "date", label: "Date", icon: "lucide:calendar", color: "warning" },
  { key: "datetime", label: "Datetime", icon: "lucide:calendar-clock", color: "warning" },
  { key: "select", label: "Select", icon: "lucide:list", color: "primary" },
  { key: "multi-select", label: "Multi-select", icon: "lucide:list-checks", color: "primary" },
  { key: "color", label: "Color", icon: "lucide:palette", color: "error" },
  { key: "json", label: "JSON", icon: "lucide:braces", color: "error" },
  { key: "url", label: "URL", icon: "lucide:link", color: "secondaryText" },
  { key: "link", label: "Link", icon: "lucide:external-link", color: "secondaryText" },
  { key: "asset", label: "Asset", icon: "lucide:image", color: "info" },
  { key: "multi-asset", label: "Multi-asset", icon: "lucide:images", color: "info" },
  { key: "sys", label: "File", icon: "lucide:file", color: "info" }
], l2 = (e) => e;
function rs(e) {
  return new Promise((n, t) => {
    e.oncomplete = e.onsuccess = () => n(e.result), e.onabort = e.onerror = () => t(e.error);
  });
}
function Qd(e, n) {
  let t;
  const a = () => {
    if (t)
      return t;
    const s = indexedDB.open(e);
    return s.onupgradeneeded = () => s.result.createObjectStore(n), t = rs(s), t.then((l) => {
      l.onclose = () => t = void 0;
    }, () => {
    }), t;
  };
  return (s, l) => a().then((r) => l(r.transaction(n, s).objectStore(n)));
}
let Tr;
function Kl() {
  return Tr || (Tr = Qd("keyval-store", "keyval")), Tr;
}
function hu(e, n = Kl()) {
  return n("readonly", (t) => rs(t.get(e)));
}
function JT(e, n, t = Kl()) {
  return t("readwrite", (a) => (a.put(n, e), rs(a.transaction)));
}
function mu(e, n = Kl()) {
  return n("readwrite", (t) => (t.delete(e), rs(t.transaction)));
}
function QT(e, n) {
  return e.openCursor().onsuccess = function() {
    this.result && (n(this.result), this.result.continue());
  }, rs(e.transaction);
}
function vu(e = Kl()) {
  return e("readonly", (n) => {
    if (n.getAllKeys)
      return rs(n.getAllKeys());
    const t = [];
    return QT(n, (a) => t.push(a.key)).then(() => t);
  });
}
const e$ = {
  deserialize: JSON.parse,
  dialect: "redis",
  serialize: JSON.stringify,
  dbName: "keyv",
  storeName: "keyv"
};
class t$ {
  constructor(n) {
    this.ttlSupport = !1, this.namespace = "", this.opts = Object.assign({}, e$, n), this.store = Qd(this.opts.dbName, this.opts.storeName);
  }
  _getKey(n) {
    return this.namespace ? `${this.namespace}${n}` : n;
  }
  _innerKeyToKey(n) {
    return this.namespace && n.startsWith(this.namespace) ? n.slice(this.namespace.length) : n;
  }
  on(n, t) {
    return this;
  }
  async get(n) {
    try {
      const t = await hu(this._getKey(n), this.store);
      return t ?? void 0;
    } catch {
    }
  }
  async getMany(n) {
    return Promise.all(n.map((t) => this.get(t)));
  }
  /**
   * Note: `await kv.set()` will wait <options.writeDelay> millseconds to save to disk, it would be slow. Please remove `await` if you find performance issues.
   * @param key
   * @param value
   * @param ttl
   * @returns
   */
  async set(n, t, a) {
    return JT(this._getKey(n), t, this.store);
  }
  async delete(n) {
    let t = await this.has(n);
    return await mu(this._getKey(n), this.store), t;
  }
  async deleteMany(n) {
    return (await Promise.all(n.map((a) => this.delete(a)))).every((a) => a);
  }
  async clear() {
    let n = await vu(this.store), t = [];
    for (let a = 0; a < n.length; a++) {
      const s = n[a];
      typeof s == "string" && s.startsWith(this.namespace) && t.push(mu(s, this.store));
    }
    await Promise.all(t);
  }
  async has(n) {
    return await this.get(n) !== void 0;
  }
  disconnect() {
    return Promise.resolve();
  }
  async *iterator(n = this.namespace) {
    let t = await vu(this.store);
    for (let a = 0; a < t.length; a++) {
      let s = t[a];
      typeof s == "string" && (!n || s.startsWith(n)) && (yield [s, await hu(s, this.store)]);
    }
  }
}
class n$ {
  constructor(n = "table-configs") {
    ke(this, "keyv");
    this.keyv = new t$({
      dbName: n,
      storeName: "keyv",
      namespace: n
    });
  }
  async get(n) {
    try {
      return await this.keyv.get(n) ?? null;
    } catch (t) {
      return console.error("IndexedDB get error:", t), null;
    }
  }
  async set(n, t) {
    try {
      await this.keyv.set(n, t);
    } catch (a) {
      throw console.error("IndexedDB set error:", a), a;
    }
  }
  async delete(n) {
    try {
      await this.keyv.delete(n);
    } catch (t) {
      throw console.error("IndexedDB delete error:", t), t;
    }
  }
  async clear() {
    try {
      await this.keyv.clear();
    } catch (n) {
      throw console.error("IndexedDB clear error:", n), n;
    }
  }
}
class pu {
  constructor(n = "localStorage") {
    ke(this, "storage");
    this.storage = n === "sessionStorage" ? sessionStorage : localStorage;
  }
  get(n) {
    try {
      const t = this.storage.getItem(n);
      return Promise.resolve(t ? JSON.parse(t) : null);
    } catch (t) {
      return console.error("WebStorage get error:", t), Promise.resolve(null);
    }
  }
  set(n, t) {
    try {
      return this.storage.setItem(n, JSON.stringify(t)), Promise.resolve();
    } catch (a) {
      return console.error("WebStorage set error:", a), a instanceof DOMException && a.name === "QuotaExceededError" && console.warn("Storage quota exceeded, consider using IndexedDB"), Promise.reject(a);
    }
  }
  delete(n) {
    try {
      return this.storage.removeItem(n), Promise.resolve();
    } catch (t) {
      return console.error("WebStorage delete error:", t), Promise.reject(t);
    }
  }
  clear() {
    try {
      return this.storage.clear(), Promise.resolve();
    } catch (n) {
      return console.error("WebStorage clear error:", n), Promise.reject(n);
    }
  }
}
function gu(e = "indexedDB", n) {
  switch (e) {
    case "indexedDB":
      return new n$(n);
    case "localStorage":
      return new pu("localStorage");
    case "sessionStorage":
      return new pu("sessionStorage");
    default:
      throw new Error(`Unknown storage type: ${e}`);
  }
}
const ha = class ha {
  constructor() {
    ke(this, "adapter");
    ke(this, "storageType");
    this.storageType = "indexedDB", this.adapter = gu(this.storageType, "table-configs");
  }
  static getInstance() {
    return ha.instance || (ha.instance = new ha()), ha.instance;
  }
  /**
     * Change storage type globally
     * Useful for testing or fallback scenarios
     */
  setStorageType(n, t) {
    this.storageType = n, this.adapter = gu(n, t);
  }
  getStorageType() {
    return this.storageType;
  }
  getAdapter() {
    return this.adapter;
  }
  /**
     * Get table configuration
     */
  getTableConfig(n) {
    return this.adapter.get(n);
  }
  /**
     * Save table configuration
     */
  async setTableConfig(n, t) {
    await this.adapter.set(n, t);
  }
  /**
     * Delete table configuration
     */
  async deleteTableConfig(n) {
    await this.adapter.delete(n);
  }
  /**
     * Clear all table configurations
     */
  async clearAllConfigs() {
    await this.adapter.clear();
  }
};
ke(ha, "instance");
let ni = ha;
const es = ni.getInstance(), _l = (e, n) => (n && es.setStorageType(n), es.getTableConfig(e)), ef = async (e, n, t) => {
  t && es.setStorageType(t), await es.setTableConfig(e, n);
}, a$ = { class: "column-picker" }, s$ = { class: "column-picker-header" }, l$ = { class: "column-picker-header-title" }, r$ = { class: "column-picker-body" }, i$ = { class: "column-picker-panel column-picker-panel--left" }, o$ = { class: "column-picker-panel-header" }, u$ = { class: "column-picker-panel-count" }, c$ = { class: "cp-toolbar" }, d$ = { class: "cp-search" }, f$ = { class: "cp-sort-group" }, h$ = { class: "column-picker-panel-list" }, m$ = ["onClick"], v$ = ["onClick"], p$ = {
  key: 0,
  class: "cp-type-group-header"
}, g$ = { class: "cp-type-group-label" }, y$ = ["onClick"], b$ = {
  key: 0,
  class: "cp-type-icon"
}, w$ = { class: "cp-available-item-label" }, k$ = {
  class: "cp-available-item-toggle",
  "aria-hidden": "true"
}, x$ = ["onClick"], S$ = {
  key: 0,
  class: "column-picker-empty"
}, T$ = { class: "column-picker-panel column-picker-panel--right" }, $$ = { class: "column-picker-panel-header" }, M$ = { class: "column-picker-panel-search" }, C$ = { class: "column-picker-panel-list" }, D$ = ["draggable", "onDragover", "onDragstart", "onDrop"], _$ = { class: "cp-selected-item-drag" }, O$ = {
  key: 0,
  class: "cp-type-icon"
}, E$ = { class: "cp-selected-item-label" }, I$ = ["title", "onClick"], A$ = ["onClick"], P$ = {
  key: 0,
  class: "column-picker-empty"
}, R$ = { class: "column-picker-footer" }, F$ = {
  key: 0,
  class: "column-picker-footer-hint column-picker-footer-hint--limit"
}, V$ = {
  key: 1,
  class: "column-picker-footer-hint"
}, $r = 6, Mr = 40, L$ = /* @__PURE__ */ xe({
  __name: "TableColumnPicker",
  props: {
    groups: {},
    columns: {},
    originalColumns: {},
    loading: { type: Boolean, default: !1 },
    storageKey: {},
    storageType: {},
    types: {}
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(""), l = ee("alpha"), r = ee(/* @__PURE__ */ new Set()), i = ee(/* @__PURE__ */ new Set());
    Be(l, () => {
      i.value = /* @__PURE__ */ new Set();
    });
    const o = (I) => {
      if (r.value.has(I)) {
        r.value.delete(I);
        const N = new Set(i.value);
        N.delete(I), i.value = N;
      } else
        r.value.add(I);
      r.value = new Set(r.value);
    }, u = M(() => {
      const I = s.value.trim().toLowerCase();
      return I ? t.groups.map((N) => ({
        ...N,
        items: N.items.filter((T) => T.label.toLowerCase().includes(I))
      })).filter((N) => N.items.length > 0) : t.groups;
    });
    Be(s, (I) => {
      I.trim() ? r.value = new Set(u.value.map((N) => N.key)) : r.value = /* @__PURE__ */ new Set();
    });
    const c = M(() => {
      const I = XT.map((N) => ({ ...N }));
      for (const N of t.types ?? []) {
        const T = I.findIndex((R) => R.key === N.key);
        T === -1 ? I.push(N) : I[T] = N;
      }
      return I;
    }), f = M(
      () => new Map(c.value.map((I) => [I.key, I]))
    ), p = M(
      () => new Map(c.value.map((I, N) => [I.key, N]))
    ), d = (I) => {
      const N = I.replace(/[-_]/g, " ").trim();
      return N.charAt(0).toUpperCase() + N.slice(1);
    }, g = (I) => {
      var N;
      return ((N = f.value.get(I)) == null ? void 0 : N.label) ?? d(I);
    }, v = (I) => {
      const N = I ? f.value.get(I) : void 0;
      return (N == null ? void 0 : N.icon) ?? "lucide:help-circle";
    }, k = (I) => {
      const N = I ? f.value.get(I) : void 0;
      return (N == null ? void 0 : N.color) ?? "secondaryText";
    };
    function y(I) {
      const N = new Set(i.value);
      N.add(I), i.value = N;
    }
    function h(I) {
      const N = [...I.items];
      return l.value === "alpha" ? N.sort((T, R) => {
        const A = T.label.toLowerCase().trim(), Z = R.label.toLowerCase().trim();
        return A < Z ? -1 : A > Z ? 1 : 0;
      }) : N.sort((T, R) => {
        const A = p.value.get(T.icon ?? "") ?? Number.MAX_SAFE_INTEGER, Z = p.value.get(R.icon ?? "") ?? Number.MAX_SAFE_INTEGER;
        if (A !== Z) return A - Z;
        if (A === Number.MAX_SAFE_INTEGER) {
          const $e = T.icon ?? "", Re = R.icon ?? "";
          if ($e !== Re) return $e < Re ? -1 : 1;
        }
        const L = T.label.toLowerCase().trim(), fe = R.label.toLowerCase().trim();
        return L < fe ? -1 : L > fe ? 1 : 0;
      });
    }
    function w(I) {
      return !s.value.trim() && !i.value.has(I.key) && h(I).length > $r;
    }
    const S = (I) => {
      if (!(s.value.trim() || i.value.has(I.key)))
        return $r;
    }, x = (I) => {
      const N = h(I), T = S(I);
      if (l.value !== "by-type")
        return (T !== void 0 ? N.slice(0, T) : N).map((fe) => ({ isHeader: !1, key: fe.key, item: fe }));
      const R = /* @__PURE__ */ new Map();
      for (const L of N) {
        const fe = L.icon ?? "", $e = R.get(fe);
        $e ? $e.push(L) : R.set(fe, [L]);
      }
      const A = [];
      let Z = 0;
      for (const [L, fe] of R) {
        if (T !== void 0 && Z >= T) break;
        A.push({ isHeader: !0, key: `hdr-${L}`, typeKey: L });
        for (const $e of fe) {
          if (T !== void 0 && Z >= T) break;
          A.push({ isHeader: !1, key: $e.key, item: $e }), Z += 1;
        }
      }
      return A;
    }, C = ee([]), _ = ee([]), O = (I, N = !1) => {
      if (I) {
        const T = /* @__PURE__ */ new Map();
        t.groups.forEach((A) => A.items.forEach((Z) => T.set(Z.key, Z)));
        const R = I.order.filter((A) => I.visible.includes(A)).map((A) => {
          var _e, We;
          const Z = t.columns.find((Rt) => Rt.key === A), L = T.get(A), fe = (Z == null ? void 0 : Z.label) ?? (L == null ? void 0 : L.label) ?? ((_e = I.labels) == null ? void 0 : _e[A]) ?? A, $e = (L == null ? void 0 : L.icon) ?? (Z == null ? void 0 : Z.icon), Re = (We = I.fixed) == null ? void 0 : We[A];
          return { key: A, label: fe, icon: $e, fixed: Re };
        }).filter((A) => A !== null);
        C.value = R;
      } else {
        const T = N ? t.originalColumns ?? t.columns : t.columns;
        C.value = T.map((R) => ({
          key: R.key,
          label: R.label,
          icon: R.icon,
          fixed: R.fixed
        }));
      }
      _.value = JSON.parse(JSON.stringify(C.value));
    };
    et(async () => {
      if (t.storageKey)
        try {
          const I = await _l(t.storageKey, t.storageType);
          O(I);
          return;
        } catch (I) {
          console.error("[TableColumnPicker] Failed to load from storage:", I);
        }
      O();
    });
    const P = ee(""), D = M(() => {
      const I = P.value.trim().toLowerCase();
      return I ? C.value.filter((N) => N.label.toLowerCase().includes(I)) : C.value;
    }), B = M(() => new Set(C.value.map((I) => I.key))), W = M(() => C.value.length >= Mr), H = M(
      () => t.groups.reduce((I, N) => I + N.items.length, 0)
    );
    function te(I) {
      return I.items.filter((N) => B.value.has(N.key)).length;
    }
    function re(I) {
      return I.items.length > 0 && I.items.every((N) => B.value.has(N.key));
    }
    function oe(I) {
      if (re(I)) {
        const N = new Set(I.items.map((T) => T.key));
        C.value = C.value.filter((T) => N.has(T.key) ? !!T.fixed : !0);
      } else {
        const N = I.items.filter((R) => !B.value.has(R.key)), T = Mr - C.value.length;
        C.value = [
          ...C.value,
          ...N.slice(0, T).map((R) => ({ key: R.key, label: R.label, icon: R.icon }))
        ];
      }
    }
    const K = (I) => {
      !B.value.has(I.key) && !W.value && (C.value = [...C.value, { key: I.key, label: I.label, icon: I.icon }]);
    }, ae = (I) => {
      const N = C.value.find((T) => T.key === I);
      N != null && N.fixed || (C.value = C.value.filter((T) => T.key !== I));
    }, U = (I) => {
      B.value.has(I.key) ? ae(I.key) : K(I);
    }, z = async () => {
      if (t.storageKey)
        try {
          await es.deleteTableConfig(t.storageKey);
        } catch (A) {
          console.error("[TableColumnPicker] Failed to clear storage:", A);
        }
      O(null, !0);
      const I = t.originalColumns ?? t.columns, N = new Map(I.map((A) => [A.key, A])), T = /* @__PURE__ */ new Map();
      t.groups.forEach((A) => A.items.forEach((Z) => T.set(Z.key, Z)));
      const R = C.value.map((A) => {
        const Z = N.get(A.key);
        if (Z) return { ...Z, fixed: A.fixed };
        const L = T.get(A.key);
        return {
          key: A.key,
          label: A.label,
          fixed: A.fixed,
          sortable: L == null ? void 0 : L.sortable,
          format: L == null ? void 0 : L.format
        };
      });
      a("update:visible-columns", R), a("close");
    }, J = (I) => I === 0 || I === 1, de = (I) => I.fixed === "left", pe = (I) => {
      !J(I) || !C.value[I] || (C.value = C.value.map(
        (T, R) => R === I ? { ...T, fixed: T.fixed === "left" ? void 0 : "left" } : T
      ));
    }, ge = () => {
      C.value = C.value.map(
        (I, N) => I.fixed === "left" && !J(N) ? { ...I, fixed: void 0 } : I
      );
    }, Me = ee(null), be = ee(null), q = (I, N) => {
      P.value.trim() || (Me.value = I, N.dataTransfer && (N.dataTransfer.effectAllowed = "move", N.dataTransfer.setData("text/html", "")));
    }, ye = (I, N) => {
      N.preventDefault(), N.dataTransfer && (N.dataTransfer.dropEffect = "move"), be.value = I;
    }, Ce = (I, N) => {
      if (N.preventDefault(), Me.value === null || Me.value === I) {
        Me.value = null, be.value = null;
        return;
      }
      const T = [...C.value], [R] = T.splice(Me.value, 1);
      T.splice(I, 0, R), C.value = T, ge(), Me.value = null, be.value = null;
    }, V = () => {
      Me.value = null, be.value = null;
    }, G = async (I) => {
      if (!t.storageKey) return;
      const N = {}, T = {};
      I.forEach((A) => {
        A.fixed && (N[A.key] = A.fixed), T[A.key] = A.label;
      });
      const R = {
        visible: I.map((A) => A.key),
        order: I.map((A) => A.key),
        fixed: Object.keys(N).length > 0 ? N : void 0,
        labels: T
      };
      try {
        await ef(t.storageKey, R, t.storageType);
      } catch (A) {
        console.error("[TableColumnPicker] Failed to save to storage:", A);
      }
    }, he = M(
      () => JSON.stringify(C.value) !== JSON.stringify(_.value)
    ), j = async () => {
      const I = new Map(t.columns.map((R) => [R.key, R])), N = /* @__PURE__ */ new Map();
      t.groups.forEach((R) => R.items.forEach((A) => N.set(A.key, A)));
      const T = C.value.map((R) => {
        const A = I.get(R.key);
        if (A) return { ...A, fixed: R.fixed };
        const Z = N.get(R.key);
        return {
          key: R.key,
          label: R.label,
          fixed: R.fixed,
          sortable: Z == null ? void 0 : Z.sortable,
          format: Z == null ? void 0 : Z.format
        };
      });
      await G(C.value), a("update:visible-columns", T), _.value = JSON.parse(JSON.stringify(C.value)), a("close");
    }, se = () => {
      C.value = JSON.parse(JSON.stringify(_.value)), a("close");
    };
    function me(I) {
      return I ? { "--cp-type-color-raw": `var(--color-${k(I)})` } : {};
    }
    return (I, N) => (b(), $("div", a$, [
      E("div", s$, [
        E("div", l$, [
          le(m(we), {
            size: 24,
            icon: "lucide:columns",
            variant: "link"
          }),
          N[5] || (N[5] = E("span", null, "Edit columns", -1))
        ]),
        E("button", {
          class: "column-picker-close-btn",
          title: "Close",
          onClick: se
        }, [
          le(m(we), {
            size: 16,
            icon: "lucide:x"
          })
        ])
      ]),
      E("div", r$, [
        E("div", i$, [
          E("div", o$, [
            E("span", u$, ie(H.value) + " columns available ", 1)
          ]),
          E("div", c$, [
            E("div", d$, [
              le(m(we), {
                size: 11,
                icon: "lucide:search"
              }),
              an(E("input", {
                "onUpdate:modelValue": N[0] || (N[0] = (T) => s.value = T),
                placeholder: "Search…"
              }, null, 512), [
                [_u, s.value]
              ])
            ]),
            E("div", f$, [
              E("button", {
                class: X([{ "cp-sort-btn--active": l.value === "by-type" }, "cp-sort-btn"]),
                title: "Group by type",
                type: "button",
                onClick: N[1] || (N[1] = (T) => l.value = "by-type")
              }, [
                le(m(we), {
                  size: 10,
                  icon: "lucide:group"
                })
              ], 2),
              N[6] || (N[6] = E("div", { class: "cp-sort-divider" }, null, -1)),
              E("button", {
                class: X([{ "cp-sort-btn--active": l.value === "alpha" }, "cp-sort-btn"]),
                title: "Sort alphabetically",
                type: "button",
                onClick: N[2] || (N[2] = (T) => l.value = "alpha")
              }, " A→Z ", 2)
            ])
          ]),
          E("div", h$, [
            e.loading ? (b(), $(Te, { key: 0 }, Ie(6, (T) => E("div", {
              key: T,
              class: "column-picker-skeleton"
            })), 64)) : (b(), $(Te, { key: 1 }, [
              (b(!0), $(Te, null, Ie(u.value, (T) => (b(), $("div", {
                key: T.key
              }, [
                E("div", {
                  class: "cp-group-header",
                  onClick: (R) => o(T.key)
                }, [
                  E("span", {
                    class: X([{ "cp-group-label--has-selection": te(T) > 0 }, "cp-group-label"])
                  }, ie(T.label), 3),
                  E("button", {
                    class: "cp-group-select-btn",
                    type: "button",
                    onClick: Ve((R) => oe(T), ["stop"])
                  }, ie(re(T) ? "Deselect all" : "Select all"), 9, v$),
                  E("span", {
                    class: X([te(T) > 0 ? "cp-group-badge--selected" : "cp-group-badge--empty", "cp-group-badge"])
                  }, ie(te(T)) + "/" + ie(T.items.length), 3),
                  le(m(we), {
                    class: X([{ "cp-group-chevron--open": r.value.has(T.key) }, "cp-group-chevron"]),
                    size: 10,
                    icon: "lucide:chevron-right"
                  }, null, 8, ["class"])
                ], 8, m$),
                r.value.has(T.key) ? (b(), $(Te, { key: 0 }, [
                  (b(!0), $(Te, null, Ie(x(T), (R) => (b(), $(Te, {
                    key: R.key
                  }, [
                    R.isHeader && R.typeKey ? (b(), $("div", p$, [
                      E("div", {
                        style: Fe({ background: `rgb(var(--color-${k(R.typeKey)}))` }),
                        class: "cp-type-group-dot"
                      }, null, 4),
                      E("span", g$, ie(g(R.typeKey)), 1)
                    ])) : R.item ? (b(), $("div", {
                      key: 1,
                      class: X([{ "cp-available-item--selected": B.value.has(R.item.key) }, "cp-available-item"]),
                      style: Fe(me(R.item.icon)),
                      onClick: (A) => U(R.item)
                    }, [
                      R.item.icon ? (b(), $("div", b$, [
                        le(m(we), {
                          icon: v(R.item.icon),
                          size: 9
                        }, null, 8, ["icon"])
                      ])) : F("", !0),
                      E("span", w$, ie(R.item.label), 1),
                      E("span", k$, [
                        le(m(we), {
                          icon: B.value.has(R.item.key) ? "lucide:check" : "lucide:plus",
                          size: B.value.has(R.item.key) ? 10 : 9
                        }, null, 8, ["icon", "size"])
                      ])
                    ], 14, y$)) : F("", !0)
                  ], 64))), 128)),
                  w(T) ? (b(), $("button", {
                    key: 0,
                    class: "cp-show-more-btn",
                    type: "button",
                    onClick: Ve((R) => y(T.key), ["stop"])
                  }, " Show " + ie(h(T).length - $r) + " more ", 9, x$)) : F("", !0)
                ], 64)) : F("", !0)
              ]))), 128)),
              u.value.length === 0 ? (b(), $("div", S$, " No columns match your search ")) : F("", !0)
            ], 64))
          ])
        ]),
        N[8] || (N[8] = E("div", { class: "column-picker-divider" }, null, -1)),
        E("div", T$, [
          E("div", $$, [
            E("span", {
              class: X([{ "column-picker-panel-count--limit": W.value }, "column-picker-panel-count"])
            }, ie(C.value.length) + " selected ", 3),
            E("button", {
              class: "column-picker-text-btn",
              onClick: z
            }, [
              le(m(we), {
                size: 12,
                icon: "lucide:rotate-ccw"
              }),
              N[7] || (N[7] = Ye(" Reset to default ", -1))
            ])
          ]),
          E("div", M$, [
            le(m(Cl), {
              modelValue: P.value,
              "onUpdate:modelValue": N[3] || (N[3] = (T) => P.value = T),
              name: "Search",
              placeholder: "Search by column name",
              type: "search"
            }, null, 8, ["modelValue"])
          ]),
          E("div", C$, [
            (b(!0), $(Te, null, Ie(D.value, (T, R) => (b(), $("div", {
              key: T.key,
              class: X([{
                "cp-selected-item--dragging": Me.value === R,
                "cp-selected-item--drag-over": be.value === R,
                "cp-selected-item--locked": !!T.fixed
              }, "cp-selected-item"]),
              draggable: !T.fixed && !P.value,
              style: Fe(me(T.icon)),
              onDragend: V,
              onDragleave: N[4] || (N[4] = (A) => be.value = null),
              onDragover: (A) => ye(R, A),
              onDragstart: (A) => q(R, A),
              onDrop: (A) => Ce(R, A)
            }, [
              E("div", _$, [
                le(m(we), {
                  size: 14,
                  icon: T.fixed ? "lucide:lock" : "lucide:grip-vertical"
                }, null, 8, ["icon"])
              ]),
              T.icon ? (b(), $("div", O$, [
                le(m(we), {
                  icon: v(T.icon),
                  size: 9
                }, null, 8, ["icon"])
              ])) : F("", !0),
              E("span", E$, ie(T.label), 1),
              J(R) && !P.value ? (b(), $("button", {
                key: 1,
                class: X([{ "cp-selected-item-pin--active": de(T) }, "cp-selected-item-pin"]),
                title: de(T) ? "Unpin column" : "Pin column to left",
                onClick: Ve((A) => pe(R), ["stop"])
              }, [
                le(m(we), {
                  icon: de(T) ? "lucide:pin" : "lucide:pin-off",
                  size: 12
                }, null, 8, ["icon"])
              ], 10, I$)) : F("", !0),
              T.fixed ? F("", !0) : (b(), $("button", {
                key: 2,
                class: "cp-selected-item-remove",
                title: "Remove column",
                onClick: (A) => ae(T.key)
              }, [
                le(m(we), {
                  size: 12,
                  icon: "lucide:x"
                })
              ], 8, A$))
            ], 46, D$))), 128)),
            C.value.length === 0 ? (b(), $("div", P$, " No columns selected. Use the left panel to add columns. ")) : F("", !0)
          ])
        ])
      ]),
      E("div", R$, [
        W.value ? (b(), $("span", F$, [
          le(m(we), {
            size: 24,
            icon: "lucide:alert-circle"
          }),
          Ye(" Max " + ie(Mr) + " columns reached ")
        ])) : (b(), $("span", V$, [
          le(m(we), {
            size: 24,
            icon: "lucide:info"
          }),
          N[9] || (N[9] = Ye(" Drag to reorder · Pin first 2 columns ", -1))
        ])),
        le(m(Et), {
          disabled: !he.value,
          class: "h-[30px]",
          text: "Apply",
          variant: "primary",
          onClick: j
        }, null, 8, ["disabled"])
      ])
    ]));
  }
}), N$ = { class: "column-setup" }, B$ = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, z$ = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, W$ = {
  key: 2,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, Y$ = { class: "column-setup-toggle-count" }, H$ = ["draggable", "onDragover", "onDragstart", "onDrop"], U$ = {
  key: 0,
  class: "column-setup-item-drag"
}, q$ = ["title", "onClick"], j$ = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, G$ = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, K$ = ["title", "onClick"], Z$ = {
  key: 2,
  class: "column-setup-item-badge column-setup-item-badge--warning",
  title: "Fixed will be removed — move to top 2 positions"
}, X$ = { class: "column-setup-footer" }, J$ = {
  key: 0,
  class: "column-setup-hint"
}, yu = "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24", Q$ = /* @__PURE__ */ xe({
  __name: "TableColumnSetup",
  props: {
    columns: {},
    config: { default: () => ({}) }
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = async () => {
      var U;
      if (!((U = t.config) != null && U.key)) return null;
      try {
        return await _l(t.config.key, t.config.type);
      } catch (z) {
        return console.error("Failed to load column setup from storage:", z), null;
      }
    }, l = async (U) => {
      var z;
      if ((z = t.config) != null && z.key)
        try {
          const J = {};
          U.forEach((pe) => {
            pe.fixed && (J[pe.key] = pe.fixed);
          });
          const de = {
            visible: U.filter((pe) => pe.visible).map((pe) => pe.key),
            order: U.map((pe) => pe.key),
            fixed: Object.keys(J).length > 0 ? J : void 0
            // Only save if there are fixed columns
          };
          await ef(t.config.key, de, t.config.type);
        } catch (J) {
          console.error("Failed to save column setup to storage:", J);
        }
    }, r = (U) => U.reduce((z, J) => J.children && J.children.length > 0 ? [...z, ...r(J.children)] : [...z, J], []), i = (U) => {
      var de;
      const z = r(t.columns);
      if (U) {
        const { visible: pe, order: ge, fixed: Me } = U, be = new Map(z.map((ye) => [ye.key, ye])), q = [];
        return ge.forEach((ye, Ce) => {
          const V = be.get(ye);
          V && (q.push({
            key: V.key,
            label: V.label,
            visible: pe.includes(ye),
            order: Ce,
            fixed: (Me == null ? void 0 : Me[ye]) || V.fixed
            // Use saved fixed state, fallback to column's fixed
          }), be.delete(ye));
        }), be.forEach((ye) => {
          q.push({
            key: ye.key,
            label: ye.label,
            visible: !0,
            order: q.length,
            fixed: ye.fixed
          });
        }), q;
      }
      const J = (de = t.config) == null ? void 0 : de.initialVisible;
      return z.map((pe, ge) => ({
        key: pe.key,
        label: pe.label,
        // If initialVisible is provided, check if column is in the list
        // If not provided, all columns are visible by default
        visible: J ? J.includes(pe.key) : !0,
        order: ge,
        fixed: pe.fixed
      }));
    }, o = ee(i()), u = ee(JSON.parse(JSON.stringify(i())));
    s().then((U) => {
      if (U) {
        const z = i(U);
        o.value = z, u.value = JSON.parse(JSON.stringify(z));
      }
    });
    const c = M(() => JSON.stringify(o.value) !== JSON.stringify(u.value)), f = () => {
      const U = r(t.columns), J = o.value.filter((de) => de.visible).sort((de, pe) => de.order - pe.order).map((de) => {
        const pe = U.find((ge) => ge.key === de.key);
        return pe ? {
          ...pe,
          fixed: de.fixed
        } : null;
      }).filter(Boolean);
      a("update:visible-columns", J);
    };
    Be(
      o,
      () => {
      },
      { deep: !0 }
    );
    const p = () => {
      l(o.value), f(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    }, d = M(() => o.value.every((U) => U.visible)), g = M(() => o.value.every((U) => !U.visible)), v = M(() => !d.value && !g.value), k = M(() => o.value.filter((U) => U.visible).length), y = ee(null), h = ee(null), w = ee(null), S = ee(null), x = (U) => {
      if (!w.value) return;
      const z = w.value.getBoundingClientRect(), J = U.clientY, de = 50, pe = 10;
      J < z.top + de && J > z.top ? S.value || (S.value = window.setInterval(() => {
        w.value && w.value.scrollTop > 0 && (w.value.scrollTop -= pe);
      }, 16)) : J > z.bottom - de && J < z.bottom ? S.value || (S.value = window.setInterval(() => {
        if (w.value) {
          const ge = w.value.scrollHeight - w.value.clientHeight;
          w.value.scrollTop < ge && (w.value.scrollTop += pe);
        }
      }, 16)) : C();
    }, C = () => {
      S.value && (clearInterval(S.value), S.value = null);
    }, _ = (U, z) => {
      var J;
      ((J = t.config) == null ? void 0 : J.allowReorder) !== !1 && (y.value = U, z.dataTransfer && (z.dataTransfer.effectAllowed = "move", z.dataTransfer.setData("text/html", "")));
    }, O = (U, z) => {
      var J;
      ((J = t.config) == null ? void 0 : J.allowReorder) !== !1 && (z.preventDefault(), z.dataTransfer && (z.dataTransfer.dropEffect = "move"), h.value = U, x(z));
    }, P = () => {
      h.value = null;
    }, D = (U, z) => {
      var pe;
      if (((pe = t.config) == null ? void 0 : pe.allowReorder) === !1) return;
      if (z.preventDefault(), C(), y.value === null || y.value === U) {
        y.value = null, h.value = null;
        return;
      }
      const J = [...o.value], [de] = J.splice(y.value, 1);
      J.splice(U, 0, de), J.forEach((ge, Me) => {
        ge.order = Me;
      }), o.value = J, K(), y.value = null, h.value = null;
    }, B = () => {
      y.value = null, h.value = null, C();
    }, W = (U) => {
      const z = o.value.find((J) => J.key === U);
      z && (z.visible = !z.visible);
    }, H = () => {
      const U = !d.value;
      o.value.forEach((z) => {
        z.visible = U;
      });
    }, te = (U) => U === 0 || U === 1, re = (U) => U.fixed === "left", oe = (U) => {
      if (!te(U)) return;
      const z = o.value[U];
      z && (z.fixed === "left" ? z.fixed = void 0 : z.fixed = "left");
    }, K = () => {
      o.value.forEach((U, z) => {
        U.fixed === "left" && !te(z) && (U.fixed = void 0);
      });
    }, ae = async () => {
      var U;
      if ((U = t.config) != null && U.key)
        try {
          await es.deleteTableConfig(t.config.key);
        } catch (z) {
          console.error("Failed to clear storage:", z);
        }
      o.value = i(), f(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    };
    return (U, z) => {
      var J;
      return b(), $("div", N$, [
        E("div", { class: "column-setup-header" }, [
          z[1] || (z[1] = E("span", { class: "column-setup-title" }, "Column Settings", -1)),
          E("button", {
            class: "column-setup-reset-btn",
            title: "Reset to default",
            onClick: ae
          }, [...z[0] || (z[0] = [
            E("svg", {
              fill: "none",
              height: "13",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2.3",
              viewBox: "0 0 24 24",
              width: "13"
            }, [
              E("polyline", { points: "1 4 1 10 7 10" }),
              E("path", { d: "M3.51 15a9 9 0 1 0 .49-4.5" })
            ], -1)
          ])])
        ]),
        E("div", {
          class: "column-setup-toggle-all",
          onClick: H
        }, [
          E("div", {
            class: X([{
              "column-setup-toggle-eye--none": g.value
            }, "column-setup-toggle-eye"])
          }, [
            d.value ? (b(), $("svg", B$, [...z[2] || (z[2] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              }, null, -1)
            ])])) : v.value ? (b(), $("svg", z$, [...z[3] || (z[3] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("line", {
                x1: "9",
                x2: "15",
                y1: "12",
                y2: "12"
              }, null, -1)
            ])])) : (b(), $("svg", W$, [
              E("path", { d: yu }),
              z[4] || (z[4] = E("line", {
                x1: "1",
                x2: "23",
                y1: "1",
                y2: "23"
              }, null, -1))
            ]))
          ], 2),
          z[5] || (z[5] = E("span", { class: "column-setup-toggle-label" }, "Show all columns", -1)),
          E("span", Y$, ie(k.value) + " / " + ie(o.value.length), 1)
        ]),
        E("div", {
          ref_key: "listRef",
          ref: w,
          class: "column-setup-list"
        }, [
          (b(!0), $(Te, null, Ie(o.value, (de, pe) => {
            var ge, Me, be;
            return b(), $("div", {
              key: de.key,
              class: X([{
                "column-setup-item--dragging": y.value === pe,
                "column-setup-item--drag-over": h.value === pe,
                "column-setup-item--no-reorder": ((ge = e.config) == null ? void 0 : ge.allowReorder) === !1
              }, "column-setup-item"]),
              draggable: ((Me = e.config) == null ? void 0 : Me.allowReorder) !== !1,
              onDragend: B,
              onDragleave: P,
              onDragover: (q) => O(pe, q),
              onDragstart: (q) => _(pe, q),
              onDrop: (q) => D(pe, q)
            }, [
              ((be = e.config) == null ? void 0 : be.allowReorder) !== !1 ? (b(), $("div", U$, [
                le(m(we), {
                  size: 16,
                  icon: "lucide:grip-vertical"
                })
              ])) : F("", !0),
              E("button", {
                class: X([de.visible ? "column-setup-item-eye--visible" : "column-setup-item-eye--hidden", "column-setup-item-eye"]),
                title: de.visible ? "Hide column" : "Show column",
                onClick: Ve((q) => W(de.key), ["stop"])
              }, [
                de.visible ? (b(), $("svg", j$, [...z[6] || (z[6] = [
                  E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                  E("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                  }, null, -1)
                ])])) : (b(), $("svg", G$, [
                  E("path", { d: yu }),
                  z[7] || (z[7] = E("line", {
                    x1: "1",
                    x2: "23",
                    y1: "1",
                    y2: "23"
                  }, null, -1))
                ]))
              ], 10, q$),
              E("div", {
                class: X([{ "column-setup-item-label--hidden": !de.visible }, "column-setup-item-label"])
              }, ie(de.label), 3),
              te(pe) ? (b(), $("button", {
                key: 1,
                class: X([{ "column-setup-item-fixed-btn--active": re(de) }, "column-setup-item-fixed-btn"]),
                title: re(de) ? "Unpin column" : "Pin column to left",
                onClick: Ve((q) => oe(pe), ["stop"])
              }, [
                le(m(we), {
                  icon: re(de) ? "lucide:pin" : "lucide:pin-off",
                  size: 16
                }, null, 8, ["icon"])
              ], 10, K$)) : F("", !0),
              de.fixed && !te(pe) ? (b(), $("div", Z$, [
                le(m(we), {
                  size: 16,
                  icon: "lucide:triangle-alert"
                })
              ])) : F("", !0)
            ], 42, H$);
          }), 128))
        ], 512),
        E("div", X$, [
          ((J = e.config) == null ? void 0 : J.allowReorder) !== !1 ? (b(), $("span", J$, [
            le(m(we), {
              size: 11,
              icon: "lucide:grip-vertical"
            }),
            z[8] || (z[8] = Ye(" Drag to reorder ", -1))
          ])) : F("", !0),
          le(m(Et), {
            disabled: !c.value,
            text: "Apply",
            variant: "primary",
            class: "h-[30px]",
            onClick: p
          }, null, 8, ["disabled"])
        ])
      ]);
    };
  }
}), eM = /* @__PURE__ */ Ue(Q$, [["__scopeId", "data-v-72a05d03"]]), tM = { class: "v-table-empty-state" }, nM = { class: "v-table-empty-state-content" }, aM = {
  key: 0,
  class: "v-table-empty-state-icon"
}, sM = {
  key: 1,
  class: "v-table-empty-state-title"
}, lM = {
  key: 2,
  class: "v-table-empty-state-description"
}, rM = /* @__PURE__ */ xe({
  __name: "TableEmptyState",
  props: {
    title: {},
    description: {},
    icon: {}
  },
  setup(e) {
    const n = On("tableSlots", {}), t = (a, { slots: s }) => Y({ default: n.emptyState }, "default", {}, s.default);
    return (a, s) => (b(), $("div", tM, [
      E("div", nM, [
        le(t, null, {
          default: ce(() => [
            e.icon ? (b(), $("div", aM, [
              le(m(we), {
                icon: e.icon,
                size: 48
              }, null, 8, ["icon"])
            ])) : F("", !0),
            e.title ? (b(), $("h3", sM, ie(e.title), 1)) : F("", !0),
            e.description ? (b(), $("p", lM, ie(e.description), 1)) : F("", !0)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), iM = /* @__PURE__ */ Ue(rM, [["__scopeId", "data-v-ca3a4ef6"]]), oM = ["aria-label", "title"], uM = /* @__PURE__ */ xe({
  __name: "TableFullscreenToggle",
  props: {
    isFullscreen: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = M(() => e.isFullscreen ? "Collapse table" : "Expand table"), s = M(() => e.isFullscreen ? "lucide:minimize-2" : "lucide:maximize-2");
    return (l, r) => (b(), $("button", {
      "aria-label": a.value,
      class: X([{ "v-table-fullscreen-toggle--active": e.isFullscreen }, "v-table-fullscreen-toggle"]),
      title: a.value,
      type: "button",
      onClick: r[0] || (r[0] = (i) => t("toggle"))
    }, [
      le(m(we), {
        icon: s.value,
        size: 15
      }, null, 8, ["icon"])
    ], 10, oM));
  }
}), cM = /* @__PURE__ */ xe({
  __name: "TableHeaderCheckbox",
  props: {
    state: {},
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = () => {
      t.disabled || a("toggle");
    };
    return (l, r) => (b(), $("div", {
      class: "v-table-header-checkbox-cell",
      onClick: r[0] || (r[0] = Ve(() => {
      }, ["stop"]))
    }, [
      le(m(Kc), {
        disabled: e.disabled,
        indeterminate: e.state === "indeterminate",
        "model-value": e.state === "checked",
        "onUpdate:modelValue": s
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), dM = /* @__PURE__ */ Ue(cM, [["__scopeId", "data-v-6525801e"]]), fM = ["aria-label", "aria-pressed"], tf = /* @__PURE__ */ xe({
  __name: "TablePinButton",
  props: {
    pinned: { type: Boolean },
    label: {}
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = M(() => e.pinned ? `Unpin ${e.label}` : `Pin ${e.label}`), s = (l) => {
      l.stopPropagation(), t("toggle");
    };
    return (l, r) => (b(), $("button", {
      "aria-label": a.value,
      "aria-pressed": e.pinned,
      class: X([{ "v-table-pin-button--active": e.pinned }, "v-table-pin-button"]),
      type: "button",
      onClick: s,
      onMousedown: r[0] || (r[0] = Ve(() => {
      }, ["stop"]))
    }, [
      le(m(we), {
        icon: e.pinned ? "lucide:x" : "lucide:pin",
        size: 13
      }, null, 8, ["icon"])
    ], 42, fM));
  }
}), hM = { class: "v-table-header-content" }, mM = ["title"], vM = { class: "items-center justify-center flex p-0 w-[16px]" }, pM = ["title"], gM = ["aria-label"], yM = /* @__PURE__ */ xe({
  __name: "TableHeader",
  props: {
    column: {},
    label: {},
    align: { default: "left" },
    columnKey: {},
    resizable: { type: Boolean, default: !0 },
    isSorted: { type: Boolean, default: !1 },
    sortOrder: { default: null },
    sortIndex: { default: -1 }
  },
  emits: ["sort-click", "resize-start", "resize-dblclick"],
  setup(e, { emit: n }) {
    const t = On("tableSlots", {}), a = On("tableHighlight", null), s = e, l = n, r = M(() => !s.isSorted || !s.sortOrder ? "lucide:arrow-up-down" : s.sortOrder === "asc" ? "lucide:arrow-up" : "lucide:arrow-down"), i = M(() => s.isSorted ? "v-sort-icon v-sort-icon--active" : "v-sort-icon"), o = (d) => {
      s.column.sortable && (d.stopPropagation(), l("sort-click"));
    }, u = (d) => {
      s.column.onHeaderClick && (d.stopPropagation(), s.column.onHeaderClick({
        column: s.column,
        columnKey: s.columnKey,
        event: d
      }));
    }, c = (d) => {
      l("resize-start", s.columnKey, d);
    }, f = () => {
      l("resize-dblclick", s.columnKey);
    }, p = (d) => {
      s.column.sortable && (d.key === "Enter" || d.key === " ") && (d.preventDefault(), l("sort-click"));
    };
    return (d, g) => {
      var v;
      return b(), $("div", {
        class: X([{
          "v-table-header-cell--left": e.align === "left",
          "v-table-header-cell--center": e.align === "center",
          "v-table-header-cell--right": e.align === "right",
          "v-table-header-cell--sortable": e.column.sortable,
          "v-table-header-cell--clickable": e.column.onHeaderClick
        }, "v-table-header-cell"])
      }, [
        E("div", hM, [
          E("div", {
            class: X([{ "v-table-header-label-wrapper--clickable": e.column.onHeaderClick }, "v-table-header-label-wrapper"]),
            onClick: u
          }, [
            Y(d.$slots, "default", {
              column: e.column,
              isSorted: e.isSorted,
              sortOrder: e.sortOrder
            }, () => [
              E("span", {
                title: e.label,
                class: "v-table-header-label"
              }, ie(e.label), 9, mM)
            ], !0),
            Y(d.$slots, "icon", { column: e.column }, void 0, !0),
            e.column.tooltip ? (b(), ue(m(Qa), {
              key: 0,
              text: e.column.tooltip,
              placement: "top",
              "tooltip-class": "bg-cardBg opacity-1 w-[300px]"
            }, {
              default: ce(() => [
                E("div", vM, [
                  le(m(we), {
                    size: 14,
                    class: "v-table-header-info-icon",
                    icon: "lucide:info"
                  })
                ])
              ]),
              _: 1
            }, 8, ["text"])) : F("", !0),
            e.column.onHeaderClick ? (b(), $("div", {
              key: 1,
              title: `Click to interact with ${e.label}`,
              class: "v-table-header-click-indicator"
            }, [
              le(m(we), {
                size: 14,
                class: "click-indicator-icon",
                icon: "lucide:mouse-pointer-click"
              })
            ], 8, pM)) : F("", !0)
          ], 2),
          e.column.sortable ? (b(), $("div", {
            key: 0,
            "aria-label": `Sort by ${e.label}`,
            tabindex: 0,
            class: "v-table-header-sort",
            role: "button",
            onClick: o,
            onKeydown: p
          }, [
            le(m(we), {
              class: X(i.value),
              icon: r.value,
              size: 16
            }, null, 8, ["class", "icon"])
          ], 40, gM)) : F("", !0),
          m(t).headerCellCustomAction ? (b(), ue(ht(m(t).headerCellCustomAction), {
            key: 1,
            column: e.column
          }, null, 8, ["column"])) : F("", !0),
          (v = m(a)) != null && v.columnEnabled.value ? (b(), ue(tf, {
            key: 2,
            label: e.label,
            pinned: m(a).isColumnPinned(e.columnKey),
            onToggle: g[0] || (g[0] = (k) => m(a).toggleColumn(e.columnKey))
          }, null, 8, ["label", "pinned"])) : F("", !0)
        ]),
        e.resizable ? (b(), $("div", {
          key: 0,
          class: "v-table-resize-handle",
          onMousedown: Ve(c, ["stop"]),
          onDblclick: Ve(f, ["stop"])
        }, [...g[1] || (g[1] = [
          E("div", { class: "v-table-resize-indicator" }, [
            E("div", { class: "v-table-resize-line" }),
            E("div", { class: "v-table-resize-line" })
          ], -1),
          E("div", { class: "v-table-resize-divider" }, null, -1)
        ])], 32)) : F("", !0)
      ], 2);
    };
  }
}), nf = /* @__PURE__ */ Ue(yM, [["__scopeId", "data-v-bd73d8e9"]]), bM = { class: "v-table-header-group-label" }, wM = /* @__PURE__ */ xe({
  __name: "TableHeaderGroup",
  props: {
    cell: {},
    groupWidth: {}
  },
  setup(e) {
    return (n, t) => (b(), $("div", {
      class: X([{
        "v-table-header-group--left": e.cell.column.align === "left",
        "v-table-header-group--center": e.cell.column.align === "center",
        "v-table-header-group--right": e.cell.column.align === "right"
      }, "v-table-header-group"])
    }, [
      E("span", bM, ie(e.cell.label), 1)
    ], 2));
  }
}), kM = /* @__PURE__ */ xe({
  __name: "TableHeaderGrouped",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getGroupWidth: { type: Function },
    getGroupFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, l = (i) => {
      a("resize-dblclick", i);
    }, r = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (b(!0), $(Te, null, Ie(e.columns, (u, c) => (b(), $("div", {
      key: `header-level-${c}`,
      class: X([`v-table-header-row-level-${c}`, "v-table-header-row"])
    }, [
      c === 0 ? Y(i.$slots, "checkbox-header", { key: 0 }) : F("", !0),
      (b(!0), $(Te, null, Ie(u, (f) => (b(), $(Te, {
        key: f.key
      }, [
        f.isGroup ? (b(), ue(wM, {
          key: 0,
          cell: f,
          class: X(e.getColumnClasses(f.column)),
          "group-width": e.getGroupWidth(f.column),
          style: Fe({
            gridColumn: `span ${f.colspan}`,
            gridRow: f.rowspan > 1 ? `span ${f.rowspan}` : void 0,
            ...e.getGroupFixedStyles(f.column)
          })
        }, null, 8, ["cell", "class", "group-width", "style"])) : (b(), ue(nf, {
          key: 1,
          align: f.column.align,
          class: X([
            e.getColumnClasses(f.column),
            {
              "v-table-header-cell--grouped": c > 0,
              "v-table-header-cell--rowspan": f.rowspan > 1
            }
          ]),
          column: f.column,
          "column-key": f.column.key,
          "is-sorted": e.getSortState(f.column.key).isSorted,
          label: f.label,
          resizable: t.isColumnResizable(f.column),
          "sort-index": e.getSortState(f.column.key).index,
          "sort-order": e.getSortState(f.column.key).order,
          style: Fe({
            gridRow: f.rowspan > 1 ? `span ${f.rowspan}` : void 0,
            ...e.getFixedStyles(f.column)
          }),
          onSortClick: (p) => r(f.column),
          onResizeStart: s,
          onResizeDblclick: l
        }, dt({ _: 2 }, [
          i.$slots[`header-icon-${f.column.key}`] ? {
            name: "icon",
            fn: ce((p) => [
              Y(i.$slots, `header-icon-${f.column.key}`, lt({ ref_for: !0 }, p))
            ]),
            key: "0"
          } : void 0,
          i.$slots[`header-${f.column.key}`] ? {
            name: "default",
            fn: ce((p) => [
              Y(i.$slots, `header-${f.column.key}`, lt({ ref_for: !0 }, p))
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))
      ], 64))), 128))
    ], 2))), 128));
  }
}), xM = { class: "v-table-header-row" }, SM = /* @__PURE__ */ xe({
  __name: "TableHeaderSimple",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, l = (i) => {
      a("resize-dblclick", i);
    }, r = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (b(), $("div", xM, [
      Y(i.$slots, "checkbox-header"),
      (b(!0), $(Te, null, Ie(e.columns, (u) => (b(), ue(nf, {
        key: u.key,
        align: u.align,
        class: X(e.getColumnClasses(u)),
        column: u,
        "column-key": u.key,
        "is-sorted": e.getSortState(u.key).isSorted,
        label: u.label,
        resizable: t.isColumnResizable(u),
        "sort-index": e.getSortState(u.key).index,
        "sort-order": e.getSortState(u.key).order,
        style: Fe(e.getFixedStyles(u)),
        onSortClick: (c) => r(u),
        onResizeStart: s,
        onResizeDblclick: l
      }, dt({ _: 2 }, [
        i.$slots[`header-icon-${u.key}`] ? {
          name: "icon",
          fn: ce((c) => [
            Y(i.$slots, `header-icon-${u.key}`, lt({ ref_for: !0 }, c))
          ]),
          key: "0"
        } : void 0,
        i.$slots[`header-${u.key}`] ? {
          name: "default",
          fn: ce((c) => [
            Y(i.$slots, `header-${u.key}`, lt({ ref_for: !0 }, c))
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))), 128))
    ]));
  }
}), TM = {
  key: 0,
  class: "v-table-loading-overlay"
}, $M = { class: "v-table-loading-spinner" }, MM = /* @__PURE__ */ xe({
  __name: "TableLoadingOverlay",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (b(), ue(St, { name: "fade" }, {
      default: ce(() => [
        e.loading ? (b(), $("div", TM, [
          t[0] || (t[0] = E("div", { class: "v-table-loading-backdrop" }, null, -1)),
          E("div", $M, [
            le(m(jl), {
              size: "large",
              variant: "primary"
            })
          ])
        ])) : F("", !0)
      ]),
      _: 1
    }));
  }
}), CM = { class: "v-table-pagination" }, DM = { class: "v-table-pagination-info" }, _M = { class: "v-table-pagination-info-highlight" }, OM = { class: "v-table-pagination-info-highlight" }, EM = { class: "v-table-pagination-controls" }, IM = ["disabled"], AM = ["disabled", "onClick"], PM = {
  key: 1,
  class: "v-table-pagination-ellipsis"
}, RM = ["disabled"], FM = {
  key: 0,
  class: "v-table-pagination-size"
}, VM = ["disabled", "value"], LM = ["value"], NM = /* @__PURE__ */ xe({
  __name: "TablePagination",
  props: {
    page: {},
    pageSize: {},
    total: {},
    pageSizeOptions: { default: () => [10, 25, 50, 100] },
    showSizeChanger: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = M(() => Math.ceil(t.total / t.pageSize)), l = M(() => t.total === 0 ? 0 : qa((t.page - 1) * t.pageSize + 1)), r = M(() => {
      const g = t.page * t.pageSize;
      return qa(Math.min(g, t.total));
    }), i = M(() => {
      const g = [], v = s.value, k = t.page;
      if (v <= 7) {
        for (let y = 1; y <= v; y++)
          g.push(y);
        return g;
      }
      return g.push(1), k <= 3 ? (g.push(2, 3, 4), g.push("ellipsis"), g.push(v)) : k >= v - 2 ? (g.push("ellipsis"), g.push(v - 3, v - 2, v - 1, v)) : (g.push("ellipsis"), g.push(k - 1, k, k + 1), g.push("ellipsis"), g.push(v)), g;
    }), o = (g) => {
      t.loading || g !== t.page && (g < 1 || g > s.value || a("page-change", { page: g, pageSize: t.pageSize }));
    }, u = () => {
      t.page > 1 && o(t.page - 1);
    }, c = () => {
      t.page < s.value && o(t.page + 1);
    }, f = (g) => {
      t.loading || g !== t.pageSize && a("page-change", { page: 1, pageSize: g });
    }, p = M(() => t.loading || t.page <= 1), d = M(() => t.loading || t.page >= s.value);
    return (g, v) => (b(), $("div", CM, [
      E("div", DM, [
        v[1] || (v[1] = Ye(" Showing ", -1)),
        E("span", _M, ie(l.value) + "–" + ie(r.value), 1),
        v[2] || (v[2] = Ye(" of ", -1)),
        E("span", OM, ie(m(qa)(e.total)), 1)
      ]),
      E("div", EM, [
        E("button", {
          disabled: p.value,
          "aria-label": "Previous page",
          class: "v-table-pagination-btn",
          onClick: u
        }, [
          le(m(we), {
            size: 18,
            icon: "lucide:chevron-left"
          })
        ], 8, IM),
        (b(!0), $(Te, null, Ie(i.value, (k, y) => (b(), $(Te, { key: y }, [
          k !== "ellipsis" ? (b(), $("button", {
            key: 0,
            class: X([{ "v-table-pagination-btn--active": k === e.page }, "v-table-pagination-btn"]),
            disabled: e.loading,
            onClick: (h) => o(k)
          }, ie(k), 11, AM)) : (b(), $("span", PM, " ... "))
        ], 64))), 128)),
        E("button", {
          disabled: d.value,
          "aria-label": "Next page",
          class: "v-table-pagination-btn",
          onClick: c
        }, [
          le(m(we), {
            size: 18,
            icon: "lucide:chevron-right"
          })
        ], 8, RM)
      ]),
      e.showSizeChanger ? (b(), $("div", FM, [
        v[3] || (v[3] = E("label", { for: "pagination-size" }, "Rows:", -1)),
        E("select", {
          id: "pagination-size",
          disabled: e.loading,
          value: e.pageSize,
          onChange: v[0] || (v[0] = (k) => f(Number(k.target.value)))
        }, [
          (b(!0), $(Te, null, Ie(e.pageSizeOptions, (k) => (b(), $("option", {
            key: k,
            value: k
          }, ie(k), 9, LM))), 128))
        ], 40, VM)
      ])) : F("", !0)
    ]));
  }
}), BM = /* @__PURE__ */ Ue(NM, [["__scopeId", "data-v-d308e929"]]), zM = { class: "v-toolbar v-toolbar--split" }, WM = { class: "v-toolbar-split-left" }, YM = { key: 0 }, HM = { class: "v-toolbar-title" }, UM = {
  key: 0,
  class: "v-toolbar-subtitle"
}, qM = {
  key: 0,
  class: "v-toolbar-search-split flex h-full items-center"
}, jM = { class: "v-toolbar-split-right" }, GM = /* @__PURE__ */ xe({
  __name: "TableToolbar",
  props: {
    config: { default: void 0 },
    search: { default: "" }
  },
  emits: ["update:search", "refresh", "reset-sort", "export"],
  setup(e, { emit: n }) {
    const t = On("tableSlots", {}), a = e, s = n, l = M({
      get: () => a.search,
      set: (h) => s("update:search", h)
    }), r = M(() => {
      var h;
      return (h = a.config) != null && h.search ? typeof a.config.search == "boolean" ? { placeholder: "Search..." } : a.config.search : null;
    }), i = M(() => {
      var w, S;
      const h = (S = (w = a.config) == null ? void 0 : w.actions) == null ? void 0 : S.refresh;
      return h ? typeof h == "object" ? { loading: h.loading ?? !1 } : { loading: !1 } : null;
    }), o = M(() => {
      var w, S;
      const h = (S = (w = a.config) == null ? void 0 : w.actions) == null ? void 0 : S.export;
      return !h || !h ? null : typeof h == "object" ? {
        mode: h.mode,
        formats: h.formats || [],
        selectedOnly: h.selectedOnly ?? !1,
        loading: h.loading ?? !1
      } : {
        mode: h,
        formats: [],
        selectedOnly: !1,
        loading: !1
      };
    }), u = M(() => o.value !== null), c = M(() => {
      var h;
      return ((h = o.value) == null ? void 0 : h.loading) || !1;
    }), f = M(() => {
      var h;
      return ((h = o.value) == null ? void 0 : h.formats) || [];
    }), p = M(() => f.value.some((h) => h.loading)), d = M(() => {
      var h;
      return (h = o.value) == null ? void 0 : h.mode;
    }), g = () => {
      s("refresh");
    }, v = () => {
      s("reset-sort");
    }, k = (h) => {
      var w;
      s("export", String(h), (w = o.value) == null ? void 0 : w.selectedOnly);
    }, y = () => {
      var h;
      s("export", "csv", (h = o.value) == null ? void 0 : h.selectedOnly);
    };
    return (h, w) => {
      var S, x, C, _, O, P;
      return b(), $("div", zM, [
        E("div", WM, [
          m(t).toolbarTitle ? (b(), ue(ht(m(t).toolbarTitle), { key: 0 })) : Y(h.$slots, "title", { key: 1 }, () => {
            var D;
            return [
              (D = e.config) != null && D.title ? (b(), $("div", YM, [
                E("h3", HM, ie(e.config.title), 1),
                e.config.subtitle ? (b(), $("p", UM, ie(e.config.subtitle), 1)) : F("", !0)
              ])) : F("", !0)
            ];
          }),
          m(t).toolbarSearch ? (b(), ue(ht(m(t).toolbarSearch), { key: 2 })) : Y(h.$slots, "search", { key: 3 }, () => [
            r.value ? (b(), $("div", qM, [
              w[1] || (w[1] = E("span", { class: "w-px h-5 bg-base-300 ml-[1px] mr-4" }, null, -1)),
              le(m(Cl), {
                modelValue: l.value,
                "onUpdate:modelValue": w[0] || (w[0] = (D) => l.value = D),
                name: r.value.placeholder,
                placeholder: r.value.placeholder,
                class: "min-w-[300px]",
                debounce: "",
                type: "search"
              }, null, 8, ["modelValue", "name", "placeholder"])
            ])) : F("", !0)
          ]),
          m(t).toolbarFilters ? (b(), ue(ht(m(t).toolbarFilters), { key: 4 })) : Y(h.$slots, "filters", { key: 5 })
        ]),
        E("div", jM, [
          m(t).toolbarActions ? (b(), ue(ht(m(t).toolbarActions), { key: 0 })) : Y(h.$slots, "actions", { key: 1 }),
          i.value ? (b(), ue(m(Et), {
            key: 2,
            loading: i.value.loading,
            icon: "lucide:refresh-cw",
            variant: "default",
            onClick: g
          }, null, 8, ["loading"])) : F("", !0),
          (x = (S = e.config) == null ? void 0 : S.actions) != null && x.resetSort ? (b(), ue(m(Et), {
            key: 3,
            icon: "lucide:arrow-up-down",
            text: "Reset Sort",
            variant: "default",
            onClick: v
          })) : F("", !0),
          u.value && d.value === "single" ? (b(), ue(m(Et), {
            key: 4,
            disabled: c.value,
            loading: c.value,
            icon: "lucide:file-down",
            text: "Export",
            variant: "primary",
            onClick: y
          }, null, 8, ["disabled", "loading"])) : F("", !0),
          u.value && d.value === "multi" ? (b(), ue(m(Dl), {
            key: 5,
            items: f.value,
            placement: "bottom-right",
            onSelect: k
          }, {
            trigger: ce(() => [
              le(m(Et), {
                loading: p.value,
                icon: "lucide:file-down",
                text: "Export",
                variant: "primary"
              }, null, 8, ["loading"])
            ]),
            _: 1
          }, 8, ["items"])) : F("", !0),
          m(t).toolbarColumnActions ? (b(), ue(ht(m(t).toolbarColumnActions), { key: 6 })) : F("", !0),
          (_ = (C = e.config) == null ? void 0 : C.actions) != null && _.columnSetup || (P = (O = e.config) == null ? void 0 : O.actions) != null && P.columnPicker ? Y(h.$slots, "column-setup", { key: 7 }) : F("", !0)
        ])
      ]);
    };
  }
}), rt = {
  SM: 640,
  // Tailwind sm
  MD: 768,
  // Tailwind md
  LG: 1024,
  // Tailwind lg
  XL: 1280,
  // Tailwind xl
  "2XL": 1536,
  // Tailwind 2xl
  "3XL": 1920,
  // custom 3xl
  ULTRA: 2560,
  // custom ultra
  "4K": 3440
  // custom 4k
}, Fi = typeof window < "u" ? window.innerWidth : 1920;
function af(e = Fi) {
  return e < rt.SM || e < rt.MD ? "sm" : e < rt.LG ? "md" : e < rt.XL ? "lg" : e < rt["2XL"] ? "xl" : e < rt["3XL"] ? "2xl" : e < rt.ULTRA ? "3xl" : e < rt["4K"] ? "ultra" : "4k";
}
function Cr(e, n = Fi) {
  const t = af(n), a = ["4k", "ultra", "3xl", "2xl", "xl", "lg", "md", "sm"], s = a.indexOf(t);
  for (let l = s; l < a.length; l++) {
    const r = e[a[l]];
    if (r !== void 0) return r;
  }
  return e.default;
}
function r2(e, n = 1920, t, a, s = Fi) {
  const l = s / n;
  let r = Math.round(e * l);
  return t !== void 0 && (r = Math.max(r, t)), a !== void 0 && (r = Math.min(r, a)), r;
}
const la = af(), Vi = la === "sm", Li = la === "md", sf = la === "lg", lf = la === "xl", rf = la === "2xl", Ni = la === "3xl", Zl = la === "ultra", Xl = la === "4k", KM = Vi || Li, i2 = Vi || Li || sf, ZM = lf || rf || Ni || Zl || Xl, XM = Ni || Zl || Xl, JM = Zl || Xl, o2 = {
  sm: Vi,
  md: Li,
  lg: sf,
  xl: lf,
  "2xl": rf,
  "3xl": Ni,
  ultra: Zl,
  "4k": Xl,
  // Grouped checks
  isMobileOrTablet: KM,
  isDesktopOrLarger: ZM,
  isLargeOrBigger: XM,
  isUltraOrBigger: JM
}, u2 = {
  sm: `(max-width: ${rt.SM - 1}px)`,
  md: `(min-width: ${rt.SM}px) and (max-width: ${rt.MD - 1}px)`,
  lg: `(min-width: ${rt.MD}px) and (max-width: ${rt.LG - 1}px)`,
  xl: `(min-width: ${rt.LG}px) and (max-width: ${rt.XL - 1}px)`,
  "2xl": `(min-width: ${rt.XL}px) and (max-width: ${rt["2XL"] - 1}px)`,
  "3xl": `(min-width: ${rt["2XL"]}px) and (max-width: ${rt["3XL"] - 1}px)`,
  ultra: `(min-width: ${rt["3XL"]}px) and (max-width: ${rt.ULTRA - 1}px)`,
  "4k": `(min-width: ${rt.ULTRA}px)`,
  // Range queries (min-width)
  minMd: `(min-width: ${rt.SM}px)`,
  minLg: `(min-width: ${rt.MD}px)`,
  minXl: `(min-width: ${rt.LG}px)`,
  min2Xl: `(min-width: ${rt.XL}px)`,
  min3Xl: `(min-width: ${rt["2XL"]}px)`,
  minUltra: `(min-width: ${rt["3XL"]}px)`,
  min4K: `(min-width: ${rt.ULTRA}px)`
}, of = {
  MIN_COLUMN_WIDTH: Cr({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 110,
    ultra: 120,
    default: 100
  }),
  DEFAULT_MIN_WIDTH: Cr({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 120,
    ultra: 190,
    default: 100
  }),
  DEFAULT_COLUMN_WIDTH: Cr({
    sm: 100,
    md: 120,
    lg: 140,
    xl: 150,
    "3xl": 180,
    ultra: 270,
    default: 150
  })
}, {
  MIN_COLUMN_WIDTH: QM,
  DEFAULT_MIN_WIDTH: bu,
  DEFAULT_COLUMN_WIDTH: bs
} = of;
function eC(e) {
  const n = ee(/* @__PURE__ */ new Map()), t = ee({
    isResizing: !1,
    columnKey: null,
    startX: 0,
    startWidth: 0
  });
  let a = null, s = null, l = 0;
  const r = (y) => y.width !== "flex", i = (y) => {
    const h = n.value.get(y.key);
    return h !== void 0 ? `${h}px` : y.width === "flex" ? `minmax(${bu}px, 1fr)` : y.width ? y.width : `${bs}px`;
  }, o = M(() => e.value.map((y) => i(y)).join(" ")), u = (y = 50) => `${y}px ${o.value}`, c = (y, h) => {
    h.preventDefault(), h.stopPropagation();
    const w = e.value.find((C) => C.key === y);
    if (!w || !r(w))
      return;
    let S;
    const x = n.value.get(y);
    if (x !== void 0)
      S = x;
    else if (w.width && w.width !== "flex" && w.width.endsWith("px"))
      S = parseInt(w.width, 10);
    else if (!w.width)
      S = bs;
    else {
      const C = h.target.closest('[role="columnheader"]');
      S = C ? C.offsetWidth : bs;
    }
    t.value = {
      isResizing: !0,
      columnKey: y,
      startX: h.clientX,
      startWidth: S
    }, document.addEventListener("mousemove", p), document.addEventListener("mouseup", d), document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
  }, f = () => {
    if (a = null, s === null) return;
    const y = new Map(n.value);
    y.set(s, l), n.value = y;
  }, p = (y) => {
    if (!t.value.isResizing || !t.value.columnKey)
      return;
    const h = y.clientX - t.value.startX, w = Math.max(
      QM,
      t.value.startWidth + h
    );
    s = t.value.columnKey, l = w, a === null && (a = requestAnimationFrame(f));
  }, d = () => {
    a !== null && (cancelAnimationFrame(a), a = null), f(), s = null, t.value = {
      isResizing: !1,
      columnKey: null,
      startX: 0,
      startWidth: 0
    }, document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", d), document.body.style.cursor = "", document.body.style.userSelect = "";
  }, g = (y) => {
    const h = new Map(n.value);
    h.delete(y), n.value = h;
  }, v = () => {
    n.value = /* @__PURE__ */ new Map();
  }, k = (y) => {
    const h = n.value.get(y);
    if (h !== void 0)
      return h;
    const w = e.value.find((S) => S.key === y);
    return w ? w.width === "flex" ? `minmax(${bu}px, 1fr)` : w.width ? w.width : bs : bs;
  };
  return {
    gridTemplateColumns: o,
    getGridTemplateWithCheckbox: u,
    resizedWidths: n,
    isResizing: M(() => t.value.isResizing),
    isColumnResizable: r,
    startResize: c,
    autoFitColumn: g,
    getColumnWidth: k,
    resetWidths: v
  };
}
function tC(e) {
  const n = ee(/* @__PURE__ */ new Set());
  return {
    flattenedData: M(() => {
      const i = [], o = (u, c = 0, f) => {
        u.forEach((p) => {
          var v, k;
          const d = !!((v = p.children) != null && v.length || p.expandable && p.expandedContent), g = n.value.has(p.id);
          i.push({
            ...p,
            depth: c,
            parentId: f,
            hasChildren: d,
            isExpanded: g
          }), g && ((k = p.children) != null && k.length) && o(p.children, c + 1, p.id);
        });
      };
      return o(e.value), i;
    }),
    // For passing to virtualizer
    expandedRows: n,
    // For UI indicators
    toggleRow: (i) => {
      n.value.has(i) ? n.value.delete(i) : n.value.add(i), n.value = new Set(n.value);
    },
    // For click handlers
    expandAll: () => {
      const i = (o) => {
        const u = [];
        return o.forEach((c) => {
          var f;
          ((f = c.children) != null && f.length || c.expandable) && (u.push(c.id), c.children && u.push(...i(c.children)));
        }), u;
      };
      n.value = new Set(i(e.value));
    },
    collapseAll: () => {
      n.value.clear(), n.value = /* @__PURE__ */ new Set();
    },
    isExpandable: (i) => {
      var o;
      return !!((o = i.children) != null && o.length || i.expandable);
    }
  };
}
const { DEFAULT_COLUMN_WIDTH: Pa } = of;
function nC(e, n) {
  const t = M(
    () => e.value.filter((v) => v.fixed === "left")
  ), a = M(
    () => e.value.filter((v) => v.fixed === "right")
  ), s = M(
    () => e.value.filter((v) => !v.fixed)
  ), l = M(() => {
    const v = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map();
    let y = 0;
    for (const h of e.value)
      if (h.fixed === "left") {
        k.set(h.key, y);
        let w = Pa;
        if (v) {
          const S = v.get(h.key);
          S !== void 0 ? w = S : w = ul(h.width) || Pa;
        } else
          w = ul(h.width) || Pa;
        y += w;
      }
    return k;
  }), r = M(() => {
    const v = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map(), y = e.value.filter((w) => w.fixed === "right");
    let h = 0;
    for (let w = y.length - 1; w >= 0; w--) {
      const S = y[w];
      k.set(S.key, h);
      let x = Pa;
      if (v) {
        const C = v.get(S.key);
        C !== void 0 ? x = C : x = ul(S.width) || Pa;
      } else
        x = ul(S.width) || Pa;
      h += x;
    }
    return k;
  }), i = (v, k) => {
    if (k.fixed === "left") {
      const h = e.value.findIndex((S) => S.key === v);
      let w = 0;
      for (let S = 0; S < h; S++)
        e.value[S].fixed === "left" && w++;
      return 50 + (t.value.length - w);
    }
    if (k.fixed === "right") {
      const h = e.value.findIndex((S) => S.key === v);
      let w = 0;
      for (let S = h + 1; S < e.value.length; S++)
        e.value[S].fixed === "right" && w++;
      return 50 + w + 1;
    }
    return 1;
  }, o = M(() => {
    const v = /* @__PURE__ */ new Map();
    return e.value.forEach((k) => {
      if (!k.fixed) {
        v.set(k.key, {});
        return;
      }
      const y = {
        // position: sticky added through CSS classes!
        // zIndex also controlled through CSS for proper hierarchy
      };
      if (k.fixed === "left") {
        const h = l.value.get(k.key) || 0;
        y.left = `${h}px`;
      } else if (k.fixed === "right") {
        const h = r.value.get(k.key) || 0;
        y.right = `${h}px`;
      }
      v.set(k.key, y);
    }), v;
  }), u = (v) => o.value.get(v.key) || {}, c = (v) => !!v.fixed, f = M(() => {
    let v = null;
    for (const k of e.value)
      k.fixed === "left" && (v = k.key);
    return v;
  }), p = M(() => {
    for (const v of e.value)
      if (v.fixed === "right")
        return v.key;
    return null;
  });
  return {
    leftFixedColumns: t,
    rightFixedColumns: a,
    normalColumns: s,
    getFixedStyles: u,
    isFixed: c,
    isLastLeftFixed: (v) => f.value === v,
    isFirstRightFixed: (v) => p.value === v,
    getZIndex: i
  };
}
function ul(e) {
  return e && e.endsWith("px") ? Number.parseInt(e, 10) : null;
}
function aC(e, n) {
  const a = M(() => ((g) => g.some((v) => !!(v.children && v.children.length > 0)))(e.value)), s = (d, g = 1) => {
    let v = g;
    return d.forEach((k) => {
      if (k.children && k.children.length > 0) {
        const y = s(k.children, g + 1);
        v = Math.max(v, y);
      }
    }), v;
  }, l = M(() => {
    const d = [], g = (v) => {
      v.forEach((k) => {
        k.children && k.children.length > 0 ? g(k.children) : d.push(k);
      });
    };
    return g(e.value), d;
  }), r = (d) => !d.children || d.children.length === 0 ? 1 : d.children.reduce((g, v) => g + r(v), 0), i = (d) => d && d.endsWith("px") ? parseInt(d, 10) : 150, o = (d) => {
    const g = n.value.get(d.key);
    return g !== void 0 ? g : i(d.width);
  }, u = (d) => !d.children || d.children.length === 0 ? o(d) : d.children.reduce((g, v) => g + u(v), 0), c = (d, g, v = 0, k = 1) => {
    const y = [];
    return d.forEach((h) => {
      if (!!(h.children && h.children.length > 0))
        v === g && y.push({
          key: h.key,
          label: h.label,
          column: h,
          colspan: r(h),
          rowspan: 1,
          isGroup: !0,
          level: v
        }), v < g && y.push(...c(h.children, g, v + 1, k));
      else if (v === g) {
        const S = v === 0;
        y.push({
          key: h.key,
          label: h.label,
          column: h,
          colspan: 1,
          rowspan: S ? k : 1,
          // Root level spans all, others just 1
          isGroup: !1,
          level: v
        });
      }
    }), y;
  }, f = M(() => {
    if (!a.value)
      return [
        e.value.map((v) => ({
          key: v.key,
          label: v.label,
          column: v,
          colspan: 1,
          rowspan: 1,
          isGroup: !1,
          level: 0
        }))
      ];
    const d = s(e.value), g = [];
    for (let v = 0; v < d; v++)
      g.push(c(e.value, v, 0, d));
    return g;
  });
  return {
    hasGroups: a,
    // Boolean - do we have grouped headers?
    flatColumns: l,
    // Flat list of leaf columns for data rows
    headerLevels: f,
    // Array of header rows (one per level)
    getGroupWidth: u,
    // Calculate width of group dynamically
    getColspan: r,
    // Get colspan for any column
    isGroupFixed: (d) => {
      if (!d.children || d.children.length === 0)
        return d.fixed || null;
      const g = (h) => !h.children || h.children.length === 0 ? [h.fixed] : h.children.flatMap((w) => g(w)), v = g(d), k = v.every((h) => h === "left"), y = v.every((h) => h === "right");
      return k ? "left" : y ? "right" : null;
    }
    // Check if group should be sticky
  };
}
const sC = (e, n, t) => {
  if (!n.format)
    return e;
  const a = n.format;
  if (a.formatter)
    return a.formatter(e, t);
  if (a.currency !== void 0 && a.currency !== !1) {
    const s = a.currency === !0 ? "USD" : a.currency;
    return Ds(e, s);
  }
  return a.percentage !== void 0 ? Ii(e, a.percentage) : a.number ? qa(e, a.number) : a.date ? Yd(e, a.date) : a.boolean ? Wd(e, a.boolean) : a.fileSize !== void 0 ? Hd(e, a.fileSize) : e;
}, lC = () => ({
  formatCellValue: sC,
  // Export individual formatters for custom use
  formatCurrency: Ds,
  formatPercentage: Ii,
  formatNumber: qa,
  formatDate: Yd,
  formatBoolean: Wd,
  formatFileSize: Hd
}), rC = (e) => {
  const { isExpandable: n, isRowExpandable: t } = e, { formatCellValue: a } = lC(), s = (o, u, c) => {
    if (!u.format)
      return o;
    const f = a(o, u, c);
    return f && typeof f == "object" && !Array.isArray(f) && "text" in f && typeof f.text < "u" ? f.text : f;
  }, l = (o, u, c) => {
    if (!u.format)
      return;
    const f = a(o, u, c);
    if (f && typeof f == "object" && !Array.isArray(f) && "class" in f && typeof f.class == "string")
      return f.class;
  }, r = /* @__PURE__ */ new WeakMap();
  return { getCellValue: s, getCellClass: l, getCellMetadata: (o, u, c, f) => {
    let p = r.get(o);
    p || (p = /* @__PURE__ */ new WeakMap(), r.set(o, p));
    const d = p.get(u);
    if (d) return d;
    const g = u.format ? a(o[u.key], u, o) : o[u.key];
    let v = g, k;
    if (g && typeof g == "object" && !Array.isArray(g) && "text" in g && (v = g.text, k = g.class), u.cellClass) {
      const C = u.cellClass({ value: o[u.key], row: o, rowIndex: f });
      C && (k = k ? `${k} ${C}` : C);
    }
    const y = u.cellStyle ? u.cellStyle({ value: o[u.key], row: o, rowIndex: f }) : void 0, h = o.depth || 0, w = c === 0 && h ? { paddingLeft: `${h * 24 + 16}px` } : null, S = c === 0 && Qe(n) ? t(o) : !1, x = {
      formattedValue: v,
      cssClass: k,
      indentStyle: w,
      customStyle: y,
      isExpandable: S
    };
    return p.set(u, x), x;
  } };
}, iC = (e) => {
  const n = M(() => Qe(e.columns)), t = M(() => {
    const k = Qe(e.columnSetup);
    return typeof k == "string" || typeof k == "object";
  }), a = M(() => {
    const k = Qe(e.columnSetup);
    return typeof k == "string" ? {
      key: k,
      type: "indexedDB",
      allowReorder: !0
    } : typeof k == "object" ? {
      ...k,
      type: k.type || "indexedDB"
      // Default to indexedDB
    } : {};
  }), s = (k, y, h) => {
    const w = (O) => O.flatMap((P) => P.children && P.children.length ? w(P.children) : [P]), S = new Map(w(n.value).map((O) => [O.key, O])), x = [], C = k.fixed, _ = (O) => {
      var W;
      if (!k.visible.includes(O)) return;
      const P = S.get(O);
      if (P) {
        x.push({ ...P, fixed: (C == null ? void 0 : C[O]) || P.fixed });
        return;
      }
      const D = y == null ? void 0 : y.get(O);
      if (D) {
        x.push({
          key: D.key,
          label: D.label,
          fixed: C == null ? void 0 : C[O],
          sortable: D.sortable ?? h
        });
        return;
      }
      const B = (W = k.labels) == null ? void 0 : W[O];
      B && x.push({
        key: O,
        label: B,
        fixed: C == null ? void 0 : C[O],
        sortable: h
      });
    };
    return k.order.forEach(_), !x.length && k.visible.length && k.visible.forEach(_), x.length ? x : null;
  }, l = async () => {
    const k = t.value, y = Qe(e.columnPicker), h = !!y && typeof y == "object";
    if (!k && !h) return null;
    if (k) {
      const w = a.value;
      if (w.key)
        try {
          const x = await _l(w.key, w.type);
          if (x) return s(x);
        } catch (x) {
          console.warn("[VTable] Failed to load stored column setup", x);
        }
      const S = Array.isArray(w.initialVisible) ? w.initialVisible : null;
      if (S) {
        const x = n.value.filter((C) => S.includes(C.key));
        return S.length === 0 ? [] : x.length ? x : null;
      }
    }
    if (h && typeof y == "object") {
      const w = y.key, S = y.type;
      if (w)
        try {
          const x = await _l(w, S);
          if (x) {
            const C = /* @__PURE__ */ new Map();
            return y.groups.forEach((_) => _.items.forEach((O) => C.set(O.key, O))), s(x, C, y.defaultSortable);
          }
        } catch (x) {
          console.warn("[VTable] Failed to load stored column picker state", x);
        }
    }
    return null;
  }, r = ee(null), i = ee(null), o = ee(null);
  l().then((k) => {
    k !== null && (r.value = k);
  });
  const u = (k) => {
    r.value = [...k];
  }, c = () => {
    var k;
    (k = i.value) == null || k.close();
  }, f = () => {
    var k;
    (k = o.value) == null || k.close();
  }, p = M(() => {
    const k = Qe(e.columnPicker);
    return !!k && typeof k == "object";
  }), d = M(() => {
    const k = Qe(e.columnPicker);
    return !k || typeof k != "object" ? null : k;
  }), g = (k) => {
    const y = k.filter((S) => S.fixed === "left"), h = k.filter((S) => !S.fixed), w = k.filter((S) => S.fixed === "right");
    return !y.length && !w.length ? k : [...y, ...h, ...w];
  }, v = M(() => !t.value && !p.value ? g(n.value) : g(r.value ?? n.value));
  return {
    columnSetupEnabledBasic: t,
    columnSetupConfig: a,
    columnSetupPopoverRef: i,
    columnPickerPopoverRef: o,
    handleVisibleColumnsUpdate: u,
    handleColumnSetupClose: c,
    handleColumnPickerClose: f,
    columnPickerEnabled: p,
    columnPickerConfig: d,
    effectiveColumns: v
  };
}, oC = (e) => e ? e === !0 ? { enabled: !0, row: !0, column: !0 } : {
  enabled: !0,
  row: e.row ?? !0,
  column: e.column ?? !0
} : { enabled: !1, row: !1, column: !1 }, uC = (e) => {
  const n = ee(null), t = ee(null), a = () => Qe(e.config), s = M(() => n.value !== null || t.value !== null), l = (v) => n.value === null ? !1 : v !== void 0 && n.value === v, r = (v) => t.value === null ? !1 : t.value === v, i = () => {
    var v;
    (v = e.onChange) == null || v.call(e, {
      rowId: n.value,
      columnKey: t.value
    });
  };
  return {
    pinnedRowId: n,
    pinnedColumnKey: t,
    hasPin: s,
    isRowPinned: l,
    isColumnPinned: r,
    toggleRow: (v) => {
      const { enabled: k, row: y } = a();
      !k || !y || (n.value = n.value === v ? null : v, i());
    },
    toggleColumn: (v) => {
      const { enabled: k, column: y } = a();
      !k || !y || (t.value = t.value === v ? null : v, i());
    },
    unpinRow: () => {
      n.value !== null && (n.value = null, i());
    },
    unpinColumn: () => {
      t.value !== null && (t.value = null, i());
    },
    clear: () => {
      s.value && (n.value = null, t.value = null, i());
    },
    applyRemote: (v) => {
      const { enabled: k, row: y, column: h } = a();
      k && (n.value = y ? v.rowId : null, t.value = h ? v.columnKey : null);
    },
    setPin: (v) => {
      const { enabled: k, row: y, column: h } = a();
      k && (n.value = y ? v.rowId : null, t.value = h ? v.columnKey : null, i());
    }
  };
}, uf = Symbol("tablePageKey");
function c2(e = []) {
  const n = ee(1);
  return e.length && Be(e, () => {
    n.value === 1 ? _r(n) : n.value = 1;
  }, { flush: "pre", deep: !0 }), ga(uf, n), n;
}
function cC(e) {
  const { config: n, flattenedData: t, selectedRows: a, onSelectionChange: s } = e, l = ee(/* @__PURE__ */ new Set()), r = (x) => x.id;
  Be(
    a,
    (x) => {
      l.value = new Set(x.map((C) => r(C)));
    },
    { immediate: !0 }
  );
  const i = M(() => {
    var x;
    return ((x = n.value) == null ? void 0 : x.enabled) ?? !1;
  }), o = M(
    () => {
      var x;
      return ((x = n.value) == null ? void 0 : x.selectionMode) === "dependent";
    }
  ), u = (x) => l.value.has(x), c = (x) => {
    var C;
    return (C = n.value) != null && C.isRowSelectable ? n.value.isRowSelectable(x) : !0;
  }, f = (x) => {
    if (!x.children || x.children.length === 0) return [];
    const C = [], _ = (O) => {
      O.forEach((P) => {
        C.push(r(P)), P.children && _(P.children);
      });
    };
    return _(x.children), C;
  }, p = (x) => {
    if (!x.children || x.children.length === 0) return [];
    const C = [], _ = t.value.filter((D) => D.isExpanded), O = new Set(_.map((D) => r(D))), P = (D, B) => {
      D.forEach((W) => {
        if (B) {
          C.push(r(W));
          const H = O.has(r(W));
          W.children && P(W.children, H);
        }
      });
    };
    return P(x.children, !0), C;
  }, d = (x) => t.value.find(
    (C) => {
      var _;
      return (_ = C.children) == null ? void 0 : _.some((O) => O.id === x);
    }
  ), g = (x) => {
    var O;
    if (!x.children || x.children.length === 0)
      return u(r(x)) ? "checked" : "unchecked";
    const C = (O = n.value) != null && O.selectOnlyVisible ? p(x) : f(x);
    if (C.length === 0)
      return u(r(x)) ? "checked" : "unchecked";
    const _ = C.filter(
      (P) => l.value.has(P)
    ).length;
    return _ === 0 && !u(r(x)) ? "unchecked" : _ === C.length && u(r(x)) ? "checked" : "indeterminate";
  }, v = (x) => {
    var P, D, B, W, H, te;
    if (!i.value || !c(x)) return;
    const C = r(x), _ = u(C), O = new Set(l.value);
    if (_ ? (O.delete(C), o.value && ((P = n.value) != null && P.selectChildren) && ((D = n.value) != null && D.selectOnlyVisible ? p(x) : f(x)).forEach((oe) => O.delete(oe))) : (O.add(C), o.value && ((B = n.value) != null && B.selectChildren) && ((W = n.value) != null && W.selectOnlyVisible ? p(x) : f(x)).forEach((oe) => O.add(oe))), o.value && ((H = n.value) != null && H.selectParent)) {
      const re = d(C);
      re && ((((te = re.children) == null ? void 0 : te.map((ae) => r(ae))) || []).every(
        (ae) => O.has(ae)
      ) ? O.add(r(re)) : O.delete(r(re)));
    }
    l.value = O, h();
  }, k = () => {
    const x = t.value.filter(
      (_) => c(_)
    );
    if (x.length === 0) return "unchecked";
    const C = x.filter(
      (_) => u(r(_))
    ).length;
    return C === 0 ? "unchecked" : C === x.length ? "checked" : "indeterminate";
  }, y = () => {
    if (!i.value) return;
    const x = k(), C = new Set(l.value), _ = t.value.filter(
      (O) => c(O)
    );
    x === "checked" ? _.forEach((O) => {
      C.delete(r(O));
    }) : _.forEach((O) => {
      C.add(r(O));
    }), l.value = C, h();
  }, h = () => {
    const x = (O, P) => {
      for (const D of P) {
        if (D.id === O) return D;
        if (D.children) {
          const B = x(O, D.children);
          if (B) return B;
        }
      }
    }, C = t.value.map((O) => {
      const { depth: P, parentId: D, hasChildren: B, isExpanded: W, ...H } = O;
      return H;
    }), _ = Array.from(l.value).map((O) => x(O, C)).filter((O) => O !== void 0);
    s(_);
  };
  return {
    // State
    isEnabled: i,
    isDependentMode: o,
    selectedIds: l,
    // Methods
    isRowSelected: u,
    isRowSelectable: c,
    toggleRow: v,
    toggleAllRows: y,
    getParentCheckboxState: g,
    getHeaderCheckboxState: k,
    clearSelection: () => {
      l.value = /* @__PURE__ */ new Set(), h();
    },
    selectRows: (x) => {
      l.value = new Set(x), h();
    }
  };
}
const dC = (e) => {
  const {
    sort: n = {},
    sortState: t,
    columns: a,
    page: s,
    pageSize: l,
    data: r,
    onRequest: i,
    onSort: o,
    onUpdateSortState: u
  } = e, c = M(() => ({
    type: n.type || "server",
    multiple: n.multiple !== void 0 ? n.multiple : !0
  })), f = ee((t == null ? void 0 : t.value) || []);
  t && Be(t, (x) => {
    f.value = x || [];
  });
  const p = (x, C) => {
    const _ = a.value.find((D) => D.key === C);
    if (_ != null && _.sortValue)
      return _.sortValue(x, C);
    const O = C.split(".");
    let P = x;
    for (const D of O) {
      if (P == null) return null;
      P = P[D];
    }
    return P;
  }, d = (x, C, _) => {
    if (x == null && C == null) return 0;
    if (x == null) return 1;
    if (C == null) return -1;
    const O = typeof x == "string" ? parseFloat(x) : x, P = typeof C == "string" ? parseFloat(C) : C;
    if (typeof O == "number" && typeof P == "number" && !Number.isNaN(O) && !Number.isNaN(P))
      return _ === "asc" ? O - P : P - O;
    const D = String(x).toLowerCase(), B = String(C).toLowerCase();
    return _ === "asc" ? D.localeCompare(B, void 0, { numeric: !0 }) : B.localeCompare(D, void 0, { numeric: !0 });
  }, g = (x, C) => C.length === 0 ? [...x] : [...x].sort((_, O) => {
    for (const P of C) {
      const D = p(_, P.field), B = p(O, P.field), W = d(D, B, P.order);
      if (W !== 0)
        return W;
    }
    return 0;
  }), v = M(() => c.value.type !== "front" || !r ? (r == null ? void 0 : r.value) || [] : g(r.value, f.value)), k = (x) => {
    const C = f.value.find((_) => _.field === x);
    return {
      isSorted: !!C,
      order: (C == null ? void 0 : C.order) || null,
      index: C ? f.value.indexOf(C) : -1
      // For multi-sort indicator
    };
  }, y = (x) => x ? x === "asc" ? "desc" : null : "asc", h = (x) => {
    if (!x.sortable) return;
    const C = x.key, _ = k(C), O = y(_.order);
    let P;
    if (c.value.multiple ? O === null ? P = f.value.filter((D) => D.field !== C) : _.isSorted ? P = f.value.map(
      (D) => D.field === C ? { field: C, order: O } : D
    ) : P = [...f.value, { field: C, order: O }] : O === null ? P = [] : P = [{ field: C, order: O }], f.value = P, u == null || u(P), c.value.type === "front") {
      if (P.length > 0) {
        const D = P.find((B) => B.field === C);
        D && (o == null || o({
          field: C,
          order: D.order,
          sortState: P
        }));
      }
    } else {
      const D = {
        // page: page?.value ?? 1,
        page: 1,
        pageSize: (l == null ? void 0 : l.value) ?? 10,
        sort: P
      };
      i == null || i(D);
    }
  }, w = M(() => f.value.length > 0);
  return {
    sortState: f,
    sortConfig: c,
    getSortState: k,
    handleSortClick: h,
    hasSortedColumns: w,
    resetSort: () => {
      if (f.value = [], u == null || u([]), c.value.type === "server") {
        const x = {
          page: (s == null ? void 0 : s.value) ?? 1,
          pageSize: (l == null ? void 0 : l.value) ?? 10,
          sort: []
        };
        i == null || i(x);
      }
    },
    // Frontend sorting
    sortedData: v
    // Reactive sorted data for frontend sorting
  };
};
function Ra(e, n, t) {
  let a = t.initialDeps ?? [], s, l = !0;
  function r() {
    var i, o, u;
    let c;
    t.key && ((i = t.debug) != null && i.call(t)) && (c = Date.now());
    const f = e();
    if (!(f.length !== a.length || f.some((g, v) => a[v] !== g)))
      return s;
    a = f;
    let d;
    if (t.key && ((o = t.debug) != null && o.call(t)) && (d = Date.now()), s = n(...f), t.key && ((u = t.debug) != null && u.call(t))) {
      const g = Math.round((Date.now() - c) * 100) / 100, v = Math.round((Date.now() - d) * 100) / 100, k = v / 16, y = (h, w) => {
        for (h = String(h); h.length < w; )
          h = " " + h;
        return h;
      };
      console.info(
        `%c⏱ ${y(v, 5)} /${y(g, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * k, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return t != null && t.onChange && !(l && t.skipInitialOnChange) && t.onChange(s), l = !1, s;
  }
  return r.updateDeps = (i) => {
    a = i;
  }, r;
}
function wu(e, n) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const fC = (e, n) => Math.abs(e - n) < 1.01, hC = (e, n, t) => {
  let a;
  return function(...s) {
    e.clearTimeout(a), a = e.setTimeout(() => n.apply(this, s), t);
  };
}, ku = (e) => {
  const { offsetWidth: n, offsetHeight: t } = e;
  return { width: n, height: t };
}, mC = (e) => e, vC = (e) => {
  const n = Math.max(e.startIndex - e.overscan, 0), t = Math.min(e.endIndex + e.overscan, e.count - 1), a = [];
  for (let s = n; s <= t; s++)
    a.push(s);
  return a;
}, pC = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  const s = (r) => {
    const { width: i, height: o } = r;
    n({ width: Math.round(i), height: Math.round(o) });
  };
  if (s(ku(t)), !a.ResizeObserver)
    return () => {
    };
  const l = new a.ResizeObserver((r) => {
    const i = () => {
      const o = r[0];
      if (o != null && o.borderBoxSize) {
        const u = o.borderBoxSize[0];
        if (u) {
          s({ width: u.inlineSize, height: u.blockSize });
          return;
        }
      }
      s(ku(t));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(i) : i();
  });
  return l.observe(t, { box: "border-box" }), () => {
    l.unobserve(t);
  };
}, xu = {
  passive: !0
}, Su = typeof window > "u" ? !0 : "onscrollend" in window, gC = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  let s = 0;
  const l = e.options.useScrollendEvent && Su ? () => {
  } : hC(
    a,
    () => {
      n(s, !1);
    },
    e.options.isScrollingResetDelay
  ), r = (c) => () => {
    const { horizontal: f, isRtl: p } = e.options;
    s = f ? t.scrollLeft * (p && -1 || 1) : t.scrollTop, l(), n(s, c);
  }, i = r(!0), o = r(!1);
  t.addEventListener("scroll", i, xu);
  const u = e.options.useScrollendEvent && Su;
  return u && t.addEventListener("scrollend", o, xu), () => {
    t.removeEventListener("scroll", i), u && t.removeEventListener("scrollend", o);
  };
}, yC = (e, n, t) => {
  if (n != null && n.borderBoxSize) {
    const a = n.borderBoxSize[0];
    if (a)
      return Math.round(
        a[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[t.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, bC = (e, {
  adjustments: n = 0,
  behavior: t
}, a) => {
  var s, l;
  const r = e + n;
  (l = (s = a.scrollElement) == null ? void 0 : s.scrollTo) == null || l.call(s, {
    [a.options.horizontal ? "left" : "top"]: r,
    behavior: t
  });
};
class wC {
  constructor(n) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.currentScrollToIndex = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const a = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((l) => {
          const r = () => {
            this._measureElement(l.target, l);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(r) : r();
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = a()) == null || s.disconnect(), t = null;
        },
        observe: (s) => {
          var l;
          return (l = a()) == null ? void 0 : l.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var l;
          return (l = a()) == null ? void 0 : l.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([a, s]) => {
        typeof s > "u" && delete t[a];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: mC,
        rangeExtractor: vC,
        onChange: () => {
        },
        measureElement: yC,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...t
      };
    }, this.notify = (t) => {
      var a, s;
      (s = (a = this.options).onChange) == null || s.call(a, this, t);
    }, this.maybeNotify = Ra(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const a = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== a) {
        if (this.cleanup(), !a) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = a, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, l) => {
            this.scrollAdjustments = 0, this.scrollDirection = l ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = l, this.maybeNotify();
          })
        ), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, a) => {
      const s = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
      for (let r = a - 1; r >= 0; r--) {
        const i = t[r];
        if (s.has(i.lane))
          continue;
        const o = l.get(
          i.lane
        );
        if (o == null || i.end > o.end ? l.set(i.lane, i) : i.end < o.end && s.set(i.lane, !0), s.size === this.options.lanes)
          break;
      }
      return l.size === this.options.lanes ? Array.from(l.values()).sort((r, i) => r.end === i.end ? r.index - i.index : r.end - i.end)[0] : void 0;
    }, this.getMeasurementOptions = Ra(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (t, a, s, l, r, i) => (this.prevLanes !== void 0 && this.prevLanes !== i && (this.lanesChangedFlag = !0), this.prevLanes = i, this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: a,
        scrollMargin: s,
        getItemKey: l,
        enabled: r,
        lanes: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Ra(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: a, scrollMargin: s, getItemKey: l, enabled: r, lanes: i }, o) => {
        if (!r)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > t)
          for (const p of this.laneAssignments.keys())
            p >= t && this.laneAssignments.delete(p);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((p) => {
          this.itemSizeCache.set(p.key, p.size);
        }));
        const u = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === t && (this.lanesSettling = !1);
        const c = this.measurementsCache.slice(0, u), f = new Array(i).fill(
          void 0
        );
        for (let p = 0; p < u; p++) {
          const d = c[p];
          d && (f[d.lane] = p);
        }
        for (let p = u; p < t; p++) {
          const d = l(p), g = this.laneAssignments.get(p);
          let v, k;
          if (g !== void 0 && this.options.lanes > 1) {
            v = g;
            const S = f[v], x = S !== void 0 ? c[S] : void 0;
            k = x ? x.end + this.options.gap : a + s;
          } else {
            const S = this.options.lanes === 1 ? c[p - 1] : this.getFurthestMeasurement(c, p);
            k = S ? S.end + this.options.gap : a + s, v = S ? S.lane : p % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(p, v);
          }
          const y = o.get(d), h = typeof y == "number" ? y : this.options.estimateSize(p), w = k + h;
          c[p] = {
            index: p,
            start: k,
            size: h,
            end: w,
            key: d,
            lane: v
          }, f[v] = p;
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Ra(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (t, a, s, l) => this.range = t.length > 0 && a > 0 ? kC({
        measurements: t,
        outerSize: a,
        scrollOffset: s,
        lanes: l
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Ra(
      () => {
        let t = null, a = null;
        const s = this.calculateRange();
        return s && (t = s.startIndex, a = s.endIndex), this.maybeNotify.updateDeps([this.isScrolling, t, a]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          t,
          a
        ];
      },
      (t, a, s, l, r) => l === null || r === null ? [] : t({
        startIndex: l,
        endIndex: r,
        overscan: a,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const a = this.options.indexAttribute, s = t.getAttribute(a);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${a}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, a) => {
      const s = this.indexFromElement(t), l = this.measurementsCache[s];
      if (!l)
        return;
      const r = l.key, i = this.elementsCache.get(r);
      i !== t && (i && this.observer.unobserve(i), this.observer.observe(t), this.elementsCache.set(r, t)), t.isConnected && this.resizeItem(s, this.options.measureElement(t, a, this));
    }, this.resizeItem = (t, a) => {
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const l = this.itemSizeCache.get(s.key) ?? s.size, r = a - l;
      r !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, r, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", r), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += r,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, a)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((a, s) => {
          a.isConnected || (this.observer.unobserve(a), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = Ra(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (t, a) => {
        const s = [];
        for (let l = 0, r = t.length; l < r; l++) {
          const i = t[l], o = a[i];
          s.push(o);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const a = this.getMeasurements();
      if (a.length !== 0)
        return wu(
          a[cf(
            0,
            a.length - 1,
            (s) => wu(a[s]).start,
            t
          )]
        );
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const t = this.scrollElement.document.documentElement;
        return this.options.horizontal ? t.scrollWidth - this.scrollElement.innerWidth : t.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getOffsetForAlignment = (t, a, s = 0) => {
      if (!this.scrollElement) return 0;
      const l = this.getSize(), r = this.getScrollOffset();
      a === "auto" && (a = t >= r + l ? "end" : "start"), a === "center" ? t += (s - l) / 2 : a === "end" && (t -= l);
      const i = this.getMaxScrollOffset();
      return Math.max(Math.min(i, t), 0);
    }, this.getOffsetForIndex = (t, a = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const l = this.getSize(), r = this.getScrollOffset();
      if (a === "auto")
        if (s.end >= r + l - this.options.scrollPaddingEnd)
          a = "end";
        else if (s.start <= r + this.options.scrollPaddingStart)
          a = "start";
        else
          return [r, a];
      if (a === "end" && t === this.options.count - 1)
        return [this.getMaxScrollOffset(), a];
      const i = a === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(i, a, s.size),
        a
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (t, { align: a = "start", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, a), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (t, { align: a = "auto", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), t = Math.max(0, Math.min(t, this.options.count - 1)), this.currentScrollToIndex = t;
      let l = 0;
      const r = 10, i = (u) => {
        if (!this.targetWindow) return;
        const c = this.getOffsetForIndex(t, u);
        if (!c) {
          console.warn("Failed to get offset for index:", t);
          return;
        }
        const [f, p] = c;
        this._scrollToOffset(f, { adjustments: void 0, behavior: s }), this.targetWindow.requestAnimationFrame(() => {
          const d = () => {
            if (this.currentScrollToIndex !== t) return;
            const g = this.getScrollOffset(), v = this.getOffsetForIndex(t, p);
            if (!v) {
              console.warn("Failed to get offset for index:", t);
              return;
            }
            fC(v[0], g) || o(p);
          };
          this.isDynamicMode() ? this.targetWindow.requestAnimationFrame(d) : d();
        });
      }, o = (u) => {
        this.targetWindow && this.currentScrollToIndex === t && (l++, l < r ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", l, r), this.targetWindow.requestAnimationFrame(() => i(u))) : console.warn(
          `Failed to scroll to index ${t} after ${r} attempts.`
        ));
      };
      i(a);
    }, this.scrollBy = (t, { behavior: a } = {}) => {
      a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: a
      });
    }, this.getTotalSize = () => {
      var t;
      const a = this.getMeasurements();
      let s;
      if (a.length === 0)
        s = this.options.paddingStart;
      else if (this.options.lanes === 1)
        s = ((t = a[a.length - 1]) == null ? void 0 : t.end) ?? 0;
      else {
        const l = Array(this.options.lanes).fill(null);
        let r = a.length - 1;
        for (; r >= 0 && l.some((i) => i === null); ) {
          const i = a[r];
          l[i.lane] === null && (l[i.lane] = i.end), r--;
        }
        s = Math.max(...l.filter((i) => i !== null));
      }
      return Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: a,
      behavior: s
    }) => {
      this.options.scrollToFn(t, { behavior: s, adjustments: a }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(n);
  }
}
const cf = (e, n, t, a) => {
  for (; e <= n; ) {
    const s = (e + n) / 2 | 0, l = t(s);
    if (l < a)
      e = s + 1;
    else if (l > a)
      n = s - 1;
    else
      return s;
  }
  return e > 0 ? e - 1 : 0;
};
function kC({
  measurements: e,
  outerSize: n,
  scrollOffset: t,
  lanes: a
}) {
  const s = e.length - 1, l = (o) => e[o].start;
  if (e.length <= a)
    return {
      startIndex: 0,
      endIndex: s
    };
  let r = cf(
    0,
    s,
    l,
    t
  ), i = r;
  if (a === 1)
    for (; i < s && e[i].end < t + n; )
      i++;
  else if (a > 1) {
    const o = Array(a).fill(0);
    for (; i < s && o.some((c) => c < t + n); ) {
      const c = e[i];
      o[c.lane] = c.end, i++;
    }
    const u = Array(a).fill(t + n);
    for (; r >= 0 && u.some((c) => c >= t); ) {
      const c = e[r];
      u[c.lane] = c.start, r--;
    }
    r = Math.max(0, r - r % a), i = Math.min(s, i + (a - 1 - i % a));
  }
  return { startIndex: r, endIndex: i };
}
function xC(e) {
  const n = new wC(m(e)), t = It(n), a = n._didMount();
  return Be(
    () => m(e).getScrollElement(),
    (s) => {
      s && n._willUpdate();
    },
    {
      immediate: !0
    }
  ), Be(
    () => m(e),
    (s) => {
      n.setOptions({
        ...s,
        onChange: (l, r) => {
          var i;
          _r(t), (i = s.onChange) == null || i.call(s, l, r);
        }
      }), n._willUpdate(), _r(t);
    },
    {
      immediate: !0
    }
  ), Ol(a), t;
}
function SC(e) {
  return xC(
    M(() => ({
      observeElementRect: pC,
      observeElementOffset: gC,
      scrollToFn: bC,
      ...m(e)
    }))
  );
}
function TC(e, n, t = {}) {
  const {
    estimateSize: a = 50,
    overscan: s = 3,
    measureElement: l = !1
  } = t, r = It(!1);
  let i = null, o = !1;
  const u = {
    get count() {
      return n.value.length;
    },
    getScrollElement: () => e.value,
    estimateSize: () => a,
    overscan: s,
    scrollingDelay: 150
  };
  l && (u.measureElement = (h) => !h || r.value ? a : h.getBoundingClientRect().height || a);
  const c = SC(u), f = M(() => c.value.getVirtualItems()), p = M(() => c.value.getTotalSize()), d = () => {
    r.value = !0, i && clearTimeout(i), i = setTimeout(() => {
      r.value = !1;
    }, 150);
  }, g = () => {
    const h = e.value;
    !h || !c.value || (c.value.measure(), h.dispatchEvent(new Event("scroll", { bubbles: !0 })));
  }, v = () => {
    const h = e.value;
    h && !o && (h.addEventListener("scroll", d, { passive: !0 }), o = !0);
  }, k = () => {
    const h = e.value;
    h && o && (h.removeEventListener("scroll", d), o = !1);
  }, y = () => {
    i && (clearTimeout(i), i = null);
  };
  return et(() => {
    requestAnimationFrame(() => {
      v();
    });
  }), Eu(() => {
    requestAnimationFrame(() => {
      g(), v();
    });
  }), Ou(() => {
    y();
  }), Jt(() => {
    k(), y();
  }), {
    virtualizer: c,
    virtualItems: f,
    totalSize: p,
    remeasure: g
  };
}
const $C = {
  key: 1,
  ref: "toolbarSlot",
  class: "v-table-toolbar-slot"
}, MC = { class: "v-table-container-wrapper" }, CC = {
  key: 1,
  class: "v-table-header-checkbox-cell v-table-header-checkbox-cell--empty"
}, DC = ["onClick"], _C = {
  key: 0,
  class: "v-table-total-cell v-table-checkbox-cell"
}, OC = { class: "v-table-total-content" }, EC = {
  key: 0,
  class: "v-table-total-spacer"
}, d2 = /* @__PURE__ */ xe({
  inheritAttrs: !1,
  __name: "VTable",
  props: /* @__PURE__ */ Ht({
    columns: {},
    data: {},
    loading: { type: Boolean, default: !1 },
    virtualized: { type: Boolean, default: !0 },
    rowHeight: { default: 50 },
    height: {},
    totalRow: {},
    selectedRows: {},
    multiSelect: {},
    expandMode: { default: "auto" },
    sort: { default: () => ({ type: "server", multiple: !0 }) },
    sortState: {},
    pagination: {},
    page: {},
    pageSize: {},
    toolbar: { default: void 0 },
    search: { default: "" },
    rowClassName: {},
    scrollSync: {},
    highlight: { type: [Boolean, Object] },
    highlightState: {},
    highlightSync: {}
  }, {
    search: {},
    searchModifiers: {}
  }),
  emits: /* @__PURE__ */ Ht(["row-click", "update:selected-rows", "expand-click", "update:sort-state", "update:highlight-state", "update:page", "update:pageSize", "request", "sort", "update:search", "toolbar:refresh", "toolbar:reset-sort", "toolbar:export"], ["update:search"]),
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, l = Ut(), r = li(), i = Xe("wrapper"), o = Xe("fullscreenPlaceholder"), u = Xe("toolbarSlot"), c = Xe("pagination");
    ga("tableSlots", {
      headerCellCustomAction: l["header-cell-custom-action"],
      toolbarTitle: l["toolbar-title"],
      toolbarSearch: l["toolbar-search"],
      toolbarFilters: l["toolbar-filters"],
      toolbarActions: l["toolbar-actions"],
      toolbarColumnActions: l["toolbar-column-actions"],
      emptyState: l["empty-state"]
    });
    const f = En(e, "search"), p = M(() => {
      var ne;
      return ((ne = a.toolbar) == null ? void 0 : ne.enabled) || l.toolbar;
    }), d = M(() => {
      var ne, Se;
      return !!p.value && ((Se = (ne = a.toolbar) == null ? void 0 : ne.actions) == null ? void 0 : Se.fullscreen) !== !1;
    }), {
      isFullscreen: g,
      zIndex: v,
      placeholderStyle: k,
      panelStyle: y,
      contentHeight: h,
      toggle: w
    } = ax({
      wrapperRef: i,
      placeholderRef: o,
      // The toolbar/pagination chrome is already rendered and is the same size in
      // both fullscreen and normal mode — the composable measures it before the
      // fullscreen flag flips (see useTableFullScreen's enter()) so
      // fullscreenContentHeight is a final px value on the very first fullscreen
      // render (see scrollContainerStyle below).
      chromeRefs: [u, c],
      isEnabled: d,
      // The scroll container's own height changed the instant the fullscreen class
      // applied — the virtualizer's cached scroll element rect is now stale. We
      // don't preserve scroll position across the toggle, so reset to top and
      // force a remeasure (delegated to useVirtualTable's own remeasure()) instead
      // of waiting for the user's next real scroll to reveal any rows.
      onToggle: () => {
        const ne = $t.value;
        ne && (ne.scrollTop = 0, ne.scrollLeft = 0), ut();
      }
    }), S = M(() => r.class), x = M(() => {
      const ne = r.style, Se = typeof ne == "object" && ne !== null ? ne : {};
      if (k.value)
        return { ...Se, ...k.value };
    }), C = () => {
      var qe, Ae;
      s("toolbar:refresh");
      const ne = (Ae = (qe = a.toolbar) == null ? void 0 : qe.actions) == null ? void 0 : Ae.refresh;
      (typeof ne == "object" ? ne.mode ?? "default" : ne) !== "custom" && (A.value = [], L.value = 1, At.collapseAll(), bt.clear(), s("request", {
        page: L.value,
        pageSize: $e.value,
        sort: []
      }));
    }, _ = () => {
      var Se, qe;
      s("toolbar:reset-sort"), ((qe = (Se = a.toolbar) == null ? void 0 : Se.actions) == null ? void 0 : qe.resetSort) !== "custom" && (A.value = [], L.value = 1, At.collapseAll(), bt.clear(), s("request", {
        page: L.value,
        pageSize: $e.value,
        sort: []
      }));
    }, O = (ne, Se) => {
      s("toolbar:export", ne, Se);
    }, {
      columnSetupEnabledBasic: P,
      columnSetupConfig: D,
      columnSetupPopoverRef: B,
      columnPickerPopoverRef: W,
      handleVisibleColumnsUpdate: H,
      handleColumnSetupClose: te,
      handleColumnPickerClose: re,
      columnPickerEnabled: oe,
      columnPickerConfig: K,
      effectiveColumns: ae
    } = iC({
      columns: () => a.columns,
      columnSetup: () => {
        var ne, Se;
        return (Se = (ne = a.toolbar) == null ? void 0 : ne.actions) == null ? void 0 : Se.columnSetup;
      },
      columnPicker: () => {
        var ne, Se;
        return (Se = (ne = a.toolbar) == null ? void 0 : ne.actions) == null ? void 0 : Se.columnPicker;
      }
    }), U = M(() => a.totalRow !== void 0), z = ee(/* @__PURE__ */ new Map()), {
      hasGroups: J,
      flatColumns: de,
      headerLevels: pe,
      getGroupWidth: ge,
      isGroupFixed: Me
    } = aC(ae, z), be = M(() => P.value ? J.value ? (console.warn("Column Setup is not supported with grouped headers yet"), !1) : !0 : !1), q = M(() => J.value ? de.value : ae.value), {
      gridTemplateColumns: ye,
      getGridTemplateWithCheckbox: Ce,
      startResize: V,
      autoFitColumn: G,
      isResizing: he,
      resizedWidths: j,
      isColumnResizable: se
    } = eC(q);
    Be(j, () => {
      const ne = /* @__PURE__ */ new Map();
      q.value.forEach((Se) => {
        var Ae;
        const qe = j.value.get(Se.key);
        qe !== void 0 ? ne.set(Se.key, qe) : (Ae = Se.width) != null && Ae.endsWith("px") && ne.set(Se.key, parseInt(Se.width, 10));
      }), z.value = ne;
    }, { immediate: !0 });
    const {
      getFixedStyles: me,
      isLastLeftFixed: I,
      isFirstRightFixed: N
    } = nC(q, z), T = M(() => a.height ? typeof a.height == "number" ? `${a.height}px` : a.height : "600px"), R = M(() => g.value ? {
      height: `${h.value}px`,
      overscrollBehavior: "contain"
    } : { height: T.value, overscrollBehavior: "contain" }), A = M({
      get: () => a.sortState || [],
      set: (ne) => s("update:sort-state", ne)
    }), Z = On(uf, null), L = M({
      get: () => {
        var ne;
        return a.page ?? (Z == null ? void 0 : Z.value) ?? ((ne = a.pagination) == null ? void 0 : ne.page) ?? 1;
      },
      set: (ne) => {
        a.page !== void 0 ? s("update:page", ne) : Z && (Z.value = ne);
      }
    }), fe = M(() => {
      var ne, Se;
      return ((ne = a.pagination) == null ? void 0 : ne.showSizeChanger) ?? ((Se = a.pagination) == null ? void 0 : Se.pageSizeOptions) !== void 0;
    }), $e = M({
      get: () => {
        var ne;
        return a.pageSize ?? ((ne = a.pagination) == null ? void 0 : ne.pageSize) ?? 10;
      },
      set: (ne) => {
        a.pageSize !== void 0 && s("update:pageSize", ne);
      }
    }), {
      getSortState: Re,
      handleSortClick: _e,
      sortedData: We
    } = dC({
      sort: a.sort,
      sortState: A,
      columns: ae,
      page: M(() => {
        var ne;
        return (ne = a.pagination) == null ? void 0 : ne.page;
      }),
      pageSize: M(() => {
        var ne;
        return (ne = a.pagination) == null ? void 0 : ne.pageSize;
      }),
      data: M(() => a.data),
      // Pass data for frontend sorting
      onRequest: (ne) => {
        L.value = ne.page, At.collapseAll(), bt.clear(), s("request", ne);
      },
      onSort: (ne) => s("sort", ne),
      onUpdateSortState: (ne) => s("update:sort-state", ne)
    }), Rt = (ne) => {
      _e(ne);
    }, un = M(() => {
      var qe;
      const ne = ((qe = a.sort) == null ? void 0 : qe.type) === "front" ? We.value : a.data, Se = (Ae, ft = "") => Ae.map((Ot, Nn) => {
        var Js;
        const us = Ot.id ?? `${ft}row-${Nn}`, jn = (Js = Ot.children) != null && Js.length ? Se(Ot.children, `${us}-`) : Ot.children;
        return Ot.id !== void 0 && jn === Ot.children ? Ot : { ...Ot, id: us, children: jn };
      });
      return Se(ne);
    }), cn = M(
      () => un.value.some((ne) => ne.children && ne.children.length > 0)
    ), Fn = M(() => un.value), At = tC(Fn), Wt = M(() => cn.value ? At.flattenedData.value : un.value), Vn = M(() => a.multiSelect), xn = M({
      get: () => a.selectedRows || [],
      set: (ne) => s("update:selected-rows", ne)
    }), Tt = cC({
      config: Vn,
      flattenedData: Wt,
      selectedRows: xn,
      onSelectionChange: (ne) => {
        s("update:selected-rows", ne);
      }
    }), $t = ee(null), {
      virtualItems: yt,
      totalSize: Ee,
      remeasure: ut
    } = TC(
      $t,
      Wt,
      {
        estimateSize: a.rowHeight,
        overscan: 2,
        // Reduced from 5 for better performance
        // PERFORMANCE: Disable measureElement to prevent memory leaks
        // Using fixed height improves performance dramatically for large datasets
        // Trade-off: scroll bar may be slightly inaccurate with expanded rows
        measureElement: !1
      }
    ), Dt = M(() => ({
      display: "grid",
      gridTemplateColumns: Tt.isEnabled.value ? Ce(50) : ye.value,
      gridAutoRows: "auto"
      // All rows auto-sized (headers get height from CSS)
    })), Sn = (ne) => {
      s("row-click", ne);
    }, Ln = ({ page: ne, pageSize: Se }) => {
      !a.pagination || a.loading || ($t.value && $t.value.scrollTop > 0 && $t.value.scrollTo({
        top: 0,
        behavior: "smooth"
      }), L.value = ne, $e.value = Se, At.collapseAll(), bt.clear(), s("request", {
        page: ne,
        pageSize: Se,
        sort: A.value
      }));
    }, Ma = (ne) => {
      const Se = ne.target;
      a.scrollSync && a.scrollSync.onScroll(Se.scrollLeft, Se.scrollTop);
    }, os = (ne, Se, qe) => {
      cn.value && (a.expandMode === "controlled" ? s("expand-click", {
        row: Se,
        column: qe,
        callback: () => At.toggleRow(ne),
        expanded: Ks(Se)
      }) : (At.toggleRow(ne), s("expand-click", {
        row: Se,
        column: qe,
        callback: () => {
        },
        // Already toggled, callback is no-op
        expanded: !Ks(Se)
        // New state after toggle
      })));
    }, Ks = (ne) => ne.isExpanded || !1, Jl = (ne) => ne.hasChildren || !1, { getCellValue: Ql, getCellClass: er, getCellMetadata: Zs } = rC({
      isExpandable: cn,
      isRowExpandable: (ne) => At.isExpandable(ne)
    });
    ga("tableCellMetadata", Zs);
    const qn = M(() => oC(a.highlight)), Xs = () => {
      const ne = bt.pinnedRowId.value, Se = bt.pinnedColumnKey.value;
      if (ne === null && Se === null) return null;
      const qe = ne === null ? -1 : Wt.value.findIndex((jn) => jn.id === ne), Ae = qe >= 0 ? Wt.value[qe] : void 0, ft = Se === null ? void 0 : q.value.find((jn) => jn.key === Se), Ot = Ae && ne !== null ? { rowId: ne, rowIndex: qe, row: Ae } : null, Nn = ft && Se !== null ? { columnKey: Se, column: ft } : null;
      let us = null;
      if (Ot && Nn) {
        const jn = q.value.indexOf(Nn.column), Js = Zs(Ot.row, Nn.column, jn, Ot.rowIndex);
        us = {
          value: Ot.row[Nn.columnKey],
          formattedValue: String(Js.formattedValue ?? "")
        };
      }
      return { row: Ot, column: Nn, cell: us };
    }, bt = uC({
      config: qn,
      onChange: (ne) => {
        var Se;
        s("update:highlight-state", Xs()), (Se = a.highlightSync) == null || Se.broadcast(ne);
      }
    }), tr = (ne) => {
      bt.applyRemote(ne), s("update:highlight-state", Xs());
    }, Q = (ne) => bt.isRowPinned(ne);
    ga("tableHighlight", {
      columnEnabled: M(() => qn.value.column),
      isColumnPinned: bt.isColumnPinned,
      toggleColumn: bt.toggleColumn
    });
    const ve = (ne, Se) => a.rowClassName ? typeof a.rowClassName == "string" ? a.rowClassName : typeof a.rowClassName == "function" ? a.rowClassName(ne, Se) : "" : "", Pe = M(() => a.virtualized ? $t.value ? yt.value.length === 0 ? [] : yt.value.map((ne) => {
      const Se = Wt.value[ne.index], qe = Se ? ve(Se, ne.index) : "";
      return {
        row: Se,
        index: ne.index,
        // CRITICAL: Use row.id as key, not index! Index causes memory leaks
        // because Vue reuses components for different data at same index
        key: (Se == null ? void 0 : Se.id) || `row-${ne.index}`,
        isVirtual: !0,
        virtualRow: ne,
        rowClass: qe,
        isCustomRow: !!qe
      };
    }) : [] : Wt.value.map((ne, Se) => {
      const qe = ve(ne, Se);
      return {
        row: ne,
        index: Se,
        key: ne.id || Se,
        isVirtual: !1,
        rowClass: qe,
        isCustomRow: !!qe
      };
    })), He = (ne) => ne.isVirtual ? {
      height: `${a.rowHeight}px`,
      minHeight: `${a.rowHeight}px`
    } : {}, tt = (ne) => {
      const Se = [], qe = ne.fixed || (J.value ? Me(ne) : null);
      return qe && (Se.push("v-table-fixed-column"), qe === "left" ? Se.push("v-table-fixed-left") : qe === "right" && Se.push("v-table-fixed-right"), I(ne.key) && Se.push("v-table-fixed-left-last"), N(ne.key) && Se.push("v-table-fixed-right-first")), bt.isColumnPinned(ne.key) && Se.push("v-table-cell--pinned-col"), Se;
    }, qt = M(() => {
      const ne = /* @__PURE__ */ new Map();
      return q.value.forEach((Se) => {
        ne.set(Se.key, tt(Se));
      }), J.value && pe.value.forEach((Se) => {
        Se.forEach((qe) => {
          ne.has(qe.column.key) || ne.set(qe.column.key, tt(qe.column));
        });
      }), ne;
    }), jt = (ne) => qt.value.get(ne.key) ?? [], ra = (ne) => Me(ne) ? me(ne) : {}, Ca = M(() => J.value ? kM : SM), ia = M(() => J.value ? pe.value : q.value);
    return Jt(() => {
      var ne, Se;
      At && At.collapseAll(), $t.value = null, (ne = a.scrollSync) == null || ne.unregister(), (Se = a.highlightSync) == null || Se.unregister();
    }), et(() => {
      var ne;
      (ne = a.highlightSync) == null || ne.register(tr), a.scrollSync && $t.value && a.scrollSync.register($t.value);
    }), qn.value.enabled && (Be(() => a.highlightState, (ne) => {
      var Ae, ft;
      const Se = ((Ae = ne == null ? void 0 : ne.row) == null ? void 0 : Ae.rowId) ?? null, qe = ((ft = ne == null ? void 0 : ne.column) == null ? void 0 : ft.columnKey) ?? null;
      Se === bt.pinnedRowId.value && qe === bt.pinnedColumnKey.value || bt.setPin({ rowId: Se, columnKey: qe });
    }), Be(qn, (ne) => {
      if (!ne.enabled) {
        bt.clear();
        return;
      }
      ne.row || bt.unpinRow(), ne.column || bt.unpinColumn();
    })), n({ visibleColumns: ae }), (ne, Se) => {
      var qe;
      return b(), $(Te, null, [
        (b(), ue(Pn, {
          disabled: !m(g),
          to: "body"
        }, [
          E("div", lt({
            ref: "wrapper",
            class: [{
              "v-table-wrapper--with-toolbar": p.value,
              "v-table-wrapper--fullscreen": m(g)
            }, "v-table-wrapper"],
            style: m(g) ? { ...m(y), zIndex: m(v) + 1 } : void 0
          }, m(r)), [
            d.value ? (b(), ue(uM, {
              key: 0,
              "is-fullscreen": m(g),
              onToggle: m(w)
            }, null, 8, ["is-fullscreen", "onToggle"])) : F("", !0),
            p.value ? (b(), $("div", $C, [
              m(l).toolbar ? Y(ne.$slots, "toolbar", { key: 0 }) : (qe = e.toolbar) != null && qe.enabled ? (b(), ue(GM, {
                key: 1,
                search: f.value,
                "onUpdate:search": Se[0] || (Se[0] = (Ae) => f.value = Ae),
                config: e.toolbar,
                onExport: O,
                onRefresh: C,
                onResetSort: _
              }, dt({ _: 2 }, [
                be.value || m(oe) ? {
                  name: "column-setup",
                  fn: ce(() => [
                    m(oe) ? (b(), ue(m(Dl), {
                      key: 0,
                      ref_key: "columnPickerPopoverRef",
                      ref: W,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: ce(() => [
                        le(m(Et), {
                          icon: "lucide:columns",
                          variant: "default"
                        })
                      ]),
                      content: ce(() => [
                        le(L$, {
                          columns: m(ae),
                          groups: m(K).groups,
                          loading: m(K).loading,
                          "original-columns": a.columns,
                          "storage-key": m(K).key,
                          "storage-type": m(K).type,
                          types: m(K).types,
                          onClose: m(re),
                          "onUpdate:visibleColumns": m(H)
                        }, null, 8, ["columns", "groups", "loading", "original-columns", "storage-key", "storage-type", "types", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : F("", !0),
                    be.value ? (b(), ue(m(Dl), {
                      key: 1,
                      ref_key: "columnSetupPopoverRef",
                      ref: B,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: ce(() => [
                        le(m(Et), {
                          icon: "lucide:table-2",
                          variant: "default"
                        })
                      ]),
                      content: ce(() => [
                        le(eM, {
                          columns: e.columns,
                          config: m(D),
                          onClose: m(te),
                          "onUpdate:visibleColumns": m(H)
                        }, null, 8, ["columns", "config", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : F("", !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["search", "config"])) : F("", !0)
            ], 512)) : F("", !0),
            E("div", MC, [
              Wt.value.length === 0 ? (b(), ue(iM, {
                key: 0,
                description: "Try adjusting your filters or search criteria",
                icon: "lucide:inbox",
                title: "No data to display"
              })) : F("", !0),
              le(MM, { loading: e.loading }, null, 8, ["loading"]),
              E("div", {
                ref_key: "scrollContainerRef",
                ref: $t,
                class: X([{ "v-table-scroll-container--loading": e.loading }, "v-table-scroll-container v-table-scrollbar-styled"]),
                style: Fe(R.value),
                onScrollPassive: Ma
              }, [
                E("div", {
                  class: X([{
                    "v-is-resizing": m(he),
                    "v-table-grid--highlight": m(bt).hasPin.value
                  }, "v-table-grid"]),
                  style: Fe(Dt.value)
                }, [
                  (b(), ue(ht(Ca.value), {
                    columns: ia.value,
                    "get-column-classes": jt,
                    "get-fixed-styles": m(me),
                    "get-group-fixed-styles": ra,
                    "get-group-width": m(ge),
                    "get-sort-state": m(Re),
                    "is-column-resizable": m(se),
                    onResizeStart: m(V),
                    onResizeDblclick: m(G),
                    onSortClick: Rt
                  }, dt({ _: 2 }, [
                    m(Tt).isEnabled.value ? {
                      name: "checkbox-header",
                      fn: ce(() => {
                        var Ae;
                        return [
                          ((Ae = Vn.value) == null ? void 0 : Ae.showHeaderCheckbox) !== !1 ? (b(), ue(dM, {
                            key: 0,
                            state: m(Tt).getHeaderCheckboxState(),
                            onToggle: m(Tt).toggleAllRows
                          }, null, 8, ["state", "onToggle"])) : (b(), $("div", CC))
                        ];
                      }),
                      key: "0"
                    } : void 0,
                    Ie(q.value, (Ae) => ({
                      name: `header-icon-${Ae.key}`,
                      fn: ce((ft) => [
                        Y(ne.$slots, `header-icon-${Ae.key}`, Ct(Bt(ft)))
                      ])
                    })),
                    Ie(q.value, (Ae) => ({
                      name: `header-${Ae.key}`,
                      fn: ce((ft) => [
                        Y(ne.$slots, `header-${Ae.key}`, Ct(Bt(ft)))
                      ])
                    }))
                  ]), 1064, ["columns", "get-fixed-styles", "get-group-width", "get-sort-state", "is-column-resizable", "onResizeStart", "onResizeDblclick"])),
                  a.virtualized && m(yt).length > 0 && m(yt)[0] ? (b(), $("div", {
                    key: 0,
                    style: Fe({ height: `${m(yt)[0].start}px` }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : F("", !0),
                  (b(!0), $(Te, null, Ie(Pe.value, (Ae) => (b(), $("div", {
                    key: Ae.key,
                    class: X([{ "v-table-row-wrapper--pinned": Q(Ae.row.id) }, "v-table-row-wrapper"]),
                    style: Fe(He(Ae)),
                    onClick: (ft) => Sn(Ae.row)
                  }, [
                    m(Tt).isEnabled.value ? (b(), ue(ZT, {
                      key: 0,
                      checked: m(Tt).isRowSelected(Ae.row.id),
                      class: X(Ae.rowClass),
                      "data-custom-row": Ae.isCustomRow ? "true" : void 0,
                      disabled: !m(Tt).isRowSelectable(Ae.row),
                      indeterminate: m(Tt).isDependentMode.value && Jl(Ae.row) && m(Tt).getParentCheckboxState(Ae.row) === "indeterminate",
                      onToggle: (ft) => m(Tt).toggleRow(Ae.row)
                    }, null, 8, ["checked", "class", "data-custom-row", "disabled", "indeterminate", "onToggle"])) : F("", !0),
                    (b(!0), $(Te, null, Ie(q.value, (ft, Ot) => (b(), ue(fu, {
                      key: ft.key,
                      align: ft.align,
                      class: X([
                        jt(ft),
                        Ae.rowClass,
                        { "v-table-cell--pin-host": qn.value.row && Ot === 0 }
                      ]),
                      "col-index": Ot,
                      column: ft,
                      "data-custom-row": Ae.isCustomRow ? "true" : void 0,
                      interactive: ft.interactive,
                      "is-expanded": !!Ae.row.isExpanded,
                      row: Ae.row,
                      "row-index": Ae.index,
                      style: Fe(m(me)(ft)),
                      onToggleExpand: (Nn) => os(Ae.row.id, Ae.row, ft)
                    }, dt({ _: 2 }, [
                      qn.value.row && Ot === 0 ? {
                        name: "pin",
                        fn: ce(() => [
                          le(tf, {
                            pinned: Q(Ae.row.id),
                            label: "row",
                            onToggle: (Nn) => m(bt).toggleRow(Ae.row.id)
                          }, null, 8, ["pinned", "onToggle"])
                        ]),
                        key: "0"
                      } : void 0,
                      m(l)[`cell-${ft.key}`] ? {
                        name: "default",
                        fn: ce(() => [
                          Y(ne.$slots, `cell-${ft.key}`, {
                            column: ft,
                            depth: Ae.row.depth || 0,
                            index: Ae.index,
                            row: Ae.row,
                            value: Ae.row[ft.key]
                          })
                        ]),
                        key: "1"
                      } : void 0
                    ]), 1032, ["align", "class", "col-index", "column", "data-custom-row", "interactive", "is-expanded", "row", "row-index", "style", "onToggleExpand"]))), 128))
                  ], 14, DC))), 128)),
                  a.virtualized && m(yt).length > 0 && m(yt)[m(yt).length - 1] ? (b(), $("div", {
                    key: 1,
                    style: Fe({
                      height: `${m(Ee) - m(yt)[m(yt).length - 1].end}px`
                    }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : F("", !0),
                  U.value && e.totalRow ? (b(), $(Te, { key: 2 }, [
                    m(Tt).isEnabled.value ? (b(), $("div", _C)) : F("", !0),
                    (b(!0), $(Te, null, Ie(q.value, (Ae, ft) => (b(), ue(fu, {
                      key: Ae.key,
                      align: Ae.align,
                      class: X([jt(Ae), "v-table-total-cell"]),
                      style: Fe(m(me)(Ae))
                    }, {
                      default: ce(() => [
                        E("div", OC, [
                          ft === 0 && cn.value ? (b(), $("div", EC)) : F("", !0),
                          E("div", {
                            class: X([{ "v-table-total-text--truncate": !Ae.interactive }, "v-table-total-text"])
                          }, [
                            Y(ne.$slots, `total-cell-${Ae.key}`, {
                              column: Ae,
                              row: e.totalRow,
                              value: e.totalRow[Ae.key]
                            }, () => [
                              le(GT, {
                                class: X(m(er)(e.totalRow[Ae.key], Ae, e.totalRow)),
                                interactive: Ae.interactive,
                                value: m(Ql)(e.totalRow[Ae.key], Ae, e.totalRow)
                              }, null, 8, ["class", "interactive", "value"])
                            ])
                          ], 2)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["align", "class", "style"]))), 128))
                  ], 64)) : F("", !0)
                ], 6)
              ], 38)
            ]),
            e.pagination ? (b(), ue(BM, {
              key: 2,
              ref: "pagination",
              loading: e.loading,
              page: L.value,
              "page-size": $e.value,
              "page-size-options": e.pagination.pageSizeOptions || [10, 25, 50, 100],
              "show-size-changer": fe.value,
              total: e.pagination.total,
              onPageChange: Ln
            }, null, 8, ["loading", "page", "page-size", "page-size-options", "show-size-changer", "total"])) : F("", !0)
          ], 16)
        ], 8, ["disabled"])),
        m(k) ? (b(), $("div", {
          key: 0,
          ref: "fullscreenPlaceholder",
          class: X(S.value),
          style: Fe(x.value),
          "aria-hidden": "true"
        }, null, 6)) : F("", !0)
      ], 64);
    };
  }
}), IC = { class: "delta-value flex flex-col" }, f2 = /* @__PURE__ */ xe({
  __name: "DeltaValue",
  props: {
    value: { default: void 0 },
    delta: { default: void 0 },
    format: { default: void 0 },
    deltaFormat: { default: void 0 },
    deltaAsPercentage: { type: Boolean, default: !0 },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showZeroDelta: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = M(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta < 0 : n.delta > 0), a = M(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta > 0 : n.delta < 0), s = M(() => n.delta === 0), l = M(() => n.delta === null || n.delta === void 0 ? !1 : n.showZeroDelta || n.delta !== 0), r = M(() => {
      var f;
      if (n.delta === null || n.delta === void 0) return "";
      const u = Math.abs(n.delta);
      if (n.deltaFormat) {
        const { type: p = "number", decimals: d = 0, currencyCode: g = "USD" } = n.deltaFormat;
        switch (p) {
          case "currency":
            return new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: g,
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u);
          case "percentage":
            return `${new Intl.NumberFormat("en-US", {
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u)}%`;
          default:
            return new Intl.NumberFormat("en-US", {
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u);
        }
      }
      const c = u.toFixed(((f = n.format) == null ? void 0 : f.decimals) ?? 0);
      return n.deltaAsPercentage ? `${c}%` : c;
    }), i = M(() => {
      if (n.value === null || n.value === void 0) return null;
      if (typeof n.value == "string") return n.value;
      const { type: u = "number", decimals: c = 0, currencyCode: f = "USD" } = n.format || {};
      switch (u) {
        case "currency":
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: f,
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value);
        case "percentage":
          return `${new Intl.NumberFormat("en-US", {
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value)}%`;
        default:
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value);
      }
    }), o = M(() => {
      switch (n.size) {
        case "sm":
          return {
            value: "text-sm",
            delta: "text-xs",
            icon: 14
          };
        case "lg":
          return {
            value: "text-lg font-semibold",
            delta: "text-sm",
            icon: 20
          };
        default:
          return {
            value: "text-base",
            delta: "text-sm",
            icon: 16
          };
      }
    });
    return (u, c) => (b(), $("div", IC, [
      i.value !== null ? (b(), $("span", {
        key: 0,
        class: X([o.value.value, "text-mainText"])
      }, ie(i.value), 3)) : F("", !0),
      l.value ? (b(), $("div", {
        key: 1,
        class: X([o.value.delta, "flex items-center gap-0.5"])
      }, [
        t.value ? (b(), ue(m(we), {
          key: 0,
          size: o.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : a.value ? (b(), ue(m(we), {
          key: 1,
          size: o.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : s.value ? (b(), ue(m(we), {
          key: 2,
          size: o.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : F("", !0),
        E("span", {
          class: X({
            "text-success": t.value,
            "text-negative": a.value,
            "text-secondaryText": s.value
          })
        }, ie(r.value), 3)
      ], 2)) : F("", !0)
    ]));
  }
}), h2 = /* @__PURE__ */ xe({
  __name: "DeltaIndicator",
  props: {
    value: { default: 0 },
    format: { default: () => {
    } },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showIcon: { type: Boolean, default: !0 },
    showZero: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = M(
      () => e.value !== null && e.value !== void 0
    ), t = M(
      () => n.value && (e.showZero || e.value !== 0)
    ), a = M(() => n.value ? e.reverse ? e.value < 0 : e.value > 0 : null), s = M(() => n.value ? e.reverse ? e.value > 0 : e.value < 0 : null), l = M(() => e.value === 0), r = M(() => {
      if (!n.value) return "";
      const o = e.format;
      if (!o) return String(e.value);
      if (o.currency !== void 0) {
        if (typeof o.currency == "object") {
          const { code: u, decimals: c } = o.currency;
          return Ds(e.value, { code: u, decimals: c });
        }
        return typeof o.currency == "string" ? Ds(e.value, o.currency) : Ds(e.value);
      }
      return o.percentage !== void 0 ? Ii(e.value, o.percentage === !0 ? void 0 : o.percentage) : o.number !== void 0 ? qa(e.value, o.number) : String(e.value);
    }), i = M(() => {
      switch (e.size) {
        case "sm":
          return { text: "text-xs", icon: 12 };
        case "lg":
          return { text: "text-sm font-semibold", icon: 18 };
        default:
          return { text: "text-sm", icon: 14 };
      }
    });
    return (o, u) => t.value ? (b(), $("div", {
      key: 0,
      class: X([i.value.text, "flex items-center gap-0.5"])
    }, [
      e.showIcon ? (b(), $(Te, { key: 0 }, [
        a.value ? (b(), ue(m(we), {
          key: 0,
          size: i.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : s.value ? (b(), ue(m(we), {
          key: 1,
          size: i.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : l.value ? (b(), ue(m(we), {
          key: 2,
          size: i.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : F("", !0)
      ], 64)) : F("", !0),
      E("span", {
        class: X({
          "text-success": a.value,
          "text-negative": s.value,
          "text-secondaryText": l.value
        })
      }, ie(r.value), 3)
    ], 2)) : F("", !0);
  }
}), AC = { class: "v-table-title-block" }, PC = { class: "v-table-title-block__title-section" }, RC = {
  key: 1,
  class: "v-table-title-block__title"
}, FC = {
  key: 2,
  class: "v-table-title-block__separator"
}, VC = {
  key: 0,
  class: "v-table-title-block__actions"
}, LC = /* @__PURE__ */ xe({
  __name: "TableTitleBlock",
  props: {
    title: { default: "" },
    icon: { default: "" }
  },
  setup(e) {
    return (n, t) => (b(), $("div", AC, [
      E("div", PC, [
        e.icon ? (b(), ue(m(we), {
          key: 0,
          icon: e.icon,
          size: 20,
          class: "v-table-title-block__icon"
        }, null, 8, ["icon"])) : F("", !0),
        e.title ? (b(), $("h3", RC, ie(e.title), 1)) : F("", !0),
        e.title && n.$slots.default ? (b(), $("span", FC)) : F("", !0)
      ]),
      n.$slots.default ? (b(), $("div", VC, [
        Y(n.$slots, "default", {}, void 0, !0)
      ])) : F("", !0)
    ]));
  }
}), m2 = /* @__PURE__ */ Ue(LC, [["__scopeId", "data-v-c3a3c2e6"]]);
function NC(e) {
  const {
    granularity: n,
    dateRange: t,
    includeSummary: a = !1,
    onPeriodChange: s
  } = e, l = ee(null), r = ee(!0), i = M(() => {
    const v = n.value, k = [], y = v === "MONTH" ? "All Months" : v === "WEEK" ? "All Weeks" : "All Days";
    return k.push({ label: y, value: "all" }), a && k.push({ label: "Summary", value: "summary" }), v === "MONTH" ? k.push(...u()) : v === "WEEK" ? k.push(...c()) : v === "DAY" && k.push(...f()), k;
  }), o = M(() => i.value[0]);
  function u() {
    const { since: v, until: k } = t.value, y = Oe.fromISO(v, { zone: "utc" }), h = Oe.fromISO(k, { zone: "utc" }), w = [];
    let S = y.startOf("month");
    for (; S <= h; )
      w.push({
        label: S.toFormat("MMMM yyyy"),
        value: S.toISODate()
      }), S = S.plus({ months: 1 });
    return w.sort(
      (x, C) => Oe.fromISO(C.value).toMillis() - Oe.fromISO(x.value).toMillis()
    );
  }
  function c() {
    const { since: v, until: k } = t.value, y = Oe.fromISO(v, { zone: "utc" }), h = Oe.fromISO(k, { zone: "utc" }), w = Oe.utc().startOf("day"), S = [];
    let x = y.startOf("week").plus({ days: 6 });
    for (; x <= h && x < w; )
      S.push({
        label: x.toFormat("MM/dd/yyyy"),
        value: x.toISODate()
      }), x = x.plus({ weeks: 1 });
    return S.sort(
      (C, _) => Oe.fromISO(_.value).toMillis() - Oe.fromISO(C.value).toMillis()
    );
  }
  function f() {
    const { since: v, until: k } = t.value, y = Oe.fromISO(v, { zone: "utc" }), h = Oe.fromISO(k, { zone: "utc" }), w = Oe.utc().startOf("day"), S = [];
    let x = y;
    for (; x <= h && x < w; )
      S.push({
        label: x.toFormat("MM/dd/yyyy"),
        value: x.toISODate()
      }), x = x.plus({ days: 1 });
    return S.sort(
      (C, _) => Oe.fromISO(_.value).toMillis() - Oe.fromISO(C.value).toMillis()
    );
  }
  const p = M(() => {
    var y;
    const v = (y = l.value) == null ? void 0 : y.value;
    if (!v || v === "all" || v === "summary")
      return {};
    const k = n.value;
    if (k === "MONTH") {
      const w = Oe.fromISO(v, { zone: "utc" }).endOf("month");
      return {
        period: {
          since: v,
          until: w.toISODate()
        }
      };
    }
    if (k === "WEEK") {
      const h = Oe.fromISO(v, { zone: "utc" });
      return {
        period: {
          since: v,
          until: h.plus({ days: 6 }).toISODate()
        }
      };
    }
    return k === "DAY" ? {
      period: {
        since: v,
        until: v
      }
    } : {};
  }), d = (v) => {
    l.value = v, r.value = v.value !== "summary", s && s(p.value, r.value);
  }, g = async () => {
    l.value = o.value, r.value = !0, s && s(p.value, r.value);
  };
  return Be(
    () => [n.value, t.value],
    () => {
      g();
    },
    { flush: "pre", deep: !0 }
  ), l.value || (l.value = o.value), {
    /** Currently selected period */
    selectedPeriod: l,
    /** Available period options for dropdown */
    periodOptions: i,
    /** Default period option */
    defaultPeriod: o,
    /** Request params to spread into API call */
    periodRequestParams: p,
    /** Whether to group by date (false when "Summary" is selected) */
    isGroupByDate: r,
    /** Handle period selection change */
    handlePeriodChange: d,
    /** Reset to default period */
    resetPeriod: g
  };
}
const BC = { class: "w-[160px]" }, v2 = /* @__PURE__ */ xe({
  __name: "TablePeriodSelect",
  props: {
    granularity: {},
    dateRange: {},
    includeSummary: { type: Boolean, default: !1 },
    widthClass: { default: "w-40" },
    placeholder: { default: "Select period" }
  },
  emits: ["change"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, {
      selectedPeriod: l,
      periodOptions: r,
      periodRequestParams: i,
      isGroupByDate: o,
      handlePeriodChange: u
    } = NC({
      granularity: pl(a, "granularity"),
      dateRange: pl(a, "dateRange"),
      includeSummary: a.includeSummary,
      onPeriodChange: () => {
        c();
      }
    }), c = () => {
      s("change", {
        selected: l.value,
        requestParams: i.value,
        isGroupByDate: o.value
      });
    }, f = (p) => {
      u(p);
    };
    return n({
      selectedPeriod: l,
      periodRequestParams: i,
      isGroupByDate: o
    }), (p, d) => (b(), $("div", BC, [
      le(m(Zk), lt({
        modelValue: m(l),
        "onUpdate:modelValue": d[0] || (d[0] = (g) => Iu(l) ? l.value = g : null),
        class: e.widthClass,
        "close-on-select": !0,
        options: m(r),
        placeholder: e.placeholder,
        searchable: !1
      }, p.$attrs, { onSelect: f }), null, 16, ["modelValue", "class", "options", "placeholder"])
    ]));
  }
}), zC = /* @__PURE__ */ xe({
  __name: "TableExpandAdditionalHeadersButton",
  props: {
    isExpanded: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, s) => (b(), $("button", {
      class: X([{ "is-expanded": e.isExpanded }, "expand-button"]),
      type: "button",
      onClick: s[0] || (s[0] = Ve((l) => t("click"), ["stop"]))
    }, [
      le(m(we), {
        size: 16,
        class: "expand-icon",
        icon: "lucide:chevron-right"
      })
    ], 2));
  }
}), p2 = /* @__PURE__ */ Ue(zC, [["__scopeId", "data-v-41dc3668"]]), da = /* @__PURE__ */ new Map(), g2 = (e, n, t) => {
  const a = (t == null ? void 0 : t.paginationMode) === "sync" ? t.totalPages : void 0, s = (t == null ? void 0 : t.paginationMode) ?? "independent", l = (t == null ? void 0 : t.initialPage) ?? 1, r = t == null ? void 0 : t.namespace, i = r ? `${r}:${e}` : e, o = n.filter((h) => h !== e), u = ee(l), c = ee(null), f = {
    scrollEl: null,
    scrollPosition: c,
    isReceivingScroll: !1,
    pendingScrollX: 0,
    pendingScrollY: 0,
    scrollRafId: null,
    page: u,
    paginationMode: s,
    totalPages: a,
    receiveHighlight: null,
    isReceivingHighlight: !1
  };
  da.set(i, f);
  const p = (h) => r ? `${r}:${h}` : h, d = {
    register: (h) => {
      f.scrollEl = h;
      for (const w of o) {
        const S = da.get(p(w));
        if (S != null && S.scrollEl) {
          h.scrollLeft = S.scrollEl.scrollLeft, h.scrollTop = S.scrollEl.scrollTop;
          break;
        }
      }
    },
    unregister: () => {
      f.scrollEl = null;
    },
    onScroll: (h, w) => {
      f.isReceivingScroll || o.forEach((S) => {
        const x = da.get(p(S));
        !x || !x.scrollEl || x.scrollEl.scrollLeft === h && x.scrollEl.scrollTop === w || (x.pendingScrollX = h, x.pendingScrollY = w, x.scrollRafId === null && (x.scrollRafId = requestAnimationFrame(() => {
          x.scrollRafId = null, x.scrollEl && (x.isReceivingScroll = !0, x.scrollEl.scrollLeft = x.pendingScrollX, x.scrollEl.scrollTop = x.pendingScrollY, requestAnimationFrame(() => {
            x.isReceivingScroll = !1;
          }));
        })));
      });
    },
    scrollPosition: c
  }, g = {
    register: (h) => {
      f.receiveHighlight = h;
    },
    unregister: () => {
      f.receiveHighlight = null;
    },
    // No rAF throttling here, unlike onScroll: this fires once per click.
    broadcast: (h) => {
      f.isReceivingHighlight || o.forEach((w) => {
        const S = da.get(p(w));
        S != null && S.receiveHighlight && (S.isReceivingHighlight = !0, S.receiveHighlight(h), S.isReceivingHighlight = !1);
      });
    }
  }, v = (h) => {
    u.value = h, o.forEach((w) => {
      const S = da.get(p(w));
      if (!(!S || S.paginationMode === "independent")) {
        if (S.paginationMode === "reset") {
          S.page.value = 1;
          return;
        }
        S.totalPages && (S.page.value = Math.min(h, S.totalPages.value));
      }
    });
  }, k = (h = 1) => {
    var w;
    f.page.value = h, f.scrollPosition.value = null, (w = f.receiveHighlight) == null || w.call(f, { rowId: null, columnKey: null }), f.scrollEl && (f.scrollEl.scrollLeft = 0, f.scrollEl.scrollTop = 0), o.forEach((S) => {
      var C;
      const x = da.get(p(S));
      x && (x.page.value = h, x.scrollPosition.value = null, (C = x.receiveHighlight) == null || C.call(x, { rowId: null, columnKey: null }), x.scrollEl && (x.scrollEl.scrollLeft = 0, x.scrollEl.scrollTop = 0));
    });
  }, y = t == null ? void 0 : t.resetOn;
  return y !== void 0 && Be(() => Qe(y), () => k()), Ol(() => {
    da.delete(i);
  }), {
    // markRaw prevents reactive() from deep-wrapping the controllers
    link: wa({
      scrollSync: zi(d),
      highlightSync: zi(g),
      page: u,
      "onUpdate:page": v
    }),
    resetState: k
  };
};
function y2(e, n = 100, t = !1) {
  const a = Math.max(0, Math.min(1, e / n)), s = Math.round(t ? 255 * a : 255 * (1 - a)), l = Math.round(t ? 255 * (1 - a) : 255 * a);
  return `rgba(${s}, ${l}, 0, 0.4)`;
}
function b2(e) {
  const n = Math.max(0, Math.min(100, e)), t = Math.round(255 * (100 - n) / 100), a = Math.round(255 * n / 100);
  return `bg-[rgb(${t},${a},0)]`;
}
const w2 = () => ({
  success: (i, o) => {
    ca.success(i, {
      description: o,
      duration: 4e3
    });
  },
  error: (i, o) => {
    ca.error(i, {
      description: o,
      duration: 5e3
    });
  },
  warning: (i, o) => {
    ca.warning(i, {
      description: o,
      duration: 4e3
    });
  },
  info: (i, o) => {
    ca.info(i, {
      description: o,
      duration: 4e3
    });
  },
  promise: (i, o) => ca.promise(i, o),
  custom: (i, o) => ca(i, o),
  dismiss: (i) => {
    ca.dismiss(i);
  }
}), df = Symbol("SidebarState");
function WC(e) {
  const n = M(
    () => Iu(e.items) ? e.items.value : e.items
  ), t = () => {
    e.isCollapsed.value = !e.isCollapsed.value;
  }, a = (u) => {
    const c = e.expandedItems.value;
    c.has(u) ? c.delete(u) : c.add(u), e.expandedItems.value = new Set(c);
  }, s = (u) => {
    if (!u.length) return;
    const c = new Set(e.expandedItems.value);
    u.forEach((f) => c.add(f)), e.expandedItems.value = c;
  }, l = (u) => e.expandedItems.value.has(u), r = () => {
    e.isMobileOpen.value = !0;
  }, i = () => {
    e.isMobileOpen.value = !1;
  }, o = () => {
    e.isMobileOpen.value = !e.isMobileOpen.value;
  };
  return {
    isCollapsed: e.isCollapsed,
    isMobileOpen: e.isMobileOpen,
    expandedItems: e.expandedItems,
    resolvedItems: n,
    options: e.options,
    toggleCollapse: t,
    toggleExpanded: a,
    expandMany: s,
    isExpanded: l,
    openMobile: r,
    closeMobile: i,
    toggleMobile: o
  };
}
function is() {
  const e = On(df);
  if (!e)
    throw new Error(
      '[NavigationSidebar] useSidebarState() called outside of <NavigationSidebar>. Make sure the component is wrapped in <NavigationSidebar :sidebar="...">.'
    );
  return e;
}
function ff(e, n = []) {
  const t = ri();
  return { resolvedTo: M(() => {
    const s = e.to;
    if (!s) return;
    if (!n.length) return s;
    const l = {};
    for (const r of n) {
      const i = t.query[r];
      i != null && (l[r] = Array.isArray(i) ? i[0] ?? "" : i);
    }
    return Object.keys(l).length ? typeof s == "string" ? { path: s, query: l } : {
      ...s,
      query: {
        ...l,
        ...s.query ?? {}
      }
    } : s;
  }) };
}
const YC = { class: "sidebar-flyout__item-label" }, HC = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, UC = /* @__PURE__ */ xe({
  __name: "SidebarMenuFlyoutItem",
  props: {
    item: {}
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n, { isActive: a, onPrefetch: s, options: l } = is(), { resolvedTo: r } = ff(e.item, l.persistentQueryParams), i = M(() => a(e.item.id)), o = M(() => ({
      "sidebar-flyout__item--active": i.value,
      "sidebar-flyout__item--disabled": e.item.disabled
    })), u = () => {
      e.item.disabled || !r.value || s(r.value);
    }, c = () => {
      e.item.disabled || t("click", e.item);
    };
    return (f, p) => {
      const d = Au("router-link");
      return e.item.to ? (b(), ue(d, {
        key: 0,
        "aria-current": i.value ? "page" : void 0,
        class: X([o.value, "sidebar-flyout__item"]),
        style: Fe(`--depth: ${e.item.level}`),
        to: m(r),
        onClick: c,
        onMouseenter: u
      }, {
        default: ce(() => [
          e.item.icon ? (b(), ue(we, {
            key: 0,
            icon: e.item.icon,
            size: 16,
            class: "sidebar-flyout__item-icon"
          }, null, 8, ["icon"])) : F("", !0),
          E("span", YC, ie(e.item.label), 1),
          e.item.badge ? (b(), $("span", HC, ie(e.item.badge), 1)) : F("", !0)
        ]),
        _: 1
      }, 8, ["aria-current", "class", "style", "to"])) : F("", !0);
    };
  }
}), qC = { class: "sidebar-flyout__item-label" }, jC = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, GC = /* @__PURE__ */ xe({
  __name: "SidebarMenuFlyoutParent",
  props: {
    item: {}
  },
  setup(e) {
    return (n, t) => (b(), $("div", {
      style: Fe(`--depth: ${e.item.level}`),
      class: "sidebar-flyout__item sidebar-flyout__item--parent"
    }, [
      e.item.icon ? (b(), ue(we, {
        key: 0,
        icon: e.item.icon,
        size: 16,
        class: "sidebar-flyout__item-icon"
      }, null, 8, ["icon"])) : F("", !0),
      E("span", qC, ie(e.item.label), 1),
      e.item.badge ? (b(), $("span", jC, ie(e.item.badge), 1)) : F("", !0)
    ], 4));
  }
}), KC = { class: "sidebar-flyout" }, ZC = { class: "sidebar-flyout__title" }, XC = { class: "sidebar-flyout__list" }, Tu = 16, JC = /* @__PURE__ */ xe({
  __name: "SidebarMenuFlyout",
  props: {
    item: {}
  },
  setup(e) {
    const { closeMobile: n } = is(), t = ee(!1), a = ee(null), s = ee(null), l = ee({ top: 0, left: 0, right: 0 }), r = ee(!1), { width: i, height: o } = M1(), u = () => {
      if (!a.value || !s.value) return;
      const h = a.value.getBoundingClientRect(), w = s.value.getBoundingClientRect(), S = h.right + 8, x = s.value.offsetHeight, C = Math.max(
        Tu,
        Math.min(h.top, o.value - Tu - x)
      );
      S + w.width > i.value - 20 ? (r.value = !0, l.value = {
        top: C,
        right: i.value - h.left + 8,
        left: 0
      }) : (r.value = !1, l.value = { top: C, left: S, right: 0 });
    };
    Be([i, o], () => {
      t.value && u();
    });
    const { start: c, stop: f } = Qr(async () => {
      t.value = !0, await Ge(), requestAnimationFrame(u);
    }, 150, { immediate: !1 }), { start: p, stop: d } = Qr(() => {
      t.value = !1;
    }, 100, { immediate: !1 }), g = () => {
      if (d(), !t.value) {
        if (a.value) {
          const h = a.value.getBoundingClientRect();
          l.value = { top: h.top, left: h.right + 8, right: 0 };
        }
        c();
      }
    }, v = () => {
      f(), p();
    }, k = M(() => {
      const h = (w, S = 0) => {
        var C;
        const x = [];
        for (const _ of w)
          x.push({ ..._, level: S }), (C = _.children) != null && C.length && x.push(...h(_.children, S + 1));
        return x;
      };
      return e.item.children ? h(e.item.children) : [];
    }), y = (h) => {
      h.disabled || (n(), t.value = !1);
    };
    return (h, w) => (b(), $("div", {
      ref_key: "buttonRef",
      ref: a,
      class: "sidebar-flyout-trigger",
      onMouseenter: g,
      onMouseleave: v
    }, [
      Y(h.$slots, "default", {}, void 0, !0),
      (b(), ue(Pn, { to: "body" }, [
        le(St, {
          "enter-active-class": "sidebar-flyout-enter-active",
          "enter-from-class": "sidebar-flyout-enter-from",
          "enter-to-class": "sidebar-flyout-enter-to",
          "leave-active-class": "sidebar-flyout-leave-active",
          "leave-from-class": "sidebar-flyout-leave-from",
          "leave-to-class": "sidebar-flyout-leave-to"
        }, {
          default: ce(() => {
            var S;
            return [
              t.value && ((S = e.item.children) != null && S.length) ? (b(), $("div", {
                key: 0,
                style: Fe({
                  top: `${l.value.top}px`,
                  ...r.value ? { right: `${l.value.right - 8}px` } : { left: `${l.value.left - 8}px` }
                }),
                class: "sidebar-flyout-portal",
                onMouseenter: g,
                onMouseleave: v
              }, [
                E("div", {
                  class: X([r.value ? "sidebar-flyout-bridge--left" : "sidebar-flyout-bridge--right", "sidebar-flyout-bridge"])
                }, null, 2),
                E("div", {
                  ref_key: "flyoutRef",
                  ref: s,
                  class: "sidebar-flyout-content"
                }, [
                  E("div", KC, [
                    E("div", ZC, ie(e.item.label), 1),
                    E("div", XC, [
                      (b(!0), $(Te, null, Ie(k.value, (x) => (b(), $(Te, {
                        key: x.id
                      }, [
                        x.to ? (b(), ue(UC, {
                          key: 0,
                          item: x,
                          onClick: y
                        }, null, 8, ["item"])) : (b(), ue(GC, {
                          key: 1,
                          item: x
                        }, null, 8, ["item"]))
                      ], 64))), 128))
                    ])
                  ])
                ], 512)
              ], 36)) : F("", !0)
            ];
          }),
          _: 1
        })
      ]))
    ], 544));
  }
}), QC = /* @__PURE__ */ Ue(JC, [["__scopeId", "data-v-c6f7104b"]]), eD = ["aria-label"], tD = ["title"], nD = {
  key: 1,
  class: "sidebar-item__badge"
}, aD = { class: "sidebar-item-children__inner" }, sD = /* @__PURE__ */ xe({
  __name: "SidebarNavItem",
  props: {
    item: {},
    level: { default: 0 }
  },
  setup(e) {
    const {
      isCollapsed: n,
      isExpanded: t,
      toggleExpanded: a,
      closeMobile: s,
      isActive: l,
      isOnActivePath: r,
      onPrefetch: i,
      options: o
    } = is(), { resolvedTo: u } = ff(e.item, o.persistentQueryParams), c = Xe("label"), f = ee(!1), p = M(() => {
      var x;
      return !!((x = e.item.children) != null && x.length);
    }), d = M(() => p.value && t(e.item.id)), g = M(() => l(e.item.id)), v = M(
      () => !g.value && p.value && r(e.item.id)
    ), k = () => {
      p.value || e.item.disabled || !u.value || i(u.value);
    }, y = () => {
      const x = c.value;
      x && (f.value = x.scrollWidth > x.clientWidth);
    }, h = () => {
      if (!e.item.disabled) {
        if (e.item.onClick) {
          e.item.onClick(), s();
          return;
        }
        p.value ? a(e.item.id) : s();
      }
    }, w = M(() => e.item.icon ?? null), S = M(() => ({
      "sidebar-item--active": g.value,
      "sidebar-item--has-active-child": v.value,
      "sidebar-item--disabled": e.item.disabled,
      "sidebar-item--collapsed": n.value,
      "sidebar-item--nested": e.level > 0,
      "sidebar-item--no-icon": !w.value
    }));
    return (x, C) => {
      const _ = Au("SidebarNavItem", !0);
      return b(), $("div", {
        style: Fe(`--depth: ${e.level}`),
        class: "sidebar-item-wrapper"
      }, [
        m(n) && p.value && !e.item.disabled ? (b(), ue(QC, {
          key: 0,
          item: e.item
        }, {
          default: ce(() => [
            E("button", {
              "aria-label": e.item.label,
              class: X([{
                "sidebar-item--active": g.value,
                "sidebar-item--has-active-child": v.value
              }, "sidebar-item sidebar-item--collapsed"]),
              type: "button",
              onClick: h
            }, [
              e.item.icon ? (b(), ue(we, {
                key: 0,
                icon: e.item.icon,
                size: 20,
                class: "sidebar-item__icon"
              }, null, 8, ["icon"])) : F("", !0)
            ], 10, eD)
          ]),
          _: 1
        }, 8, ["item"])) : m(n) && !e.item.disabled ? (b(), ue(Qa, {
          key: 1,
          delay: 200,
          text: e.item.label,
          placement: "right"
        }, {
          default: ce(() => [
            (b(), ue(ht(e.item.to ? "router-link" : "button"), {
              "aria-label": e.item.label,
              class: X([{ "sidebar-item--active": g.value }, "sidebar-item sidebar-item--collapsed"]),
              disabled: e.item.disabled || void 0,
              to: e.item.to ? m(u) : void 0,
              type: e.item.to ? void 0 : "button",
              onClick: h,
              onMouseenter: k
            }, {
              default: ce(() => [
                e.item.icon ? (b(), ue(we, {
                  key: 0,
                  icon: e.item.icon,
                  size: 20,
                  class: "sidebar-item__icon"
                }, null, 8, ["icon"])) : F("", !0)
              ]),
              _: 1
            }, 40, ["aria-label", "class", "disabled", "to", "type"]))
          ]),
          _: 1
        }, 8, ["text"])) : (b(), ue(ht(p.value || !e.item.to ? "button" : "router-link"), {
          key: 2,
          "aria-current": g.value ? "page" : void 0,
          "aria-expanded": p.value ? d.value : void 0,
          "aria-label": e.item.label,
          class: X([S.value, "sidebar-item"]),
          disabled: e.item.disabled || void 0,
          to: !p.value && e.item.to ? m(u) : void 0,
          type: p.value || !e.item.to ? "button" : void 0,
          onClick: h,
          onMouseenter: k
        }, {
          default: ce(() => [
            w.value ? (b(), ue(we, {
              key: 0,
              icon: w.value,
              size: 20,
              class: "sidebar-item__icon"
            }, null, 8, ["icon"])) : F("", !0),
            le(St, {
              "enter-active-class": "sidebar-label-enter-active",
              "enter-from-class": "sidebar-label-enter-from",
              "enter-to-class": "sidebar-label-enter-to",
              "leave-active-class": "sidebar-label-leave-active",
              "leave-from-class": "sidebar-label-leave-from",
              "leave-to-class": "sidebar-label-leave-to"
            }, {
              default: ce(() => [
                m(n) ? F("", !0) : (b(), $("span", {
                  key: 0,
                  ref: "label",
                  title: f.value ? e.item.label : void 0,
                  class: "sidebar-item__label",
                  onMouseenter: y
                }, ie(e.item.label), 41, tD))
              ]),
              _: 1
            }),
            e.item.badge && !m(n) ? (b(), $("span", nD, ie(e.item.badge), 1)) : F("", !0),
            p.value && !m(n) ? (b(), ue(we, {
              key: 2,
              class: X([{ "sidebar-item__chevron--expanded": d.value }, "sidebar-item__chevron"]),
              size: 16,
              icon: "mdi:chevron-down"
            }, null, 8, ["class"])) : F("", !0)
          ]),
          _: 1
        }, 40, ["aria-current", "aria-expanded", "aria-label", "class", "disabled", "to", "type"])),
        p.value && !m(n) ? (b(), $("div", {
          key: 3,
          class: X([{ "sidebar-item-children--expanded": d.value }, "sidebar-item-children"])
        }, [
          E("div", aD, [
            (b(!0), $(Te, null, Ie(e.item.children, (O) => (b(), ue(_, {
              key: O.id,
              item: O,
              level: e.level + 1
            }, null, 8, ["item", "level"]))), 128))
          ])
        ], 2)) : F("", !0)
      ], 4);
    };
  }
}), hf = /* @__PURE__ */ Ue(sD, [["__scopeId", "data-v-25de8820"]]), lD = {
  key: 0,
  class: "v-sidebar-footer__slot"
}, rD = {
  key: 1,
  class: "v-sidebar-footer__nav"
}, iD = {
  key: 2,
  class: "v-sidebar-footer__slot"
}, oD = /* @__PURE__ */ xe({
  __name: "SidebarFooter",
  props: {
    items: { default: () => [] }
  },
  setup(e) {
    const { isCollapsed: n } = is();
    return (t, a) => (b(), $("div", {
      class: X([{ "v-sidebar-footer--collapsed": m(n) }, "v-sidebar-footer"])
    }, [
      t.$slots.start ? (b(), $("div", lD, [
        Y(t.$slots, "start")
      ])) : F("", !0),
      e.items.length ? (b(), $("nav", rD, [
        (b(!0), $(Te, null, Ie(e.items, (s) => (b(), ue(hf, {
          key: s.id,
          item: s,
          level: 0
        }, null, 8, ["item"]))), 128))
      ])) : F("", !0),
      t.$slots.end ? (b(), $("div", iD, [
        Y(t.$slots, "end")
      ])) : F("", !0)
    ], 2));
  }
}), uD = {
  key: 0,
  class: "sidebar-header__brand"
}, cD = {
  key: 0,
  class: "sidebar-header__logo"
}, dD = ["alt", "src"], fD = { class: "sidebar-header__name" }, hD = { class: "sidebar-header__controls" }, mD = ["aria-label"], vD = { class: "sidebar-header__toggle-icons" }, pD = /* @__PURE__ */ xe({
  __name: "SidebarHeader",
  setup(e) {
    const { isCollapsed: n, toggleCollapse: t, options: a } = is();
    return (s, l) => (b(), $("div", {
      class: X([{ "sidebar-header--collapsed": m(n) }, "sidebar-header"])
    }, [
      le(St, {
        "enter-active-class": "sidebar-label-enter-active",
        "enter-from-class": "sidebar-label-enter-from",
        "enter-to-class": "sidebar-label-enter-to",
        "leave-active-class": "sidebar-label-leave-active",
        "leave-from-class": "sidebar-label-leave-from",
        "leave-to-class": "sidebar-label-leave-to"
      }, {
        default: ce(() => [
          m(n) ? F("", !0) : (b(), $("div", uD, [
            Y(s.$slots, "start", {}, () => [
              m(a).logoUrl ? (b(), $("div", cD, [
                E("img", {
                  alt: m(a).brandName,
                  src: m(a).logoUrl
                }, null, 8, dD)
              ])) : F("", !0),
              E("span", fD, ie(m(a).brandName), 1)
            ], !0)
          ]))
        ]),
        _: 3
      }),
      E("div", hD, [
        Y(s.$slots, "end", {}, void 0, !0),
        E("button", {
          "aria-label": m(n) ? "Expand sidebar" : "Collapse sidebar",
          class: X([{ "sidebar-header__toggle--collapsed": m(n) }, "sidebar-header__toggle"]),
          type: "button",
          onClick: l[0] || (l[0] = //@ts-ignore
          (...r) => m(t) && m(t)(...r))
        }, [
          E("span", vD, [
            le(we, {
              size: 20,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--close",
              icon: "lucide:panel-left-close"
            }),
            le(we, {
              size: 20,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--open",
              icon: "lucide:panel-left-open"
            })
          ])
        ], 10, mD)
      ])
    ], 2));
  }
}), gD = /* @__PURE__ */ Ue(pD, [["__scopeId", "data-v-ef54c1d6"]]), yD = { class: "sidebar-nav__list" }, bD = /* @__PURE__ */ xe({
  __name: "SidebarNav",
  setup(e) {
    const {
      resolvedItems: n,
      isCollapsed: t,
      expandedItems: a,
      activeItemId: s
    } = is();
    return (l, r) => (b(), $("nav", {
      class: X([{ "sidebar-nav--collapsed": m(t) }, "sidebar-nav"])
    }, [
      E("div", yD, [
        (b(!0), $(Te, null, Ie(m(n), (i, o, u, c) => {
          const f = [m(s), m(a), m(t), i.id];
          if (c && c.key === i.id && kf(c, f)) return c;
          const p = (b(), ue(hf, {
            key: i.id,
            item: i,
            level: 0
          }, null, 8, ["item"]));
          return p.memo = f, p;
        }, r, 0), 128))
      ])
    ], 2));
  }
});
function mf(e, n = []) {
  var a;
  const t = [];
  for (const s of e) {
    const l = [...n, s.id];
    if (s.to) {
      const r = { itemId: s.id, ancestorIds: l };
      typeof s.to == "string" ? r.path = s.to : typeof s.to == "object" && "name" in s.to && s.to.name ? r.routeName = s.to.name : typeof s.to == "object" && "path" in s.to && s.to.path && (r.path = s.to.path), t.push(r);
    }
    (a = s.children) != null && a.length && t.push(...mf(s.children, l));
  }
  return t;
}
function wD(e) {
  const n = ri(), t = M(() => mf(e.value)), a = It(null), s = It(/* @__PURE__ */ new Set());
  Be(
    () => ({ path: n.path, name: n.name }),
    ({ path: u, name: c }) => {
      let f;
      for (const p of t.value) {
        if (p.path && p.path === u) {
          f = p;
          break;
        }
        if (p.routeName && p.routeName === c) {
          f = p;
          break;
        }
      }
      f ? (a.value = f.itemId, s.value = new Set(f.ancestorIds)) : (a.value = null, s.value = /* @__PURE__ */ new Set());
    },
    { immediate: !0 }
  );
  const l = M(() => a.value), r = M(() => s.value);
  return { activeItemId: l, activePathIds: r, isActive: (u) => a.value === u, isOnActivePath: (u) => s.value.has(u) };
}
const k2 = /* @__PURE__ */ xe({
  __name: "NavigationSidebar",
  props: {
    sidebar: {}
  },
  emits: ["prefetch", "collapse", "item-click"],
  setup(e, { emit: n }) {
    const t = n, a = xf(
      () => import("./NavigationSidebarMobile-BpJoo4rW.js")
    ), s = WC(e.sidebar), { activeItemId: l, activePathIds: r, isActive: i, isOnActivePath: o } = wD(
      s.resolvedItems
    );
    ga(df, {
      ...s,
      activeItemId: l,
      activePathIds: r,
      isActive: i,
      isOnActivePath: o,
      onPrefetch: (c) => t("prefetch", c)
    });
    const u = M(() => e.sidebar.isCollapsed.value);
    return Be(
      r,
      (c) => {
        s.expandMany([...c]);
      },
      { immediate: !0 }
    ), (c, f) => (b(), $("div", null, [
      E("aside", {
        class: X([{ "sidebar--collapsed": u.value }, "sidebar sidebar--flat"]),
        "aria-label": "Main navigation"
      }, [
        le(gD, null, dt({ _: 2 }, [
          c.$slots["header-title"] ? {
            name: "start",
            fn: ce(() => [
              Y(c.$slots, "header-title")
            ]),
            key: "0"
          } : void 0,
          c.$slots["header-end"] ? {
            name: "end",
            fn: ce(() => [
              Y(c.$slots, "header-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024),
        Y(c.$slots, "subtitle-block"),
        le(bD),
        le(oD, null, dt({ _: 2 }, [
          c.$slots["footer-start"] ? {
            name: "start",
            fn: ce(() => [
              Y(c.$slots, "footer-start")
            ]),
            key: "0"
          } : void 0,
          c.$slots["footer-end"] ? {
            name: "end",
            fn: ce(() => [
              Y(c.$slots, "footer-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024)
      ], 2),
      le(m(a), null, dt({ _: 2 }, [
        c.$slots["footer-start"] ? {
          name: "start",
          fn: ce(() => [
            Y(c.$slots, "footer-start")
          ]),
          key: "0"
        } : void 0,
        c.$slots["footer-end"] ? {
          name: "end",
          fn: ce(() => [
            Y(c.$slots, "footer-end")
          ]),
          key: "1"
        } : void 0
      ]), 1024)
    ]));
  }
}), kD = "ui-sidebar";
function xD(e) {
  try {
    return localStorage.getItem(`${e}:collapsed`) === "true";
  } catch {
    return !1;
  }
}
function SD(e, n) {
  try {
    localStorage.setItem(`${e}:collapsed`, String(n));
  } catch {
  }
}
function TD(e) {
  try {
    const n = localStorage.getItem(`${e}:expanded`);
    if (!n) return /* @__PURE__ */ new Set();
    const t = JSON.parse(n);
    return Array.isArray(t) ? new Set(t) : /* @__PURE__ */ new Set();
  } catch {
    return /* @__PURE__ */ new Set();
  }
}
function $D(e, n) {
  try {
    localStorage.setItem(`${e}:expanded`, JSON.stringify([...n]));
  } catch {
  }
}
function x2(e) {
  const n = {
    brandName: e.brandName ?? "",
    logoUrl: e.logoUrl ?? "",
    storageKey: e.storageKey ?? kD,
    persistCollapse: e.persistCollapse ?? !0,
    persistentQueryParams: e.persistentQueryParams ?? []
  }, t = ee(!1), a = ee(!1), s = ee(/* @__PURE__ */ new Set());
  return n.persistCollapse && typeof window < "u" && (t.value = xD(n.storageKey), s.value = TD(n.storageKey), Gt(() => {
    SD(n.storageKey, t.value);
  }), Gt(() => {
    $D(n.storageKey, s.value);
  })), {
    items: e.items,
    isCollapsed: t,
    isMobileOpen: a,
    expandedItems: s,
    options: n,
    toggleCollapse: () => {
      t.value = !t.value;
    },
    toggleMobile: () => {
      a.value = !a.value;
    }
  };
}
function MD(e, n, t, a, s) {
  let l = e.find((r) => r.id === n);
  return l || (l = { id: n, label: t, icon: a, order: s ?? 999, children: [] }, e.push(l)), l;
}
function CD(e, n, t) {
  if (!t.menuGroup) {
    e.push(n);
    return;
  }
  const a = t.menuGroup.split("/");
  let s = e;
  a.forEach((l, r) => {
    var c;
    const i = `group:${a.slice(0, r + 1).join("/")}`, o = (c = t.menuGroupMeta) == null ? void 0 : c[l];
    s = MD(
      s,
      i,
      l,
      (o == null ? void 0 : o.icon) ?? (r === 0 ? t.menuGroupIcon : void 0),
      (o == null ? void 0 : o.order) ?? (r === 0 ? t.menuGroupOrder : void 0)
    ).children;
  }), s.push(n);
}
function vf(e) {
  return e.sort((n, t) => (n.order ?? 999) - (t.order ?? 999)).map((n) => {
    var t;
    return {
      ...n,
      children: (t = n.children) != null && t.length ? vf(n.children) : void 0
    };
  });
}
function S2(e) {
  const n = [];
  for (const { item: t, meta: a } of e)
    CD(n, t, a);
  return vf(n);
}
export {
  Qa as $,
  Dl as A,
  rt as B,
  XT as C,
  ND as D,
  n2 as E,
  Cl as F,
  YD as G,
  jl as H,
  ZD as I,
  GD as J,
  XD as K,
  a2 as L,
  u2 as M,
  HD as N,
  Zk as O,
  UD as P,
  d2 as Q,
  of as R,
  BM as S,
  iM as T,
  s2 as U,
  we as V,
  ju as W,
  JD as X,
  QD as Y,
  tk as Z,
  Ue as _,
  ff as a,
  Fx as a0,
  S2 as a1,
  x2 as a2,
  la as a3,
  l2 as a4,
  Wd as a5,
  Cs as a6,
  sC as a7,
  Ds as a8,
  Yd as a9,
  J1 as aA,
  es as aB,
  WD as aC,
  Bd as aD,
  g2 as aE,
  Gl as aF,
  wD as aG,
  Mx as aH,
  lC as aI,
  c2 as aJ,
  NC as aK,
  Nd as aL,
  w2 as aM,
  Fi as aN,
  Hd as aa,
  LD as ab,
  qa as ac,
  Ii as ad,
  af as ae,
  zd as af,
  y2 as ag,
  b2 as ah,
  Cr as ai,
  r2 as aj,
  rf as ak,
  Ni as al,
  Xl as am,
  ZM as an,
  VD as ao,
  i2 as ap,
  XM as aq,
  sf as ar,
  Li as as,
  KM as at,
  js as au,
  Vi as av,
  Zl as aw,
  JM as ax,
  o2 as ay,
  lf as az,
  Is as b,
  Cw as c,
  h2 as d,
  f2 as e,
  KD as f,
  k2 as g,
  p2 as h,
  v2 as i,
  m2 as j,
  e2 as k,
  t2 as l,
  ID as m,
  qD as n,
  Et as o,
  AD as p,
  uT as q,
  Kc as r,
  PD as s,
  R1 as t,
  is as u,
  zD as v,
  RD as w,
  FD as x,
  jD as y,
  BD as z
};
//# sourceMappingURL=index-XU_gxlzV.js.map
